var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGetSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 127,
    viewBox: "0 0 192 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.1327 29.0112C82.0635 28.9403 81.9837 28.8768 81.8914 28.8239L75.0441 24.8534C74.3904 24.4734 73.5856 24.4734 72.933 24.8534L52.5873 36.6951H51.5108V41.7453C51.5087 42.0491 51.6556 42.3529 51.9535 42.5265L58.762 46.4748C59.6476 46.9903 60.7377 46.9892 61.6222 46.4748L81.8914 34.6765C82.2597 34.4616 82.4433 34.0879 82.4454 33.7122V28.6376L82.1306 29.0123L82.1327 29.0112Z",
    fill: "#C2E6F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8925 29.618L61.6234 41.4164C61.4786 41.501 61.3286 41.5698 61.1743 41.627V46.6846C61.3286 46.6275 61.4786 46.5587 61.6234 46.474L81.8925 34.6757C82.2608 34.4608 82.4444 34.0871 82.4465 33.7114V28.6484C82.4465 29.0253 82.2618 29.4032 81.8925 29.618Z",
    fill: "#39BAE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8914 27.6786L75.0441 23.7081C74.3904 23.3281 73.5856 23.3281 72.933 23.7081L51.9535 35.9203C51.3628 36.2643 51.3628 37.1249 51.9535 37.4689L58.762 41.4172C59.6476 41.9327 60.7377 41.9317 61.6222 41.4172L81.8914 29.6189C82.6311 29.187 82.6311 28.1105 81.8914 27.6797V27.6786Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7622 41.4173L58.4631 41.2437V46.3013L58.7622 46.4749C59.0958 46.6697 59.4589 46.7903 59.8292 46.838V41.7803C59.4589 41.7327 59.0958 41.612 58.7622 41.4173Z",
    fill: "#39BAE9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8924 33.8138L61.6232 45.6121C60.7387 46.1276 59.6475 46.1286 58.763 45.6121L51.9545 41.6638C51.6565 41.4902 51.5096 41.1864 51.5117 40.8826V41.2679C51.5096 41.5717 51.6565 41.8755 51.9545 42.0491L58.763 45.9974C59.6486 46.5129 60.7387 46.5118 61.6232 45.9963L81.8924 34.198C82.2606 33.9831 82.4443 33.6095 82.4464 33.2337V32.8484C82.4443 33.2231 82.2606 33.5978 81.8924 33.8127V33.8138Z",
    fill: "#39BAE9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8924 30.1504L61.6232 41.9487C60.7387 42.4642 59.6475 42.4652 58.763 41.9487L51.9545 38.0004C51.6565 37.8268 51.5096 37.523 51.5117 37.2192V37.6045C51.5096 37.9083 51.6565 38.2121 51.9545 38.3857L58.763 42.334C59.6486 42.8495 60.7387 42.8495 61.6232 42.334L81.8924 30.5357C82.2606 30.3208 82.4443 29.9471 82.4464 29.5713V29.186C82.4443 29.5608 82.2606 29.9355 81.8924 30.1504Z",
    fill: "#39BAE9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1327 23.055C82.0635 22.984 81.9837 22.9205 81.8914 22.8676L75.0441 18.8971C74.3904 18.5171 73.5856 18.5171 72.933 18.8971L52.5873 30.7388H51.5108V35.789C51.5087 36.0928 51.6556 36.3966 51.9535 36.5702L58.762 40.5185C59.6476 41.034 60.7377 41.0329 61.6222 40.5185L81.8914 28.7202C82.2597 28.5053 82.4433 28.1316 82.4454 27.7559V22.6813L82.1306 23.056L82.1327 23.055Z",
    fill: "#C2E6F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8925 23.6617L61.6234 35.4601C61.4786 35.5447 61.3286 35.6135 61.1743 35.6707V40.7283C61.3286 40.6712 61.4786 40.6024 61.6234 40.5177L81.8925 28.7194C82.2608 28.5045 82.4444 28.1308 82.4465 27.7551V22.6921C82.4465 23.069 82.2618 23.4469 81.8925 23.6617Z",
    fill: "#39BAE9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8914 21.7223L75.0441 17.7518C74.3904 17.3718 73.5856 17.3718 72.933 17.7518L51.9535 29.964C51.3628 30.308 51.3628 31.1686 51.9535 31.5126L58.762 35.4609C59.6476 35.9764 60.7377 35.9754 61.6222 35.4609L81.8914 23.6626C82.6311 23.2318 82.6311 22.1542 81.8914 21.7234V21.7223Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7622 35.4609L58.4631 35.2874V40.345L58.7622 40.5186C59.0958 40.7133 59.4589 40.834 59.8292 40.8817V35.824C59.4589 35.7764 59.0958 35.6557 58.7622 35.4609Z",
    fill: "#39BAE9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8924 27.8576L61.6232 39.6559C60.7387 40.1714 59.6475 40.1725 58.763 39.6559L51.9545 35.7076C51.6565 35.534 51.5096 35.2302 51.5117 34.9264V35.3118C51.5096 35.6155 51.6565 35.9193 51.9545 36.0929L58.763 40.0412C59.6486 40.5567 60.7387 40.5557 61.6232 40.0412L81.8924 28.2429C82.2606 28.028 82.4443 27.6544 82.4464 27.2786V26.8933C82.4443 27.268 82.2606 27.6427 81.8924 27.8576Z",
    fill: "#39BAE9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8924 24.1941L61.6232 35.9924C60.7387 36.5079 59.6475 36.5089 58.763 35.9924L51.9545 32.0441C51.6565 31.8705 51.5096 31.5667 51.5117 31.2629V31.6482C51.5096 31.952 51.6565 32.2558 51.9545 32.4294L58.763 36.3777C59.6486 36.8932 60.7387 36.8921 61.6232 36.3777L81.8924 24.5794C82.2606 24.3645 82.4443 23.9908 82.4464 23.615V23.2297C82.4443 23.6045 82.2606 23.9792 81.8924 24.1941Z",
    fill: "#39BAE9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1327 17.0987C82.0635 17.0277 81.9837 16.9642 81.8914 16.9113L75.0441 12.9408C74.3904 12.5608 73.5856 12.5608 72.933 12.9408L52.5873 24.7825H51.5108V29.8327C51.5087 30.1365 51.6556 30.4403 51.9535 30.6139L58.762 34.5622C59.6476 35.0777 60.7377 35.0766 61.6222 34.5622L81.8914 22.7639C82.2597 22.549 82.4433 22.1753 82.4454 21.7996V16.725L82.1306 17.0997L82.1327 17.0987Z",
    fill: "#C2E6F8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8925 17.7052L61.6234 29.5035C61.4786 29.5882 61.3286 29.657 61.1743 29.7142V34.7718C61.3286 34.7146 61.4786 34.6458 61.6234 34.5611L81.8925 22.7628C82.2608 22.548 82.4444 22.1743 82.4465 21.7985V16.7356C82.4465 17.1124 82.2618 17.4903 81.8925 17.7052Z",
    fill: "#39BAE9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8914 15.766L75.0441 11.7955C74.3904 11.4155 73.5856 11.4155 72.933 11.7955L51.9535 24.0077C51.3628 24.3517 51.3628 25.2123 51.9535 25.5563L58.762 29.5046C59.6476 30.0201 60.7377 30.0191 61.6222 29.5046L81.8914 17.7063C82.6311 17.2755 82.6311 16.1979 81.8914 15.7671V15.766Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7622 29.5047L58.4631 29.3311V34.3887L58.7622 34.5623C59.0958 34.7571 59.4589 34.8777 59.8292 34.9254V29.8677C59.4589 29.8201 59.0958 29.6994 58.7622 29.5047Z",
    fill: "#39BAE9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8924 21.9001L61.6232 33.6984C60.7387 34.2139 59.6475 34.215 58.763 33.6984L51.9545 29.7501C51.6565 29.5765 51.5096 29.2727 51.5117 28.9689V29.3542C51.5096 29.658 51.6565 29.9618 51.9545 30.1354L58.763 34.0837C59.6486 34.5992 60.7387 34.5982 61.6232 34.0837L81.8924 22.2854C82.2606 22.0705 82.4443 21.6969 82.4464 21.3211V20.9358C82.4443 21.3105 82.2606 21.6852 81.8924 21.9001Z",
    fill: "#39BAE9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8924 18.2365L61.6232 30.0348C60.7387 30.5503 59.6475 30.5514 58.763 30.0348L51.9545 26.0865C51.6565 25.9129 51.5096 25.6092 51.5117 25.3054V25.6907C51.5096 25.9945 51.6565 26.2983 51.9545 26.4718L58.763 30.4201C59.6486 30.9356 60.7387 30.9346 61.6232 30.4201L81.8924 18.6218C82.2606 18.407 82.4443 18.0333 82.4464 17.6575V17.2722C82.4443 17.6469 82.2606 18.0217 81.8924 18.2365Z",
    fill: "#39BAE9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1327 11.1424C82.0635 11.0714 81.9837 11.0079 81.8914 10.955L75.0441 6.98447C74.3904 6.60446 73.5856 6.60446 72.933 6.98447L52.5873 18.8262H51.5108V23.8764C51.5087 24.1802 51.6556 24.484 51.9535 24.6576L58.762 28.6059C59.6476 29.1214 60.7377 29.1203 61.6222 28.6059L81.8914 16.8076C82.2597 16.5927 82.4433 16.219 82.4454 15.8433V10.7687L82.1306 11.1434L82.1327 11.1424Z",
    fill: "#C2E6F8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8925 11.7489L61.6234 23.5472C61.4786 23.6319 61.3286 23.7007 61.1743 23.7579V28.8155C61.3286 28.7583 61.4786 28.6895 61.6234 28.6048L81.8925 16.8065C82.2608 16.5917 82.4444 16.218 82.4465 15.8422V10.7793C82.4465 11.1561 82.2618 11.534 81.8925 11.7489Z",
    fill: "#39BAE9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8914 9.80973L75.0441 5.83921C74.3904 5.4592 73.5856 5.4592 72.933 5.83921L51.9535 18.0514C51.3628 18.3954 51.3628 19.256 51.9535 19.6L58.762 23.5483C59.6476 24.0638 60.7377 24.0628 61.6222 23.5483L81.8914 11.75C82.6311 11.3192 82.6311 10.2416 81.8914 9.81079V9.80973Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7622 23.5484L58.4631 23.3748V28.4324L58.7622 28.606C59.0958 28.8007 59.4589 28.9214 59.8292 28.9691V23.9114C59.4589 23.8638 59.0958 23.7431 58.7622 23.5484Z",
    fill: "#39BAE9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8924 15.9438L61.6232 27.7421C60.7387 28.2576 59.6475 28.2587 58.763 27.7421L51.9545 23.7938C51.6565 23.6202 51.5096 23.3164 51.5117 23.0126V23.3979C51.5096 23.7017 51.6565 24.0055 51.9545 24.1791L58.763 28.1274C59.6486 28.6429 60.7387 28.6419 61.6232 28.1274L81.8924 16.3291C82.2606 16.1142 82.4443 15.7406 82.4464 15.3648V14.9795C82.4443 15.3542 82.2606 15.7289 81.8924 15.9438Z",
    fill: "#39BAE9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8924 12.2802L61.6232 24.0785C60.7387 24.594 59.6475 24.5951 58.763 24.0785L51.9545 20.1302C51.6565 19.9567 51.5096 19.6529 51.5117 19.3491V19.7344C51.5096 20.0382 51.6565 20.342 51.9545 20.5156L58.763 24.4638C59.6486 24.9793 60.7387 24.9783 61.6232 24.4638L81.8924 12.6655C82.2606 12.4507 82.4443 12.077 82.4464 11.7012V11.3159C82.4443 11.6906 82.2606 12.0654 81.8924 12.2802Z",
    fill: "#39BAE9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M175.908 49.8295C177.207 50.5864 178.349 52.0228 179.013 53.5788C179.331 53.6624 179.665 53.8022 180.01 54.0033C182.015 55.1708 183.645 57.959 183.724 60.3089L183.845 60.3788C185.406 61.288 186.667 63.4919 186.662 65.3009C186.657 67.1099 185.387 67.8392 183.827 66.931L168.711 58.1262C167.149 57.2169 165.888 55.0131 165.893 53.2041C165.899 51.412 167.144 50.6795 168.683 51.5486C169.228 50.2466 170.584 49.8888 172.17 50.8129C172.216 50.8393 172.261 50.8669 172.306 50.8954C172.75 49.3288 174.196 48.8313 175.907 49.8285L175.908 49.8295Z",
    fill: "#39BAE9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M191.366 35.4208C191.366 35.3457 191.305 35.2864 191.231 35.2864H191.23C191.155 35.2864 191.096 35.3488 191.097 35.424C191.097 35.4928 191.098 35.5616 191.098 35.6304V35.6833C191.098 35.8146 191.096 35.9458 191.093 36.075C191.09 36.1501 191.15 36.2126 191.224 36.2147H191.227C191.301 36.2147 191.36 36.1554 191.362 36.0813C191.366 35.9511 191.368 35.8167 191.368 35.6833V35.6293C191.368 35.5595 191.368 35.4896 191.367 35.4198L191.366 35.4208Z",
    fill: "#B8BCFC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M177.343 11.6569L177.352 11.6622C177.535 11.7692 177.722 11.8824 177.906 11.9978C177.928 12.0116 177.953 12.019 177.977 12.019C178.022 12.019 178.066 11.9957 178.092 11.9544C178.131 11.8909 178.111 11.8062 178.049 11.767C177.862 11.6495 177.673 11.5352 177.487 11.4272L177.479 11.422C177.414 11.3838 177.332 11.4071 177.294 11.4717C177.256 11.5373 177.279 11.6199 177.343 11.658V11.6569Z",
    fill: "#B8BCFC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M169.999 36.7481C169.954 36.6877 169.869 36.6761 169.809 36.7227C169.749 36.7682 169.738 36.8539 169.784 36.9143C169.915 37.0879 170.049 37.2625 170.183 37.4329C170.21 37.4668 170.25 37.4848 170.289 37.4848C170.319 37.4848 170.348 37.4753 170.373 37.4552C170.432 37.4086 170.442 37.3229 170.395 37.2636C170.262 37.0942 170.129 36.9206 169.999 36.7491V36.7481Z",
    fill: "#B8BCFC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M175.666 10.7984C175.86 10.8842 176.056 10.9752 176.251 11.0715C176.27 11.081 176.29 11.0853 176.31 11.0853C176.36 11.0853 176.409 11.0567 176.432 11.008C176.464 10.9403 176.436 10.8588 176.369 10.8259C176.17 10.7286 175.97 10.6354 175.773 10.5486C175.705 10.519 175.625 10.5497 175.594 10.6195C175.565 10.6883 175.595 10.7688 175.665 10.7995L175.666 10.7984Z",
    fill: "#B8BCFC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M167.887 33.5895C167.849 33.525 167.766 33.5038 167.701 33.5419C167.637 33.58 167.616 33.6636 167.654 33.7292C167.765 33.9177 167.879 34.1061 167.994 34.2924C168.019 34.3337 168.063 34.3569 168.109 34.3569C168.133 34.3569 168.158 34.3506 168.181 34.3368C168.243 34.2966 168.263 34.213 168.224 34.1495C168.11 33.9653 167.997 33.7769 167.887 33.5906V33.5895Z",
    fill: "#B8BCFC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M173.899 10.1581C174.101 10.2152 174.309 10.2798 174.514 10.3497C174.528 10.3549 174.542 10.3571 174.557 10.3571C174.613 10.3571 174.666 10.3211 174.685 10.2639C174.709 10.193 174.67 10.1157 174.6 10.0914C174.39 10.0205 174.179 9.95482 173.971 9.89661C173.899 9.87649 173.824 9.91883 173.805 9.99081C173.785 10.0639 173.827 10.139 173.898 10.1591L173.899 10.1581Z",
    fill: "#B8BCFC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M166.966 31.9235C166.931 31.8568 166.849 31.8304 166.783 31.8653C166.717 31.9002 166.691 31.9828 166.725 32.0495C166.826 32.2432 166.929 32.439 167.034 32.6317C167.058 32.6772 167.105 32.7026 167.152 32.7026C167.174 32.7026 167.196 32.6973 167.217 32.6856C167.282 32.6497 167.307 32.5671 167.271 32.5004C167.167 32.3099 167.064 32.1151 166.966 31.9224V31.9235Z",
    fill: "#B8BCFC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M167.366 10.6842C167.325 10.6207 167.241 10.6038 167.179 10.6451C166.996 10.7668 166.815 10.8991 166.643 11.0388C166.586 11.0865 166.576 11.1722 166.622 11.2304C166.649 11.2643 166.688 11.2812 166.727 11.2812C166.757 11.2812 166.787 11.2717 166.812 11.2505C166.978 11.1161 167.151 10.9891 167.327 10.8726C167.389 10.8314 167.407 10.7467 167.366 10.6842Z",
    fill: "#B8BCFC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M173.833 40.9443C173.777 40.8945 173.691 40.8998 173.642 40.9559C173.592 41.012 173.598 41.0988 173.653 41.1486C173.817 41.2947 173.984 41.4397 174.149 41.5794C174.174 41.6006 174.205 41.6111 174.236 41.6111C174.274 41.6111 174.312 41.5942 174.339 41.5625C174.388 41.5053 174.38 41.4185 174.323 41.3709C174.16 41.2322 173.994 41.0893 173.833 40.9443Z",
    fill: "#B8BCFC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M180.918 14.281C180.945 14.3043 180.976 14.3149 181.007 14.3149C181.045 14.3149 181.082 14.299 181.109 14.2694C181.159 14.2133 181.153 14.1265 181.098 14.0767C180.934 13.9307 180.767 13.7856 180.602 13.6459C180.546 13.5972 180.46 13.6046 180.411 13.6628C180.363 13.72 180.371 13.8068 180.428 13.8555C180.592 13.9942 180.757 14.1371 180.918 14.2821V14.281Z",
    fill: "#B8BCFC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M175.814 42.535C175.64 42.4101 175.464 42.281 175.292 42.1497C175.232 42.1042 175.147 42.1169 175.103 42.1762C175.058 42.2365 175.07 42.3223 175.13 42.3667C175.304 42.4991 175.482 42.6303 175.658 42.7563C175.683 42.7732 175.71 42.7817 175.736 42.7817C175.778 42.7817 175.82 42.7616 175.846 42.7245C175.889 42.6631 175.875 42.5784 175.814 42.534V42.535Z",
    fill: "#B8BCFC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M172.465 39.6315C172.412 39.5775 172.327 39.5764 172.274 39.6294C172.22 39.6823 172.219 39.768 172.272 39.822C172.425 39.9787 172.58 40.1353 172.735 40.2878C172.762 40.3132 172.795 40.3259 172.83 40.3259C172.864 40.3259 172.9 40.3121 172.926 40.2846C172.979 40.2306 172.977 40.1438 172.924 40.0919C172.771 39.9416 172.617 39.786 172.466 39.6304L172.465 39.6315Z",
    fill: "#B8BCFC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M178.937 12.69C179.112 12.8138 179.287 12.944 179.459 13.0753C179.483 13.0943 179.511 13.1028 179.54 13.1028C179.581 13.1028 179.621 13.0838 179.648 13.0488C179.693 12.9885 179.681 12.9027 179.621 12.8583C179.447 12.7249 179.269 12.5947 179.094 12.4688C179.033 12.4254 178.949 12.4402 178.905 12.5016C178.862 12.563 178.876 12.6476 178.937 12.6921V12.69Z",
    fill: "#B8BCFC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M171.187 38.2279C171.138 38.1708 171.052 38.1644 170.996 38.2131C170.939 38.2618 170.933 38.3486 170.981 38.4058C171.123 38.5719 171.268 38.7381 171.413 38.9011C171.439 38.9308 171.477 38.9467 171.514 38.9467C171.546 38.9467 171.579 38.935 171.604 38.9117C171.66 38.8609 171.664 38.7752 171.615 38.7191C171.471 38.5582 171.327 38.3931 171.187 38.229V38.2279Z",
    fill: "#B8BCFC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M168.899 35.1996C168.857 35.1371 168.773 35.1202 168.711 35.1625C168.65 35.2049 168.633 35.2895 168.675 35.352C168.795 35.533 168.92 35.7151 169.045 35.8939C169.071 35.9321 169.113 35.9522 169.156 35.9522C169.184 35.9522 169.21 35.9437 169.234 35.9278C169.295 35.8844 169.31 35.7997 169.267 35.7373C169.143 35.5595 169.02 35.3795 168.899 35.1996Z",
    fill: "#B8BCFC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M163.581 18.0291C163.581 18.0291 163.59 18.0291 163.594 18.0291C163.663 18.0291 163.721 17.9762 163.729 17.9064C163.75 17.6883 163.776 17.4713 163.806 17.2607C163.817 17.1866 163.765 17.1167 163.692 17.1061C163.619 17.0955 163.549 17.1474 163.539 17.2215C163.508 17.4364 163.482 17.6576 163.46 17.8788C163.453 17.954 163.507 18.0207 163.582 18.0281L163.581 18.0291Z",
    fill: "#B8BCFC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M163.761 21.7012C163.739 21.4842 163.719 21.2661 163.703 21.0513C163.698 20.9761 163.633 20.9189 163.559 20.9253C163.484 20.9306 163.428 20.9962 163.434 21.0714C163.449 21.2884 163.469 21.5096 163.491 21.7287C163.499 21.7986 163.557 21.8504 163.626 21.8504C163.63 21.8504 163.635 21.8504 163.64 21.8504C163.715 21.843 163.768 21.7753 163.761 21.7012Z",
    fill: "#B8BCFC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M163.872 16.1398C163.883 16.1419 163.893 16.144 163.904 16.144C163.965 16.144 164.02 16.1016 164.035 16.0392C164.085 15.8264 164.142 15.6158 164.202 15.4125C164.223 15.3406 164.183 15.2644 164.111 15.2432C164.039 15.222 163.964 15.2622 163.943 15.3353C163.881 15.5438 163.824 15.7587 163.772 15.9757C163.754 16.0487 163.799 16.1228 163.871 16.1398H163.872Z",
    fill: "#B8BCFC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M163.516 19.941C163.59 19.941 163.65 19.8786 163.649 19.8034C163.649 19.7325 163.648 19.6616 163.648 19.5917V19.5388C163.648 19.4097 163.65 19.2795 163.653 19.1524C163.655 19.0773 163.596 19.0148 163.521 19.0127C163.447 19.0117 163.385 19.0709 163.383 19.1461C163.38 19.2752 163.378 19.4075 163.378 19.5388V19.5928C163.378 19.6648 163.378 19.7357 163.379 19.8077C163.379 19.8828 163.44 19.9421 163.514 19.9421H163.515L163.516 19.941Z",
    fill: "#B8BCFC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M172.062 9.80461C172.27 9.82472 172.484 9.8533 172.697 9.88823C172.705 9.88929 172.712 9.89035 172.719 9.89035C172.784 9.89035 172.842 9.84272 172.853 9.77603C172.864 9.70193 172.815 9.63207 172.741 9.61937C172.522 9.58338 172.303 9.5548 172.088 9.53363C172.013 9.52622 171.947 9.58126 171.94 9.65642C171.933 9.73157 171.987 9.79826 172.062 9.80567V9.80461Z",
    fill: "#B8BCFC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M170.181 9.82574C170.187 9.82574 170.193 9.82574 170.198 9.82469C170.406 9.79822 170.62 9.78023 170.835 9.7707C170.909 9.76752 170.967 9.70401 170.964 9.62886C170.961 9.5537 170.898 9.49548 170.823 9.49866C170.602 9.50819 170.381 9.52724 170.165 9.55476C170.09 9.56429 170.038 9.63203 170.047 9.70719C170.055 9.77599 170.114 9.8268 170.181 9.8268V9.82574Z",
    fill: "#B8BCFC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M165.35 12.6403C165.374 12.6583 165.401 12.6668 165.429 12.6668C165.471 12.6668 165.512 12.6477 165.539 12.6107C165.665 12.436 165.798 12.2667 165.935 12.1068C165.985 12.0497 165.978 11.9639 165.922 11.9142C165.865 11.8644 165.78 11.8708 165.731 11.9279C165.588 12.0941 165.449 12.2698 165.319 12.4509C165.275 12.5122 165.289 12.5969 165.35 12.6414V12.6403Z",
    fill: "#B8BCFC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M165.412 28.4462C165.385 28.3764 165.307 28.3404 165.237 28.3679C165.168 28.3944 165.133 28.4738 165.16 28.5436C165.237 28.7479 165.317 28.9543 165.399 29.1576C165.42 29.2105 165.471 29.2423 165.524 29.2423C165.541 29.2423 165.559 29.2391 165.574 29.2327C165.644 29.2041 165.677 29.1248 165.649 29.0549C165.568 28.8538 165.488 28.6484 165.412 28.4462Z",
    fill: "#B8BCFC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M164.793 26.6447C164.77 26.5727 164.695 26.5325 164.624 26.5547C164.552 26.5769 164.512 26.6531 164.534 26.7251C164.598 26.9326 164.667 27.1443 164.736 27.3528C164.755 27.41 164.807 27.446 164.864 27.446C164.879 27.446 164.892 27.4439 164.907 27.4386C164.977 27.4142 165.016 27.337 164.992 27.266C164.923 27.0596 164.857 26.85 164.793 26.6447Z",
    fill: "#B8BCFC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M166.138 30.2055C166.107 30.1367 166.026 30.106 165.959 30.1378C165.891 30.1685 165.861 30.25 165.892 30.3177C165.981 30.5178 166.074 30.7189 166.167 30.9179C166.19 30.9666 166.238 30.9962 166.289 30.9962C166.309 30.9962 166.328 30.992 166.346 30.9835C166.414 30.9507 166.443 30.8703 166.41 30.8015C166.318 30.6046 166.226 30.4045 166.138 30.2066V30.2055Z",
    fill: "#B8BCFC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M164.292 24.8081C164.275 24.7351 164.202 24.6896 164.129 24.7075C164.057 24.7245 164.012 24.7986 164.03 24.8716C164.08 25.0833 164.134 25.2993 164.189 25.511C164.205 25.5724 164.26 25.6126 164.319 25.6126C164.331 25.6126 164.342 25.6115 164.354 25.6084C164.426 25.5893 164.469 25.5141 164.451 25.4422C164.396 25.2315 164.342 25.0188 164.293 24.8092L164.292 24.8081Z",
    fill: "#B8BCFC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M164.621 14.2471C164.708 14.047 164.8 13.8512 164.896 13.6628C164.931 13.5961 164.905 13.5135 164.839 13.4786C164.773 13.4436 164.691 13.4701 164.656 13.5368C164.556 13.7305 164.461 13.9327 164.373 14.138C164.343 14.2068 164.375 14.2873 164.443 14.3169C164.461 14.3243 164.479 14.3286 164.497 14.3286C164.549 14.3286 164.598 14.2979 164.62 14.246L164.621 14.2471Z",
    fill: "#B8BCFC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M164.034 23.5844C163.994 23.3706 163.957 23.1536 163.923 22.9409C163.911 22.8668 163.842 22.8159 163.767 22.8276C163.694 22.8392 163.644 22.9091 163.655 22.9843C163.689 23.1991 163.727 23.4182 163.767 23.6342C163.78 23.6998 163.837 23.7453 163.9 23.7453C163.908 23.7453 163.916 23.7453 163.925 23.7432C163.998 23.7295 164.047 23.6585 164.033 23.5844H164.034Z",
    fill: "#B8BCFC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M182.286 15.5947C182.313 15.6223 182.348 15.636 182.383 15.636C182.418 15.636 182.451 15.6233 182.477 15.5969C182.531 15.5439 182.532 15.4582 182.479 15.4042C182.326 15.2465 182.171 15.0898 182.017 14.9385C181.963 14.8855 181.877 14.8866 181.826 14.9406C181.773 14.9946 181.774 15.0814 181.828 15.1332C181.981 15.2835 182.135 15.4381 182.286 15.5947Z",
    fill: "#B8BCFC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M190.084 28.678C190.098 28.678 190.112 28.6759 190.124 28.6716C190.196 28.6494 190.235 28.5732 190.213 28.5012C190.149 28.2937 190.081 28.082 190.012 27.8735C189.988 27.8026 189.911 27.7634 189.841 27.7878C189.771 27.8121 189.732 27.8894 189.756 27.9603C189.824 28.1667 189.891 28.3763 189.955 28.5816C189.973 28.6399 190.027 28.678 190.084 28.678Z",
    fill: "#B8BCFC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M190.301 40.9093C190.232 40.8797 190.153 40.9114 190.123 40.9802C190.037 41.1792 189.945 41.3761 189.848 41.5635C189.814 41.6301 189.84 41.7127 189.906 41.7476C189.926 41.7582 189.947 41.7635 189.968 41.7635C190.017 41.7635 190.063 41.7371 190.088 41.6905C190.187 41.4968 190.283 41.2946 190.371 41.0892C190.4 41.0204 190.369 40.94 190.301 40.9104V40.9093Z",
    fill: "#B8BCFC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M190.618 30.5199C190.691 30.5029 190.736 30.4288 190.719 30.3558C190.669 30.1441 190.615 29.9282 190.56 29.7154C190.541 29.6424 190.466 29.599 190.395 29.618C190.323 29.6371 190.28 29.7122 190.298 29.7842C190.353 29.9948 190.406 30.2076 190.456 30.4183C190.47 30.4807 190.526 30.523 190.587 30.523C190.597 30.523 190.608 30.522 190.618 30.5188V30.5199Z",
    fill: "#B8BCFC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M190.872 39.0874C190.8 39.0694 190.727 39.115 190.71 39.188C190.659 39.3997 190.603 39.6103 190.543 39.8146C190.522 39.8866 190.562 39.9628 190.634 39.984C190.647 39.9882 190.66 39.9893 190.673 39.9893C190.731 39.9893 190.785 39.9512 190.802 39.8919C190.864 39.6834 190.922 39.4685 190.973 39.2515C190.991 39.1785 190.946 39.1044 190.873 39.0874H190.872Z",
    fill: "#B8BCFC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M186.338 44.9263C186.143 45.0078 185.942 45.0798 185.738 45.1433C185.667 45.1656 185.627 45.2418 185.648 45.3138C185.666 45.373 185.72 45.4101 185.777 45.4101C185.79 45.4101 185.803 45.408 185.817 45.4037C186.029 45.3381 186.239 45.2629 186.441 45.1783C186.511 45.1497 186.543 45.0703 186.515 45.0004C186.487 44.9306 186.407 44.8977 186.339 44.9263H186.338Z",
    fill: "#B8BCFC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M189.394 42.586C189.333 42.5415 189.249 42.5553 189.205 42.6156C189.079 42.7903 188.946 42.9596 188.808 43.1195C188.759 43.1766 188.765 43.2624 188.822 43.3121C188.847 43.3343 188.879 43.346 188.91 43.346C188.948 43.346 188.986 43.3301 189.012 43.2994C189.155 43.1343 189.293 42.9575 189.423 42.7765C189.467 42.7151 189.454 42.6304 189.394 42.586Z",
    fill: "#B8BCFC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M187.93 43.9747C187.765 44.1091 187.591 44.2362 187.415 44.3526C187.352 44.3939 187.335 44.4786 187.376 44.541C187.403 44.5812 187.446 44.6024 187.49 44.6024C187.515 44.6024 187.541 44.595 187.563 44.5802C187.747 44.4585 187.927 44.3261 188.099 44.1864C188.157 44.1388 188.166 44.053 188.12 43.9948C188.073 43.9366 187.988 43.9271 187.93 43.9736V43.9747Z",
    fill: "#B8BCFC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M188.858 24.9086C188.769 24.7086 188.676 24.5064 188.583 24.3084C188.55 24.2407 188.471 24.2111 188.402 24.2439C188.334 24.2767 188.306 24.3571 188.338 24.4259C188.431 24.6228 188.523 24.8229 188.611 25.0208C188.634 25.0716 188.683 25.1013 188.735 25.1013C188.754 25.1013 188.773 25.097 188.791 25.0896C188.859 25.0589 188.889 24.9774 188.858 24.9097V24.9086Z",
    fill: "#B8BCFC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M187.783 23.3028C187.807 23.3494 187.855 23.3758 187.903 23.3758C187.924 23.3758 187.945 23.3705 187.965 23.3599C188.031 23.325 188.057 23.2425 188.023 23.1758C187.923 22.9821 187.819 22.7862 187.714 22.5936C187.678 22.528 187.597 22.5036 187.53 22.5396C187.465 22.5756 187.441 22.6581 187.477 22.7248C187.581 22.9164 187.684 23.1101 187.782 23.3028H187.783Z",
    fill: "#B8BCFC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M184.543 45.3984C184.336 45.4249 184.122 45.4429 183.907 45.4524C183.832 45.4556 183.774 45.5191 183.777 45.5942C183.781 45.6673 183.84 45.7244 183.913 45.7244C183.915 45.7244 183.917 45.7244 183.919 45.7244C184.14 45.7149 184.362 45.6959 184.578 45.6683C184.653 45.6588 184.705 45.5911 184.696 45.5159C184.686 45.4408 184.619 45.3878 184.544 45.3973L184.543 45.3984Z",
    fill: "#B8BCFC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M189.351 26.0697C189.323 25.9998 189.244 25.9659 189.175 25.9945C189.105 26.0231 189.072 26.1025 189.1 26.1724C189.181 26.3735 189.261 26.5788 189.337 26.781C189.358 26.835 189.409 26.8689 189.463 26.8689C189.479 26.8689 189.496 26.8657 189.511 26.8604C189.581 26.8339 189.616 26.7545 189.589 26.6847C189.511 26.4804 189.432 26.274 189.35 26.0707L189.351 26.0697Z",
    fill: "#B8BCFC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M186.755 20.9338C186.715 20.8703 186.632 20.8502 186.569 20.8904C186.507 20.9306 186.487 21.0143 186.526 21.0778C186.64 21.262 186.753 21.4493 186.863 21.6367C186.888 21.6801 186.934 21.7034 186.98 21.7034C187.003 21.7034 187.027 21.697 187.049 21.6843C187.113 21.6462 187.134 21.5626 187.096 21.497C186.985 21.3085 186.871 21.1191 186.756 20.9338H186.755Z",
    fill: "#B8BCFC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M180.843 45.0628C180.639 45.0057 180.432 44.9411 180.228 44.8713C180.157 44.8469 180.081 44.8861 180.057 44.957C180.033 45.0279 180.071 45.1052 180.142 45.1295C180.352 45.2005 180.562 45.2661 180.77 45.3254C180.783 45.3285 180.794 45.3307 180.807 45.3307C180.866 45.3307 180.92 45.2915 180.937 45.2312C180.957 45.1581 180.915 45.083 180.844 45.0628H180.843Z",
    fill: "#B8BCFC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M191.165 37.1981C191.091 37.1907 191.025 37.2457 191.017 37.3198C190.996 37.5368 190.97 37.7549 190.94 37.9655C190.929 38.0396 190.981 38.1095 191.054 38.12C191.06 38.12 191.067 38.1211 191.073 38.1211C191.139 38.1211 191.197 38.0724 191.206 38.0036C191.237 37.7887 191.263 37.5675 191.285 37.3463C191.292 37.2711 191.238 37.2044 191.164 37.197L191.165 37.1981Z",
    fill: "#B8BCFC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M168.353 10.3083C168.369 10.3083 168.387 10.3051 168.404 10.2977C168.598 10.2162 168.8 10.1432 169.003 10.0807C169.075 10.0585 169.114 9.98228 169.092 9.9103C169.07 9.83832 168.995 9.7981 168.923 9.82033C168.712 9.88596 168.502 9.96217 168.3 10.0458C168.231 10.0744 168.198 10.1548 168.227 10.2236C168.249 10.2766 168.299 10.3083 168.352 10.3083H168.353Z",
    fill: "#B8BCFC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M177.4 43.5629L177.394 43.5597C177.211 43.4528 177.027 43.3417 176.845 43.2273C176.782 43.1871 176.698 43.2072 176.659 43.2707C176.619 43.3342 176.639 43.4189 176.702 43.4581C176.887 43.5745 177.076 43.6888 177.263 43.7968L177.332 43.6793L177.263 43.7968C177.285 43.8095 177.308 43.8159 177.332 43.8159C177.378 43.8159 177.423 43.7915 177.448 43.7492C177.486 43.6846 177.465 43.601 177.401 43.5618L177.4 43.5629Z",
    fill: "#B8BCFC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M183.564 16.9982C183.591 17.0299 183.628 17.0458 183.667 17.0458C183.699 17.0458 183.73 17.0352 183.755 17.013C183.812 16.9643 183.818 16.8775 183.77 16.8204C183.628 16.6542 183.483 16.488 183.338 16.325C183.287 16.2689 183.202 16.2646 183.147 16.3144C183.091 16.3652 183.087 16.4509 183.136 16.507C183.28 16.6679 183.424 16.8331 183.564 16.9971V16.9982Z",
    fill: "#B8BCFC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M179.077 44.4215C178.883 44.3358 178.686 44.2447 178.491 44.1484C178.424 44.1156 178.343 44.1442 178.311 44.2109C178.278 44.2786 178.306 44.3601 178.373 44.3929C178.571 44.4903 178.771 44.5835 178.969 44.6703C178.986 44.6777 179.004 44.6819 179.023 44.6819C179.076 44.6819 179.125 44.6512 179.147 44.6004C179.176 44.5316 179.146 44.4511 179.078 44.4204L179.077 44.4215Z",
    fill: "#B8BCFC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M190.714 31.643C190.754 31.8579 190.79 32.0739 190.824 32.2866C190.834 32.3533 190.892 32.402 190.957 32.402C190.965 32.402 190.972 32.402 190.978 32.3999C191.052 32.3882 191.102 32.3184 191.09 32.2432C191.057 32.0283 191.019 31.8092 190.978 31.5933C190.965 31.5192 190.894 31.4705 190.821 31.4843C190.747 31.498 190.699 31.5689 190.713 31.643H190.714Z",
    fill: "#B8BCFC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M185.851 20.0255C185.877 20.0647 185.92 20.0859 185.963 20.0859C185.989 20.0859 186.016 20.0785 186.039 20.0626C186.101 20.0203 186.117 19.9356 186.075 19.8731C185.955 19.6921 185.83 19.51 185.705 19.3312C185.662 19.2698 185.578 19.2549 185.517 19.2983C185.456 19.3417 185.442 19.4264 185.485 19.4878C185.608 19.6646 185.731 19.8456 185.852 20.0255H185.851Z",
    fill: "#B8BCFC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M184.752 18.4779C184.778 18.5129 184.819 18.5319 184.86 18.5319C184.889 18.5319 184.918 18.5224 184.942 18.5044C185.002 18.4589 185.014 18.3731 184.967 18.3128C184.836 18.1392 184.702 17.9646 184.568 17.7941C184.521 17.7349 184.436 17.7253 184.378 17.7719C184.319 17.8185 184.309 17.9042 184.356 17.9635C184.489 18.1329 184.622 18.3054 184.752 18.4779Z",
    fill: "#B8BCFC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M190.987 33.5259C191.009 33.7429 191.029 33.962 191.045 34.1759C191.05 34.2478 191.109 34.3018 191.179 34.3018C191.182 34.3018 191.185 34.3018 191.189 34.3018C191.264 34.2965 191.319 34.2309 191.314 34.1557C191.298 33.9387 191.279 33.7175 191.256 33.4984C191.249 33.4232 191.182 33.3692 191.109 33.3767C191.034 33.3841 190.981 33.4518 190.988 33.5259H190.987Z",
    fill: "#B8BCFC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M182.681 45.4176C182.472 45.3975 182.258 45.3689 182.045 45.334C181.972 45.3213 181.902 45.3721 181.89 45.4462C181.877 45.5203 181.928 45.5901 182.001 45.6028C182.22 45.6388 182.44 45.6685 182.655 45.6896C182.659 45.6896 182.663 45.6896 182.668 45.6896C182.738 45.6896 182.796 45.6367 182.803 45.5669C182.81 45.4917 182.756 45.425 182.681 45.4176Z",
    fill: "#B8BCFC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M170.796 13.6851C170.585 13.7497 170.377 13.827 170.177 13.9148C170.109 13.9455 170.078 14.026 170.108 14.0948C170.13 14.1456 170.179 14.1763 170.232 14.1763C170.25 14.1763 170.269 14.1721 170.286 14.1647C170.476 14.081 170.674 14.0069 170.875 13.9466C170.946 13.9254 170.987 13.8492 170.965 13.7772C170.944 13.7053 170.869 13.664 170.797 13.6862L170.796 13.6851Z",
    fill: "#B8BCFC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M172.046 13.7264C172.046 13.7264 172.053 13.7264 172.056 13.7264C172.219 13.7137 172.386 13.7073 172.553 13.7073C172.598 13.7073 172.642 13.7073 172.686 13.7084C172.759 13.7116 172.822 13.6502 172.823 13.575C172.825 13.4999 172.766 13.4374 172.691 13.4364C172.645 13.4364 172.599 13.4364 172.553 13.4353C172.379 13.4353 172.204 13.4417 172.034 13.4554C171.96 13.4618 171.904 13.5274 171.911 13.6026C171.916 13.6735 171.976 13.7285 172.045 13.7285L172.046 13.7264Z",
    fill: "#B8BCFC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M182.084 19.2296C182.11 19.2603 182.148 19.2762 182.186 19.2762C182.217 19.2762 182.249 19.2656 182.275 19.2423C182.332 19.1925 182.337 19.1068 182.288 19.0496C182.146 18.8856 182 18.7215 181.855 18.5627C181.805 18.5077 181.719 18.5034 181.664 18.5553C181.61 18.6061 181.606 18.6929 181.657 18.748C181.801 18.9046 181.945 19.0666 182.085 19.2285L182.084 19.2296Z",
    fill: "#B8BCFC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M178.896 16.2213C179.065 16.3483 179.235 16.4806 179.402 16.6161C179.427 16.6362 179.457 16.6457 179.486 16.6457C179.526 16.6457 179.565 16.6278 179.592 16.5949C179.639 16.5357 179.63 16.4499 179.571 16.4033C179.402 16.2668 179.229 16.1313 179.058 16.0032C178.998 15.9588 178.913 15.9704 178.869 16.0307C178.825 16.0911 178.837 16.1768 178.896 16.2213Z",
    fill: "#B8BCFC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M185.892 24.7912C185.824 24.824 185.796 24.9055 185.829 24.9733C185.922 25.167 186.013 25.3649 186.101 25.5597C186.125 25.6105 186.173 25.6401 186.224 25.6401C186.243 25.6401 186.262 25.6359 186.28 25.6285C186.348 25.5978 186.378 25.5163 186.347 25.4475C186.258 25.2495 186.165 25.0505 186.072 24.8547C186.04 24.787 185.959 24.7584 185.892 24.7912Z",
    fill: "#B8BCFC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M177.335 15.1818L177.343 15.1861C177.524 15.2919 177.708 15.4041 177.888 15.5195C177.91 15.5343 177.935 15.5407 177.961 15.5407C178.006 15.5407 178.049 15.5184 178.075 15.4772C178.115 15.4136 178.096 15.329 178.033 15.2887C177.849 15.1712 177.661 15.0569 177.478 14.949L177.469 14.9437C177.404 14.9066 177.323 14.9288 177.285 14.9945C177.248 15.0601 177.27 15.1427 177.335 15.1808V15.1818Z",
    fill: "#B8BCFC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M180.8 17.862C180.826 17.8875 180.859 17.9002 180.894 17.9002C180.929 17.9002 180.964 17.8864 180.991 17.8589C181.043 17.8049 181.041 17.7181 180.987 17.6662C180.832 17.5138 180.673 17.3635 180.515 17.2185C180.46 17.1677 180.375 17.1719 180.324 17.2269C180.274 17.283 180.278 17.3688 180.333 17.4196C180.489 17.5625 180.645 17.7117 180.799 17.862H180.8Z",
    fill: "#B8BCFC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M184.318 22.2463C184.344 22.2876 184.387 22.3098 184.432 22.3098C184.457 22.3098 184.483 22.3024 184.505 22.2887C184.567 22.2484 184.586 22.1638 184.545 22.1003C184.43 21.9171 184.31 21.734 184.191 21.5541C184.149 21.4916 184.065 21.4747 184.003 21.517C183.941 21.5593 183.924 21.644 183.966 21.7065C184.085 21.8843 184.203 22.0664 184.318 22.2463Z",
    fill: "#B8BCFC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M187.772 30.142C187.698 30.1579 187.652 30.2299 187.668 30.304C187.712 30.5157 187.754 30.7284 187.791 30.937C187.802 31.0026 187.859 31.0492 187.924 31.0492C187.931 31.0492 187.94 31.0492 187.948 31.0471C188.021 31.0344 188.071 30.9634 188.057 30.8893C188.019 30.6776 187.978 30.4617 187.933 30.2468C187.918 30.1727 187.846 30.1261 187.773 30.142H187.772Z",
    fill: "#B8BCFC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M187.964 32.1605C187.987 32.3754 188.006 32.5914 188.02 32.8031C188.026 32.875 188.084 32.9301 188.155 32.9301C188.158 32.9301 188.161 32.9301 188.164 32.9301C188.239 32.9248 188.295 32.8602 188.29 32.7851C188.275 32.5702 188.255 32.3511 188.232 32.133C188.224 32.0579 188.157 32.0039 188.083 32.0123C188.009 32.0208 187.955 32.0875 187.964 32.1627V32.1605Z",
    fill: "#B8BCFC"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M173.891 13.8353C174.094 13.8734 174.302 13.92 174.51 13.975C174.521 13.9782 174.533 13.9793 174.544 13.9793C174.604 13.9793 174.659 13.9391 174.675 13.8777C174.694 13.8046 174.651 13.7305 174.579 13.7115C174.365 13.6554 174.151 13.6067 173.941 13.5675C173.867 13.5538 173.797 13.6024 173.784 13.6765C173.77 13.7506 173.818 13.8216 173.892 13.8353H173.891Z",
    fill: "#B8BCFC"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M175.666 14.3605C175.859 14.4378 176.056 14.5225 176.251 14.6135C176.269 14.622 176.289 14.6262 176.308 14.6262C176.359 14.6262 176.408 14.5966 176.431 14.5468C176.462 14.478 176.433 14.3976 176.365 14.3658C176.165 14.2727 175.964 14.1859 175.766 14.1065C175.696 14.079 175.618 14.1128 175.59 14.1827C175.563 14.2526 175.597 14.3319 175.666 14.3595V14.3605Z",
    fill: "#B8BCFC"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M187.377 29.1013C187.394 29.1616 187.449 29.2018 187.507 29.2018C187.519 29.2018 187.532 29.2008 187.543 29.1966C187.616 29.1764 187.658 29.1013 187.638 29.0293C187.581 28.8218 187.52 28.6101 187.457 28.4016C187.435 28.3296 187.36 28.2894 187.288 28.3106C187.217 28.3328 187.177 28.409 187.198 28.481C187.261 28.6874 187.321 28.8959 187.376 29.1013H187.377Z",
    fill: "#B8BCFC"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M183.591 41.3528C183.39 41.4015 183.182 41.4407 182.973 41.4671C182.898 41.4767 182.846 41.5444 182.855 41.6196C182.863 41.6884 182.922 41.7392 182.989 41.7392C182.995 41.7392 183.001 41.7392 183.006 41.7381C183.225 41.7095 183.444 41.6693 183.654 41.6185C183.726 41.6005 183.771 41.5275 183.753 41.4534C183.735 41.3803 183.663 41.3348 183.59 41.3528H183.591Z",
    fill: "#B8BCFC"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M179.953 41.1664C179.755 41.1071 179.551 41.0393 179.35 40.9642C179.279 40.9388 179.202 40.9748 179.177 41.0457C179.151 41.1166 179.187 41.1949 179.257 41.2204C179.464 41.2966 179.673 41.3664 179.876 41.4278C179.889 41.4321 179.903 41.4331 179.915 41.4331C179.974 41.4331 180.027 41.395 180.044 41.3357C180.065 41.2637 180.024 41.1875 179.953 41.1664Z",
    fill: "#B8BCFC"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M181.767 41.502C181.562 41.4893 181.35 41.466 181.139 41.4343C181.065 41.4237 180.996 41.4745 180.986 41.5486C180.975 41.6227 181.025 41.6925 181.099 41.7031C181.317 41.7359 181.536 41.7592 181.75 41.773C181.754 41.773 181.756 41.773 181.759 41.773C181.829 41.773 181.889 41.7179 181.893 41.6449C181.897 41.5697 181.841 41.5052 181.766 41.4999L181.767 41.502Z",
    fill: "#B8BCFC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M183.256 20.6956C183.282 20.7316 183.323 20.7507 183.364 20.7507C183.392 20.7507 183.421 20.7422 183.445 20.7231C183.505 20.6776 183.517 20.5929 183.472 20.5326C183.343 20.358 183.211 20.1844 183.079 20.015C183.033 19.9557 182.948 19.9451 182.889 19.9917C182.83 20.0383 182.82 20.124 182.866 20.1833C182.996 20.3505 183.127 20.5231 183.255 20.6956H183.256Z",
    fill: "#B8BCFC"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M176.616 39.5439C176.441 39.4274 176.264 39.3036 176.091 39.1776C176.03 39.1342 175.946 39.148 175.902 39.2094C175.858 39.2708 175.873 39.3554 175.933 39.3999C176.11 39.528 176.29 39.6529 176.467 39.7714C176.491 39.7863 176.517 39.7937 176.542 39.7937C176.586 39.7937 176.629 39.7725 176.655 39.7323C176.696 39.6698 176.679 39.5851 176.618 39.5428L176.616 39.5439Z",
    fill: "#B8BCFC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M167.508 16.7316C167.528 16.7422 167.55 16.7474 167.571 16.7474C167.619 16.7474 167.666 16.721 167.691 16.6755C167.79 16.486 167.898 16.3018 168.013 16.1293C168.054 16.0668 168.037 15.9821 167.975 15.9398C167.913 15.8985 167.829 15.9154 167.787 15.9779C167.669 16.1589 167.555 16.3505 167.451 16.5474C167.417 16.6141 167.441 16.6966 167.507 16.7316H167.508Z",
    fill: "#B8BCFC"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M185.257 40.6149C185.084 40.7324 184.902 40.8404 184.718 40.9357C184.651 40.9695 184.624 41.0521 184.658 41.1188C184.682 41.1664 184.729 41.1939 184.778 41.1939C184.799 41.1939 184.819 41.1897 184.839 41.1791C185.034 41.0796 185.226 40.9653 185.408 40.8415C185.47 40.7991 185.486 40.7144 185.445 40.652C185.403 40.5895 185.319 40.5736 185.257 40.6149Z",
    fill: "#B8BCFC"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M187.428 38.4091C187.52 38.2143 187.607 38.01 187.686 37.8015C187.712 37.7306 187.677 37.6522 187.607 37.6258C187.538 37.5993 187.459 37.6342 187.433 37.7052C187.357 37.9063 187.273 38.1042 187.184 38.2916C187.152 38.3593 187.18 38.4408 187.247 38.4737C187.266 38.4832 187.286 38.4874 187.306 38.4874C187.356 38.4874 187.404 38.4588 187.428 38.4101V38.4091Z",
    fill: "#B8BCFC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M175.121 38.4228C174.959 38.2873 174.795 38.1465 174.635 38.0036C174.58 37.9539 174.494 37.9592 174.444 38.0153C174.395 38.0714 174.4 38.1582 174.456 38.2079C174.619 38.3529 174.784 38.4958 174.949 38.6334C174.974 38.6546 175.005 38.6652 175.035 38.6652C175.074 38.6652 175.113 38.6483 175.139 38.6154C175.186 38.5572 175.179 38.4715 175.121 38.4238V38.4228Z",
    fill: "#B8BCFC"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M188.058 35.789C187.985 35.7774 187.916 35.8271 187.903 35.9012C187.868 36.1151 187.827 36.3268 187.781 36.53C187.764 36.603 187.811 36.6761 187.883 36.693C187.894 36.6951 187.903 36.6962 187.913 36.6962C187.975 36.6962 188.031 36.6539 188.046 36.5903C188.093 36.3808 188.135 36.1638 188.171 35.9446C188.182 35.8705 188.133 35.8007 188.059 35.788L188.058 35.789Z",
    fill: "#B8BCFC"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M188.193 33.9019C188.118 33.9008 188.058 33.9611 188.057 34.0363C188.055 34.2533 188.048 34.4692 188.035 34.6788C188.031 34.754 188.087 34.8185 188.162 34.8228C188.165 34.8228 188.167 34.8228 188.17 34.8228C188.241 34.8228 188.3 34.7667 188.304 34.6947C188.316 34.4809 188.324 34.2607 188.326 34.0395C188.326 33.9643 188.267 33.9029 188.193 33.9019Z",
    fill: "#B8BCFC"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M186.754 39.3078C186.694 39.2633 186.609 39.276 186.565 39.3364C186.44 39.5078 186.305 39.673 186.165 39.8254C186.115 39.8804 186.118 39.9672 186.173 40.018C186.199 40.0424 186.232 40.054 186.264 40.054C186.301 40.054 186.336 40.0392 186.364 40.0106C186.511 39.8508 186.651 39.6783 186.782 39.4983C186.826 39.438 186.814 39.3522 186.754 39.3078Z",
    fill: "#B8BCFC"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M185.19 23.1694C185.153 23.1038 185.07 23.0816 185.005 23.1197C184.94 23.1567 184.918 23.2404 184.956 23.306C185.062 23.4923 185.167 23.6818 185.268 23.8712C185.293 23.9168 185.34 23.9422 185.387 23.9422C185.409 23.9422 185.431 23.9369 185.451 23.9252C185.517 23.8892 185.541 23.8067 185.506 23.74C185.403 23.5495 185.297 23.3568 185.19 23.1694Z",
    fill: "#B8BCFC"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M186.833 26.6023C186.805 26.5325 186.727 26.4975 186.657 26.5261C186.588 26.5536 186.554 26.633 186.582 26.7029C186.661 26.9029 186.737 27.1062 186.81 27.3073C186.83 27.3623 186.881 27.3973 186.937 27.3973C186.952 27.3973 186.968 27.3941 186.983 27.3888C187.053 27.3634 187.089 27.2851 187.064 27.2141C186.99 27.0109 186.912 26.8056 186.834 26.6034L186.833 26.6023Z",
    fill: "#B8BCFC"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M178.229 40.4795C178.042 40.3874 177.851 40.2869 177.663 40.1831C177.598 40.1471 177.516 40.1704 177.48 40.2371C177.444 40.3027 177.467 40.3864 177.533 40.4223C177.725 40.5293 177.919 40.6309 178.11 40.7251C178.129 40.7346 178.15 40.7388 178.17 40.7388C178.221 40.7388 178.268 40.7103 178.292 40.6626C178.324 40.5949 178.297 40.5134 178.23 40.4806L178.229 40.4795Z",
    fill: "#B8BCFC"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M166.58 22.2729C166.654 22.2686 166.712 22.2051 166.707 22.13C166.697 21.914 166.69 21.6981 166.688 21.4864C166.688 21.4112 166.625 21.3488 166.552 21.3509C166.477 21.3509 166.418 21.4133 166.418 21.4885C166.42 21.7034 166.426 21.9246 166.438 22.1437C166.442 22.2168 166.5 22.2729 166.572 22.2729C166.575 22.2729 166.577 22.2729 166.58 22.2729Z",
    fill: "#B8BCFC"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M166.797 24.1548C166.87 24.1432 166.92 24.0723 166.909 23.9982C166.874 23.7854 166.844 23.5705 166.818 23.3599C166.808 23.2847 166.741 23.2318 166.666 23.2413C166.592 23.2509 166.54 23.3186 166.549 23.3938C166.575 23.6076 166.607 23.8256 166.641 24.0416C166.652 24.1083 166.709 24.1559 166.775 24.1559C166.782 24.1559 166.789 24.1559 166.797 24.1538V24.1548Z",
    fill: "#B8BCFC"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M167.759 27.8154C167.829 27.79 167.866 27.7127 167.842 27.6418C167.771 27.4385 167.702 27.2321 167.638 27.0289C167.615 26.9569 167.539 26.9178 167.468 26.941C167.397 26.9643 167.358 27.0405 167.381 27.1125C167.446 27.3179 167.515 27.5264 167.588 27.7318C167.608 27.7879 167.659 27.8228 167.716 27.8228C167.73 27.8228 167.746 27.8207 167.761 27.8154H167.759Z",
    fill: "#B8BCFC"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M167.143 25.2124C167.126 25.1393 167.054 25.0927 166.981 25.1097C166.909 25.1266 166.863 25.1997 166.879 25.2727C166.927 25.4823 166.978 25.6961 167.033 25.9078C167.048 25.9692 167.103 26.0094 167.164 26.0094C167.175 26.0094 167.187 26.0084 167.198 26.0052C167.271 25.9861 167.314 25.912 167.295 25.839C167.241 25.6305 167.19 25.4188 167.143 25.2113V25.2124Z",
    fill: "#B8BCFC"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M166.903 18.513C166.962 18.513 167.018 18.4728 167.034 18.4114C167.087 18.2018 167.148 17.9965 167.215 17.7985C167.239 17.7276 167.202 17.6493 167.13 17.626C167.06 17.6017 166.982 17.6398 166.959 17.7117C166.891 17.915 166.828 18.1277 166.773 18.3437C166.754 18.4167 166.797 18.4908 166.869 18.5099C166.881 18.513 166.892 18.5141 166.903 18.5141V18.513Z",
    fill: "#B8BCFC"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M166.586 20.3792C166.586 20.3792 166.593 20.3792 166.597 20.3792C166.667 20.3792 166.726 20.3253 166.732 20.2543C166.749 20.0384 166.771 19.8235 166.8 19.616C166.81 19.5409 166.758 19.4731 166.684 19.4626C166.61 19.453 166.543 19.5049 166.532 19.579C166.504 19.7918 166.48 20.0109 166.462 20.2321C166.456 20.3073 166.511 20.3729 166.586 20.3792Z",
    fill: "#B8BCFC"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M169.049 30.5178C169.016 30.45 168.935 30.4225 168.868 30.4564C168.801 30.4903 168.773 30.5718 168.807 30.6395C168.902 30.8332 169.002 31.0291 169.103 31.2217C169.127 31.2683 169.174 31.2947 169.222 31.2947C169.243 31.2947 169.265 31.2895 169.285 31.2789C169.351 31.2439 169.377 31.1614 169.342 31.0947C169.242 30.9041 169.144 30.7104 169.049 30.5188V30.5178Z",
    fill: "#B8BCFC"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M171.21 34.5074C171.237 34.5074 171.265 34.4989 171.289 34.4809C171.35 34.4364 171.363 34.3518 171.319 34.2904C171.194 34.1178 171.069 33.9411 170.948 33.7643C170.906 33.7018 170.821 33.687 170.761 33.7294C170.699 33.7717 170.684 33.8574 170.726 33.9188C170.849 34.0977 170.974 34.2766 171.101 34.4513C171.127 34.4883 171.168 34.5074 171.21 34.5074Z",
    fill: "#B8BCFC"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M170.16 32.9375C170.184 32.9375 170.209 32.9311 170.231 32.9163C170.294 32.8761 170.314 32.7925 170.274 32.729C170.162 32.5469 170.049 32.3606 169.941 32.1764C169.904 32.1118 169.821 32.0896 169.757 32.1288C169.693 32.1669 169.671 32.2505 169.709 32.3151C169.819 32.5014 169.932 32.6898 170.045 32.874C170.07 32.9153 170.114 32.9386 170.16 32.9386V32.9375Z",
    fill: "#B8BCFC"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M172.371 35.9957C172.403 35.9957 172.433 35.9851 172.458 35.9629C172.515 35.9142 172.522 35.8284 172.474 35.7702C172.336 35.6072 172.199 35.4399 172.065 35.2727C172.017 35.2145 171.932 35.2049 171.875 35.2526C171.817 35.3002 171.808 35.386 171.855 35.4442C171.99 35.6135 172.13 35.7829 172.268 35.948C172.294 35.9798 172.333 35.9957 172.371 35.9957Z",
    fill: "#B8BCFC"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M168.277 28.7997C168.249 28.7299 168.17 28.6971 168.101 28.7256C168.032 28.7542 167.999 28.8336 168.027 28.9035C168.108 29.1035 168.193 29.3057 168.28 29.5047C168.302 29.5555 168.352 29.5862 168.404 29.5862C168.422 29.5862 168.441 29.583 168.459 29.5746C168.527 29.5439 168.558 29.4634 168.528 29.3946C168.442 29.1977 168.358 28.9977 168.277 28.7997Z",
    fill: "#B8BCFC"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M168.779 15.1925C168.929 15.0443 169.088 14.9056 169.253 14.7786C169.313 14.7331 169.323 14.6473 169.278 14.587C169.233 14.5267 169.148 14.5161 169.088 14.5616C168.915 14.695 168.747 14.841 168.589 14.9966C168.535 15.0496 168.534 15.1353 168.587 15.1893C168.613 15.2168 168.648 15.2306 168.683 15.2306C168.718 15.2306 168.751 15.2179 168.778 15.1914L168.779 15.1925Z",
    fill: "#B8BCFC"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M173.742 37.3484C173.794 37.2955 173.794 37.2087 173.742 37.1558C173.593 37.0054 173.442 36.8498 173.295 36.6932C173.243 36.6381 173.158 36.636 173.104 36.6879C173.049 36.7398 173.047 36.8255 173.098 36.8805C173.247 37.0393 173.4 37.197 173.551 37.3484C173.577 37.3749 173.611 37.3886 173.646 37.3886C173.681 37.3886 173.715 37.3749 173.742 37.3484Z",
    fill: "#B8BCFC"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8723 3.21612L48.2195 2.43175C48.251 2.4127 48.2814 2.37777 48.2993 2.33648L48.444 2.01469C48.4629 1.97341 48.4923 1.93848 48.5248 1.91943L49.4345 1.3891C49.4796 1.36264 49.5153 1.38381 49.5153 1.43568V1.67596L49.5216 3.50192C49.5216 3.55379 49.4859 3.61624 49.4408 3.6427L46.8775 5.13628C46.8324 5.16274 46.7967 5.14157 46.7967 5.0897L46.7915 3.35796C46.7915 3.30609 46.8272 3.24364 46.8723 3.21718V3.21612Z",
    fill: "#39BAE9"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1684 5.36797L44.5156 4.58361C44.5481 4.56455 44.5775 4.52962 44.5964 4.48834L44.7412 4.16655C44.7601 4.12527 44.7894 4.09033 44.822 4.07128L45.7316 3.54096C45.7768 3.5145 45.8124 3.53567 45.8124 3.58754V3.82782L45.8187 5.65377C45.8187 5.70564 45.7831 5.76809 45.7379 5.79456L43.1747 7.28813C43.1295 7.3146 43.0939 7.29343 43.0939 7.24156L43.0886 5.50981C43.0886 5.45795 43.1243 5.39444 43.1694 5.36903L43.1684 5.36797Z",
    fill: "#39BAE9"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4657 7.5191L40.8129 6.73473C40.8444 6.71568 40.8748 6.68074 40.8937 6.63946L41.0385 6.31767C41.0574 6.27639 41.0868 6.24146 41.1193 6.2224L42.029 5.69208C42.0741 5.66562 42.1098 5.68679 42.1098 5.73866V5.97894L42.1161 7.8049C42.1161 7.85677 42.0804 7.91922 42.0353 7.94568L39.472 9.43926C39.4269 9.46572 39.3912 9.44455 39.3912 9.39268L39.386 7.66094C39.386 7.60907 39.4217 7.54662 39.4668 7.52015L39.4657 7.5191Z",
    fill: "#39BAE9"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7619 9.67095L37.1091 8.88659C37.1406 8.86753 37.171 8.8326 37.1899 8.79132L37.3347 8.46953C37.3525 8.42824 37.3829 8.39331 37.4155 8.37426L38.3252 7.84394C38.3703 7.81748 38.406 7.83865 38.406 7.89051V8.1308L38.4122 9.95675C38.4122 10.0086 38.3766 10.0711 38.3315 10.0975L35.7682 11.5911C35.7241 11.6176 35.6874 11.5964 35.6874 11.5445L35.6821 9.81279C35.6821 9.76093 35.7178 9.69847 35.7629 9.67201L35.7619 9.67095Z",
    fill: "#258BE0"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M32.059 11.823L33.4062 11.0387C33.4377 11.0196 33.4681 10.9847 33.487 10.9434L33.6318 10.6216C33.6507 10.5803 33.6801 10.5454 33.7126 10.5264L34.6223 9.99604C34.6674 9.96958 34.7031 9.99075 34.7031 10.0426V10.2829L34.7094 12.1089C34.7094 12.1607 34.6737 12.2232 34.6286 12.2496L32.0653 13.7432C32.0202 13.7697 31.9845 13.7485 31.9845 13.6966L31.9792 11.9649C31.9792 11.913 32.0149 11.8506 32.06 11.8241L32.059 11.823Z",
    fill: "#258BE0"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3564 13.9749L29.7036 13.1905C29.7361 13.1715 29.7655 13.1366 29.7844 13.0953L29.9292 12.7735C29.948 12.7322 29.9774 12.6973 30.0099 12.6782L30.9196 12.1479C30.9647 12.1214 31.0004 12.1426 31.0004 12.1945V12.4348L31.0067 14.2607C31.0067 14.3126 30.971 14.375 30.9259 14.4015L28.3626 15.8951C28.3186 15.9215 28.2819 15.9004 28.2819 15.8485L28.2766 14.1167C28.2766 14.0649 28.3123 14.0024 28.3574 13.976L28.3564 13.9749Z",
    fill: "#39BAE9"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8723 6.71246L48.2195 5.92809C48.251 5.90904 48.2814 5.8741 48.2993 5.83282L48.444 5.51103C48.4629 5.46975 48.4923 5.43482 48.5248 5.41576L49.4345 4.88544C49.4796 4.85898 49.5153 4.88015 49.5153 4.93202V5.1723L49.5216 6.99826C49.5216 7.05012 49.4859 7.11258 49.4408 7.13904L46.8775 8.63262C46.8324 8.65908 46.7967 8.63791 46.7967 8.58604L46.7915 6.8543C46.7915 6.80243 46.8272 6.73998 46.8723 6.71351V6.71246Z",
    fill: "#258BE0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1684 8.86333L44.5156 8.07897C44.5481 8.05991 44.5775 8.02498 44.5964 7.9837L44.7412 7.66191C44.7601 7.62063 44.7894 7.5857 44.822 7.56664L45.7316 7.03632C45.7768 7.00986 45.8124 7.03103 45.8124 7.0829V7.32318L45.8187 9.14914C45.8187 9.201 45.7831 9.26346 45.7379 9.28992L43.1747 10.7835C43.1295 10.81 43.0939 10.7888 43.0939 10.7369L43.0886 9.00518C43.0886 8.95331 43.1243 8.89086 43.1694 8.86439L43.1684 8.86333Z",
    fill: "#39BAE9"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4657 11.0154L40.8129 10.2311C40.8444 10.212 40.8748 10.1771 40.8937 10.1358L41.0385 9.81401C41.0574 9.77273 41.0868 9.7378 41.1193 9.71874L42.029 9.18842C42.0741 9.16196 42.1098 9.18313 42.1098 9.235V9.47528L42.1161 11.3012C42.1161 11.3531 42.0804 11.4156 42.0353 11.442L39.472 12.9356C39.4269 12.9621 39.3912 12.9409 39.3912 12.889L39.386 11.1573C39.386 11.1054 39.4217 11.043 39.4668 11.0165L39.4657 11.0154Z",
    fill: "#39BAE9"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7619 13.1673L37.1091 12.3829C37.1406 12.3639 37.171 12.3289 37.1899 12.2877L37.3347 11.9659C37.3525 11.9246 37.3829 11.8896 37.4155 11.8706L38.3252 11.3403C38.3703 11.3138 38.406 11.335 38.406 11.3869V11.6271L38.4122 13.4531C38.4122 13.505 38.3766 13.5674 38.3315 13.5939L35.7682 15.0875C35.7241 15.1139 35.6874 15.0927 35.6874 15.0409L35.6821 13.3091C35.6821 13.2573 35.7178 13.1948 35.7629 13.1683L35.7619 13.1673Z",
    fill: "#39BAE9"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M32.059 15.3182L33.4062 14.5338C33.4377 14.5147 33.4681 14.4798 33.487 14.4385L33.6318 14.1167C33.6507 14.0755 33.6801 14.0405 33.7126 14.0215L34.6223 13.4912C34.6674 13.4647 34.7031 13.4859 34.7031 13.5377V13.778L34.7094 15.604C34.7094 15.6558 34.6737 15.7183 34.6286 15.7448L32.0653 17.2383C32.0202 17.2648 31.9845 17.2436 31.9845 17.1918L31.9792 15.46C31.9792 15.4081 32.0149 15.3457 32.06 15.3192L32.059 15.3182Z",
    fill: "#39BAE9"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3564 17.4703L29.7036 16.6859C29.7361 16.6668 29.7655 16.6319 29.7844 16.5906L29.9292 16.2688C29.948 16.2276 29.9774 16.1926 30.0099 16.1736L30.9196 15.6433C30.9647 15.6168 31.0004 15.638 31.0004 15.6898V15.9301L31.0067 17.7561C31.0067 17.8079 30.971 17.8704 30.9259 17.8969L28.3626 19.3904C28.3186 19.4169 28.2819 19.3957 28.2819 19.3439L28.2766 17.6121C28.2766 17.5602 28.3123 17.4978 28.3574 17.4713L28.3564 17.4703Z",
    fill: "#39BAE9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8723 10.2076L48.2195 9.42321C48.251 9.40415 48.2814 9.36922 48.2993 9.32794L48.444 9.00615C48.4629 8.96486 48.4923 8.92993 48.5248 8.91088L49.4345 8.38056C49.4796 8.3541 49.5153 8.37527 49.5153 8.42713V8.66742L49.5216 10.4934C49.5216 10.5452 49.4859 10.6077 49.4408 10.6342L46.8775 12.1277C46.8324 12.1542 46.7967 12.133 46.7967 12.0812L46.7915 10.3494C46.7915 10.2975 46.8272 10.2351 46.8723 10.2086V10.2076Z",
    fill: "#39BAE9"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1684 12.3597L44.5156 11.5753C44.5481 11.5563 44.5775 11.5213 44.5964 11.48L44.7412 11.1582C44.7601 11.117 44.7894 11.082 44.822 11.063L45.7316 10.5327C45.7768 10.5062 45.8124 10.5274 45.8124 10.5792V10.8195L45.8187 12.6455C45.8187 12.6973 45.7831 12.7598 45.7379 12.7863L43.1747 14.2798C43.1295 14.3063 43.0939 14.2851 43.0939 14.2333L43.0886 12.5015C43.0886 12.4496 43.1243 12.3872 43.1694 12.3607L43.1684 12.3597Z",
    fill: "#39BAE9"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4657 14.5115L40.8129 13.7272C40.8444 13.7081 40.8748 13.6732 40.8937 13.6319L41.0385 13.3101C41.0574 13.2688 41.0868 13.2339 41.1193 13.2148L42.029 12.6845C42.0741 12.6581 42.1098 12.6792 42.1098 12.7311V12.9714L42.1161 14.7973C42.1161 14.8492 42.0804 14.9116 42.0353 14.9381L39.472 16.4317C39.4269 16.4582 39.3912 16.437 39.3912 16.3851L39.386 14.6534C39.386 14.6015 39.4217 14.539 39.4668 14.5126L39.4657 14.5115Z",
    fill: "#39BAE9"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7619 16.6626L37.1091 15.8783C37.1406 15.8592 37.171 15.8243 37.1899 15.783L37.3347 15.4612C37.3525 15.4199 37.3829 15.385 37.4155 15.366L38.3252 14.8356C38.3703 14.8092 38.406 14.8303 38.406 14.8822V15.1225L38.4122 16.9485C38.4122 17.0003 38.3766 17.0628 38.3315 17.0892L35.7682 18.5828C35.7241 18.6093 35.6874 18.5881 35.6874 18.5362L35.6821 16.8045C35.6821 16.7526 35.7178 16.6902 35.7629 16.6637L35.7619 16.6626Z",
    fill: "#39BAE9"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M32.059 18.8145L33.4062 18.0301C33.4377 18.0111 33.4681 17.9762 33.487 17.9349L33.6318 17.6131C33.6507 17.5718 33.6801 17.5369 33.7126 17.5178L34.6223 16.9875C34.6674 16.961 34.7031 16.9822 34.7031 17.0341V17.2744L34.7094 19.1003C34.7094 19.1522 34.6737 19.2146 34.6286 19.2411L32.0653 20.7347C32.0202 20.7611 31.9845 20.74 31.9845 20.6881L31.9792 18.9563C31.9792 18.9045 32.0149 18.842 32.06 18.8156L32.059 18.8145Z",
    fill: "#39BAE9"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3564 20.9666L29.7036 20.1822C29.7361 20.1632 29.7655 20.1283 29.7844 20.087L29.9292 19.7652C29.948 19.7239 29.9774 19.689 30.0099 19.6699L30.9196 19.1396C30.9647 19.1131 31.0004 19.1343 31.0004 19.1862V19.4265L31.0067 21.2524C31.0067 21.3043 30.971 21.3667 30.9259 21.3932L28.3626 22.8868C28.3186 22.9132 28.2819 22.8921 28.2819 22.8402L28.2766 21.1084C28.2766 21.0566 28.3123 20.9941 28.3574 20.9677L28.3564 20.9666Z",
    fill: "#258BE0"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8723 13.7039L48.2195 12.9195C48.251 12.9005 48.2814 12.8656 48.2993 12.8243L48.444 12.5025C48.4629 12.4612 48.4923 12.4263 48.5248 12.4072L49.4345 11.8769C49.4796 11.8504 49.5153 11.8716 49.5153 11.9235V12.1638L49.5216 13.9897C49.5216 14.0416 49.4859 14.104 49.4408 14.1305L46.8775 15.6241C46.8324 15.6505 46.7967 15.6294 46.7967 15.5775L46.7915 13.8458C46.7915 13.7939 46.8272 13.7314 46.8723 13.705V13.7039Z",
    fill: "#258BE0"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1684 15.856L44.5156 15.0716C44.5481 15.0526 44.5775 15.0177 44.5964 14.9764L44.7412 14.6546C44.7601 14.6133 44.7894 14.5784 44.822 14.5593L45.7316 14.029C45.7768 14.0025 45.8124 14.0237 45.8124 14.0756V14.3159L45.8187 16.1418C45.8187 16.1937 45.7831 16.2561 45.7379 16.2826L43.1747 17.7762C43.1295 17.8026 43.0939 17.7815 43.0939 17.7296L43.0886 15.9979C43.0886 15.946 43.1243 15.8835 43.1694 15.8571L43.1684 15.856Z",
    fill: "#39BAE9"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4657 18.0069L40.8129 17.2225C40.8444 17.2035 40.8748 17.1685 40.8937 17.1273L41.0385 16.8055C41.0574 16.7642 41.0868 16.7293 41.1193 16.7102L42.029 16.1799C42.0741 16.1534 42.1098 16.1746 42.1098 16.2265V16.4667L42.1161 18.2927C42.1161 18.3446 42.0804 18.407 42.0353 18.4335L39.472 19.9271C39.4269 19.9535 39.3912 19.9323 39.3912 19.8805L39.386 18.1487C39.386 18.0969 39.4217 18.0344 39.4668 18.0079L39.4657 18.0069Z",
    fill: "#258BE0"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7619 20.1587L37.1091 19.3744C37.1406 19.3553 37.171 19.3204 37.1899 19.2791L37.3347 18.9573C37.3525 18.916 37.3829 18.8811 37.4155 18.8621L38.3252 18.3317C38.3703 18.3053 38.406 18.3264 38.406 18.3783V18.6186L38.4122 20.4445C38.4122 20.4964 38.3766 20.5589 38.3315 20.5853L35.7682 22.0789C35.7241 22.1054 35.6874 22.0842 35.6874 22.0323L35.6821 20.3006C35.6821 20.2487 35.7178 20.1863 35.7629 20.1598L35.7619 20.1587Z",
    fill: "#39BAE9"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M32.059 22.3108L33.4062 21.5265C33.4377 21.5074 33.4681 21.4725 33.487 21.4312L33.6318 21.1094C33.6507 21.0681 33.6801 21.0332 33.7126 21.0142L34.6223 20.4838C34.6674 20.4574 34.7031 20.4785 34.7031 20.5304V20.7707L34.7094 22.5966C34.7094 22.6485 34.6737 22.711 34.6286 22.7374L32.0653 24.231C32.0202 24.2575 31.9845 24.2363 31.9845 24.1844L31.9792 22.4527C31.9792 22.4008 32.0149 22.3384 32.06 22.3119L32.059 22.3108Z",
    fill: "#39BAE9"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3564 24.4629L29.7036 23.6786C29.7361 23.6595 29.7655 23.6246 29.7844 23.5833L29.9292 23.2615C29.948 23.2202 29.9774 23.1853 30.0099 23.1663L30.9196 22.6359C30.9647 22.6095 31.0004 22.6306 31.0004 22.6825V22.9228L31.0067 24.7487C31.0067 24.8006 30.971 24.8631 30.9259 24.8895L28.3626 26.3831C28.3186 26.4096 28.2819 26.3884 28.2819 26.3365L28.2766 24.6048C28.2766 24.5529 28.3123 24.4905 28.3574 24.464L28.3564 24.4629Z",
    fill: "#258BE0"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M48.594 44.7516V47.3968L49.5215 46.8549V44.2202L48.594 44.7516Z",
    fill: "#258BE0"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0791 46.8305V50.0273L45.0056 49.4853V46.2981L44.0791 46.8305Z",
    fill: "#258BE0"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8213 46.0197V51.3431L42.7488 50.8011V45.4873L41.8213 46.0197Z",
    fill: "#39BAE9"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5632 48.6151V52.6576L40.4908 52.1167V48.0837L39.5632 48.6151Z",
    fill: "#258BE0"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3064 48.8649V53.9733L38.2329 53.4314V48.3335L37.3064 48.8649Z",
    fill: "#258BE0"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0483 52.4227V55.2892L35.9759 54.7473V51.8914L35.0483 52.4227Z",
    fill: "#39BAE9"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7905 52.0903V56.6039L33.7181 56.0629V51.5579L32.7905 52.0903Z",
    fill: "#258BE0"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5334 52.4279V57.9195L31.4599 57.3775V51.8965L30.5334 52.4279Z",
    fill: "#258BE0"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2756 52.9784V59.2353L29.2032 58.6934V52.447L28.2756 52.9784Z",
    fill: "#39BAE9"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2798 29.9332V30.1534L35.2541 26.0781V25.8579L28.2798 29.9332Z",
    fill: "#258BE0"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2798 30.7874V31.0086L35.2541 26.9333V26.7131L28.2798 30.7874Z",
    fill: "#258BE0"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2798 32.4982V32.7183L35.2541 28.643V28.4229L28.2798 32.4982Z",
    fill: "#258BE0"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2798 35.0618V35.283L35.2541 31.2077V30.9875L28.2798 35.0618Z",
    fill: "#258BE0"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3488 27.7124L28.2798 29.5055V29.7257L31.3488 27.9326V27.7124Z",
    fill: "#258BE0"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5901 27.5717V27.7919L35.254 25.6516V25.4314L31.5901 27.5717Z",
    fill: "#258BE0"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8377 27.6978L28.2798 30.361V30.5812L32.8377 27.9179V27.6978Z",
    fill: "#258BE0"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0789 27.5569V27.7771L35.2539 26.5058V26.2856L33.0789 27.5569Z",
    fill: "#258BE0"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7664 29.1775V29.3987L35.254 27.361V27.1409L31.7664 29.1775Z",
    fill: "#258BE0"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0664 28.8462L28.2798 31.6428V31.863L33.0664 29.0664V28.8462Z",
    fill: "#258BE0"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3076 28.7055V28.9256L35.254 27.7888V27.5686L33.3076 28.7055Z",
    fill: "#258BE0"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1075 30.418L28.2798 32.0703V32.2905L31.1075 30.6381V30.418Z",
    fill: "#258BE0"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3489 30.2773V30.4975L35.2541 28.2163V27.9951L31.3489 30.2773Z",
    fill: "#258BE0"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M31.887 31.2448V31.465L35.254 29.4983V29.2781L31.887 31.2448Z",
    fill: "#258BE0"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4202 32.5289V32.7501L35.254 29.926V29.7058L30.4202 32.5289Z",
    fill: "#258BE0"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4074 31.2119L28.2798 34.2075V34.4277L33.4074 31.4321V31.2119Z",
    fill: "#258BE0"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6487 31.0702V31.2903L35.254 30.3536V30.1323L33.6487 31.0702Z",
    fill: "#258BE0"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M30.865 33.1182L28.2922 34.6223V34.8425L30.865 33.3383V33.1182Z",
    fill: "#258BE0"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1074 32.9775V33.1977L35.2666 30.7673V30.5471L31.1074 32.9775Z",
    fill: "#258BE0"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3204 33.1292L28.2798 35.4897V35.7098L32.3204 33.3493V33.1292Z",
    fill: "#258BE0"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5618 32.9883V33.2084L35.2541 31.6355V31.4153L32.5618 32.9883Z",
    fill: "#258BE0"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3005 34.7357V34.957L35.254 32.0629V31.8428L30.3005 34.7357Z",
    fill: "#258BE0"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2798 37.2679V37.488L35.2541 33.4138V33.1936L28.2798 37.2679Z",
    fill: "#258BE0"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2798 38.1232V38.3433L35.2541 34.268V34.0479L28.2798 38.1232Z",
    fill: "#258BE0"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5901 34.9062V35.1264L35.254 32.986V32.7659L31.5901 34.9062Z",
    fill: "#258BE0"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8377 35.0322L28.2798 37.6955V37.9156L32.8377 35.2535V35.0322Z",
    fill: "#258BE0"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0789 34.8914V35.1116L35.2539 33.8413V33.6201L33.0789 34.8914Z",
    fill: "#258BE0"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7664 36.513V36.7332L35.254 34.6955V34.4753L31.7664 36.513Z",
    fill: "#258BE0"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3076 36.0399V36.2601L35.254 35.1232V34.9031L33.3076 36.0399Z",
    fill: "#258BE0"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 24.3442L38.1688 23.7334V23.9536L37.1238 24.5643V24.3442Z",
    fill: "#39BAE9"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 24.7602L38.1688 24.1494V24.3696L37.1238 24.9804V24.7602Z",
    fill: "#39BAE9"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 25.1752L38.1688 24.5645V24.7846L37.1238 25.3954V25.1752Z",
    fill: "#39BAE9"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 25.5912L38.1688 24.9805V25.2006L37.1238 25.8114V25.5912Z",
    fill: "#39BAE9"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 26.006L38.1688 25.3953V25.6154L37.1238 26.2262V26.006Z",
    fill: "#39BAE9"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 26.422L38.1688 25.8113V26.0315L37.1238 26.6422V26.422Z",
    fill: "#39BAE9"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 26.8381L38.1688 26.2263V26.4475L37.1238 27.0583V26.8381Z",
    fill: "#39BAE9"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 27.2531L38.1688 26.6423V26.8625L37.1238 27.4733V27.2531Z",
    fill: "#39BAE9"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 27.6691L38.1688 27.0583V27.2785L37.1238 27.8893V27.6691Z",
    fill: "#39BAE9"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 28.0839L38.1688 27.4731V27.6933L37.1238 28.3041V28.0839Z",
    fill: "#39BAE9"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 28.4999L38.1688 27.8892V28.1093L37.1238 28.7201V28.4999Z",
    fill: "#39BAE9"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 28.915L38.1688 28.3042V28.5254L37.1238 29.1362V28.915Z",
    fill: "#39BAE9"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 29.331L38.1688 28.7202V28.9404L37.1238 29.5512V29.331Z",
    fill: "#39BAE9"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 29.747L38.1688 29.1362V29.3564L37.1238 29.9672V29.747Z",
    fill: "#39BAE9"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 30.1618L38.1688 29.551V29.7712L37.1238 30.382V30.1618Z",
    fill: "#39BAE9"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 30.5778L38.1688 29.967V30.1872L37.1238 30.798V30.5778Z",
    fill: "#39BAE9"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 30.9928L38.1688 30.3821V30.6033L37.1238 31.2141V30.9928Z",
    fill: "#39BAE9"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 31.4089L38.1688 30.7981V31.0183L37.1238 31.629V31.4089Z",
    fill: "#39BAE9"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 31.8249L38.1688 31.2141V31.4343L37.1238 32.0451V31.8249Z",
    fill: "#39BAE9"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 32.2397L38.1688 31.6289V31.8491L37.1238 32.4598V32.2397Z",
    fill: "#39BAE9"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 25.0651L36.9296 24.4543V24.6745L35.8845 25.2853V25.0651Z",
    fill: "#39BAE9"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 25.4811L36.9296 24.8704V25.0905L35.8845 25.7013V25.4811Z",
    fill: "#39BAE9"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 25.8959L36.9296 25.2852V25.5053L35.8845 26.1161V25.8959Z",
    fill: "#39BAE9"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 26.3119L36.9296 25.7012V25.9213L35.8845 26.5321V26.3119Z",
    fill: "#39BAE9"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 27.143L36.9296 26.5322V26.7524L35.8845 27.3632V27.143Z",
    fill: "#39BAE9"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 27.5591L36.9296 26.9473V27.1685L35.8845 27.7793V27.5591Z",
    fill: "#39BAE9"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 27.9738L36.9296 27.363V27.5832L35.8845 28.194V27.9738Z",
    fill: "#39BAE9"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 28.3898L36.9296 27.7791V27.9992L35.8845 28.61V28.3898Z",
    fill: "#39BAE9"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 28.8049L36.9296 28.1941V28.4143L35.8845 29.025V28.8049Z",
    fill: "#39BAE9"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 29.2209L36.9296 28.6101V28.8303L35.8845 29.4411V29.2209Z",
    fill: "#39BAE9"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 30.4679L36.9296 29.8572V30.0774L35.8845 30.6881V30.4679Z",
    fill: "#39BAE9"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 30.8827L36.9296 30.272V30.4921L35.8845 31.1029V30.8827Z",
    fill: "#39BAE9"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 31.2988L36.9296 30.688V30.9082L35.8845 31.5189V31.2988Z",
    fill: "#39BAE9"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 31.7138L36.9296 31.103V31.3243L35.8845 31.935V31.7138Z",
    fill: "#39BAE9"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 32.5458L36.9296 31.9351V32.1552L35.8845 32.766V32.5458Z",
    fill: "#39BAE9"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 32.9606L36.9296 32.3499V32.57L35.8845 33.1808V32.9606Z",
    fill: "#39BAE9"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2798 41.3843V41.6045L35.2541 37.5302V37.3101L28.2798 41.3843Z",
    fill: "#258BE0"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2798 42.2396V42.4598L35.2541 38.3845V38.1643L28.2798 42.2396Z",
    fill: "#258BE0"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2798 43.9491V44.1693L35.2541 40.095V39.8738L28.2798 43.9491Z",
    fill: "#258BE0"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2798 46.514V46.7342L35.2541 42.6589V42.4387L28.2798 46.514Z",
    fill: "#258BE0"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3488 39.1638L28.2798 40.957V41.1771L31.3488 39.384V39.1638Z",
    fill: "#258BE0"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5901 39.0229V39.2431L35.254 37.1027V36.8826L31.5901 39.0229Z",
    fill: "#258BE0"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8377 39.1487L28.2798 41.8119V42.0321L32.8377 39.3689V39.1487Z",
    fill: "#258BE0"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0789 39.0079V39.228L35.2539 37.9578V37.7366L33.0789 39.0079Z",
    fill: "#258BE0"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7664 40.6297V40.8499L35.254 38.8122V38.592L31.7664 40.6297Z",
    fill: "#258BE0"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0664 40.2971L28.2798 43.0937V43.3139L33.0664 40.5173V40.2971Z",
    fill: "#258BE0"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3076 40.1564V40.3766L35.254 39.2397V39.0195L33.3076 40.1564Z",
    fill: "#258BE0"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1075 41.8691L28.2798 43.5215V43.7417L31.1075 42.0893V41.8691Z",
    fill: "#258BE0"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3489 41.7284V41.9486L35.2541 39.6674V39.4473L31.3489 41.7284Z",
    fill: "#258BE0"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M31.887 42.696V42.9162L35.254 40.9494V40.7292L31.887 42.696Z",
    fill: "#258BE0"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4202 43.9809V44.2011L35.254 41.3769V41.1567L30.4202 43.9809Z",
    fill: "#258BE0"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4074 42.6631L28.2798 45.6587V45.8789L33.4074 42.8833V42.6631Z",
    fill: "#258BE0"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6487 42.5213V42.7425L35.254 41.8046V41.5845L33.6487 42.5213Z",
    fill: "#258BE0"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M30.865 44.5696L28.2922 46.0737V46.2939L30.865 44.7908V44.5696Z",
    fill: "#258BE0"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1074 44.4287V44.6488L35.2666 42.2185V41.9983L31.1074 44.4287Z",
    fill: "#258BE0"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3204 44.5798L28.2798 46.9403V47.1616L32.3204 44.8011V44.5798Z",
    fill: "#258BE0"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5618 44.4392V44.6594L35.2541 43.0864V42.8662L32.5618 44.4392Z",
    fill: "#258BE0"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3005 46.188V46.4081L35.254 43.5141V43.2939L30.3005 46.188Z",
    fill: "#258BE0"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2798 48.7188V48.94L35.2541 44.8647V44.6445L28.2798 48.7188Z",
    fill: "#258BE0"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2798 49.5743V49.7944L35.2541 45.7202V45.5L28.2798 49.5743Z",
    fill: "#258BE0"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5901 46.3574V46.5776L35.254 44.4372V44.217L31.5901 46.3574Z",
    fill: "#258BE0"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8377 46.4844L28.2798 49.1466V49.3667L32.8377 46.7045V46.4844Z",
    fill: "#258BE0"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0789 46.3425V46.5627L35.2539 45.2924V45.0723L33.0789 46.3425Z",
    fill: "#258BE0"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7664 47.9642V48.1843L35.254 46.1467V45.9265L31.7664 47.9642Z",
    fill: "#258BE0"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3076 47.4909V47.711L35.254 46.5742V46.354L33.3076 47.4909Z",
    fill: "#258BE0"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 35.7953L38.1688 35.1846V35.4047L37.1238 36.0155V35.7953Z",
    fill: "#39BAE9"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 36.2114L38.1688 35.6006V35.8208L37.1238 36.4315V36.2114Z",
    fill: "#39BAE9"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 36.6264L38.1688 36.0156V36.2369L37.1238 36.8476V36.6264Z",
    fill: "#39BAE9"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 37.0424L38.1688 36.4316V36.6518L37.1238 37.2626V37.0424Z",
    fill: "#39BAE9"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 37.4584L38.1688 36.8477V37.0678L37.1238 37.6786V37.4584Z",
    fill: "#39BAE9"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 37.8732L38.1688 37.2625V37.4826L37.1238 38.0934V37.8732Z",
    fill: "#39BAE9"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 38.2892L38.1688 37.6785V37.8986L37.1238 38.5094V38.2892Z",
    fill: "#39BAE9"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 38.7043L38.1688 38.0935V38.3137L37.1238 38.9244V38.7043Z",
    fill: "#39BAE9"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 39.1203L38.1688 38.5095V38.7297L37.1238 39.3405V39.1203Z",
    fill: "#39BAE9"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 39.5361L38.1688 38.9243V39.1455L37.1238 39.7563V39.5361Z",
    fill: "#39BAE9"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 39.9511L38.1688 39.3403V39.5605L37.1238 40.1713V39.9511Z",
    fill: "#39BAE9"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 40.3671L38.1688 39.7563V39.9765L37.1238 40.5873V40.3671Z",
    fill: "#39BAE9"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 40.7822L38.1688 40.1714V40.3916L37.1238 41.0023V40.7822Z",
    fill: "#39BAE9"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 41.1982L38.1688 40.5874V40.8076L37.1238 41.4183V41.1982Z",
    fill: "#39BAE9"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 41.614L38.1688 41.0022V41.2234L37.1238 41.8342V41.614Z",
    fill: "#39BAE9"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 42.029L38.1688 41.4182V41.6384L37.1238 42.2491V42.029Z",
    fill: "#39BAE9"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 42.445L38.1688 41.8342V42.0544L37.1238 42.6652V42.445Z",
    fill: "#39BAE9"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 42.86L38.1688 42.2493V42.4694L37.1238 43.0802V42.86Z",
    fill: "#39BAE9"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 43.2761L38.1688 42.6653V42.8855L37.1238 43.4962V43.2761Z",
    fill: "#39BAE9"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1238 43.6908L38.1688 43.0801V43.3013L37.1238 43.9121V43.6908Z",
    fill: "#39BAE9"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 36.5163L36.9296 35.9055V36.1257L35.8845 36.7365V36.5163Z",
    fill: "#39BAE9"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 36.9323L36.9296 36.3215V36.5417L35.8845 37.1525V36.9323Z",
    fill: "#39BAE9"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 37.3471L36.9296 36.7363V36.9576L35.8845 37.5683V37.3471Z",
    fill: "#39BAE9"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 37.7631L36.9296 37.1523V37.3725L35.8845 37.9833V37.7631Z",
    fill: "#39BAE9"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 38.5942L36.9296 37.9834V38.2036L35.8845 38.8143V38.5942Z",
    fill: "#39BAE9"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 39.0102L36.9296 38.3994V38.6196L35.8845 39.2304V39.0102Z",
    fill: "#39BAE9"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 39.425L36.9296 38.8142V39.0354L35.8845 39.6462V39.425Z",
    fill: "#39BAE9"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 39.841L36.9296 39.2302V39.4504L35.8845 40.0612V39.841Z",
    fill: "#39BAE9"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 40.257L36.9296 39.6462V39.8664L35.8845 40.4772V40.257Z",
    fill: "#39BAE9"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 40.672L36.9296 40.0613V40.2815L35.8845 40.8922V40.672Z",
    fill: "#39BAE9"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 41.9189L36.9296 41.3081V41.5283L35.8845 42.139V41.9189Z",
    fill: "#39BAE9"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 42.3349L36.9296 41.7241V41.9443L35.8845 42.5551V42.3349Z",
    fill: "#39BAE9"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 42.7499L36.9296 42.1392V42.3593L35.8845 42.9701V42.7499Z",
    fill: "#39BAE9"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 43.1659L36.9296 42.5552V42.7753L35.8845 43.3861V43.1659Z",
    fill: "#39BAE9"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 43.9968L36.9296 43.386V43.6062L35.8845 44.2169V43.9968Z",
    fill: "#39BAE9"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8845 44.4128L36.9296 43.801V44.0223L35.8845 44.633V44.4128Z",
    fill: "#39BAE9"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3362 44.4201V48.7114L47.2637 48.1705V43.8877L46.3362 44.4201Z",
    fill: "#39BAE9"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 38.5231L49.512 38.2468V37.6826L49.0388 37.9589V38.5231Z",
    fill: "#39BAE9"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3904 38.901L48.8636 38.6247V38.0605L48.3904 38.3368V38.901Z",
    fill: "#39BAE9"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 39.2799L48.2164 39.0036V38.4395L47.7432 38.7157V39.2799Z",
    fill: "#39BAE9"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 39.6578L47.5679 39.3816V38.8174L47.0947 39.0937V39.6578Z",
    fill: "#39BAE9"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 40.0368L46.9205 39.7605V39.1963L46.4463 39.4726V40.0368Z",
    fill: "#39BAE9"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 40.4147L46.272 40.1384V39.5742L45.7988 39.8505V40.4147Z",
    fill: "#258BE0"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 40.7938L45.6236 40.5176V39.9534L45.1504 40.2296V40.7938Z",
    fill: "#258BE0"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 41.1715L44.9764 40.8952V40.3311L44.5032 40.6073V41.1715Z",
    fill: "#39BAE9"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 41.5504L44.3279 41.2742V40.71L43.8547 40.9862V41.5504Z",
    fill: "#39BAE9"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 41.9284L43.6806 41.6521V41.0879L43.2063 41.3642V41.9284Z",
    fill: "#39BAE9"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 42.3075L43.032 42.0312V41.467L42.5588 41.7433V42.3075Z",
    fill: "#39BAE9"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9104 42.6852L42.3836 42.4089V41.8447L41.9104 42.121V42.6852Z",
    fill: "#258BE0"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 43.0643L41.7361 42.7881V42.2239L41.2629 42.5001V43.0643Z",
    fill: "#39BAE9"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 43.4423L41.0879 43.166V42.6018L40.6147 42.8781V43.4423Z",
    fill: "#39BAE9"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 43.8212L40.4395 43.5449V42.9807L39.9663 43.257V43.8212Z",
    fill: "#39BAE9"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3188 44.1989L39.7921 43.9226V43.3584L39.3188 43.6347V44.1989Z",
    fill: "#39BAE9"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 37.7663L49.512 37.49V36.9258L49.0388 37.2021V37.7663Z",
    fill: "#39BAE9"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3904 38.1442L48.8636 37.8679V37.3037L48.3904 37.58V38.1442Z",
    fill: "#39BAE9"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 38.5231L48.2164 38.2468V37.6826L47.7432 37.9589V38.5231Z",
    fill: "#39BAE9"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 38.901L47.5679 38.6247V38.0605L47.0947 38.3368V38.901Z",
    fill: "#39BAE9"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 39.2799L46.9205 39.0036V38.4395L46.4463 38.7157V39.2799Z",
    fill: "#39BAE9"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 39.6578L46.272 39.3816V38.8174L45.7988 39.0937V39.6578Z",
    fill: "#39BAE9"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 40.0368L45.6236 39.7605V39.1963L45.1504 39.4726V40.0368Z",
    fill: "#39BAE9"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 40.4147L44.9764 40.1384V39.5742L44.5032 39.8505V40.4147Z",
    fill: "#39BAE9"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 40.7938L44.3279 40.5176V39.9534L43.8547 40.2296V40.7938Z",
    fill: "#39BAE9"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 41.1715L43.6806 40.8952V40.3311L43.2063 40.6073V41.1715Z",
    fill: "#39BAE9"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 41.5504L43.032 41.2742V40.71L42.5588 40.9862V41.5504Z",
    fill: "#39BAE9"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9104 41.9284L42.3836 41.6521V41.0879L41.9104 41.3642V41.9284Z",
    fill: "#39BAE9"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 42.3075L41.7361 42.0312V41.467L41.2629 41.7433V42.3075Z",
    fill: "#39BAE9"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 42.6852L41.0879 42.4089V41.8447L40.6147 42.121V42.6852Z",
    fill: "#39BAE9"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 43.0643L40.4395 42.7881V42.2239L39.9663 42.5001V43.0643Z",
    fill: "#39BAE9"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3188 43.4423L39.7921 43.166V42.6018L39.3188 42.8781V43.4423Z",
    fill: "#39BAE9"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 37.0094L49.512 36.7331V36.1689L49.0388 36.4452V37.0094Z",
    fill: "#39BAE9"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3904 37.3873L48.8636 37.1111V36.5469L48.3904 36.8231V37.3873Z",
    fill: "#39BAE9"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 37.7663L48.2164 37.49V36.9258L47.7432 37.2021V37.7663Z",
    fill: "#39BAE9"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 38.1442L47.5679 37.8679V37.3037L47.0947 37.58V38.1442Z",
    fill: "#39BAE9"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 38.5231L46.9205 38.2468V37.6826L46.4463 37.9589V38.5231Z",
    fill: "#39BAE9"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 38.901L46.272 38.6247V38.0605L45.7988 38.3368V38.901Z",
    fill: "#39BAE9"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 39.2799L45.6236 39.0036V38.4395L45.1504 38.7157V39.2799Z",
    fill: "#39BAE9"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 39.6578L44.9764 39.3816V38.8174L44.5032 39.0937V39.6578Z",
    fill: "#39BAE9"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 40.0368L44.3279 39.7605V39.1963L43.8547 39.4726V40.0368Z",
    fill: "#39BAE9"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 40.4147L43.6806 40.1384V39.5742L43.2063 39.8505V40.4147Z",
    fill: "#39BAE9"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 40.7938L43.032 40.5176V39.9534L42.5588 40.2296V40.7938Z",
    fill: "#39BAE9"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9104 41.1715L42.3836 40.8952V40.3311L41.9104 40.6073V41.1715Z",
    fill: "#39BAE9"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 41.5504L41.7361 41.2742V40.71L41.2629 40.9862V41.5504Z",
    fill: "#39BAE9"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 41.9284L41.0879 41.6521V41.0879L40.6147 41.3642V41.9284Z",
    fill: "#39BAE9"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 42.3075L40.4395 42.0312V41.467L39.9663 41.7433V42.3075Z",
    fill: "#39BAE9"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3188 42.6852L39.7921 42.4089V41.8447L39.3188 42.121V42.6852Z",
    fill: "#39BAE9"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 36.2526L49.512 35.9763V35.4121L49.0388 35.6884V36.2526Z",
    fill: "#39BAE9"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3904 36.6305L48.8636 36.3542V35.79L48.3904 36.0663V36.6305Z",
    fill: "#39BAE9"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 37.0094L48.2164 36.7331V36.1689L47.7432 36.4452V37.0094Z",
    fill: "#39BAE9"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 37.3873L47.5679 37.1111V36.5469L47.0947 36.8231V37.3873Z",
    fill: "#39BAE9"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 37.7663L46.9205 37.49V36.9258L46.4463 37.2021V37.7663Z",
    fill: "#258BE0"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 38.1442L46.272 37.8679V37.3037L45.7988 37.58V38.1442Z",
    fill: "#39BAE9"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 38.5231L45.6236 38.2468V37.6826L45.1504 37.9589V38.5231Z",
    fill: "#39BAE9"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 38.901L44.9764 38.6247V38.0605L44.5032 38.3368V38.901Z",
    fill: "#39BAE9"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 39.2799L44.3279 39.0036V38.4395L43.8547 38.7157V39.2799Z",
    fill: "#39BAE9"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 39.6578L43.6806 39.3816V38.8174L43.2063 39.0937V39.6578Z",
    fill: "#39BAE9"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 40.0368L43.032 39.7605V39.1963L42.5588 39.4726V40.0368Z",
    fill: "#39BAE9"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9104 40.4147L42.3836 40.1384V39.5742L41.9104 39.8505V40.4147Z",
    fill: "#39BAE9"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 40.7938L41.7361 40.5176V39.9534L41.2629 40.2296V40.7938Z",
    fill: "#39BAE9"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 41.1715L41.0879 40.8952V40.3311L40.6147 40.6073V41.1715Z",
    fill: "#258BE0"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 41.5504L40.4395 41.2742V40.71L39.9663 40.9862V41.5504Z",
    fill: "#39BAE9"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3188 41.9284L39.7921 41.6521V41.0879L39.3188 41.3642V41.9284Z",
    fill: "#39BAE9"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 35.4957L49.512 35.2195V34.6553L49.0388 34.9315V35.4957Z",
    fill: "#39BAE9"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3904 35.8737L48.8636 35.5974V35.0332L48.3904 35.3095V35.8737Z",
    fill: "#39BAE9"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 36.2526L48.2164 35.9763V35.4121L47.7432 35.6884V36.2526Z",
    fill: "#39BAE9"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 36.6305L47.5679 36.3542V35.79L47.0947 36.0663V36.6305Z",
    fill: "#39BAE9"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 37.0094L46.9205 36.7331V36.1689L46.4463 36.4452V37.0094Z",
    fill: "#39BAE9"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 37.3873L46.272 37.1111V36.5469L45.7988 36.8231V37.3873Z",
    fill: "#39BAE9"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 37.7663L45.6236 37.49V36.9258L45.1504 37.2021V37.7663Z",
    fill: "#39BAE9"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 38.1442L44.9764 37.8679V37.3037L44.5032 37.58V38.1442Z",
    fill: "#39BAE9"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 38.5231L44.3279 38.2468V37.6826L43.8547 37.9589V38.5231Z",
    fill: "#258BE0"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 38.901L43.6806 38.6247V38.0605L43.2063 38.3368V38.901Z",
    fill: "#258BE0"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 39.2799L43.032 39.0036V38.4395L42.5588 38.7157V39.2799Z",
    fill: "#39BAE9"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9104 39.6578L42.3836 39.3816V38.8174L41.9104 39.0937V39.6578Z",
    fill: "#39BAE9"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 40.0368L41.7361 39.7605V39.1963L41.2629 39.4726V40.0368Z",
    fill: "#39BAE9"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 40.4147L41.0879 40.1384V39.5742L40.6147 39.8505V40.4147Z",
    fill: "#39BAE9"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 40.7938L40.4395 40.5176V39.9534L39.9663 40.2296V40.7938Z",
    fill: "#39BAE9"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3188 41.1715L39.7921 40.8952V40.3311L39.3188 40.6073V41.1715Z",
    fill: "#39BAE9"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 34.7389L49.512 34.4626V33.8984L49.0388 34.1747V34.7389Z",
    fill: "#39BAE9"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3904 35.1168L48.8636 34.8406V34.2764L48.3904 34.5526V35.1168Z",
    fill: "#39BAE9"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 35.4957L48.2164 35.2195V34.6553L47.7432 34.9315V35.4957Z",
    fill: "#39BAE9"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 35.8737L47.5679 35.5974V35.0332L47.0947 35.3095V35.8737Z",
    fill: "#39BAE9"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 36.2526L46.9205 35.9763V35.4121L46.4463 35.6884V36.2526Z",
    fill: "#39BAE9"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 36.6305L46.272 36.3542V35.79L45.7988 36.0663V36.6305Z",
    fill: "#39BAE9"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 37.0094L45.6236 36.7331V36.1689L45.1504 36.4452V37.0094Z",
    fill: "#39BAE9"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 37.3873L44.9764 37.1111V36.5469L44.5032 36.8231V37.3873Z",
    fill: "#39BAE9"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 37.7663L44.3279 37.49V36.9258L43.8547 37.2021V37.7663Z",
    fill: "#39BAE9"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 38.1442L43.6806 37.8679V37.3037L43.2063 37.58V38.1442Z",
    fill: "#39BAE9"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 38.5231L43.032 38.2468V37.6826L42.5588 37.9589V38.5231Z",
    fill: "#39BAE9"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9104 38.901L42.3836 38.6247V38.0605L41.9104 38.3368V38.901Z",
    fill: "#39BAE9"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 39.2799L41.7361 39.0036V38.4395L41.2629 38.7157V39.2799Z",
    fill: "#39BAE9"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 40.0368L40.4395 39.7605V39.1963L39.9663 39.4726V40.0368Z",
    fill: "#39BAE9"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3188 40.4147L39.7921 40.1384V39.5742L39.3188 39.8505V40.4147Z",
    fill: "#39BAE9"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 33.9821L49.512 33.7058V33.1416L49.0388 33.4179V33.9821Z",
    fill: "#39BAE9"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3904 34.36L48.8636 34.0837V33.5195L48.3904 33.7958V34.36Z",
    fill: "#39BAE9"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 34.7389L48.2164 34.4626V33.8984L47.7432 34.1747V34.7389Z",
    fill: "#39BAE9"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 35.1168L47.5679 34.8406V34.2764L47.0947 34.5526V35.1168Z",
    fill: "#39BAE9"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 35.4957L46.9205 35.2195V34.6553L46.4463 34.9315V35.4957Z",
    fill: "#39BAE9"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 36.2526L45.6236 35.9763V35.4121L45.1504 35.6884V36.2526Z",
    fill: "#258BE0"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 37.0094L44.3279 36.7331V36.1689L43.8547 36.4452V37.0094Z",
    fill: "#39BAE9"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 37.3873L43.6806 37.1111V36.5469L43.2063 36.8231V37.3873Z",
    fill: "#39BAE9"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 37.7663L43.032 37.49V36.9258L42.5588 37.2021V37.7663Z",
    fill: "#39BAE9"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9104 38.1442L42.3836 37.8679V37.3037L41.9104 37.58V38.1442Z",
    fill: "#39BAE9"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 38.5231L41.7361 38.2468V37.6826L41.2629 37.9589V38.5231Z",
    fill: "#39BAE9"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 38.901L41.0879 38.6247V38.0605L40.6147 38.3368V38.901Z",
    fill: "#258BE0"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 39.2799L40.4395 39.0036V38.4395L39.9663 38.7157V39.2799Z",
    fill: "#39BAE9"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3188 39.6578L39.7921 39.3816V38.8174L39.3188 39.0937V39.6578Z",
    fill: "#39BAE9"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 33.2252L49.512 32.949V32.3848L49.0388 32.661V33.2252Z",
    fill: "#39BAE9"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3904 33.6032L48.8636 33.3269V32.7627L48.3904 33.039V33.6032Z",
    fill: "#39BAE9"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 33.9821L48.2164 33.7058V33.1416L47.7432 33.4179V33.9821Z",
    fill: "#258BE0"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 34.36L47.5679 34.0837V33.5195L47.0947 33.7958V34.36Z",
    fill: "#39BAE9"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 34.7389L46.9205 34.4626V33.8984L46.4463 34.1747V34.7389Z",
    fill: "#39BAE9"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 35.1168L46.272 34.8406V34.2764L45.7988 34.5526V35.1168Z",
    fill: "#39BAE9"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 35.4957L45.6236 35.2195V34.6553L45.1504 34.9315V35.4957Z",
    fill: "#39BAE9"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 35.8737L44.9764 35.5974V35.0332L44.5032 35.3095V35.8737Z",
    fill: "#39BAE9"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 36.2526L44.3279 35.9763V35.4121L43.8547 35.6884V36.2526Z",
    fill: "#39BAE9"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 36.6305L43.6806 36.3542V35.79L43.2063 36.0663V36.6305Z",
    fill: "#39BAE9"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 37.0094L43.032 36.7331V36.1689L42.5588 36.4452V37.0094Z",
    fill: "#39BAE9"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9104 37.3873L42.3836 37.1111V36.5469L41.9104 36.8231V37.3873Z",
    fill: "#39BAE9"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 37.7663L41.7361 37.49V36.9258L41.2629 37.2021V37.7663Z",
    fill: "#39BAE9"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 38.5231L40.4395 38.2468V37.6826L39.9663 37.9589V38.5231Z",
    fill: "#39BAE9"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3188 38.901L39.7921 38.6247V38.0605L39.3188 38.3368V38.901Z",
    fill: "#39BAE9"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 32.4684L49.512 32.1921V31.6279L49.0388 31.9042V32.4684Z",
    fill: "#39BAE9"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3904 32.8463L48.8636 32.5701V32.0059L48.3904 32.2821V32.8463Z",
    fill: "#258BE0"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 33.2252L48.2164 32.949V32.3848L47.7432 32.661V33.2252Z",
    fill: "#39BAE9"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 33.6032L47.5679 33.3269V32.7627L47.0947 33.039V33.6032Z",
    fill: "#39BAE9"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 33.9821L46.9205 33.7058V33.1416L46.4463 33.4179V33.9821Z",
    fill: "#39BAE9"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 34.36L46.272 34.0837V33.5195L45.7988 33.7958V34.36Z",
    fill: "#39BAE9"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 34.7389L45.6236 34.4626V33.8984L45.1504 34.1747V34.7389Z",
    fill: "#39BAE9"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 35.4957L44.3279 35.2195V34.6553L43.8547 34.9315V35.4957Z",
    fill: "#39BAE9"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 35.8737L43.6806 35.5974V35.0332L43.2063 35.3095V35.8737Z",
    fill: "#39BAE9"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 36.2526L43.032 35.9763V35.4121L42.5588 35.6884V36.2526Z",
    fill: "#39BAE9"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9104 36.6305L42.3836 36.3542V35.79L41.9104 36.0663V36.6305Z",
    fill: "#39BAE9"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 37.0094L41.7361 36.7331V36.1689L41.2629 36.4452V37.0094Z",
    fill: "#39BAE9"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 37.3873L41.0879 37.1111V36.5469L40.6147 36.8231V37.3873Z",
    fill: "#39BAE9"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 37.7663L40.4395 37.49V36.9258L39.9663 37.2021V37.7663Z",
    fill: "#39BAE9"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3188 38.1442L39.7921 37.8679V37.3037L39.3188 37.58V38.1442Z",
    fill: "#39BAE9"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 31.7116L49.512 31.4353V30.8711L49.0388 31.1474V31.7116Z",
    fill: "#39BAE9"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3904 32.0895L48.8636 31.8132V31.249L48.3904 31.5253V32.0895Z",
    fill: "#39BAE9"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 32.8463L47.5679 32.5701V32.0059L47.0947 32.2821V32.8463Z",
    fill: "#39BAE9"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 33.2252L46.9205 32.949V32.3848L46.4463 32.661V33.2252Z",
    fill: "#39BAE9"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 33.6032L46.272 33.3269V32.7627L45.7988 33.039V33.6032Z",
    fill: "#39BAE9"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 33.9821L45.6236 33.7058V33.1416L45.1504 33.4179V33.9821Z",
    fill: "#39BAE9"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 34.36L44.9764 34.0837V33.5195L44.5032 33.7958V34.36Z",
    fill: "#39BAE9"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 34.7389L44.3279 34.4626V33.8984L43.8547 34.1747V34.7389Z",
    fill: "#39BAE9"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 35.1168L43.6806 34.8406V34.2764L43.2063 34.5526V35.1168Z",
    fill: "#39BAE9"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 35.4957L43.032 35.2195V34.6553L42.5588 34.9315V35.4957Z",
    fill: "#39BAE9"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9104 35.8737L42.3836 35.5974V35.0332L41.9104 35.3095V35.8737Z",
    fill: "#39BAE9"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 36.2526L41.7361 35.9763V35.4121L41.2629 35.6884V36.2526Z",
    fill: "#39BAE9"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 36.6305L41.0879 36.3542V35.79L40.6147 36.0663V36.6305Z",
    fill: "#39BAE9"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 37.0094L40.4395 36.7331V36.1689L39.9663 36.4452V37.0094Z",
    fill: "#39BAE9"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3188 37.3873L39.7921 37.1111V36.5469L39.3188 36.8231V37.3873Z",
    fill: "#39BAE9"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 30.9547L49.512 30.6784V30.1143L49.0388 30.3905V30.9547Z",
    fill: "#39BAE9"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3904 31.3327L48.8636 31.0564V30.4922L48.3904 30.7685V31.3327Z",
    fill: "#39BAE9"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 31.7116L48.2164 31.4353V30.8711L47.7432 31.1474V31.7116Z",
    fill: "#39BAE9"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 32.0895L47.5679 31.8132V31.249L47.0947 31.5253V32.0895Z",
    fill: "#39BAE9"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 32.4684L46.9205 32.1921V31.6279L46.4463 31.9042V32.4684Z",
    fill: "#39BAE9"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 32.8463L46.272 32.5701V32.0059L45.7988 32.2821V32.8463Z",
    fill: "#258BE0"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 33.2252L45.6236 32.949V32.3848L45.1504 32.661V33.2252Z",
    fill: "#39BAE9"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 33.6032L44.9764 33.3269V32.7627L44.5032 33.039V33.6032Z",
    fill: "#39BAE9"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 33.9821L44.3279 33.7058V33.1416L43.8547 33.4179V33.9821Z",
    fill: "#39BAE9"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 34.36L43.6806 34.0837V33.5195L43.2063 33.7958V34.36Z",
    fill: "#39BAE9"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 34.7389L43.032 34.4626V33.8984L42.5588 34.1747V34.7389Z",
    fill: "#39BAE9"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9104 35.1168L42.3836 34.8406V34.2764L41.9104 34.5526V35.1168Z",
    fill: "#39BAE9"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 35.4957L41.7361 35.2195V34.6553L41.2629 34.9315V35.4957Z",
    fill: "#39BAE9"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 35.8737L41.0879 35.5974V35.0332L40.6147 35.3095V35.8737Z",
    fill: "#39BAE9"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 36.2526L40.4395 35.9763V35.4121L39.9663 35.6884V36.2526Z",
    fill: "#39BAE9"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3904 30.5758L48.8636 30.2995V29.7354L48.3904 30.0116V30.5758Z",
    fill: "#39BAE9"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 30.9547L48.2164 30.6784V30.1143L47.7432 30.3905V30.9547Z",
    fill: "#39BAE9"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 31.3327L47.5679 31.0564V30.4922L47.0947 30.7685V31.3327Z",
    fill: "#39BAE9"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 31.7116L46.9205 31.4353V30.8711L46.4463 31.1474V31.7116Z",
    fill: "#39BAE9"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 32.0895L46.272 31.8132V31.249L45.7988 31.5253V32.0895Z",
    fill: "#39BAE9"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 32.4684L45.6236 32.1921V31.6279L45.1504 31.9042V32.4684Z",
    fill: "#39BAE9"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 32.8463L44.9764 32.5701V32.0059L44.5032 32.2821V32.8463Z",
    fill: "#39BAE9"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 33.2252L44.3279 32.949V32.3848L43.8547 32.661V33.2252Z",
    fill: "#39BAE9"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 34.7389L41.7361 34.4626V33.8984L41.2629 34.1747V34.7389Z",
    fill: "#39BAE9"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 35.4957L40.4395 35.2195V34.6553L39.9663 34.9315V35.4957Z",
    fill: "#39BAE9"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 29.4411L49.512 29.1648V28.6006L49.0388 28.8769V29.4411Z",
    fill: "#39BAE9"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3904 29.819L48.8636 29.5427V28.9785L48.3904 29.2548V29.819Z",
    fill: "#39BAE9"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 30.1979L48.2164 29.9216V29.3574L47.7432 29.6337V30.1979Z",
    fill: "#39BAE9"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 30.5758L47.5679 30.2995V29.7354L47.0947 30.0116V30.5758Z",
    fill: "#39BAE9"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 30.9547L46.9205 30.6784V30.1143L46.4463 30.3905V30.9547Z",
    fill: "#39BAE9"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 31.3327L46.272 31.0564V30.4922L45.7988 30.7685V31.3327Z",
    fill: "#39BAE9"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 31.7116L45.6236 31.4353V30.8711L45.1504 31.1474V31.7116Z",
    fill: "#39BAE9"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 32.0895L44.9764 31.8132V31.249L44.5032 31.5253V32.0895Z",
    fill: "#39BAE9"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 32.8463L43.6806 32.5701V32.0059L43.2063 32.2821V32.8463Z",
    fill: "#39BAE9"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 33.9821L41.7361 33.7058V33.1416L41.2629 33.4179V33.9821Z",
    fill: "#39BAE9"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 34.36L41.0879 34.0837V33.5195L40.6147 33.7958V34.36Z",
    fill: "#39BAE9"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 34.7389L40.4395 34.4626V33.8984L39.9663 34.1747V34.7389Z",
    fill: "#258BE0"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3188 35.1168L39.7921 34.8406V34.2764L39.3188 34.5526V35.1168Z",
    fill: "#39BAE9"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 28.6842L49.512 28.4079V27.8438L49.0388 28.12V28.6842Z",
    fill: "#39BAE9"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3904 29.0621L48.8636 28.7859V28.2217L48.3904 28.498V29.0621Z",
    fill: "#39BAE9"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 29.4411L48.2164 29.1648V28.6006L47.7432 28.8769V29.4411Z",
    fill: "#39BAE9"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 29.819L47.5679 29.5427V28.9785L47.0947 29.2548V29.819Z",
    fill: "#39BAE9"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 30.1979L46.9205 29.9216V29.3574L46.4463 29.6337V30.1979Z",
    fill: "#39BAE9"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 30.5758L46.272 30.2995V29.7354L45.7988 30.0116V30.5758Z",
    fill: "#39BAE9"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 31.3327L44.9764 31.0564V30.4922L44.5032 30.7685V31.3327Z",
    fill: "#39BAE9"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 31.7116L44.3279 31.4353V30.8711L43.8547 31.1474V31.7116Z",
    fill: "#39BAE9"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 32.0895L43.6806 31.8132V31.249L43.2063 31.5253V32.0895Z",
    fill: "#258BE0"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 33.2252L41.7361 32.949V32.3848L41.2629 32.661V33.2252Z",
    fill: "#39BAE9"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 33.6032L41.0879 33.3269V32.7627L40.6147 33.039V33.6032Z",
    fill: "#39BAE9"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 33.9821L40.4395 33.7058V33.1416L39.9663 33.4179V33.9821Z",
    fill: "#39BAE9"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 27.9274L49.512 27.6511V27.0869L49.0388 27.3632V27.9274Z",
    fill: "#39BAE9"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 28.6842L48.2164 28.4079V27.8438L47.7432 28.12V28.6842Z",
    fill: "#39BAE9"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 29.0621L47.5679 28.7859V28.2217L47.0947 28.498V29.0621Z",
    fill: "#258BE0"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 29.4411L46.9205 29.1648V28.6006L46.4463 28.8769V29.4411Z",
    fill: "#39BAE9"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 29.819L46.272 29.5427V28.9785L45.7988 29.2548V29.819Z",
    fill: "#39BAE9"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 30.1979L45.6236 29.9216V29.3574L45.1504 29.6337V30.1979Z",
    fill: "#39BAE9"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 30.5758L44.9764 30.2995V29.7354L44.5032 30.0116V30.5758Z",
    fill: "#39BAE9"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 30.9547L44.3279 30.6784V30.1143L43.8547 30.3905V30.9547Z",
    fill: "#39BAE9"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 31.3327L43.6806 31.0564V30.4922L43.2063 30.7685V31.3327Z",
    fill: "#258BE0"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 31.7116L43.032 31.4353V30.8711L42.5588 31.1474V31.7116Z",
    fill: "#39BAE9"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9104 32.0895L42.3836 31.8132V31.249L41.9104 31.5253V32.0895Z",
    fill: "#39BAE9"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 32.4684L41.7361 32.1921V31.6279L41.2629 31.9042V32.4684Z",
    fill: "#39BAE9"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 32.8463L41.0879 32.5701V32.0059L40.6147 32.2821V32.8463Z",
    fill: "#39BAE9"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 33.2252L40.4395 32.949V32.3848L39.9663 32.661V33.2252Z",
    fill: "#258BE0"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 27.1705L49.512 26.8943V26.3301L49.0388 26.6064V27.1705Z",
    fill: "#39BAE9"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3904 27.5485L48.8636 27.2722V26.708L48.3904 26.9843V27.5485Z",
    fill: "#39BAE9"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 27.9274L48.2164 27.6511V27.0869L47.7432 27.3632V27.9274Z",
    fill: "#39BAE9"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 28.3053L47.5679 28.029V27.4648L47.0947 27.7411V28.3053Z",
    fill: "#39BAE9"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 28.6842L46.9205 28.4079V27.8438L46.4463 28.12V28.6842Z",
    fill: "#39BAE9"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 29.0621L46.272 28.7859V28.2217L45.7988 28.498V29.0621Z",
    fill: "#39BAE9"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 29.4411L45.6236 29.1648V28.6006L45.1504 28.8769V29.4411Z",
    fill: "#39BAE9"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 29.819L44.9764 29.5427V28.9785L44.5032 29.2548V29.819Z",
    fill: "#258BE0"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 30.1979L44.3279 29.9216V29.3574L43.8547 29.6337V30.1979Z",
    fill: "#39BAE9"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 30.5758L43.6806 30.2995V29.7354L43.2063 30.0116V30.5758Z",
    fill: "#39BAE9"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 30.9547L43.032 30.6784V30.1143L42.5588 30.3905V30.9547Z",
    fill: "#39BAE9"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 31.7116L41.7361 31.4353V30.8711L41.2629 31.1474V31.7116Z",
    fill: "#39BAE9"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 32.0895L41.0879 31.8132V31.249L40.6147 31.5253V32.0895Z",
    fill: "#39BAE9"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 32.4684L40.4395 32.1921V31.6279L39.9663 31.9042V32.4684Z",
    fill: "#258BE0"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 26.3956L49.512 26.1194V25.5552L49.0388 25.8315V26.3956Z",
    fill: "#39BAE9"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3904 26.7746L48.8636 26.4983V25.9341L48.3904 26.2104V26.7746Z",
    fill: "#39BAE9"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 27.1525L48.2164 26.8762V26.312L47.7432 26.5883V27.1525Z",
    fill: "#39BAE9"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 27.5314L47.5679 27.2551V26.6909L47.0947 26.9672V27.5314Z",
    fill: "#39BAE9"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 27.9093L46.9205 27.633V27.0688L46.4463 27.3451V27.9093Z",
    fill: "#258BE0"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 28.6662L45.6236 28.3899V27.8257L45.1504 28.102V28.6662Z",
    fill: "#39BAE9"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 29.0451L44.9764 28.7688V28.2046L44.5032 28.4809V29.0451Z",
    fill: "#39BAE9"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 29.423L44.3279 29.1467V28.5825L43.8547 28.8588V29.423Z",
    fill: "#39BAE9"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 29.8019L43.6806 29.5256V28.9614L43.2063 29.2377V29.8019Z",
    fill: "#39BAE9"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 30.1798L43.032 29.9035V29.3394L42.5588 29.6156V30.1798Z",
    fill: "#39BAE9"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 30.9367L41.7361 30.6604V30.0962L41.2629 30.3725V30.9367Z",
    fill: "#39BAE9"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 31.6935L40.4395 31.4172V30.853L39.9663 31.1293V31.6935Z",
    fill: "#39BAE9"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3188 32.0726L39.7921 31.7964V31.2322L39.3188 31.5085V32.0726Z",
    fill: "#39BAE9"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 25.6388L49.512 25.3625V24.7983L49.0388 25.0746V25.6388Z",
    fill: "#39BAE9"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 26.3956L48.2164 26.1194V25.5552L47.7432 25.8315V26.3956Z",
    fill: "#39BAE9"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 26.7746L47.5679 26.4983V25.9341L47.0947 26.2104V26.7746Z",
    fill: "#39BAE9"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 27.1525L46.9205 26.8762V26.312L46.4463 26.5883V27.1525Z",
    fill: "#258BE0"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 27.9093L45.6236 27.633V27.0688L45.1504 27.3451V27.9093Z",
    fill: "#39BAE9"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 28.2882L44.9764 28.0119V27.4478L44.5032 27.724V28.2882Z",
    fill: "#39BAE9"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 28.6662L44.3279 28.3899V27.8257L43.8547 28.102V28.6662Z",
    fill: "#39BAE9"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 29.0451L43.6806 28.7688V28.2046L43.2063 28.4809V29.0451Z",
    fill: "#39BAE9"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 29.423L43.032 29.1467V28.5825L42.5588 28.8588V29.423Z",
    fill: "#39BAE9"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9104 29.8019L42.3836 29.5256V28.9614L41.9104 29.2377V29.8019Z",
    fill: "#39BAE9"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 30.1798L41.7361 29.9035V29.3394L41.2629 29.6156V30.1798Z",
    fill: "#39BAE9"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 30.559L41.0879 30.2827V29.7185L40.6147 29.9948V30.559Z",
    fill: "#39BAE9"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 30.9367L40.4395 30.6604V30.0962L39.9663 30.3725V30.9367Z",
    fill: "#39BAE9"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3188 31.3156L39.7921 31.0393V30.4751L39.3188 30.7514V31.3156Z",
    fill: "#39BAE9"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 24.882L49.512 24.6057V24.0415L49.0388 24.3178V24.882Z",
    fill: "#258BE0"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 25.6388L48.2164 25.3625V24.7983L47.7432 25.0746V25.6388Z",
    fill: "#39BAE9"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 26.0177L47.5679 25.7414V25.1772L47.0947 25.4535V26.0177Z",
    fill: "#39BAE9"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 26.3956L46.9205 26.1194V25.5552L46.4463 25.8315V26.3956Z",
    fill: "#39BAE9"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 26.7746L46.272 26.4983V25.9341L45.7988 26.2104V26.7746Z",
    fill: "#39BAE9"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 27.1525L45.6236 26.8762V26.312L45.1504 26.5883V27.1525Z",
    fill: "#39BAE9"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 27.5314L44.9764 27.2551V26.6909L44.5032 26.9672V27.5314Z",
    fill: "#39BAE9"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 27.9093L44.3279 27.633V27.0688L43.8547 27.3451V27.9093Z",
    fill: "#39BAE9"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 28.2882L43.6806 28.0119V27.4478L43.2063 27.724V28.2882Z",
    fill: "#39BAE9"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 28.6662L43.032 28.3899V27.8257L42.5588 28.102V28.6662Z",
    fill: "#39BAE9"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 29.423L41.7361 29.1467V28.5825L41.2629 28.8588V29.423Z",
    fill: "#39BAE9"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 29.8019L41.0879 29.5256V28.9614L40.6147 29.2377V29.8019Z",
    fill: "#39BAE9"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 30.1798L40.4395 29.9035V29.3394L39.9663 29.6156V30.1798Z",
    fill: "#39BAE9"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3188 30.559L39.7921 30.2827V29.7185L39.3188 29.9948V30.559Z",
    fill: "#39BAE9"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 24.1251L49.512 23.8489V23.2847L49.0388 23.5609V24.1251Z",
    fill: "#39BAE9"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 24.882L48.2164 24.6057V24.0415L47.7432 24.3178V24.882Z",
    fill: "#258BE0"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 25.2609L47.5679 24.9846V24.4204L47.0947 24.6967V25.2609Z",
    fill: "#39BAE9"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 25.6388L46.9205 25.3625V24.7983L46.4463 25.0746V25.6388Z",
    fill: "#39BAE9"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 26.0177L46.272 25.7414V25.1772L45.7988 25.4535V26.0177Z",
    fill: "#39BAE9"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 26.3956L45.6236 26.1194V25.5552L45.1504 25.8315V26.3956Z",
    fill: "#39BAE9"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 26.7746L44.9764 26.4983V25.9341L44.5032 26.2104V26.7746Z",
    fill: "#39BAE9"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 27.1525L44.3279 26.8762V26.312L43.8547 26.5883V27.1525Z",
    fill: "#39BAE9"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 27.9093L43.032 27.633V27.0688L42.5588 27.3451V27.9093Z",
    fill: "#39BAE9"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 28.6662L41.7361 28.3899V27.8257L41.2629 28.102V28.6662Z",
    fill: "#39BAE9"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 29.0451L41.0879 28.7688V28.2046L40.6147 28.4809V29.0451Z",
    fill: "#39BAE9"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 29.423L40.4395 29.1467V28.5825L39.9663 28.8588V29.423Z",
    fill: "#39BAE9"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 23.3683L49.512 23.092V22.5278L49.0388 22.8041V23.3683Z",
    fill: "#39BAE9"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 24.504L47.5679 24.2278V23.6636L47.0947 23.9398V24.504Z",
    fill: "#39BAE9"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 24.882L46.9205 24.6057V24.0415L46.4463 24.3178V24.882Z",
    fill: "#39BAE9"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 25.2609L46.272 24.9846V24.4204L45.7988 24.6967V25.2609Z",
    fill: "#39BAE9"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 25.6388L45.6236 25.3625V24.7983L45.1504 25.0746V25.6388Z",
    fill: "#39BAE9"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 26.3956L44.3279 26.1194V25.5552L43.8547 25.8315V26.3956Z",
    fill: "#39BAE9"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 26.7746L43.6806 26.4983V25.9341L43.2063 26.2104V26.7746Z",
    fill: "#39BAE9"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 27.1525L43.032 26.8762V26.312L42.5588 26.5883V27.1525Z",
    fill: "#39BAE9"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 27.9093L41.7361 27.633V27.0688L41.2629 27.3451V27.9093Z",
    fill: "#39BAE9"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 28.2882L41.0879 28.0119V27.4478L40.6147 27.724V28.2882Z",
    fill: "#39BAE9"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3188 29.0451L39.7921 28.7688V28.2046L39.3188 28.4809V29.0451Z",
    fill: "#39BAE9"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 22.6115L49.512 22.3352V21.771L49.0388 22.0473V22.6115Z",
    fill: "#39BAE9"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 24.1251L46.9205 23.8489V23.2847L46.4463 23.5609V24.1251Z",
    fill: "#39BAE9"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 24.504L46.272 24.2278V23.6636L45.7988 23.9398V24.504Z",
    fill: "#39BAE9"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 24.882L45.6236 24.6057V24.0415L45.1504 24.3178V24.882Z",
    fill: "#39BAE9"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 25.2609L44.9764 24.9846V24.4204L44.5032 24.6967V25.2609Z",
    fill: "#39BAE9"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 25.6388L44.3279 25.3625V24.7983L43.8547 25.0746V25.6388Z",
    fill: "#39BAE9"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 26.0177L43.6806 25.7414V25.1772L43.2063 25.4535V26.0177Z",
    fill: "#39BAE9"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 26.3956L43.032 26.1194V25.5552L42.5588 25.8315V26.3956Z",
    fill: "#39BAE9"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 27.1525L41.7361 26.8762V26.312L41.2629 26.5883V27.1525Z",
    fill: "#39BAE9"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 27.5314L41.0879 27.2551V26.6909L40.6147 26.9672V27.5314Z",
    fill: "#39BAE9"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 27.9093L40.4395 27.633V27.0688L39.9663 27.3451V27.9093Z",
    fill: "#39BAE9"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 21.8546L49.512 21.5784V21.0142L49.0388 21.2904V21.8546Z",
    fill: "#39BAE9"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 22.9904L47.5679 22.7141V22.1499L47.0947 22.4262V22.9904Z",
    fill: "#39BAE9"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 23.7472L46.272 23.4709V22.9067L45.7988 23.183V23.7472Z",
    fill: "#39BAE9"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 24.1251L45.6236 23.8489V23.2847L45.1504 23.5609V24.1251Z",
    fill: "#39BAE9"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 24.504L44.9764 24.2278V23.6636L44.5032 23.9398V24.504Z",
    fill: "#39BAE9"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 24.882L44.3279 24.6057V24.0415L43.8547 24.3178V24.882Z",
    fill: "#39BAE9"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 25.2609L43.6806 24.9846V24.4204L43.2063 24.6967V25.2609Z",
    fill: "#39BAE9"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 25.6388L43.032 25.3625V24.7983L42.5588 25.0746V25.6388Z",
    fill: "#39BAE9"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 26.7746L41.0879 26.4983V25.9341L40.6147 26.2104V26.7746Z",
    fill: "#39BAE9"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 27.1525L40.4395 26.8762V26.312L39.9663 26.5883V27.1525Z",
    fill: "#258BE0"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 21.0978L49.512 20.8215V20.2573L49.0388 20.5336V21.0978Z",
    fill: "#258BE0"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 22.2335L47.5679 21.9573V21.3931L47.0947 21.6693V22.2335Z",
    fill: "#39BAE9"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 22.6115L46.9205 22.3352V21.771L46.4463 22.0473V22.6115Z",
    fill: "#39BAE9"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 22.9904L46.272 22.7141V22.1499L45.7988 22.4262V22.9904Z",
    fill: "#39BAE9"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 23.3683L45.6236 23.092V22.5278L45.1504 22.8041V23.3683Z",
    fill: "#39BAE9"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 23.7472L44.9764 23.4709V22.9067L44.5032 23.183V23.7472Z",
    fill: "#39BAE9"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 24.1251L44.3279 23.8489V23.2847L43.8547 23.5609V24.1251Z",
    fill: "#39BAE9"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 24.882L43.032 24.6057V24.0415L42.5588 24.3178V24.882Z",
    fill: "#39BAE9"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2629 25.6388L41.7361 25.3625V24.7983L41.2629 25.0746V25.6388Z",
    fill: "#39BAE9"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6147 26.0177L41.0879 25.7414V25.1772L40.6147 25.4535V26.0177Z",
    fill: "#39BAE9"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 26.3956L40.4395 26.1194V25.5552L39.9663 25.8315V26.3956Z",
    fill: "#39BAE9"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0388 19.7768V20.341L49.512 20.0647V19.5005L49.0388 19.7768Z",
    fill: "#39BAE9"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 21.4767L47.5679 21.2004V20.6362L47.0947 20.9125V21.4767Z",
    fill: "#39BAE9"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 21.8546L46.9205 21.5784V21.0142L46.4463 21.2904V21.8546Z",
    fill: "#39BAE9"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7988 22.2335L46.272 21.9573V21.3931L45.7988 21.6693V22.2335Z",
    fill: "#39BAE9"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1504 22.6115L45.6236 22.3352V21.771L45.1504 22.0473V22.6115Z",
    fill: "#39BAE9"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 22.9904L44.9764 22.7141V22.1499L44.5032 22.4262V22.9904Z",
    fill: "#39BAE9"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 23.3683L44.3279 23.092V22.5278L43.8547 22.8041V23.3683Z",
    fill: "#258BE0"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 23.7472L43.6806 23.4709V22.9067L43.2063 23.183V23.7472Z",
    fill: "#39BAE9"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 24.1251L43.032 23.8489V23.2847L42.5588 23.5609V24.1251Z",
    fill: "#39BAE9"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9104 24.504L42.3836 24.2278V23.6636L41.9104 23.9398V24.504Z",
    fill: "#39BAE9"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 25.6388L40.4395 25.3625V24.7983L39.9663 25.0746V25.6388Z",
    fill: "#39BAE9"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 20.341L48.2164 20.0647V19.5005L47.7432 19.7768V20.341Z",
    fill: "#39BAE9"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0947 20.7199L47.5679 20.4436V19.8794L47.0947 20.1557V20.7199Z",
    fill: "#258BE0"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 21.0978L46.9205 20.8215V20.2573L46.4463 20.5336V21.0978Z",
    fill: "#39BAE9"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 22.2335L44.9764 21.9573V21.3931L44.5032 21.6693V22.2335Z",
    fill: "#39BAE9"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 22.6115L44.3279 22.3352V21.771L43.8547 22.0473V22.6115Z",
    fill: "#39BAE9"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 23.3683L43.032 23.092V22.5278L42.5588 22.8041V23.3683Z",
    fill: "#39BAE9"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9104 23.7472L42.3836 23.4709V22.9067L41.9104 23.183V23.7472Z",
    fill: "#39BAE9"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9663 24.882L40.4395 24.6057V24.0415L39.9663 24.3178V24.882Z",
    fill: "#39BAE9"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7432 19.5841L48.2164 19.3078V18.7437L47.7432 19.0199V19.5841Z",
    fill: "#39BAE9"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4463 20.341L46.9205 20.0647V19.5005L46.4463 19.7768V20.341Z",
    fill: "#39BAE9"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 21.4767L44.9764 21.2004V20.6362L44.5032 20.9125V21.4767Z",
    fill: "#39BAE9"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 21.8546L44.3279 21.5784V21.0142L43.8547 21.2904V21.8546Z",
    fill: "#39BAE9"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 22.2335L43.6806 21.9573V21.3931L43.2063 21.6693V22.2335Z",
    fill: "#39BAE9"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9104 22.9904L42.3836 22.7141V22.1499L41.9104 22.4262V22.9904Z",
    fill: "#39BAE9"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5032 20.7199L44.9764 20.4436V19.8794L44.5032 20.1557V20.7199Z",
    fill: "#39BAE9"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2063 21.4767L43.6806 21.2004V20.6362L43.2063 20.9125V21.4767Z",
    fill: "#39BAE9"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9104 22.2335L42.3836 21.9573V21.3931L41.9104 21.6693V22.2335Z",
    fill: "#39BAE9"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M145.058 9.39919L145.976 8.86675H145.977C146.275 8.68045 146.666 8.64658 147.013 8.84875L177.113 26.3631C177.78 26.7516 178.192 27.4692 178.192 28.2462V52.7891C178.192 53.0601 178.04 53.2782 177.833 53.3893L176.908 53.9281L176.761 53.5407L177.028 53.2909L146.225 35.3669C145.777 35.1065 145.5 34.6238 145.5 34.1009V9.72839C145.5 9.71357 145.503 9.70087 145.504 9.68605L145.057 9.39919H145.058Z",
    fill: "white"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M173.799 29.8044L173.805 28.7036L177.43 26.5886C177.677 26.8003 177.871 27.0639 178.003 27.3592L173.799 29.8055V29.8044Z",
    fill: "#C2E6F8"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M170.597 32.5458L178.187 28.1169C178.189 28.1593 178.191 28.2027 178.191 28.245V52.788C178.191 53.0589 178.04 53.277 177.833 53.3881L176.908 53.9269L176.761 53.5395L177.028 53.2897L170.584 49.5404L170.597 32.5458Z",
    fill: "#C2E6F8"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M146.081 9.38872L176.18 26.9031C176.847 27.2915 177.259 28.0092 177.259 28.7862V53.3291C177.259 53.8531 176.697 54.1802 176.247 53.9187L145.294 35.9069C144.846 35.6465 144.569 35.1638 144.569 34.6409V10.2705C144.569 9.48822 145.408 8.99919 146.081 9.38978V9.38872Z",
    fill: "#314467"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M145.216 33.544L176.612 51.8142V29.4253L145.216 11.1562V33.544Z",
    fill: "#2B6AB1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 21.3181V21.4854L148.759 22.9101V22.7418L146.32 21.3181Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 21.8452L148.759 23.2689V23.1017L146.32 21.678V21.8452Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 22.2052L148.759 23.6289V23.4616L146.32 22.0369V22.2052Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 22.564L148.759 23.9877V23.8204L146.32 22.3967V22.564Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 22.9238L148.759 24.3476V24.1803L146.32 22.7566V22.9238Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 23.2838L148.759 24.7075V24.5392L146.32 23.1155V23.2838Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 24.0186V24.1858L148.759 25.6106V25.4423L146.32 24.0186Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 24.5457L148.759 25.9694V25.8021L146.32 24.3784V24.5457Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 24.9056L148.759 26.3293V26.1621L146.32 24.7373V24.9056Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 25.2644L148.759 26.6892V26.5209L146.32 25.0972V25.2644Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 25.6243L148.759 27.048V26.8807L146.32 25.457V25.6243Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 25.9842L148.759 27.4079V27.2407L146.32 25.8159V25.9842Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 27.5974V27.7647L148.759 29.1894V29.0211L146.32 27.5974Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 28.1245L148.759 29.5482V29.381L146.32 27.9573V28.1245Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 28.4845L148.759 29.9082V29.7399L146.32 28.3162V28.4845Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 28.8433L148.759 30.267V30.0997L146.32 28.676V28.8433Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 29.2031L148.759 30.6269V30.4596L146.32 29.0359V29.2031Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 29.5631L148.759 30.9868V30.8185L146.32 29.3948V29.5631Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 30.2976V30.4649L148.759 31.8896V31.7213L146.32 30.2976Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 30.8247L148.759 32.2484V32.0812L146.32 30.6575V30.8247Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 31.1847L148.759 32.6084V32.4411L146.32 31.0164V31.1847Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 31.5435L148.759 32.9682V32.7999L146.32 31.3762V31.5435Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 31.9033L148.759 33.327V33.1598L146.32 31.7361V31.9033Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M146.32 32.2633L148.759 33.687V33.5197L146.32 32.095V32.2633Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M164.615 37.8217V42.9291L163.489 42.2718V37.176L164.615 37.8217Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M175.523 44.1782V49.2856L174.397 48.6282V43.5325L175.523 44.1782Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M165.978 40.5165V43.7239L164.853 43.0655V39.8708L165.978 40.5165Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M167.342 40.3061V44.518L166.217 43.8606V39.6604L167.342 40.3061Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M168.705 43.2202V45.3129L167.579 44.6555V42.5745L168.705 43.2202Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M170.069 42.2802V46.1078L168.943 45.4494V41.6345L170.069 42.2802Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M171.433 43.7895V46.9016L170.306 46.2442V43.1438L171.433 43.7895Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M159.161 35.5436V39.7555L158.036 39.0982V34.8979L159.161 35.5436Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M160.525 38.4577V40.5504L159.4 39.892V37.812L160.525 38.4577Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M161.89 37.5179V41.3444L160.763 40.6871V36.8711L161.89 37.5179Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M163.253 39.0273V42.1394L162.127 41.482V38.3816L163.253 39.0273Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M172.796 45.7351V47.6965L171.67 47.0392V45.0894L172.796 45.7351Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M174.16 46.0358V48.4916L173.034 47.8332V45.3901L174.16 46.0358Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M168.913 33.5675C168.75 33.4733 168.59 33.3293 168.429 33.1261C167.615 32.0972 166.67 29.6944 165.229 28.8581C164.435 28.3977 163.491 28.4114 162.334 29.3916C159.867 31.4833 158.483 30.9402 158.128 30.7338C158.067 30.6978 158.038 30.6735 158.036 30.6724V31.948L175.523 42.1183V30.4798C172.644 29.4573 170.719 34.6154 168.913 33.5675Z",
    fill: "white"
  }))), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M150.483 16.3293V16.9348L152.924 18.3596V17.7531L150.483 16.3293Z",
    fill: "#F3F5F7"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M150.483 17.2947L152.924 18.7184V18.5512L150.483 17.1274V17.2947Z",
    fill: "#F9E268"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M153.472 18.0769V18.6834L155.912 20.1072V19.5006L153.472 18.0769Z",
    fill: "#F3F5F7"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M153.472 19.0422L155.912 20.466V20.2987L153.472 18.875V19.0422Z",
    fill: "#F9E268"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M150.483 18.2327V18.8392L152.924 20.2629V19.6564L150.483 18.2327Z",
    fill: "#F3F5F7"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M150.483 19.1991L152.924 20.6228V20.4555L150.483 19.0308V19.1991Z",
    fill: "#F9E268"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M153.472 19.9802V20.5868L155.912 22.0115V21.405L153.472 19.9802Z",
    fill: "#F3F5F7"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M153.472 20.9465L155.912 22.3703V22.203L153.472 20.7793V20.9465Z",
    fill: "#F9E268"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M156.461 19.8245V20.431L158.9 21.8547V21.2482L156.461 19.8245Z",
    fill: "#F3F5F7"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M156.461 20.7898L158.9 22.2135V22.0463L156.461 20.6226V20.7898Z",
    fill: "#F9E268"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M159.449 21.5723V22.1788L161.89 23.6025V22.996L159.449 21.5723Z",
    fill: "#F3F5F7"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M159.449 22.5376L161.89 23.9624V23.7941L159.449 22.3704V22.5376Z",
    fill: "#F9E268"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M156.908 24.6558V24.858L150.496 21.1118V20.9097L156.908 24.6558Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M156.908 25.4412V25.6444L150.496 21.8972V21.6951L156.908 25.4412Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M156.908 27.0143V27.2164L150.496 23.4703V23.2671L156.908 27.0143Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M156.908 29.3716V29.5748L150.496 25.8277V25.6255L156.908 29.3716Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M154.086 22.614L156.908 24.2632V24.4654L154.086 22.8162V22.614Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M153.864 22.4837V22.6869L150.496 20.7191V20.5159L153.864 22.4837Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M152.717 22.6003L156.908 25.0487V25.2519L152.717 22.8036V22.6003Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M152.496 22.4711V22.6733L150.496 21.5047V21.3025L152.496 22.4711Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M153.701 23.9615V24.1637L150.496 22.2911V22.0879L153.701 23.9615Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M152.507 23.6567L156.908 26.2279V26.4301L152.507 23.8589V23.6567Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M152.285 23.5265V23.7297L150.496 22.6839V22.4817L152.285 23.5265Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M154.308 25.1013L156.908 26.6203V26.8235L154.308 25.3046V25.1013Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M154.086 24.9723V25.1744L150.496 23.0764V22.8743L154.086 24.9723Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M153.591 25.8614V26.0636L150.496 24.2556V24.0535L153.591 25.8614Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M154.939 27.0428V27.245L150.496 24.6485V24.4463L154.939 27.0428Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M152.194 25.8306L156.908 28.5859V28.7881L152.194 26.0338V25.8306Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M151.971 25.7016V25.9037L150.496 25.0421V24.8389L151.971 25.7016Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M154.53 27.5847L156.896 28.9672V29.1693L154.53 27.7869V27.5847Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M154.308 27.4545V27.6577L150.483 25.4232V25.22L154.308 27.4545Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M153.194 27.5942L156.908 29.7642V29.9674L153.194 27.7964V27.5942Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M152.971 27.464V27.6672L150.496 26.2202V26.0181L152.971 27.464Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M155.05 29.072V29.2742L150.496 26.6141V26.4109L155.05 29.072Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M156.908 32.743V32.9452L150.496 29.1991V28.9958L156.908 32.743Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M156.908 33.5283V33.7316L150.496 29.9844V29.7822L156.908 33.5283Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M156.908 35.1004V35.3036L150.496 31.5564V31.3542L156.908 35.1004Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M156.908 37.4588V37.6609L150.496 33.9148V33.7126L156.908 37.4588Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M154.086 30.7009L156.908 32.3491V32.5523L154.086 30.9031V30.7009Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M153.864 30.5708V30.7741L150.496 28.8063V28.603L153.864 30.5708Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M152.717 30.6875L156.908 33.1359V33.338L152.717 30.8897V30.6875Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M152.496 30.5572V30.7604L150.496 29.5918V29.3896L152.496 30.5572Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M153.701 32.0486V32.2508L150.496 30.3783V30.175L153.701 32.0486Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M152.507 31.7437L156.908 34.3148V34.517L152.507 31.9458V31.7437Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M152.285 31.6134V31.8167L150.496 30.7709V30.5676L152.285 31.6134Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M154.308 33.1885L156.908 34.7075V34.9107L154.308 33.3907V33.1885Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M154.086 33.0584V33.2616L150.496 31.1636V30.9614L154.086 33.0584Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M153.591 33.9486V34.1508L150.496 32.3428V32.1406L153.591 33.9486Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M154.939 35.13V35.3322L150.496 32.7356V32.5334L154.939 35.13Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M152.194 33.918L156.908 36.6722V36.8755L152.194 34.1212V33.918Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M151.971 33.7887V33.9909L150.496 33.1282V32.926L151.971 33.7887Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M154.53 35.6719L156.896 37.0543V37.2565L154.53 35.8741V35.6719Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M154.308 35.5417V35.7438L150.483 33.5104V33.3071L154.308 35.5417Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M153.194 35.6814L156.908 37.8514V38.0546L153.194 35.8836V35.6814Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M152.971 35.5512V35.7544L150.496 34.3074V34.1052L152.971 35.5512Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M155.05 37.1592V37.3614L150.496 34.7013V34.498L155.05 37.1592Z",
    fill: "white"
  })))), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M147.674 16.2995C147.845 16.399 147.983 16.6393 147.982 16.8372C147.982 17.0352 147.842 17.1146 147.672 17.0151C147.501 16.9156 147.364 16.6753 147.365 16.4773C147.365 16.2794 147.504 16.2 147.674 16.2995Z",
    fill: "#F9E268"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M146.838 15.2071C147.1 15.2008 147.389 15.2886 147.676 15.4569C147.964 15.6242 148.251 15.8719 148.514 16.1831C148.61 16.2974 148.647 16.4572 148.596 16.5398C148.56 16.597 148.492 16.6022 148.42 16.561C148.39 16.543 148.358 16.5165 148.329 16.4816C148.124 16.2381 147.899 16.0444 147.674 15.9131C147.45 15.7819 147.224 15.7131 147.019 15.7184C146.989 15.7184 146.959 15.7088 146.927 15.6909C146.856 15.6496 146.788 15.5649 146.753 15.4664C146.703 15.3257 146.74 15.2092 146.837 15.2071H146.838Z",
    fill: "#F9E268"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M146.344 14.2207C146.739 14.1402 147.201 14.245 147.68 14.5234C148.158 14.8018 148.62 15.2347 149.013 15.7756C149.103 15.8984 149.125 16.054 149.065 16.1228C149.027 16.1652 148.964 16.1641 148.901 16.1281C148.863 16.1059 148.824 16.071 148.791 16.0244C148.458 15.5682 148.069 15.2104 147.679 14.9828C147.288 14.7552 146.898 14.6589 146.564 14.7277C146.531 14.7351 146.492 14.7245 146.454 14.7023C146.391 14.6652 146.329 14.5943 146.291 14.5075C146.231 14.3678 146.255 14.2397 146.345 14.2207H146.344Z",
    fill: "#F9E268"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M147.674 20.0151C147.845 20.1146 147.983 20.3549 147.982 20.5528C147.982 20.7507 147.842 20.8301 147.672 20.7306C147.501 20.6311 147.364 20.3908 147.365 20.1929C147.366 19.995 147.504 19.9156 147.674 20.0151Z",
    fill: "#F9E268"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M146.838 18.9227C147.1 18.9163 147.389 19.0042 147.676 19.1725C147.964 19.3397 148.251 19.5874 148.514 19.8986C148.61 20.013 148.647 20.1728 148.596 20.2554C148.56 20.3125 148.492 20.3178 148.42 20.2765C148.39 20.2585 148.358 20.2321 148.329 20.1971C148.124 19.9537 147.899 19.76 147.674 19.6287C147.45 19.4975 147.224 19.4287 147.019 19.434C146.989 19.434 146.959 19.4244 146.927 19.4064C146.856 19.3651 146.788 19.2805 146.753 19.182C146.703 19.0412 146.74 18.9248 146.837 18.9227H146.838Z",
    fill: "#F9E268"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M146.344 17.9362C146.739 17.8558 147.201 17.9606 147.68 18.239C148.158 18.5174 148.62 18.9503 149.013 19.4912C149.103 19.614 149.125 19.7696 149.065 19.8384C149.027 19.8807 148.964 19.8797 148.901 19.8437C148.863 19.8215 148.824 19.7865 148.791 19.74C148.458 19.2837 148.069 18.926 147.679 18.6984C147.288 18.4708 146.898 18.3745 146.564 18.4433C146.531 18.4507 146.492 18.4401 146.454 18.4189C146.391 18.3819 146.329 18.311 146.291 18.2242C146.231 18.0844 146.255 17.9563 146.345 17.9373L146.344 17.9362Z",
    fill: "#F9E268"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6414 57.874C32.5722 57.8031 32.4924 57.7396 32.4001 57.6867L25.5528 53.7162C24.8991 53.3361 24.0943 53.3361 23.4417 53.7162L3.09705 65.5579H2.02053V70.6081C2.01843 70.9119 2.16532 71.2157 2.46331 71.3893L9.2718 75.3376C10.1574 75.8531 11.2475 75.852 12.132 75.3365L32.4011 63.5382C32.7694 63.3233 32.953 62.9497 32.9551 62.5739V57.4993L32.6404 57.874H32.6414Z",
    fill: "#C2E6F8"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4011 58.4806L12.1319 70.2789C11.9871 70.3636 11.8371 70.4324 11.6829 70.4895V75.5472C11.8371 75.49 11.9871 75.4212 12.1319 75.3365L32.4011 63.5382C32.7694 63.3233 32.953 62.9497 32.9551 62.5739V57.511C32.9551 57.8878 32.7704 58.2657 32.4011 58.4806Z",
    fill: "#39BAE9"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4011 56.5414L25.5538 52.5709C24.9002 52.1909 24.0954 52.1909 23.4428 52.5709L2.4633 64.7831C1.87258 65.1271 1.87258 65.9877 2.4633 66.3317L9.27179 70.28C10.1573 70.7955 11.2475 70.7945 12.132 70.28L32.4011 58.4817C33.1409 58.0509 33.1409 56.9733 32.4011 56.5425V56.5414Z",
    fill: "white"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27169 70.28L8.97266 70.1064V75.1641L9.27169 75.3377C9.60535 75.5324 9.96838 75.6531 10.3388 75.7007V70.6431C9.96838 70.5955 9.60535 70.4748 9.27169 70.28Z",
    fill: "#39BAE9"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4011 62.6767L12.132 74.475C11.2475 74.9905 10.1563 74.9916 9.2718 74.475L2.46331 70.5267C2.16532 70.3531 2.01843 70.0493 2.02053 69.7455V70.1308C2.01843 70.4346 2.16532 70.7384 2.46331 70.912L9.2718 74.8603C10.1574 75.3758 11.2475 75.3748 12.132 74.8603L32.4011 63.062C32.7694 62.8471 32.953 62.4735 32.9551 62.0977V61.7124C32.953 62.0871 32.7694 62.4618 32.4011 62.6767Z",
    fill: "#39BAE9"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4011 59.0131L12.132 70.8115C11.2475 71.327 10.1563 71.328 9.2718 70.8115L2.46331 66.8632C2.16532 66.6896 2.01843 66.3858 2.02053 66.082V66.4673C2.01843 66.7711 2.16532 67.0749 2.46331 67.2485L9.2718 71.1968C10.1574 71.7123 11.2475 71.7123 12.132 71.1968L32.4011 59.3984C32.7694 59.1836 32.953 58.8099 32.9551 58.4341V58.0488C32.953 58.4235 32.7694 58.7983 32.4011 59.0131Z",
    fill: "#39BAE9"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8183 63.0008C26.5727 63.1437 26.3744 63.4898 26.3755 63.7745C26.3755 64.0593 26.5759 64.1736 26.8214 64.0307C27.0669 63.8878 27.2652 63.5417 27.2642 63.2569C27.2642 62.9722 27.0638 62.8579 26.8183 63.0008Z",
    fill: "#4E5EA6"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 64.0965C26.5914 64.0361 26.5725 63.9197 26.5757 63.8265C26.583 63.6032 26.7037 63.3851 26.86 63.2295C26.9293 63.1597 27.0185 63.1046 27.116 63.0866C27.1685 63.0771 27.2241 63.0771 27.2713 63.1046L27.1223 63.0178C27.1223 63.0178 27.1118 63.0125 27.1066 63.0094C27.1045 63.0094 27.1034 63.0083 27.1013 63.0072C27.0436 62.9818 26.9765 62.9882 26.9177 63.0072C26.859 63.0263 26.8034 63.0602 26.7551 63.0983L26.7509 63.1014C26.7509 63.1014 26.7457 63.1057 26.7425 63.1078C26.5662 63.2549 26.4403 63.4857 26.4235 63.7164C26.4151 63.8265 26.4361 63.9641 26.5411 64.0255L26.69 64.1123C26.69 64.1123 26.6817 64.1071 26.6775 64.1049L26.6743 64.1028C26.6743 64.1028 26.6691 64.0986 26.6659 64.0965H26.667Z",
    fill: "white"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9798 63.1333C26.7531 63.2656 26.5706 63.5853 26.5706 63.8478C26.5706 64.1103 26.7552 64.2162 26.9819 64.0839C27.2085 63.9515 27.3911 63.6319 27.3911 63.3694C27.3911 63.1069 27.2064 63.001 26.9798 63.1323V63.1333Z",
    fill: "url(#paint0_linear_917_439)"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0353 62.2903C27.7898 62.4332 27.5915 62.7793 27.5925 63.0641C27.5925 63.3488 27.7929 63.4631 28.0385 63.3202C28.284 63.1773 28.4823 62.8312 28.4812 62.5465C28.4812 62.2617 28.2808 62.1474 28.0353 62.2903Z",
    fill: "#4E5EA6"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M27.884 63.3858C27.8085 63.3254 27.7896 63.209 27.7927 63.1158C27.8001 62.8914 27.9207 62.6744 28.0771 62.5188C28.1463 62.449 28.2355 62.3939 28.3331 62.3759C28.3855 62.3664 28.4411 62.3664 28.4884 62.3939L28.3394 62.3071C28.3394 62.3071 28.3289 62.3018 28.3236 62.2987C28.3215 62.2987 28.3205 62.2976 28.3184 62.2965C28.2607 62.2711 28.1935 62.2775 28.1348 62.2965C28.076 62.3156 28.0204 62.3495 27.9721 62.3876C27.9711 62.3886 27.969 62.3897 27.9679 62.3908C27.9648 62.3929 27.9627 62.395 27.9595 62.3971C27.7833 62.5442 27.6574 62.775 27.6406 63.0058C27.6322 63.1158 27.6532 63.2535 27.7581 63.3149L27.9071 63.4017C27.9071 63.4017 27.8987 63.3964 27.8945 63.3942L27.8913 63.3921C27.8913 63.3921 27.8861 63.3879 27.883 63.3858H27.884Z",
    fill: "white"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1968 62.4227C27.9702 62.555 27.7876 62.8746 27.7876 63.1372C27.7876 63.3997 27.9723 63.5055 28.1989 63.3743C28.4255 63.2419 28.6081 62.9223 28.6081 62.6598C28.6081 62.3973 28.4234 62.2914 28.1968 62.4237V62.4227Z",
    fill: "url(#paint1_linear_917_439)"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2526 61.5791C29.0071 61.722 28.8088 62.0682 28.8098 62.3529C28.8098 62.6377 29.0102 62.752 29.2557 62.6091C29.5013 62.4662 29.6996 62.12 29.6985 61.8353C29.6985 61.5505 29.4981 61.4362 29.2526 61.5791Z",
    fill: "#4E5EA6"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1013 62.6748C29.0257 62.6145 29.0069 62.4981 29.01 62.4049C29.0174 62.1805 29.138 61.9635 29.2943 61.8079C29.3636 61.738 29.4528 61.684 29.5504 61.665C29.6028 61.6555 29.6584 61.6555 29.7056 61.683L29.5567 61.5962C29.5567 61.5962 29.5462 61.5909 29.5409 61.5877C29.5388 61.5877 29.5378 61.5867 29.5357 61.5856C29.478 61.5602 29.4108 61.5666 29.3521 61.5856C29.2933 61.6047 29.2377 61.6385 29.1894 61.6766L29.1852 61.6798C29.1852 61.6798 29.18 61.684 29.1768 61.6862C29.0006 61.8333 28.8747 62.0641 28.8579 62.2948C28.8495 62.4049 28.8705 62.5425 28.9754 62.6039L29.1244 62.6907C29.1244 62.6907 29.116 62.6854 29.1118 62.6833L29.1086 62.6812C29.1086 62.6812 29.1034 62.677 29.1002 62.6748H29.1013Z",
    fill: "white"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4141 61.7128C29.1875 61.8451 29.0049 62.1648 29.0049 62.4273C29.0049 62.6898 29.1896 62.7957 29.4162 62.6633C29.6428 62.531 29.8254 62.2113 29.8254 61.9488C29.8254 61.6863 29.6407 61.5805 29.4141 61.7128Z",
    fill: "url(#paint2_linear_917_439)"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4696 60.8689C30.2241 61.0118 30.0258 61.358 30.0269 61.6427C30.0269 61.9274 30.2273 62.0418 30.4728 61.8989C30.7183 61.756 30.9166 61.4098 30.9156 61.1251C30.9156 60.8403 30.7152 60.726 30.4696 60.8689Z",
    fill: "#4E5EA6"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3174 61.9644C30.2418 61.904 30.2229 61.7876 30.2261 61.6944C30.2334 61.47 30.3541 61.253 30.5104 61.0974C30.5797 61.0276 30.6689 60.9736 30.7664 60.9545C30.8189 60.945 30.8745 60.945 30.9217 60.9725L30.7727 60.8857C30.7727 60.8857 30.7622 60.8804 30.757 60.8773C30.7549 60.8773 30.7538 60.8762 30.7517 60.8752C30.694 60.8497 30.6269 60.8561 30.5681 60.8752C30.5094 60.8942 30.4538 60.9281 30.4055 60.9662L30.4013 60.9694C30.4013 60.9694 30.396 60.9736 30.3929 60.9757C30.2166 61.1228 30.0907 61.3536 30.0739 61.5844C30.0655 61.6944 30.0865 61.8321 30.1914 61.8934L30.3404 61.9802C30.3404 61.9802 30.332 61.9749 30.3278 61.9728L30.3247 61.9707C30.3247 61.9707 30.3195 61.9665 30.3163 61.9644H30.3174Z",
    fill: "white"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6311 61.0022C30.4045 61.1345 30.2219 61.4542 30.2219 61.7167C30.2219 61.9792 30.4066 62.0851 30.6332 61.9528C30.8599 61.8204 31.0424 61.5008 31.0424 61.2383C31.0424 60.9758 30.8578 60.8699 30.6311 61.0012V61.0022Z",
    fill: "url(#paint3_linear_917_439)"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6867 60.1585C31.4412 60.3014 31.2429 60.6475 31.2439 60.9323C31.2439 61.217 31.4443 61.3313 31.6898 61.1884C31.9353 61.0455 32.1336 60.6994 32.1326 60.4146C32.1326 60.1299 31.9322 60.0156 31.6867 60.1585Z",
    fill: "#4E5EA6"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5344 61.2542C31.4588 61.1938 31.44 61.0774 31.4431 60.9842C31.4505 60.7598 31.5711 60.5428 31.7275 60.3872C31.7967 60.3174 31.8859 60.2634 31.9835 60.2443C32.0359 60.2348 32.0915 60.2348 32.1388 60.2623L31.9898 60.1755C31.9898 60.1755 31.9793 60.1702 31.974 60.1671C31.9719 60.1671 31.9709 60.166 31.9688 60.1649C31.9111 60.1395 31.8439 60.1459 31.7852 60.1649C31.7264 60.184 31.6708 60.2179 31.6225 60.256L31.6183 60.2592C31.6183 60.2592 31.6131 60.2634 31.6099 60.2655C31.4337 60.4126 31.3078 60.6434 31.291 60.8742C31.2826 60.9842 31.3036 61.1218 31.4085 61.1832L31.5575 61.27C31.5575 61.27 31.5491 61.2647 31.5449 61.2626L31.5417 61.2605C31.5417 61.2605 31.5365 61.2563 31.5333 61.2542H31.5344Z",
    fill: "white"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8482 60.2911C31.6215 60.4234 31.439 60.7431 31.439 61.0056C31.439 61.2681 31.6236 61.3739 31.8503 61.2427C32.0769 61.1104 32.2595 60.7907 32.2595 60.5282C32.2595 60.2657 32.0748 60.1598 31.8482 60.2921V60.2911Z",
    fill: "url(#paint4_linear_917_439)"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8183 64.4326C26.5727 64.5755 26.3744 64.9217 26.3755 65.2064C26.3755 65.4912 26.5759 65.6055 26.8214 65.4626C27.0669 65.3197 27.2652 64.9736 27.2642 64.6888C27.2642 64.4041 27.0638 64.2897 26.8183 64.4326Z",
    fill: "#4E5EA6"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 65.5283C26.5914 65.468 26.5725 65.3516 26.5757 65.2584C26.583 65.034 26.7037 64.817 26.86 64.6614C26.9293 64.5915 27.0185 64.5376 27.116 64.5185C27.1685 64.509 27.2241 64.509 27.2713 64.5365L27.1223 64.4497C27.1223 64.4497 27.1118 64.4444 27.1066 64.4412C27.1045 64.4412 27.1034 64.4402 27.1013 64.4391C27.0436 64.4137 26.9765 64.4201 26.9177 64.4391C26.859 64.4582 26.8034 64.492 26.7551 64.5302C26.7541 64.5312 26.752 64.5323 26.7509 64.5333C26.7478 64.5354 26.7457 64.5376 26.7425 64.5397C26.5662 64.6868 26.4403 64.9176 26.4235 65.1483C26.4151 65.2584 26.4361 65.396 26.5411 65.4574L26.69 65.5442C26.69 65.5442 26.6817 65.5389 26.6775 65.5368L26.6743 65.5347C26.6743 65.5347 26.6691 65.5305 26.6659 65.5283H26.667Z",
    fill: "white"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9798 64.5651C26.7531 64.6974 26.5706 65.0171 26.5706 65.2796C26.5706 65.5421 26.7552 65.6479 26.9819 65.5156C27.2085 65.3833 27.3911 65.0636 27.3911 64.8011C27.3911 64.5386 27.2064 64.4328 26.9798 64.5651Z",
    fill: "url(#paint5_linear_917_439)"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0353 63.7224C27.7898 63.8653 27.5915 64.2115 27.5925 64.4962C27.5925 64.781 27.7929 64.8953 28.0385 64.7524C28.284 64.6095 28.4823 64.2634 28.4812 63.9786C28.4812 63.6939 28.2808 63.5795 28.0353 63.7224Z",
    fill: "#4E5EA6"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M27.884 64.818C27.8085 64.7577 27.7896 64.6412 27.7927 64.5481C27.8001 64.3237 27.9207 64.1067 28.0771 63.9511C28.1463 63.8812 28.2355 63.8272 28.3331 63.8082C28.3855 63.7987 28.4411 63.7987 28.4884 63.8262L28.3394 63.7394C28.3394 63.7394 28.3289 63.7341 28.3236 63.7309C28.3215 63.7309 28.3205 63.7299 28.3184 63.7288C28.2607 63.7034 28.1935 63.7087 28.1348 63.7288C28.076 63.7478 28.0204 63.7817 27.9721 63.8198L27.9679 63.823C27.9679 63.823 27.9627 63.8272 27.9595 63.8294C27.7833 63.9765 27.6574 64.2073 27.6406 64.438C27.6322 64.5481 27.6532 64.6857 27.7581 64.7471L27.9071 64.8339C27.9071 64.8339 27.8987 64.8286 27.8945 64.8265L27.8913 64.8244C27.8913 64.8244 27.8861 64.8201 27.883 64.818H27.884Z",
    fill: "white"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1968 63.8547C27.9702 63.987 27.7876 64.3067 27.7876 64.5692C27.7876 64.8317 27.9723 64.9375 28.1989 64.8063C28.4255 64.674 28.6081 64.3543 28.6081 64.0918C28.6081 63.8293 28.4234 63.7234 28.1968 63.8547Z",
    fill: "url(#paint6_linear_917_439)"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2526 63.0122C29.0071 63.1551 28.8088 63.5013 28.8098 63.786C28.8098 64.0708 29.0102 64.1851 29.2557 64.0422C29.5013 63.8993 29.6996 63.5531 29.6985 63.2684C29.6985 62.9836 29.4981 62.8693 29.2526 63.0122Z",
    fill: "#4E5EA6"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1013 64.1078C29.0257 64.0475 29.0069 63.931 29.01 63.8379C29.0174 63.6135 29.138 63.3965 29.2943 63.2409C29.3636 63.171 29.4528 63.116 29.5504 63.098C29.6028 63.0885 29.6584 63.0885 29.7056 63.116L29.5567 63.0292C29.5567 63.0292 29.5462 63.0239 29.5409 63.0207C29.5388 63.0207 29.5378 63.0196 29.5357 63.0186C29.478 62.9932 29.4108 62.9985 29.3521 63.0186C29.2933 63.0376 29.2377 63.0715 29.1894 63.1096L29.1852 63.1128C29.1852 63.1128 29.18 63.117 29.1768 63.1192C29.0006 63.2663 28.8747 63.497 28.8579 63.7278C28.8495 63.8379 28.8705 63.9755 28.9754 64.0369L29.1244 64.1237C29.1244 64.1237 29.116 64.1184 29.1118 64.1163L29.1086 64.1142C29.1086 64.1142 29.1034 64.1099 29.1002 64.1078H29.1013Z",
    fill: "white"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4141 63.1447C29.1875 63.277 29.0049 63.5967 29.0049 63.8592C29.0049 64.1217 29.1896 64.2275 29.4162 64.0952C29.6428 63.9629 29.8254 63.6432 29.8254 63.3807C29.8254 63.1182 29.6407 63.0123 29.4141 63.1447Z",
    fill: "url(#paint7_linear_917_439)"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4696 62.3018C30.2241 62.4447 30.0258 62.7908 30.0269 63.0756C30.0269 63.3603 30.2273 63.4746 30.4728 63.3317C30.7183 63.1888 30.9166 62.8427 30.9156 62.5579C30.9156 62.2732 30.7152 62.1589 30.4696 62.3018Z",
    fill: "#4E5EA6"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3174 63.3972C30.2418 63.3369 30.2229 63.2205 30.2261 63.1273C30.2334 62.9029 30.3541 62.6859 30.5104 62.5303C30.5797 62.4604 30.6689 62.4054 30.7664 62.3874C30.8189 62.3779 30.8745 62.3779 30.9217 62.4054L30.7727 62.3186C30.7727 62.3186 30.7622 62.3133 30.757 62.3101C30.7549 62.3101 30.7538 62.3091 30.7517 62.308C30.694 62.2826 30.6269 62.289 30.5681 62.308C30.5094 62.3271 30.4538 62.3609 30.4055 62.399L30.4013 62.4022L30.3929 62.4086C30.2166 62.5557 30.0907 62.7865 30.0739 63.0172C30.0655 63.1273 30.0865 63.2649 30.1914 63.3263L30.3404 63.4131C30.3404 63.4131 30.332 63.4078 30.3278 63.4057L30.3247 63.4036C30.3247 63.4036 30.3195 63.3994 30.3163 63.3972H30.3174Z",
    fill: "white"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6311 62.434C30.4045 62.5663 30.2219 62.886 30.2219 63.1485C30.2219 63.411 30.4066 63.5169 30.6332 63.3845C30.8599 63.2522 31.0424 62.9325 31.0424 62.67C31.0424 62.4075 30.8578 62.3017 30.6311 62.434Z",
    fill: "url(#paint8_linear_917_439)"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6867 61.5916C31.4412 61.7345 31.2429 62.0806 31.2439 62.3654C31.2439 62.6501 31.4443 62.7644 31.6898 62.6215C31.9353 62.4786 32.1336 62.1325 32.1326 61.8477C32.1326 61.563 31.9322 61.4487 31.6867 61.5916Z",
    fill: "#4E5EA6"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5344 62.6873C31.4588 62.6269 31.44 62.5105 31.4431 62.4174C31.4505 62.193 31.5711 61.976 31.7275 61.8203C31.7967 61.7505 31.8859 61.6954 31.9835 61.6774C32.0359 61.6679 32.0915 61.6679 32.1388 61.6954L31.9898 61.6086C31.9898 61.6086 31.9793 61.6033 31.974 61.6002C31.9719 61.6002 31.9709 61.5991 31.9688 61.5981C31.9111 61.5727 31.8439 61.579 31.7852 61.5981C31.7264 61.6171 31.6708 61.651 31.6225 61.6891L31.6183 61.6923C31.6183 61.6923 31.6131 61.6965 31.6099 61.6986C31.4337 61.8458 31.3078 62.0765 31.291 62.3073C31.2826 62.4174 31.3036 62.555 31.4085 62.6164L31.5575 62.7032C31.5575 62.7032 31.5491 62.6979 31.5449 62.6957L31.5417 62.6936C31.5417 62.6936 31.5365 62.6894 31.5333 62.6873H31.5344Z",
    fill: "white"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8482 61.7241C31.6215 61.8564 31.439 62.1761 31.439 62.4386C31.439 62.7011 31.6236 62.807 31.8503 62.6747C32.0769 62.5424 32.2595 62.2227 32.2595 61.9602C32.2595 61.6977 32.0748 61.5918 31.8482 61.7231V61.7241Z",
    fill: "url(#paint9_linear_917_439)"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6343 70.9787L25.6872 66.2821V63.6199L17.6343 68.3165V70.9787Z",
    fill: "#258BE0"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M17.928 70.4854L18.7023 70.0344V69.7253L17.928 70.1763V70.4854Z",
    fill: "white"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9312 69.9044L19.7055 69.4524V69.1433L18.9312 69.5942V69.9044Z",
    fill: "white"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9343 69.3221L20.7087 68.8712V68.561L19.9343 69.013V69.3221Z",
    fill: "white"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9404 68.1588L22.7148 67.7079V67.3977L21.9404 67.8486V68.1588Z",
    fill: "white"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9446 67.5767L23.7179 67.1257V66.8167L22.9446 67.2676V67.5767Z",
    fill: "white"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M17.928 68.7791L18.7023 68.3281V68.019L17.928 68.47V68.7791Z",
    fill: "white"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9312 68.1981L19.7055 67.7472V67.437L18.9312 67.8879V68.1981Z",
    fill: "white"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9343 67.6157L20.7087 67.1648V66.8557L19.9343 67.3066V67.6157Z",
    fill: "white"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9404 66.4525L22.7148 66.0016V65.6914L21.9404 66.1434V66.4525Z",
    fill: "white"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9446 65.8714L23.7179 65.4194V65.1104L22.9446 65.5613V65.8714Z",
    fill: "white"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7085 68.3112V68.1768L17.928 69.7984V69.9328L20.7085 68.3112Z",
    fill: "white"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7085 68.036V67.9016L17.928 69.5233V69.6577L20.7085 68.036Z",
    fill: "white"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7085 67.7609V67.6265L17.928 69.2481V69.3826L20.7085 67.7609Z",
    fill: "white"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3577 71.3894V74.0526L17.3478 71.1417V68.4795L12.3577 71.3894Z",
    fill: "#258BE0"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 70.5639V70.4294L12.5381 72.0511V72.1866L15.3186 70.5639Z",
    fill: "white"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 70.2895V70.1541L12.5381 71.7757V71.9112L15.3186 70.2895Z",
    fill: "white"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 70.0143V69.8799L12.5381 71.5015V71.636L15.3186 70.0143Z",
    fill: "white"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 71.8002V71.6658L12.5381 73.2874V73.4219L15.3186 71.8002Z",
    fill: "white"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 71.5251V71.3906L12.5381 73.0123V73.1467L15.3186 71.5251Z",
    fill: "white"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 71.2497V71.1152L12.5381 72.7369V72.8713L15.3186 71.2497Z",
    fill: "white"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6414 51.9177C32.5722 51.8468 32.4924 51.7833 32.4001 51.7304L25.5528 47.7599C24.8991 47.3799 24.0943 47.3799 23.4417 47.7599L3.09705 59.6016H2.02053V64.6518C2.01843 64.9556 2.16532 65.2594 2.46331 65.433L9.2718 69.3813C10.1574 69.8968 11.2475 69.8957 12.132 69.3813L32.4011 57.583C32.7694 57.3681 32.953 56.9944 32.9551 56.6187V51.5441L32.6404 51.9188L32.6414 51.9177Z",
    fill: "#C2E6F8"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4011 52.5243L12.1319 64.3226C11.9871 64.4073 11.8371 64.4761 11.6829 64.5333V69.5909C11.8371 69.5337 11.9871 69.4649 12.1319 69.3802L32.4011 57.5819C32.7694 57.367 32.953 56.9934 32.9551 56.6176V51.5547C32.9551 51.9315 32.7704 52.3094 32.4011 52.5243Z",
    fill: "#39BAE9"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4011 50.5851L25.5538 46.6146C24.9002 46.2346 24.0954 46.2346 23.4428 46.6146L2.4633 58.8268C1.87258 59.1708 1.87258 60.0314 2.4633 60.3754L9.27179 64.3237C10.1573 64.8392 11.2475 64.8381 12.132 64.3237L32.4011 52.5254C33.1409 52.0946 33.1409 51.017 32.4011 50.5862V50.5851Z",
    fill: "white"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27169 64.3237L8.97266 64.1501V69.2078L9.27169 69.3814C9.60535 69.5761 9.96838 69.6968 10.3388 69.7444V64.6868C9.96838 64.6392 9.60535 64.5185 9.27169 64.3237Z",
    fill: "#39BAE9"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4011 56.7192L12.132 68.5175C11.2475 69.033 10.1563 69.0341 9.2718 68.5175L2.46331 64.5692C2.16532 64.3956 2.01843 64.0918 2.02053 63.788V64.1733C2.01843 64.4771 2.16532 64.7809 2.46331 64.9545L9.2718 68.9028C10.1574 69.4183 11.2475 69.4173 12.132 68.9028L32.4011 57.1045C32.7694 56.8896 32.953 56.516 32.9551 56.1402V55.7549C32.953 56.1296 32.7694 56.5043 32.4011 56.7192Z",
    fill: "#39BAE9"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4011 53.0556L12.132 64.8539C11.2475 65.3694 10.1563 65.3705 9.2718 64.8539L2.46331 60.9056C2.16532 60.732 2.01843 60.4282 2.02053 60.1244V60.5098C2.01843 60.8135 2.16532 61.1173 2.46331 61.2909L9.2718 65.2392C10.1574 65.7547 11.2475 65.7537 12.132 65.2392L32.4011 53.4409C32.7694 53.226 32.953 52.8524 32.9551 52.4766V52.0913C32.953 52.466 32.7694 52.8407 32.4011 53.0556Z",
    fill: "#39BAE9"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8183 57.0445C26.5727 57.1874 26.3744 57.5335 26.3755 57.8182C26.3755 58.103 26.5759 58.2173 26.8214 58.0744C27.0669 57.9315 27.2652 57.5854 27.2642 57.3006C27.2642 57.0159 27.0638 56.9016 26.8183 57.0445Z",
    fill: "#4E5EA6"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 58.14C26.5914 58.0797 26.5725 57.9633 26.5757 57.8701C26.583 57.6468 26.7037 57.4287 26.86 57.2731C26.9293 57.2032 27.0185 57.1482 27.116 57.1302C27.1685 57.1207 27.2241 57.1207 27.2713 57.1482L27.1223 57.0614C27.1223 57.0614 27.1118 57.0561 27.1066 57.0529C27.1045 57.0529 27.1034 57.0519 27.1013 57.0508C27.0436 57.0254 26.9765 57.0307 26.9177 57.0508C26.859 57.0699 26.8034 57.1037 26.7551 57.1418L26.7509 57.145C26.7509 57.145 26.7457 57.1493 26.7425 57.1514C26.5662 57.2985 26.4403 57.5293 26.4235 57.76C26.4151 57.8701 26.4361 58.0077 26.5411 58.0691L26.69 58.1559C26.69 58.1559 26.6817 58.1506 26.6775 58.1485L26.6743 58.1464C26.6743 58.1464 26.6691 58.1422 26.6659 58.14H26.667Z",
    fill: "white"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9798 57.1769C26.7531 57.3092 26.5706 57.6289 26.5706 57.8914C26.5706 58.1539 26.7552 58.2598 26.9819 58.1275C27.2085 57.9951 27.3911 57.6755 27.3911 57.4129C27.3911 57.1504 27.2064 57.0446 26.9798 57.1769Z",
    fill: "url(#paint10_linear_917_439)"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0353 56.333C27.7898 56.4759 27.5915 56.8221 27.5925 57.1068C27.5925 57.3916 27.7929 57.5059 28.0385 57.363C28.284 57.2201 28.4823 56.8739 28.4812 56.5892C28.4812 56.3045 28.2808 56.1901 28.0353 56.333Z",
    fill: "#4E5EA6"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M27.884 57.4296C27.8085 57.3693 27.7896 57.2528 27.7927 57.1597C27.8001 56.9363 27.9207 56.7183 28.0771 56.5627C28.1463 56.4928 28.2355 56.4378 28.3331 56.4198C28.3855 56.4102 28.4411 56.4102 28.4884 56.4378L28.3394 56.351C28.3394 56.351 28.3289 56.3457 28.3236 56.3425C28.3215 56.3425 28.3205 56.3414 28.3184 56.3404C28.2607 56.315 28.1935 56.3203 28.1348 56.3404C28.076 56.3594 28.0204 56.3933 27.9721 56.4314C27.9711 56.4325 27.969 56.4335 27.9679 56.4346C27.9648 56.4367 27.9627 56.4388 27.9595 56.4409C27.7833 56.5881 27.6574 56.8188 27.6406 57.0496C27.6322 57.1597 27.6532 57.2973 27.7581 57.3587L27.9071 57.4455C27.9071 57.4455 27.8987 57.4402 27.8945 57.4381L27.8913 57.4359C27.8913 57.4359 27.8861 57.4317 27.883 57.4296H27.884Z",
    fill: "white"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1968 56.4664C27.9702 56.5987 27.7876 56.9183 27.7876 57.1809C27.7876 57.4434 27.9723 57.5492 28.1989 57.418C28.4255 57.2857 28.6081 56.966 28.6081 56.7035C28.6081 56.441 28.4234 56.3351 28.1968 56.4674V56.4664Z",
    fill: "url(#paint11_linear_917_439)"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2526 55.6228C29.0071 55.7657 28.8088 56.1119 28.8098 56.3966C28.8098 56.6814 29.0102 56.7957 29.2557 56.6528C29.5013 56.5099 29.6996 56.1637 29.6985 55.879C29.6985 55.5942 29.4981 55.4799 29.2526 55.6228Z",
    fill: "#4E5EA6"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1013 56.7183C29.0257 56.6579 29.0069 56.5415 29.01 56.4484C29.0174 56.2239 29.138 56.007 29.2943 55.8513C29.3636 55.7815 29.4528 55.7275 29.5504 55.7084C29.6028 55.6989 29.6584 55.6989 29.7056 55.7264L29.5567 55.6396C29.5567 55.6396 29.5462 55.6343 29.5409 55.6312C29.5388 55.6312 29.5378 55.6301 29.5357 55.6291C29.478 55.6037 29.4108 55.61 29.3521 55.6291C29.2933 55.6481 29.2377 55.682 29.1894 55.7201L29.1852 55.7233C29.1852 55.7233 29.18 55.7275 29.1768 55.7296C29.0006 55.8767 28.8747 56.1075 28.8579 56.3383C28.8495 56.4484 28.8705 56.586 28.9754 56.6474L29.1244 56.7342C29.1244 56.7342 29.116 56.7289 29.1118 56.7267L29.1086 56.7246C29.1086 56.7246 29.1034 56.7204 29.1002 56.7183H29.1013Z",
    fill: "white"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4141 55.7562C29.1875 55.8885 29.0049 56.2081 29.0049 56.4706C29.0049 56.7332 29.1896 56.839 29.4162 56.7078C29.6428 56.5754 29.8254 56.2558 29.8254 55.9933C29.8254 55.7308 29.6407 55.6249 29.4141 55.7572V55.7562Z",
    fill: "url(#paint12_linear_917_439)"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4696 54.9124C30.2241 55.0553 30.0258 55.4014 30.0269 55.6862C30.0269 55.9709 30.2273 56.0852 30.4728 55.9423C30.7183 55.7994 30.9166 55.4533 30.9156 55.1685C30.9156 54.8838 30.7152 54.7695 30.4696 54.9124Z",
    fill: "#4E5EA6"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3174 56.0078C30.2418 55.9475 30.2229 55.8311 30.2261 55.7379C30.2334 55.5135 30.3541 55.2965 30.5104 55.1409C30.5797 55.071 30.6689 55.016 30.7664 54.998C30.8189 54.9885 30.8745 54.9885 30.9217 55.016L30.7727 54.9292C30.7727 54.9292 30.7622 54.9239 30.757 54.9207C30.7549 54.9207 30.7538 54.9197 30.7517 54.9186C30.694 54.8932 30.6269 54.8996 30.5681 54.9186C30.5094 54.9377 30.4538 54.9715 30.4055 55.0096L30.4013 55.0128C30.4013 55.0128 30.396 55.0171 30.3929 55.0192C30.2166 55.1663 30.0907 55.3971 30.0739 55.6278C30.0655 55.7379 30.0865 55.8755 30.1914 55.9369L30.3404 56.0237C30.3404 56.0237 30.332 56.0184 30.3278 56.0163L30.3247 56.0142C30.3247 56.0142 30.3195 56.0099 30.3163 56.0078H30.3174Z",
    fill: "white"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6311 55.0455C30.4045 55.1779 30.2219 55.4975 30.2219 55.76C30.2219 56.0226 30.4066 56.1284 30.6332 55.9961C30.8599 55.8638 31.0424 55.5441 31.0424 55.2816C31.0424 55.0191 30.8578 54.9132 30.6311 55.0455Z",
    fill: "url(#paint13_linear_917_439)"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6867 54.2022C31.4412 54.3451 31.2429 54.6912 31.2439 54.976C31.2439 55.2607 31.4443 55.375 31.6898 55.2321C31.9353 55.0892 32.1336 54.7431 32.1326 54.4583C32.1326 54.1736 31.9322 54.0593 31.6867 54.2022Z",
    fill: "#4E5EA6"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5344 55.2979C31.4588 55.2375 31.44 55.1211 31.4431 55.028C31.4505 54.8046 31.5711 54.5866 31.7275 54.4309C31.7967 54.3611 31.8859 54.3071 31.9835 54.288C32.0359 54.2785 32.0915 54.2785 32.1388 54.306L31.9898 54.2192C31.9898 54.2192 31.9793 54.2139 31.974 54.2108C31.9719 54.2108 31.9709 54.2097 31.9688 54.2087C31.9111 54.1832 31.8439 54.1896 31.7852 54.2087C31.7264 54.2277 31.6708 54.2616 31.6225 54.2997L31.6183 54.3029C31.6183 54.3029 31.6131 54.3071 31.6099 54.3092C31.4337 54.4563 31.3078 54.6871 31.291 54.9179C31.2826 55.028 31.3036 55.1656 31.4085 55.227L31.5575 55.3138C31.5575 55.3138 31.5491 55.3085 31.5449 55.3063L31.5417 55.3042C31.5417 55.3042 31.5365 55.3 31.5333 55.2979H31.5344Z",
    fill: "white"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8482 54.3345C31.6215 54.4668 31.439 54.7865 31.439 55.049C31.439 55.3115 31.6236 55.4174 31.8503 55.2861C32.0769 55.1538 32.2595 54.8342 32.2595 54.5716C32.2595 54.3091 32.0748 54.2033 31.8482 54.3356V54.3345Z",
    fill: "url(#paint14_linear_917_439)"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8183 58.4763C26.5727 58.6192 26.3744 58.9654 26.3755 59.2501C26.3755 59.5349 26.5759 59.6492 26.8214 59.5063C27.0669 59.3634 27.2652 59.0173 27.2642 58.7325C27.2642 58.4478 27.0638 58.3334 26.8183 58.4763Z",
    fill: "#4E5EA6"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 59.572C26.5914 59.5117 26.5725 59.3953 26.5757 59.3021C26.583 59.0777 26.7037 58.8607 26.86 58.7051C26.9293 58.6353 27.0185 58.5802 27.116 58.5622C27.1685 58.5527 27.2241 58.5527 27.2713 58.5802L27.1223 58.4934C27.1223 58.4934 27.1118 58.4881 27.1066 58.4849C27.1045 58.4849 27.1034 58.4839 27.1013 58.4828C27.0436 58.4574 26.9765 58.4638 26.9177 58.4828C26.859 58.5019 26.8034 58.5358 26.7551 58.5739L26.7509 58.577C26.7509 58.577 26.7457 58.5813 26.7425 58.5834C26.5662 58.7305 26.4403 58.9613 26.4235 59.192C26.4151 59.3021 26.4361 59.4397 26.5411 59.5011L26.69 59.5879C26.69 59.5879 26.6817 59.5826 26.6775 59.5805L26.6743 59.5784C26.6743 59.5784 26.6691 59.5742 26.6659 59.572H26.667Z",
    fill: "white"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9798 58.6088C26.7531 58.7411 26.5706 59.0608 26.5706 59.3233C26.5706 59.5858 26.7552 59.6916 26.9819 59.5593C27.2085 59.427 27.3911 59.1073 27.3911 58.8448C27.3911 58.5823 27.2064 58.4765 26.9798 58.6088Z",
    fill: "url(#paint15_linear_917_439)"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0353 57.7661C27.7898 57.909 27.5915 58.2552 27.5925 58.5399C27.5925 58.8247 27.7929 58.939 28.0385 58.7961C28.284 58.6532 28.4823 58.307 28.4812 58.0223C28.4812 57.7376 28.2808 57.6232 28.0353 57.7661Z",
    fill: "#4E5EA6"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M27.884 58.8617C27.8085 58.8014 27.7896 58.6849 27.7927 58.5918C27.8001 58.3684 27.9207 58.1504 28.0771 57.9948C28.1463 57.9249 28.2355 57.8709 28.3331 57.8519C28.3855 57.8424 28.4411 57.8424 28.4884 57.8699L28.3394 57.7831C28.3394 57.7831 28.3289 57.7778 28.3236 57.7746C28.3215 57.7746 28.3205 57.7736 28.3184 57.7725C28.2607 57.7471 28.1935 57.7524 28.1348 57.7725C28.076 57.7916 28.0204 57.8254 27.9721 57.8635L27.9679 57.8667C27.9679 57.8667 27.9627 57.8709 27.9595 57.8731C27.7833 58.0202 27.6574 58.2509 27.6406 58.4817C27.6322 58.5918 27.6532 58.7294 27.7581 58.7908L27.9071 58.8776C27.9071 58.8776 27.8987 58.8723 27.8945 58.8702L27.8913 58.8681C27.8913 58.8681 27.8861 58.8638 27.883 58.8617H27.884Z",
    fill: "white"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1968 57.8984C27.9702 58.0307 27.7876 58.3504 27.7876 58.6129C27.7876 58.8754 27.9723 58.9812 28.1989 58.85C28.4255 58.7177 28.6081 58.398 28.6081 58.1355C28.6081 57.873 28.4234 57.7671 28.1968 57.8984Z",
    fill: "url(#paint16_linear_917_439)"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2526 57.0559C29.0071 57.1988 28.8088 57.545 28.8098 57.8297C28.8098 58.1145 29.0102 58.2288 29.2557 58.0859C29.5013 57.943 29.6996 57.5968 29.6985 57.3121C29.6985 57.0274 29.4981 56.913 29.2526 57.0559Z",
    fill: "#4E5EA6"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1013 58.1514C29.0257 58.091 29.0069 57.9746 29.01 57.8815C29.0174 57.6581 29.138 57.4401 29.2943 57.2845C29.3636 57.2146 29.4528 57.1606 29.5504 57.1416C29.6028 57.132 29.6584 57.132 29.7056 57.1595L29.5567 57.0727C29.5567 57.0727 29.5462 57.0675 29.5409 57.0643C29.5388 57.0643 29.5378 57.0632 29.5357 57.0622C29.478 57.0368 29.4108 57.0431 29.3521 57.0622C29.2933 57.0812 29.2377 57.1151 29.1894 57.1532L29.1852 57.1564C29.1852 57.1564 29.18 57.1606 29.1768 57.1627C29.0006 57.3099 28.8747 57.5406 28.8579 57.7714C28.8495 57.8815 28.8705 58.0191 28.9754 58.0805L29.1244 58.1673C29.1244 58.1673 29.116 58.162 29.1118 58.1599L29.1086 58.1577C29.1086 58.1577 29.1034 58.1535 29.1002 58.1514H29.1013Z",
    fill: "white"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4141 57.1883C29.1875 57.3206 29.0049 57.6403 29.0049 57.9028C29.0049 58.1653 29.1896 58.2711 29.4162 58.1399C29.6428 58.0076 29.8254 57.6879 29.8254 57.4254C29.8254 57.1629 29.6407 57.057 29.4141 57.1893V57.1883Z",
    fill: "url(#paint17_linear_917_439)"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4696 56.3455C30.2241 56.4884 30.0258 56.8345 30.0269 57.1193C30.0269 57.404 30.2273 57.5183 30.4728 57.3754C30.7183 57.2325 30.9166 56.8864 30.9156 56.6017C30.9156 56.3169 30.7152 56.2026 30.4696 56.3455Z",
    fill: "#4E5EA6"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3174 57.4411C30.2418 57.3807 30.2229 57.2643 30.2261 57.1711C30.2334 56.9467 30.3541 56.7297 30.5104 56.5741C30.5797 56.5043 30.6689 56.4503 30.7664 56.4312C30.8189 56.4217 30.8745 56.4217 30.9217 56.4492L30.7727 56.3624C30.7727 56.3624 30.7622 56.3571 30.757 56.354C30.7549 56.354 30.7538 56.3529 30.7517 56.3518C30.694 56.3264 30.6269 56.3317 30.5681 56.3518C30.5094 56.3709 30.4538 56.4048 30.4055 56.4429L30.4013 56.4461L30.3929 56.4524C30.2166 56.5995 30.0907 56.8303 30.0739 57.061C30.0655 57.1711 30.0865 57.3087 30.1914 57.3701L30.3404 57.4569C30.3404 57.4569 30.332 57.4516 30.3278 57.4495L30.3247 57.4474C30.3247 57.4474 30.3195 57.4432 30.3163 57.4411H30.3174Z",
    fill: "white"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6311 56.4777C30.4045 56.61 30.2219 56.9297 30.2219 57.1922C30.2219 57.4547 30.4066 57.5605 30.6332 57.4282C30.8599 57.2959 31.0424 56.9762 31.0424 56.7137C31.0424 56.4512 30.8578 56.3454 30.6311 56.4777Z",
    fill: "url(#paint18_linear_917_439)"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6867 55.6343C31.4412 55.7772 31.2429 56.1233 31.2439 56.4081C31.2439 56.6928 31.4443 56.8071 31.6898 56.6642C31.9353 56.5213 32.1336 56.1752 32.1326 55.8905C32.1326 55.6057 31.9322 55.4914 31.6867 55.6343Z",
    fill: "#4E5EA6"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5344 56.7309C31.4588 56.6705 31.44 56.5541 31.4431 56.4609C31.4505 56.2376 31.5711 56.0195 31.7275 55.8639C31.7967 55.7941 31.8859 55.739 31.9835 55.721C32.0359 55.7115 32.0915 55.7115 32.1388 55.739L31.9898 55.6522C31.9898 55.6522 31.9793 55.6469 31.974 55.6438C31.9719 55.6438 31.9709 55.6427 31.9688 55.6416C31.9111 55.6162 31.8439 55.6215 31.7852 55.6416C31.7264 55.6607 31.6708 55.6946 31.6225 55.7327L31.6183 55.7358C31.6183 55.7358 31.6131 55.7401 31.6099 55.7422C31.4337 55.8893 31.3078 56.1201 31.291 56.3509C31.2826 56.4609 31.3036 56.5985 31.4085 56.6599L31.5575 56.7467C31.5575 56.7467 31.5491 56.7414 31.5449 56.7393L31.5417 56.7372C31.5417 56.7372 31.5365 56.733 31.5333 56.7309H31.5344Z",
    fill: "white"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8482 55.7676C31.6215 55.8999 31.439 56.2196 31.439 56.4821C31.439 56.7446 31.6236 56.8505 31.8503 56.7182C32.0769 56.5858 32.2595 56.2662 32.2595 56.0036C32.2595 55.7411 32.0748 55.6353 31.8482 55.7665V55.7676Z",
    fill: "url(#paint19_linear_917_439)"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6343 65.0224L25.6872 60.3258V57.6636L17.6343 62.3602V65.0224Z",
    fill: "#258BE0"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M17.928 64.5291L18.7023 64.0782V63.7681L17.928 64.2201V64.5291Z",
    fill: "white"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9312 63.9481L19.7055 63.4961V63.187L18.9312 63.6379V63.9481Z",
    fill: "white"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9343 63.3658L20.7087 62.9149V62.6047L19.9343 63.0567V63.3658Z",
    fill: "white"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9404 62.2025L22.7148 61.7516V61.4414L21.9404 61.8923V62.2025Z",
    fill: "white"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9446 61.6204L23.7179 61.1694V60.8604L22.9446 61.3113V61.6204Z",
    fill: "white"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M17.928 62.8228L18.7023 62.3718V62.0627L17.928 62.5137V62.8228Z",
    fill: "white"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9312 62.2418L19.7055 61.7898V61.4807L18.9312 61.9316V62.2418Z",
    fill: "white"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9343 61.6594L20.7087 61.2085V60.8994L19.9343 61.3503V61.6594Z",
    fill: "white"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9404 60.4962L22.7148 60.0453V59.7351L21.9404 60.1871V60.4962Z",
    fill: "white"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9446 59.9141L23.7179 59.4631V59.1541L22.9446 59.605V59.9141Z",
    fill: "white"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7085 62.3549V62.2205L17.928 63.8421V63.9766L20.7085 62.3549Z",
    fill: "white"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7085 62.0797V61.9453L17.928 63.567V63.7014L20.7085 62.0797Z",
    fill: "white"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7085 61.8046V61.6702L17.928 63.2918V63.4263L20.7085 61.8046Z",
    fill: "white"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3577 65.4331V68.0963L17.3478 65.1854V62.5232L12.3577 65.4331Z",
    fill: "#258BE0"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 64.6076V64.4731L12.5381 66.0948V66.2292L15.3186 64.6076Z",
    fill: "white"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 64.3322V64.1978L12.5381 65.8194V65.9539L15.3186 64.3322Z",
    fill: "white"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 64.0581V63.9226L12.5381 65.5443V65.6798L15.3186 64.0581Z",
    fill: "white"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 65.8439V65.7095L12.5381 67.3311V67.4656L15.3186 65.8439Z",
    fill: "white"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 65.5685V65.4341L12.5381 67.0557V67.1902L15.3186 65.5685Z",
    fill: "white"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 65.2934V65.1589L12.5381 66.7806V66.915L15.3186 65.2934Z",
    fill: "white"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6414 45.9614C32.5722 45.8905 32.4924 45.827 32.4001 45.7741L25.5528 41.8036C24.8991 41.4236 24.0943 41.4236 23.4417 41.8036L3.09705 53.6453H2.02053V58.6955C2.01843 58.9993 2.16532 59.3031 2.46331 59.4767L9.2718 63.425C10.1574 63.9405 11.2475 63.9394 12.132 63.425L32.4011 51.6267C32.7694 51.4118 32.953 51.0381 32.9551 50.6623V45.5878L32.6404 45.9625L32.6414 45.9614Z",
    fill: "#C2E6F8"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4011 46.568L12.1319 58.3663C11.9871 58.451 11.8371 58.5198 11.6829 58.5769V63.6346C11.8371 63.5774 11.9871 63.5086 12.1319 63.4239L32.4011 51.6256C32.7694 51.4107 32.953 51.0371 32.9551 50.6613V45.5984C32.9551 45.9752 32.7704 46.3531 32.4011 46.568Z",
    fill: "#39BAE9"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4011 44.6288L25.5538 40.6583C24.9002 40.2783 24.0954 40.2783 23.4428 40.6583L2.4633 52.8705C1.87258 53.2145 1.87258 54.0751 2.4633 54.4191L9.27179 58.3674C10.1573 58.8829 11.2475 58.8818 12.132 58.3674L32.4011 46.5691C33.1409 46.1383 33.1409 45.0607 32.4011 44.6299V44.6288Z",
    fill: "white"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27169 58.3674L8.97266 58.1938V63.2515L9.27169 63.4251C9.60535 63.6198 9.96838 63.7405 10.3388 63.7881V58.7305C9.96838 58.6829 9.60535 58.5622 9.27169 58.3674Z",
    fill: "#39BAE9"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4011 50.7629L12.132 62.5612C11.2475 63.0767 10.1563 63.0778 9.2718 62.5612L2.46331 58.6129C2.16532 58.4393 2.01843 58.1355 2.02053 57.8317V58.217C2.01843 58.5208 2.16532 58.8246 2.46331 58.9982L9.2718 62.9465C10.1574 63.462 11.2475 63.461 12.132 62.9465L32.4011 51.1482C32.7694 50.9333 32.953 50.5597 32.9551 50.1839V49.7986C32.953 50.1733 32.7694 50.548 32.4011 50.7629Z",
    fill: "#39BAE9"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4011 47.0993L12.132 58.8976C11.2475 59.4131 10.1563 59.4142 9.2718 58.8976L2.46331 54.9493C2.16532 54.7757 2.01843 54.4719 2.02053 54.1681V54.5534C2.01843 54.8572 2.16532 55.161 2.46331 55.3346L9.2718 59.2829C10.1574 59.7984 11.2475 59.7974 12.132 59.2829L32.4011 47.4846C32.7694 47.2697 32.953 46.8961 32.9551 46.5203V46.135C32.953 46.5097 32.7694 46.8844 32.4011 47.0993Z",
    fill: "#39BAE9"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8183 51.0869C26.5727 51.2298 26.3744 51.576 26.3755 51.8607C26.3755 52.1455 26.5759 52.2598 26.8214 52.1169C27.0669 51.974 27.2652 51.6278 27.2642 51.3431C27.2642 51.0584 27.0638 50.944 26.8183 51.0869Z",
    fill: "#4E5EA6"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 52.1836C26.5914 52.1233 26.5725 52.0068 26.5757 51.9137C26.583 51.6893 26.7037 51.4723 26.86 51.3167C26.9293 51.2468 27.0185 51.1928 27.116 51.1738C27.1685 51.1643 27.2241 51.1643 27.2713 51.1918L27.1223 51.105C27.1223 51.105 27.1118 51.0997 27.1066 51.0965C27.1045 51.0965 27.1034 51.0955 27.1013 51.0944C27.0436 51.069 26.9765 51.0753 26.9177 51.0944C26.859 51.1134 26.8034 51.1473 26.7551 51.1854C26.7541 51.1865 26.752 51.1875 26.7509 51.1886C26.7478 51.1907 26.7457 51.1928 26.7425 51.195C26.5662 51.3421 26.4403 51.5729 26.4235 51.8036C26.4151 51.9137 26.4361 52.0513 26.5411 52.1127L26.69 52.1995C26.69 52.1995 26.6817 52.1942 26.6775 52.1921L26.6743 52.19C26.6743 52.19 26.6691 52.1857 26.6659 52.1836H26.667Z",
    fill: "white"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9798 51.2202C26.7531 51.3526 26.5706 51.6722 26.5706 51.9347C26.5706 52.1973 26.7552 52.3031 26.9819 52.1708C27.2085 52.0385 27.3911 51.7188 27.3911 51.4563C27.3911 51.1938 27.2064 51.0879 26.9798 51.2192V51.2202Z",
    fill: "url(#paint20_linear_917_439)"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0353 50.3767C27.7898 50.5196 27.5915 50.8658 27.5925 51.1505C27.5925 51.4353 27.7929 51.5496 28.0385 51.4067C28.284 51.2638 28.4823 50.9176 28.4812 50.6329C28.4812 50.3482 28.2808 50.2338 28.0353 50.3767Z",
    fill: "#4E5EA6"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M27.884 51.4723C27.8085 51.412 27.7896 51.2955 27.7927 51.2024C27.8001 50.978 27.9207 50.761 28.0771 50.6054C28.1463 50.5355 28.2355 50.4805 28.3331 50.4625C28.3855 50.453 28.4411 50.453 28.4884 50.4805L28.3394 50.3937C28.3394 50.3937 28.3289 50.3884 28.3236 50.3852C28.3215 50.3852 28.3205 50.3842 28.3184 50.3831C28.2607 50.3577 28.1935 50.363 28.1348 50.3831C28.076 50.4021 28.0204 50.436 27.9721 50.4741L27.9679 50.4773C27.9679 50.4773 27.9627 50.4815 27.9595 50.4837C27.7833 50.6308 27.6574 50.8615 27.6406 51.0923C27.6322 51.2024 27.6532 51.34 27.7581 51.4014L27.9071 51.4882C27.9071 51.4882 27.8987 51.4829 27.8945 51.4808L27.8913 51.4787C27.8913 51.4787 27.8861 51.4744 27.883 51.4723H27.884Z",
    fill: "white"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1968 50.5101C27.9702 50.6424 27.7876 50.9621 27.7876 51.2246C27.7876 51.4871 27.9723 51.5929 28.1989 51.4617C28.4255 51.3294 28.6081 51.0097 28.6081 50.7472C28.6081 50.4847 28.4234 50.3788 28.1968 50.5111V50.5101Z",
    fill: "url(#paint21_linear_917_439)"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2526 49.6665C29.0071 49.8094 28.8088 50.1556 28.8098 50.4403C28.8098 50.725 29.0102 50.8394 29.2557 50.6965C29.5013 50.5536 29.6996 50.2074 29.6985 49.9227C29.6985 49.6379 29.4981 49.5236 29.2526 49.6665Z",
    fill: "#4E5EA6"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1013 50.762C29.0257 50.7017 29.0069 50.5852 29.01 50.4921C29.0174 50.2687 29.138 50.0507 29.2943 49.8951C29.3636 49.8252 29.4528 49.7712 29.5504 49.7522C29.6028 49.7426 29.6584 49.7426 29.7056 49.7701L29.5567 49.6833C29.5567 49.6833 29.5462 49.6781 29.5409 49.6749C29.5388 49.6749 29.5378 49.6738 29.5357 49.6728C29.478 49.6474 29.4108 49.6537 29.3521 49.6728C29.2933 49.6918 29.2377 49.7257 29.1894 49.7638L29.1852 49.767C29.1852 49.767 29.18 49.7712 29.1768 49.7733C29.0006 49.9205 28.8747 50.1512 28.8579 50.382C28.8495 50.4921 28.8705 50.6297 28.9754 50.6911L29.1244 50.7779C29.1244 50.7779 29.116 50.7726 29.1118 50.7705L29.1086 50.7683C29.1086 50.7683 29.1034 50.7641 29.1002 50.762H29.1013Z",
    fill: "white"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4141 49.7999C29.1875 49.9322 29.0049 50.2518 29.0049 50.5144C29.0049 50.7769 29.1896 50.8827 29.4162 50.7515C29.6428 50.6191 29.8254 50.2995 29.8254 50.037C29.8254 49.7745 29.6407 49.6686 29.4141 49.8009V49.7999Z",
    fill: "url(#paint22_linear_917_439)"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4696 48.9561C30.2241 49.099 30.0258 49.4451 30.0269 49.7299C30.0269 50.0146 30.2273 50.1289 30.4728 49.986C30.7183 49.8431 30.9166 49.497 30.9156 49.2122C30.9156 48.9275 30.7152 48.8132 30.4696 48.9561Z",
    fill: "#4E5EA6"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3174 50.0518C30.2418 49.9914 30.2229 49.875 30.2261 49.7819C30.2334 49.5574 30.3541 49.3405 30.5104 49.1848C30.5797 49.115 30.6689 49.061 30.7664 49.0419C30.8189 49.0324 30.8745 49.0324 30.9217 49.0599L30.7727 48.9731C30.7727 48.9731 30.7622 48.9678 30.757 48.9647C30.7549 48.9647 30.7538 48.9636 30.7517 48.9626C30.694 48.9372 30.6269 48.9435 30.5681 48.9626C30.5094 48.9816 30.4538 49.0155 30.4055 49.0536L30.4013 49.0568C30.4013 49.0568 30.396 49.061 30.3929 49.0631C30.2166 49.2103 30.0907 49.441 30.0739 49.6718C30.0655 49.7819 30.0865 49.9195 30.1914 49.9809L30.3404 50.0677C30.3404 50.0677 30.332 50.0624 30.3278 50.0602L30.3247 50.0581C30.3247 50.0581 30.3195 50.0539 30.3163 50.0518H30.3174Z",
    fill: "white"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6311 49.0885C30.4045 49.2208 30.2219 49.5405 30.2219 49.803C30.2219 50.0655 30.4066 50.1714 30.6332 50.0391C30.8599 49.9067 31.0424 49.5871 31.0424 49.3246C31.0424 49.062 30.8578 48.9562 30.6311 49.0885Z",
    fill: "url(#paint23_linear_917_439)"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6867 48.2459C31.4412 48.3888 31.2429 48.7349 31.2439 49.0196C31.2439 49.3044 31.4443 49.4187 31.6898 49.2758C31.9353 49.1329 32.1336 48.7868 32.1326 48.502C32.1326 48.2173 31.9322 48.103 31.6867 48.2459Z",
    fill: "#4E5EA6"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5344 49.3413C31.4588 49.281 31.44 49.1646 31.4431 49.0714C31.4505 48.847 31.5711 48.63 31.7275 48.4744C31.7967 48.4045 31.8859 48.3506 31.9835 48.3315C32.0359 48.322 32.0915 48.322 32.1388 48.3495L31.9898 48.2627C31.9898 48.2627 31.9793 48.2574 31.974 48.2542C31.9719 48.2542 31.9709 48.2532 31.9688 48.2521C31.9111 48.2267 31.8439 48.2331 31.7852 48.2521C31.7264 48.2712 31.6708 48.305 31.6225 48.3431L31.6183 48.3463C31.6183 48.3463 31.6131 48.3506 31.6099 48.3527C31.4337 48.4998 31.3078 48.7306 31.291 48.9613C31.2826 49.0714 31.3036 49.209 31.4085 49.2704L31.5575 49.3572C31.5575 49.3572 31.5491 49.3519 31.5449 49.3498L31.5417 49.3477C31.5417 49.3477 31.5365 49.3434 31.5333 49.3413H31.5344Z",
    fill: "white"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8482 48.378C31.6215 48.5103 31.439 48.83 31.439 49.0925C31.439 49.355 31.6236 49.4609 31.8503 49.3296C32.0769 49.1973 32.2595 48.8776 32.2595 48.6151C32.2595 48.3526 32.0748 48.2467 31.8482 48.379V48.378Z",
    fill: "url(#paint24_linear_917_439)"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8183 52.5203C26.5727 52.6632 26.3744 53.0093 26.3755 53.2941C26.3755 53.5788 26.5759 53.6931 26.8214 53.5502C27.0669 53.4073 27.2652 53.0612 27.2642 52.7765C27.2642 52.4917 27.0638 52.3774 26.8183 52.5203Z",
    fill: "#4E5EA6"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 53.6158C26.5914 53.5554 26.5725 53.439 26.5757 53.3458C26.583 53.1214 26.7037 52.9044 26.86 52.7488C26.9293 52.679 27.0185 52.625 27.116 52.6059C27.1685 52.5964 27.2241 52.5964 27.2713 52.6239L27.1223 52.5371C27.1223 52.5371 27.1118 52.5318 27.1066 52.5286C27.1045 52.5286 27.1034 52.5276 27.1013 52.5265C27.0436 52.5011 26.9765 52.5075 26.9177 52.5265C26.859 52.5456 26.8034 52.5794 26.7551 52.6176L26.7509 52.6207C26.7509 52.6207 26.7457 52.625 26.7425 52.6271C26.5662 52.7742 26.4403 53.005 26.4235 53.2357C26.4151 53.3458 26.4361 53.4834 26.5411 53.5448L26.69 53.6316C26.69 53.6316 26.6817 53.6263 26.6775 53.6242L26.6743 53.6221C26.6743 53.6221 26.6691 53.6179 26.6659 53.6158H26.667Z",
    fill: "white"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9798 52.6525C26.7531 52.7848 26.5706 53.1045 26.5706 53.367C26.5706 53.6295 26.7552 53.7354 26.9819 53.603C27.2085 53.4707 27.3911 53.151 27.3911 52.8885C27.3911 52.626 27.2064 52.5202 26.9798 52.6525Z",
    fill: "url(#paint25_linear_917_439)"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0353 51.8098C27.7898 51.9527 27.5915 52.2989 27.5925 52.5836C27.5925 52.8684 27.7929 52.9827 28.0385 52.8398C28.284 52.6969 28.4823 52.3507 28.4812 52.066C28.4812 51.7813 28.2808 51.6669 28.0353 51.8098Z",
    fill: "#4E5EA6"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M27.884 52.9054C27.8085 52.8451 27.7896 52.7286 27.7927 52.6355C27.8001 52.4111 27.9207 52.1941 28.0771 52.0385C28.1463 51.9686 28.2355 51.9146 28.3331 51.8956C28.3855 51.8861 28.4411 51.8861 28.4884 51.9136L28.3394 51.8268C28.3394 51.8268 28.3289 51.8215 28.3236 51.8183C28.3215 51.8183 28.3205 51.8173 28.3184 51.8162C28.2607 51.7908 28.1935 51.7961 28.1348 51.8162C28.076 51.8353 28.0204 51.8691 27.9721 51.9072L27.9679 51.9104C27.9679 51.9104 27.9627 51.9146 27.9595 51.9168C27.7833 52.0639 27.6574 52.2947 27.6406 52.5254C27.6322 52.6355 27.6532 52.7731 27.7581 52.8345L27.9071 52.9213C27.9071 52.9213 27.8987 52.916 27.8945 52.9139L27.8913 52.9118C27.8913 52.9118 27.8861 52.9075 27.883 52.9054H27.884Z",
    fill: "white"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1968 51.9422C27.9702 52.0745 27.7876 52.3942 27.7876 52.6567C27.7876 52.9192 27.9723 53.0251 28.1989 52.8938C28.4255 52.7615 28.6081 52.4418 28.6081 52.1793C28.6081 51.9168 28.4234 51.8109 28.1968 51.9432V51.9422Z",
    fill: "url(#paint26_linear_917_439)"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2526 51.0996C29.0071 51.2425 28.8088 51.5887 28.8098 51.8734C28.8098 52.1582 29.0102 52.2725 29.2557 52.1296C29.5013 51.9867 29.6996 51.6405 29.6985 51.3558C29.6985 51.0711 29.4981 50.9567 29.2526 51.0996Z",
    fill: "#4E5EA6"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1013 52.1953C29.0257 52.135 29.0069 52.0186 29.01 51.9254C29.0174 51.7021 29.138 51.484 29.2943 51.3284C29.3636 51.2585 29.4528 51.2035 29.5504 51.1855C29.6028 51.176 29.6584 51.176 29.7056 51.2035L29.5567 51.1167C29.5567 51.1167 29.5462 51.1114 29.5409 51.1082C29.5388 51.1082 29.5378 51.1072 29.5357 51.1061C29.478 51.0807 29.4108 51.0871 29.3521 51.1061C29.2933 51.1252 29.2377 51.159 29.1894 51.1971L29.1852 51.2003C29.1852 51.2003 29.18 51.2046 29.1768 51.2067C29.0006 51.3538 28.8747 51.5846 28.8579 51.8153C28.8495 51.9254 28.8705 52.063 28.9754 52.1244L29.1244 52.2112C29.1244 52.2112 29.116 52.2059 29.1118 52.2038L29.1086 52.2017C29.1086 52.2017 29.1034 52.1975 29.1002 52.1953H29.1013Z",
    fill: "white"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4141 51.2321C29.1875 51.3644 29.0049 51.6841 29.0049 51.9466C29.0049 52.2091 29.1896 52.3149 29.4162 52.1826C29.6428 52.0503 29.8254 51.7306 29.8254 51.4681C29.8254 51.2056 29.6407 51.0997 29.4141 51.2321Z",
    fill: "url(#paint27_linear_917_439)"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4696 50.3882C30.2241 50.5311 30.0258 50.8772 30.0269 51.162C30.0269 51.4467 30.2273 51.561 30.4728 51.4181C30.7183 51.2752 30.9166 50.9291 30.9156 50.6444C30.9156 50.3596 30.7152 50.2453 30.4696 50.3882Z",
    fill: "#4E5EA6"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3174 51.4849C30.2418 51.4246 30.2229 51.3081 30.2261 51.215C30.2334 50.9906 30.3541 50.7736 30.5104 50.618C30.5797 50.5481 30.6689 50.4941 30.7664 50.4751C30.8189 50.4655 30.8745 50.4655 30.9217 50.493L30.7727 50.4062C30.7727 50.4062 30.7622 50.401 30.757 50.3978C30.7549 50.3978 30.7538 50.3967 30.7517 50.3957C30.694 50.3703 30.6269 50.3766 30.5681 50.3957C30.5094 50.4147 30.4538 50.4486 30.4055 50.4867L30.4013 50.4899C30.4013 50.4899 30.396 50.4941 30.3929 50.4962C30.2166 50.6434 30.0907 50.8741 30.0739 51.1049C30.0655 51.215 30.0865 51.3526 30.1914 51.414L30.3404 51.5008C30.3404 51.5008 30.332 51.4955 30.3278 51.4934L30.3247 51.4912C30.3247 51.4912 30.3195 51.487 30.3163 51.4849H30.3174Z",
    fill: "white"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6311 50.5216C30.4045 50.6539 30.2219 50.9736 30.2219 51.2361C30.2219 51.4986 30.4066 51.6045 30.6332 51.4722C30.8599 51.3399 31.0424 51.0202 31.0424 50.7577C31.0424 50.4952 30.8578 50.3893 30.6311 50.5216Z",
    fill: "url(#paint28_linear_917_439)"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6867 49.678C31.4412 49.8209 31.2429 50.167 31.2439 50.4518C31.2439 50.7365 31.4443 50.8508 31.6898 50.7079C31.9353 50.565 32.1336 50.2189 32.1326 49.9342C32.1326 49.6494 31.9322 49.5351 31.6867 49.678Z",
    fill: "#4E5EA6"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5344 50.7737C31.4588 50.7134 31.44 50.5969 31.4431 50.5038C31.4505 50.2804 31.5711 50.0624 31.7275 49.9068C31.7967 49.8369 31.8859 49.7829 31.9835 49.7639C32.0359 49.7543 32.0915 49.7543 32.1388 49.7819L31.9898 49.6951C31.9898 49.6951 31.9793 49.6898 31.974 49.6866C31.9719 49.6866 31.9709 49.6855 31.9688 49.6845C31.9111 49.6591 31.8439 49.6654 31.7852 49.6845C31.7264 49.7035 31.6708 49.7374 31.6225 49.7755L31.6183 49.7787C31.6183 49.7787 31.6131 49.7829 31.6099 49.785C31.4337 49.9322 31.3078 50.1629 31.291 50.3937C31.2826 50.5038 31.3036 50.6414 31.4085 50.7028L31.5575 50.7896C31.5575 50.7896 31.5491 50.7843 31.5449 50.7822L31.5417 50.7801C31.5417 50.7801 31.5365 50.7758 31.5333 50.7737H31.5344Z",
    fill: "white"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8482 49.8115C31.6215 49.9439 31.439 50.2635 31.439 50.526C31.439 50.7886 31.6236 50.8944 31.8503 50.7621C32.0769 50.6298 32.2595 50.3101 32.2595 50.0476C32.2595 49.7851 32.0748 49.6792 31.8482 49.8105V49.8115Z",
    fill: "url(#paint29_linear_917_439)"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6343 59.0659L25.6872 54.3692V51.707L17.6343 56.4037V59.0659Z",
    fill: "#258BE0"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M17.928 58.5726L18.7023 58.1217V57.8115L17.928 58.2635V58.5726Z",
    fill: "white"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9312 57.9905L19.7055 57.5396V57.2305L18.9312 57.6814V57.9905Z",
    fill: "white"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9343 57.4093L20.7087 56.9583V56.6482L19.9343 57.0991V57.4093Z",
    fill: "white"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9404 56.2459L22.7148 55.795V55.4849L21.9404 55.9358V56.2459Z",
    fill: "white"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9446 55.6638L23.7179 55.2129V54.9038L22.9446 55.3547V55.6638Z",
    fill: "white"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M17.928 56.8662L18.7023 56.4153V56.1062L17.928 56.5571V56.8662Z",
    fill: "white"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9312 56.285L19.7055 55.833V55.5239L18.9312 55.9749V56.285Z",
    fill: "white"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9343 55.703L20.7087 55.252V54.9419L19.9343 55.3939V55.703Z",
    fill: "white"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9404 54.5396L22.7148 54.0887V53.7786L21.9404 54.2295V54.5396Z",
    fill: "white"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9446 53.9575L23.7179 53.5066V53.1975L22.9446 53.6484V53.9575Z",
    fill: "white"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7085 56.3984V56.2629L17.928 57.8857V58.0201L20.7085 56.3984Z",
    fill: "white"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7085 56.1232V55.9888L17.928 57.6104V57.7449L20.7085 56.1232Z",
    fill: "white"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7085 55.8481V55.7136L17.928 57.3353V57.4697L20.7085 55.8481Z",
    fill: "white"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3577 59.4765V62.1387L17.3478 59.2288V56.5667L12.3577 59.4765Z",
    fill: "#258BE0"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 58.6508V58.5164L12.5381 60.138V60.2724L15.3186 58.6508Z",
    fill: "white"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 58.3756V58.2412L12.5381 59.8629V59.9973L15.3186 58.3756Z",
    fill: "white"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 58.1005V57.9661L12.5381 59.5877V59.7222L15.3186 58.1005Z",
    fill: "white"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 59.8874V59.7529L12.5381 61.3746V61.509L15.3186 59.8874Z",
    fill: "white"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 59.612V59.4775L12.5381 61.0992V61.2336L15.3186 59.612Z",
    fill: "white"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 59.3368V59.2024L12.5381 60.8241V60.9585L15.3186 59.3368Z",
    fill: "white"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6414 40.0051C32.5722 39.9342 32.4924 39.8707 32.4001 39.8178L25.5528 35.8473C24.8991 35.4673 24.0943 35.4673 23.4417 35.8473L3.09705 47.689H2.02053V52.7392C2.01843 53.043 2.16532 53.3468 2.46331 53.5204L9.2718 57.4687C10.1574 57.9842 11.2475 57.9831 12.132 57.4687L32.4011 45.6704C32.7694 45.4555 32.953 45.0818 32.9551 44.706V39.6315L32.6404 40.0062L32.6414 40.0051Z",
    fill: "#C2E6F8"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4011 40.6119L12.1319 52.4103C11.9871 52.4949 11.8371 52.5637 11.6829 52.6209V57.6785C11.8371 57.6214 11.9871 57.5526 12.1319 57.4679L32.4011 45.6696C32.7694 45.4547 32.953 45.081 32.9551 44.7053V39.6423C32.9551 40.0192 32.7704 40.3971 32.4011 40.6119Z",
    fill: "#39BAE9"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4011 38.6725L25.5538 34.702C24.9002 34.322 24.0954 34.322 23.4428 34.702L2.4633 46.9142C1.87258 47.2582 1.87258 48.1188 2.4633 48.4628L9.27179 52.4111C10.1573 52.9266 11.2475 52.9255 12.132 52.4111L32.4011 40.6128C33.1409 40.182 33.1409 39.1044 32.4011 38.6736V38.6725Z",
    fill: "white"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27169 52.4111L8.97266 52.2375V57.2952L9.27169 57.4688C9.60535 57.6635 9.96838 57.7842 10.3388 57.8319V52.7742C9.96838 52.7266 9.60535 52.6059 9.27169 52.4111Z",
    fill: "#39BAE9"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4011 44.8066L12.132 56.6049C11.2475 57.1204 10.1563 57.1215 9.2718 56.6049L2.46331 52.6566C2.16532 52.483 2.01843 52.1792 2.02053 51.8754V52.2607C2.01843 52.5645 2.16532 52.8683 2.46331 53.0419L9.2718 56.9902C10.1574 57.5057 11.2475 57.5047 12.132 56.9902L32.4011 45.1919C32.7694 44.977 32.953 44.6034 32.9551 44.2276V43.8423C32.953 44.217 32.7694 44.5917 32.4011 44.8066Z",
    fill: "#39BAE9"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4011 41.1433L12.132 52.9416C11.2475 53.4571 10.1563 53.4581 9.2718 52.9416L2.46331 48.9933C2.16532 48.8197 2.01843 48.5159 2.02053 48.2121V48.5974C2.01843 48.9012 2.16532 49.205 2.46331 49.3786L9.2718 53.3269C10.1574 53.8424 11.2475 53.8424 12.132 53.3269L32.4011 41.5286C32.7694 41.3137 32.953 40.94 32.9551 40.5643V40.179C32.953 40.5537 32.7694 40.9284 32.4011 41.1433Z",
    fill: "#39BAE9"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8183 45.1306C26.5727 45.2735 26.3744 45.6197 26.3755 45.9044C26.3755 46.1892 26.5759 46.3035 26.8214 46.1606C27.0669 46.0177 27.2652 45.6715 27.2642 45.3868C27.2642 45.1021 27.0638 44.9877 26.8183 45.1306Z",
    fill: "#4E5EA6"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 46.2262C26.5914 46.1659 26.5725 46.0494 26.5757 45.9563C26.583 45.7319 26.7037 45.5149 26.86 45.3593C26.9293 45.2894 27.0185 45.2354 27.116 45.2164C27.1685 45.2069 27.2241 45.2069 27.2713 45.2344L27.1223 45.1476C27.1223 45.1476 27.1118 45.1423 27.1066 45.1391C27.1045 45.1391 27.1034 45.1381 27.1013 45.137C27.0436 45.1116 26.9765 45.1169 26.9177 45.137C26.859 45.1561 26.8034 45.1899 26.7551 45.228C26.7541 45.2291 26.752 45.2302 26.7509 45.2312C26.7478 45.2333 26.7457 45.2354 26.7425 45.2376C26.5662 45.3847 26.4403 45.6155 26.4235 45.8462C26.4151 45.9563 26.4361 46.0939 26.5411 46.1553L26.69 46.2421C26.69 46.2421 26.6817 46.2368 26.6775 46.2347L26.6743 46.2326C26.6743 46.2326 26.6691 46.2283 26.6659 46.2262H26.667Z",
    fill: "white"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9798 45.2639C26.7531 45.3963 26.5706 45.7159 26.5706 45.9784C26.5706 46.241 26.7552 46.3468 26.9819 46.2145C27.2085 46.0822 27.3911 45.7625 27.3911 45.5C27.3911 45.2375 27.2064 45.1316 26.9798 45.2629V45.2639Z",
    fill: "url(#paint30_linear_917_439)"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0353 44.4204C27.7898 44.5633 27.5915 44.9095 27.5925 45.1942C27.5925 45.479 27.7929 45.5933 28.0385 45.4504C28.284 45.3075 28.4823 44.9613 28.4812 44.6766C28.4812 44.3919 28.2808 44.2775 28.0353 44.4204Z",
    fill: "#4E5EA6"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M27.884 45.516C27.8085 45.4557 27.7896 45.3392 27.7927 45.2461C27.8001 45.0227 27.9207 44.8047 28.0771 44.6491C28.1463 44.5792 28.2355 44.5252 28.3331 44.5062C28.3855 44.4967 28.4411 44.4967 28.4884 44.5242L28.3394 44.4374C28.3394 44.4374 28.3289 44.4321 28.3236 44.4289C28.3215 44.4289 28.3205 44.4279 28.3184 44.4268C28.2607 44.4014 28.1935 44.4067 28.1348 44.4268C28.076 44.4458 28.0204 44.4797 27.9721 44.5178L27.9679 44.521C27.9679 44.521 27.9627 44.5252 27.9595 44.5274C27.7833 44.6745 27.6574 44.9052 27.6406 45.136C27.6322 45.2461 27.6532 45.3837 27.7581 45.4451L27.9071 45.5319C27.9071 45.5319 27.8987 45.5266 27.8945 45.5245L27.8913 45.5224C27.8913 45.5224 27.8861 45.5181 27.883 45.516H27.884Z",
    fill: "white"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1968 44.5538C27.9702 44.6861 27.7876 45.0058 27.7876 45.2683C27.7876 45.5308 27.9723 45.6366 28.1989 45.5054C28.4255 45.3731 28.6081 45.0534 28.6081 44.7909C28.6081 44.5284 28.4234 44.4225 28.1968 44.5548V44.5538Z",
    fill: "url(#paint31_linear_917_439)"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2526 43.7102C29.0071 43.8531 28.8088 44.1993 28.8098 44.484C28.8098 44.7688 29.0102 44.8831 29.2557 44.7402C29.5013 44.5973 29.6996 44.2511 29.6985 43.9664C29.6985 43.6816 29.4981 43.5673 29.2526 43.7102Z",
    fill: "#4E5EA6"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1013 44.8059C29.0257 44.7456 29.0069 44.6291 29.01 44.536C29.0174 44.3116 29.138 44.0946 29.2943 43.939C29.3636 43.8691 29.4528 43.8151 29.5504 43.7961C29.6028 43.7866 29.6584 43.7866 29.7056 43.8141L29.5567 43.7273C29.5567 43.7273 29.5462 43.722 29.5409 43.7188C29.5388 43.7188 29.5378 43.7178 29.5357 43.7167C29.478 43.6913 29.4108 43.6977 29.3521 43.7167C29.2933 43.7358 29.2377 43.7696 29.1894 43.8077L29.1852 43.8109C29.1852 43.8109 29.18 43.8151 29.1768 43.8173C29.0006 43.9644 28.8747 44.1952 28.8579 44.4259C28.8495 44.536 28.8705 44.6736 28.9754 44.735L29.1244 44.8218C29.1244 44.8218 29.116 44.8165 29.1118 44.8144L29.1086 44.8123C29.1086 44.8123 29.1034 44.808 29.1002 44.8059H29.1013Z",
    fill: "white"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4141 43.8426C29.1875 43.9749 29.0049 44.2946 29.0049 44.5571C29.0049 44.8196 29.1896 44.9254 29.4162 44.7942C29.6428 44.6619 29.8254 44.3422 29.8254 44.0797C29.8254 43.8172 29.6407 43.7113 29.4141 43.8436V43.8426Z",
    fill: "url(#paint32_linear_917_439)"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4696 42.9998C30.2241 43.1427 30.0258 43.4888 30.0269 43.7736C30.0269 44.0583 30.2273 44.1726 30.4728 44.0297C30.7183 43.8868 30.9166 43.5407 30.9156 43.2559C30.9156 42.9712 30.7152 42.8569 30.4696 42.9998Z",
    fill: "#4E5EA6"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3174 44.0955C30.2418 44.0351 30.2229 43.9187 30.2261 43.8256C30.2334 43.6011 30.3541 43.3842 30.5104 43.2285C30.5797 43.1587 30.6689 43.1047 30.7664 43.0856C30.8189 43.0761 30.8745 43.0761 30.9217 43.1036L30.7727 43.0168C30.7727 43.0168 30.7622 43.0116 30.757 43.0084C30.7549 43.0084 30.7538 43.0073 30.7517 43.0063C30.694 42.9809 30.6269 42.9872 30.5681 43.0063C30.5094 43.0253 30.4538 43.0592 30.4055 43.0973L30.4013 43.1005C30.4013 43.1005 30.396 43.1047 30.3929 43.1068C30.2166 43.254 30.0907 43.4847 30.0739 43.7155C30.0655 43.8256 30.0865 43.9632 30.1914 44.0246L30.3404 44.1114C30.3404 44.1114 30.332 44.1061 30.3278 44.1039L30.3247 44.1018C30.3247 44.1018 30.3195 44.0976 30.3163 44.0955H30.3174Z",
    fill: "white"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6311 43.1322C30.4045 43.2645 30.2219 43.5842 30.2219 43.8467C30.2219 44.1092 30.4066 44.2151 30.6332 44.0828C30.8599 43.9505 31.0424 43.6308 31.0424 43.3683C31.0424 43.1057 30.8578 42.9999 30.6311 43.1322Z",
    fill: "url(#paint33_linear_917_439)"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6867 42.2896C31.4412 42.4325 31.2429 42.7786 31.2439 43.0634C31.2439 43.3481 31.4443 43.4624 31.6898 43.3195C31.9353 43.1766 32.1336 42.8305 32.1326 42.5457C32.1326 42.261 31.9322 42.1467 31.6867 42.2896Z",
    fill: "#4E5EA6"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5344 43.385C31.4588 43.3247 31.44 43.2083 31.4431 43.1151C31.4505 42.8907 31.5711 42.6737 31.7275 42.5181C31.7967 42.4482 31.8859 42.3943 31.9835 42.3752C32.0359 42.3657 32.0915 42.3657 32.1388 42.3932L31.9898 42.3064C31.9898 42.3064 31.9793 42.3011 31.974 42.2979C31.9719 42.2979 31.9709 42.2969 31.9688 42.2958C31.9111 42.2704 31.8439 42.2768 31.7852 42.2958C31.7264 42.3149 31.6708 42.3487 31.6225 42.3868L31.6183 42.39C31.6183 42.39 31.6131 42.3943 31.6099 42.3964C31.4337 42.5435 31.3078 42.7743 31.291 43.005C31.2826 43.1151 31.3036 43.2527 31.4085 43.3141L31.5575 43.4009C31.5575 43.4009 31.5491 43.3956 31.5449 43.3935L31.5417 43.3914C31.5417 43.3914 31.5365 43.3872 31.5333 43.385H31.5344Z",
    fill: "white"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8482 42.4217C31.6215 42.554 31.439 42.8737 31.439 43.1362C31.439 43.3987 31.6236 43.5045 31.8503 43.3733C32.0769 43.241 32.2595 42.9213 32.2595 42.6588C32.2595 42.3963 32.0748 42.2904 31.8482 42.4227V42.4217Z",
    fill: "url(#paint34_linear_917_439)"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8183 46.564C26.5727 46.7069 26.3744 47.053 26.3755 47.3378C26.3755 47.6225 26.5759 47.7368 26.8214 47.5939C27.0669 47.451 27.2652 47.1049 27.2642 46.8201C27.2642 46.5354 27.0638 46.4211 26.8183 46.564Z",
    fill: "#4E5EA6"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 47.6597C26.5914 47.5994 26.5725 47.4829 26.5757 47.3898C26.583 47.1654 26.7037 46.9484 26.86 46.7928C26.9293 46.7229 27.0185 46.6679 27.116 46.6499C27.1685 46.6403 27.2241 46.6403 27.2713 46.6679L27.1223 46.5811C27.1223 46.5811 27.1118 46.5758 27.1066 46.5726C27.1045 46.5726 27.1034 46.5715 27.1013 46.5705C27.0436 46.5451 26.9765 46.5514 26.9177 46.5705C26.859 46.5895 26.8034 46.6234 26.7551 46.6615L26.7509 46.6647C26.7509 46.6647 26.7457 46.6689 26.7425 46.671C26.5662 46.8182 26.4403 47.0489 26.4235 47.2797C26.4151 47.3898 26.4361 47.5274 26.5411 47.5888L26.69 47.6756C26.69 47.6756 26.6817 47.6703 26.6775 47.6682L26.6743 47.666C26.6743 47.666 26.6691 47.6618 26.6659 47.6597H26.667Z",
    fill: "white"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9798 46.6964C26.7531 46.8287 26.5706 47.1484 26.5706 47.4109C26.5706 47.6734 26.7552 47.7793 26.9819 47.647C27.2085 47.5147 27.3911 47.195 27.3911 46.9325C27.3911 46.67 27.2064 46.5641 26.9798 46.6964Z",
    fill: "url(#paint35_linear_917_439)"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0353 45.8535C27.7898 45.9964 27.5915 46.3426 27.5925 46.6273C27.5936 46.9121 27.7929 47.0264 28.0385 46.8835C28.284 46.7406 28.4823 46.3944 28.4812 46.1097C28.4812 45.825 28.2808 45.7106 28.0353 45.8535Z",
    fill: "#4E5EA6"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M27.884 46.9491C27.8085 46.8888 27.7896 46.7724 27.7927 46.6792C27.8001 46.4559 27.9207 46.2378 28.0771 46.0822C28.1463 46.0123 28.2355 45.9573 28.3331 45.9393C28.3855 45.9298 28.4411 45.9298 28.4884 45.9573L28.3394 45.8705C28.3394 45.8705 28.3289 45.8652 28.3236 45.862C28.3215 45.862 28.3205 45.861 28.3184 45.8599C28.2607 45.8345 28.1935 45.8398 28.1348 45.8599C28.076 45.879 28.0204 45.9128 27.9721 45.9509L27.9679 45.9541C27.9679 45.9541 27.9627 45.9583 27.9595 45.9605C27.7833 46.1076 27.6574 46.3384 27.6406 46.5691C27.6322 46.6792 27.6532 46.8168 27.7581 46.8782L27.9071 46.965C27.9071 46.965 27.8987 46.9597 27.8945 46.9576L27.8913 46.9555C27.8913 46.9555 27.8861 46.9512 27.883 46.9491H27.884Z",
    fill: "white"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1968 45.9858C27.9702 46.1181 27.7876 46.4378 27.7876 46.7003C27.7876 46.9628 27.9723 47.0686 28.1989 46.9374C28.4255 46.8051 28.6081 46.4854 28.6081 46.2229C28.6081 45.9604 28.4234 45.8545 28.1968 45.9858Z",
    fill: "url(#paint36_linear_917_439)"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2526 45.1424C29.0071 45.2853 28.8088 45.6314 28.8098 45.9161C28.8098 46.2009 29.0102 46.3152 29.2557 46.1723C29.5013 46.0294 29.6996 45.6833 29.6985 45.3985C29.6985 45.1138 29.4981 44.9995 29.2526 45.1424Z",
    fill: "#4E5EA6"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1013 46.239C29.0257 46.1787 29.0069 46.0623 29.01 45.9691C29.0174 45.7447 29.138 45.5277 29.2943 45.3721C29.3636 45.3022 29.4528 45.2472 29.5504 45.2292C29.6028 45.2197 29.6584 45.2197 29.7056 45.2472L29.5567 45.1604C29.5567 45.1604 29.5462 45.1551 29.5409 45.1519C29.5388 45.1519 29.5378 45.1509 29.5357 45.1498C29.478 45.1244 29.4108 45.1308 29.3521 45.1498C29.2933 45.1689 29.2377 45.2027 29.1894 45.2408L29.1852 45.244C29.1852 45.244 29.18 45.2483 29.1768 45.2504C29.0006 45.3975 28.8747 45.6283 28.8579 45.859C28.8495 45.9691 28.8705 46.1067 28.9754 46.1681L29.1244 46.2549C29.1244 46.2549 29.116 46.2496 29.1118 46.2475L29.1086 46.2454C29.1086 46.2454 29.1034 46.2412 29.1002 46.239H29.1013Z",
    fill: "white"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4141 45.2758C29.1875 45.4081 29.0049 45.7278 29.0049 45.9903C29.0049 46.2528 29.1896 46.3586 29.4162 46.2263C29.6428 46.094 29.8254 45.7743 29.8254 45.5118C29.8254 45.2493 29.6407 45.1435 29.4141 45.2758Z",
    fill: "url(#paint37_linear_917_439)"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4696 44.4319C30.2241 44.5748 30.0258 44.9209 30.0269 45.2057C30.0269 45.4904 30.2273 45.6048 30.4728 45.4619C30.7183 45.319 30.9166 44.9728 30.9156 44.6881C30.9156 44.4033 30.7152 44.289 30.4696 44.4319Z",
    fill: "#4E5EA6"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3174 45.5274C30.2418 45.467 30.2229 45.3506 30.2261 45.2574C30.2334 45.033 30.3541 44.816 30.5104 44.6604C30.5797 44.5906 30.6689 44.5366 30.7664 44.5175C30.8189 44.508 30.8745 44.508 30.9217 44.5355L30.7727 44.4487C30.7727 44.4487 30.7622 44.4434 30.757 44.4403C30.7549 44.4403 30.7538 44.4392 30.7517 44.4381C30.694 44.4127 30.6269 44.4191 30.5681 44.4381C30.5094 44.4572 30.4538 44.4911 30.4055 44.5292L30.4013 44.5324C30.4013 44.5324 30.396 44.5366 30.3929 44.5387C30.2166 44.6858 30.0907 44.9166 30.0739 45.1474C30.0655 45.2574 30.0865 45.3951 30.1914 45.4565L30.3404 45.5433C30.3404 45.5433 30.332 45.538 30.3278 45.5358L30.3247 45.5337C30.3247 45.5337 30.3195 45.5295 30.3163 45.5274H30.3174Z",
    fill: "white"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6311 44.5651C30.4045 44.6974 30.2219 45.0171 30.2219 45.2796C30.2219 45.5421 30.4066 45.6479 30.6332 45.5156C30.8599 45.3833 31.0424 45.0636 31.0424 44.8011C31.0424 44.5386 30.8578 44.4328 30.6311 44.5651Z",
    fill: "url(#paint38_linear_917_439)"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6867 43.7217C31.4412 43.8646 31.2429 44.2107 31.2439 44.4955C31.2439 44.7802 31.4443 44.8945 31.6898 44.7516C31.9353 44.6087 32.1336 44.2626 32.1326 43.9779C32.1326 43.6931 31.9322 43.5788 31.6867 43.7217Z",
    fill: "#4E5EA6"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5344 44.8174C31.4588 44.7571 31.44 44.6406 31.4431 44.5475C31.4505 44.3231 31.5711 44.1061 31.7275 43.9505C31.7967 43.8806 31.8859 43.8266 31.9835 43.8076C32.0359 43.798 32.0915 43.798 32.1388 43.8256L31.9898 43.7388C31.9898 43.7388 31.9793 43.7335 31.974 43.7303C31.9719 43.7303 31.9709 43.7292 31.9688 43.7282C31.9111 43.7028 31.8439 43.7091 31.7852 43.7282C31.7264 43.7472 31.6708 43.7811 31.6225 43.8192L31.6183 43.8224C31.6183 43.8224 31.6131 43.8266 31.6099 43.8287C31.4337 43.9759 31.3078 44.2066 31.291 44.4374C31.2826 44.5475 31.3036 44.6851 31.4085 44.7465L31.5575 44.8333C31.5575 44.8333 31.5491 44.828 31.5449 44.8259L31.5417 44.8238C31.5417 44.8238 31.5365 44.8195 31.5333 44.8174H31.5344Z",
    fill: "white"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8482 43.8552C31.6215 43.9876 31.439 44.3072 31.439 44.5697C31.439 44.8323 31.6236 44.9381 31.8503 44.8058C32.0769 44.6735 32.2595 44.3538 32.2595 44.0913C32.2595 43.8288 32.0748 43.7229 31.8482 43.8542V43.8552Z",
    fill: "url(#paint39_linear_917_439)"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6343 53.1098L25.6872 48.4132V45.751L17.6343 50.4476V53.1098Z",
    fill: "#258BE0"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M17.928 52.6166L18.7023 52.1656V51.8555L17.928 52.3064V52.6166Z",
    fill: "white"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9312 52.0344L19.7055 51.5835V51.2744L18.9312 51.7253V52.0344Z",
    fill: "white"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9343 51.4532L20.7087 51.0023V50.6921L19.9343 51.1431V51.4532Z",
    fill: "white"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9404 50.2899L22.7148 49.8379V49.5288L21.9404 49.9797V50.2899Z",
    fill: "white"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9446 49.7076L23.7179 49.2567V48.9465L22.9446 49.3985V49.7076Z",
    fill: "white"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M17.928 50.9103L18.7023 50.4593V50.1492L17.928 50.6012V50.9103Z",
    fill: "white"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9312 50.3279L19.7055 49.877V49.5679L18.9312 50.0188V50.3279Z",
    fill: "white"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9343 49.7469L20.7087 49.296V48.9858L19.9343 49.4378V49.7469Z",
    fill: "white"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9404 48.5836L22.7148 48.1327V47.8225L21.9404 48.2734V48.5836Z",
    fill: "white"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9446 48.0015L23.7179 47.5505V47.2415L22.9446 47.6924V48.0015Z",
    fill: "white"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7085 50.4424V50.3069L17.928 51.9286V52.064L20.7085 50.4424Z",
    fill: "white"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7085 50.167V50.0315L17.928 51.6542V51.7886L20.7085 50.167Z",
    fill: "white"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7085 49.892V49.7576L17.928 51.3792V51.5137L20.7085 49.892Z",
    fill: "white"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3577 53.5205V56.1827L17.3478 53.2728V50.6106L12.3577 53.5205Z",
    fill: "#258BE0"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 52.6947V52.5603L12.5381 54.182V54.3164L15.3186 52.6947Z",
    fill: "white"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 52.4196V52.2852L12.5381 53.9068V54.0412L15.3186 52.4196Z",
    fill: "white"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 52.1444V52.01L12.5381 53.6317V53.7661L15.3186 52.1444Z",
    fill: "white"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 53.9313V53.7969L12.5381 55.4185V55.553L15.3186 53.9313Z",
    fill: "white"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 53.6559V53.5215L12.5381 55.1432V55.2776L15.3186 53.6559Z",
    fill: "white"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3186 53.3808V53.2463L12.5381 54.868V55.0024L15.3186 53.3808Z",
    fill: "white"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M131.659 0.517015C132.958 1.27386 134.099 2.71028 134.763 4.26631C135.081 4.34993 135.415 4.48966 135.76 4.69077C137.765 5.85833 139.396 8.64648 139.475 10.9964L139.595 11.0663C141.156 11.9755 142.418 14.1794 142.412 15.9884C142.407 17.7974 141.138 18.5267 139.577 17.6185L124.461 8.81373C122.9 7.90445 121.639 5.70061 121.644 3.89159C121.649 2.09951 122.895 1.36701 124.434 2.23606C124.978 0.934074 126.335 0.576293 127.92 1.50038C127.967 1.52685 128.012 1.55437 128.057 1.58295C128.501 0.0163335 129.946 -0.481173 131.658 0.515957L131.659 0.517015Z",
    fill: "#39BAE9"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M145.937 94.9288C145.746 94.7319 145.523 94.5562 145.268 94.408L69.6163 50.2623C67.8043 49.2069 65.5705 49.208 63.7595 50.2644L20.4775 75.5282H17.4903V78.6847C17.484 79.5262 17.8932 80.3709 18.719 80.8515L94.2639 124.935C96.7192 126.365 99.7452 126.364 102.199 124.932L145.272 99.7896C146.292 99.1947 146.804 98.1552 146.809 97.1147V93.8915L145.937 94.9299V94.9288Z",
    fill: "#C2E6F8"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M100.717 125.601C101.227 125.43 101.723 125.209 102.198 124.932L145.271 99.7896C146.291 99.1947 146.803 98.1553 146.808 97.1147V93.8915L145.936 94.9299C145.745 94.7331 145.522 94.5573 145.267 94.4091L141.553 92.2466L100.716 115.142V125.602L100.717 125.601Z",
    fill: "#39BAE9"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1243 125.717C96.8797 125.927 97.6593 126.02 98.4368 125.999V120.94H96.1243V125.717Z",
    fill: "#C2E6F8"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M145.268 91.2315L69.6164 47.0858C67.8044 46.0304 65.5705 46.0315 63.7596 47.0879L18.7169 73.3785C17.078 74.3343 17.0791 76.7202 18.718 77.675L94.263 121.758C96.7182 123.188 99.7442 123.187 102.198 121.755L145.27 96.612C147.323 95.4148 147.322 92.4266 145.268 91.2315Z",
    fill: "#ECF3FA"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M177.345 76.6248C177.154 76.4279 176.931 76.2522 176.676 76.104L101.024 31.9593C99.2124 30.904 96.9786 30.905 95.1676 31.9614L78.2497 41.8216H75.2625V44.9781C75.2562 45.8196 75.6654 46.6643 76.4912 47.1449L152.036 91.2282C154.491 92.6582 157.517 92.6572 159.972 91.225L176.68 81.4866C177.7 80.8917 178.212 79.8522 178.217 78.8117V75.5885L177.345 76.6269V76.6248Z",
    fill: "#C2E6F8"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M158.489 91.8931C158.999 91.7227 159.495 91.5014 159.97 91.2241L176.678 81.4857C177.699 80.8908 178.211 79.8513 178.216 78.8108V75.5876L177.344 76.626C177.153 76.4291 176.93 76.2534 176.675 76.1052L172.961 73.9426L158.488 81.4349V91.8941L158.489 91.8931Z",
    fill: "#39BAE9"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M153.897 92.0095C154.653 92.2191 155.433 92.3123 156.21 92.2911V87.2324H153.897V92.0095Z",
    fill: "#39BAE9"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M176.676 72.9275L101.024 28.7828C99.2122 27.7274 96.9784 27.7285 95.1674 28.7849L76.4889 39.6708C74.85 40.6266 74.8511 43.0125 76.49 43.9673L152.035 88.0506C154.49 89.4807 157.516 89.4796 159.97 88.0474L176.678 78.309C178.731 77.1118 178.73 74.1236 176.676 72.9285V72.9275Z",
    fill: "#ECF3FA"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4451 73.8676L65.0146 48.4429C66.0586 47.8353 67.345 47.8353 68.3879 48.4439L94.3282 63.5851C95.2714 64.1355 95.2714 65.5094 94.3282 66.0599L50.8206 91.4475C49.4062 92.2711 47.6634 92.27 46.2501 91.4454L21.4441 76.9659C20.2626 76.2768 20.2626 74.5556 21.4451 73.8676Z",
    fill: "#2B6AB1"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4451 74.9928L65.0146 49.5681C66.0586 48.9605 67.345 48.9605 68.3879 49.5691L94.3282 64.7103C94.6115 64.8754 94.8087 65.1157 94.9221 65.3845C95.1854 64.7579 94.9882 63.9693 94.3282 63.5851L68.3879 48.4439C67.345 47.8353 66.0586 47.8353 65.0146 48.4429L21.4451 73.8676C20.6676 74.3206 20.4011 75.2204 20.6467 75.9793C20.7747 75.5845 21.0401 75.2278 21.4451 74.9917V74.9928Z",
    fill: "#B8BCFC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4981 72.2246L58.7957 76.7064L66.3869 81.1289L74.082 76.6514L66.4981 72.2246ZM59.3308 76.7064L66.497 72.5369L73.5458 76.6514L66.3858 80.8177L59.3297 76.7064H59.3308Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7154 73.2874L66.4783 73.426L71.9427 76.6048L72.1798 76.4672L66.7154 73.2874Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0386 73.6811L71.503 76.8609L71.7401 76.7223L66.2757 73.5425L66.0386 73.6811Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5979 73.9362L71.0634 77.116L71.3005 76.9784L65.835 73.7986L65.5979 73.9362Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2253 75.395L70.6238 77.3713L70.8609 77.2337L67.4625 75.2563L67.2253 75.395Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2298 75.8977L61.9927 76.0364L67.4581 79.2151L67.6953 79.0775L62.2298 75.8977Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5532 76.2915L67.0187 79.4713L67.2558 79.3326L61.7904 76.1528L61.5532 76.2915Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1135 76.5465L66.578 79.7264L66.8151 79.5887L61.3507 76.4089L61.1135 76.5465Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M62.741 78.0051L66.1384 79.9814L66.3755 79.8438L62.9781 77.8665L62.741 78.0051Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8797 77.2515L50.1772 81.7333L57.7685 86.1558L65.4636 81.6782L57.8797 77.2515ZM50.7124 81.7333L57.8786 77.5637L64.9274 81.6782L57.7674 85.8446L50.7113 81.7333H50.7124Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3243 80.1782C58.9529 79.3748 56.7149 79.3748 55.3341 80.1782C53.9544 80.9817 53.947 82.29 55.3173 83.0945C56.6887 83.899 58.9277 83.899 60.3075 83.0945C61.6872 82.2911 61.6946 80.9827 60.3232 80.1782H60.3243ZM59.7472 82.6933C58.678 83.2914 56.9436 83.2914 55.8818 82.6933C54.82 82.0952 54.8252 81.1214 55.8944 80.5233C56.9636 79.9253 58.698 79.9253 59.7598 80.5233C60.8216 81.1214 60.8164 82.0952 59.7472 82.6933Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5226 81.0135L59.3232 80.897C59.2991 80.8833 59.2603 80.8833 59.2372 80.897L58.9465 81.0674L58.7629 80.9605L59.0536 80.7901C59.0777 80.7763 59.0767 80.7541 59.0536 80.7393L58.8542 80.6229C58.8301 80.6091 58.7913 80.6091 58.7682 80.6229L58.4775 80.7933L57.9152 80.4662C57.89 80.4514 57.8501 80.4514 57.826 80.4662L57.6339 80.5784C57.6098 80.5932 57.6098 80.6165 57.6339 80.6303L57.6696 80.6514C57.7231 80.6821 57.7546 80.7065 57.7641 80.7234C57.7735 80.7404 57.7735 80.7552 57.7641 80.77C57.7557 80.7848 57.721 80.8092 57.6602 80.8441L56.5291 81.5078C56.4703 81.5427 56.4284 81.5628 56.4032 81.5681C56.378 81.5734 56.3518 81.5734 56.3235 81.5681C56.2951 81.5628 56.2542 81.5438 56.2007 81.5131L56.165 81.4919C56.1398 81.4771 56.1 81.4771 56.0758 81.4919L55.8838 81.6041C55.8597 81.6189 55.8597 81.6422 55.8838 81.656L56.4462 81.9831L56.1577 82.1524C56.1325 82.1672 56.1325 82.1905 56.1577 82.2054L56.3528 82.3197C56.378 82.3345 56.4179 82.3345 56.4431 82.3197L56.7316 82.1503L56.9163 82.2572L56.6277 82.4266C56.6026 82.4414 56.6026 82.4647 56.6277 82.4795L56.8229 82.5938C56.8481 82.6086 56.8879 82.6086 56.9131 82.5938L57.2185 82.4149C57.3223 82.4615 57.4178 82.4964 57.5049 82.5176C57.6707 82.5589 57.8333 82.5727 57.9896 82.5578C58.146 82.543 58.2771 82.5039 58.3852 82.4403C58.4744 82.3874 58.5352 82.3271 58.5657 82.2593C58.5961 82.1916 58.5951 82.1238 58.5625 82.0572C58.5405 82.0106 58.4943 81.9524 58.423 81.8825C58.5426 81.9164 58.6517 81.9365 58.7524 81.9407C58.8521 81.945 58.9476 81.9386 59.0368 81.9195C59.126 81.9016 59.2036 81.8719 59.2708 81.8327C59.3631 81.7788 59.4198 81.7131 59.4428 81.6359C59.4649 81.5586 59.446 81.4792 59.3862 81.3956C59.3516 81.3469 59.2949 81.295 59.2204 81.24L59.5226 81.0632C59.5467 81.0494 59.5457 81.0272 59.5226 81.0124V81.0135ZM58.019 81.9852C58.0054 82.0265 57.9687 82.0635 57.9089 82.0995C57.8386 82.1408 57.7578 82.1651 57.6675 82.1715C57.5773 82.1778 57.4955 82.1694 57.422 82.145C57.3486 82.1217 57.2699 82.0847 57.1828 82.0339L57.0338 81.9471C56.9845 81.9185 56.9561 81.8984 56.9509 81.8888C56.9446 81.8793 56.9467 81.8687 56.9551 81.8582C56.9614 81.8497 56.996 81.8275 57.0569 81.7904L57.4965 81.5332L57.7609 81.6867C57.8774 81.7544 57.9519 81.8105 57.9875 81.856C58.0232 81.9016 58.0337 81.945 58.0201 81.9852H58.019ZM58.7965 81.4856C58.785 81.5237 58.7535 81.5575 58.7 81.5893C58.6486 81.6189 58.5888 81.638 58.5216 81.6443C58.4534 81.6507 58.3821 81.6443 58.3065 81.6221C58.231 81.6009 58.1344 81.5565 58.0169 81.4877L57.7934 81.3575L58.2887 81.0674L58.5122 81.1976C58.6433 81.2738 58.7262 81.331 58.7608 81.3702C58.7965 81.4093 58.808 81.4474 58.7965 81.4856Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2613 82.2786L41.5588 86.7604L49.1501 91.1829L56.8451 86.7053L49.2613 82.2786ZM42.0939 86.7604L49.2602 82.5908L56.309 86.7053L49.149 90.8717L42.0929 86.7604H42.0939Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4009 56.7119L66.6985 61.1937L74.2897 65.6162L81.9848 61.1387L74.4009 56.7119ZM67.2336 61.1937L74.3999 57.0242L81.4486 61.1387L74.2887 65.305L67.2325 61.1937H67.2336Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3746 59.0798L72.1375 59.2185L77.6019 62.3983L77.839 62.2596L72.3746 59.0798Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M71.698 59.4736L77.1624 62.6534L77.3995 62.5157L71.9351 59.3359L71.698 59.4736Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2583 59.7297L76.7227 62.9085L76.9598 62.7709L71.4954 59.5911L71.2583 59.7297Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8845 61.1875L76.283 63.1648L76.5201 63.0261L73.1216 61.0488L72.8845 61.1875Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1326 60.385L69.8955 60.5237L75.3599 63.7035L75.5971 63.5648L70.1326 60.385Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4558 60.7787L74.9202 63.9585L75.1574 63.8209L69.6929 60.6411L69.4558 60.7787Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0151 61.0349L74.4806 64.2137L74.7177 64.076L69.2523 60.8962L69.0151 61.0349Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6426 62.4927L74.0411 64.47L74.2782 64.3313L70.8797 62.354L70.6426 62.4927Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7825 61.7388L58.0801 66.2206L65.6713 70.6431L73.3664 66.1655L65.7825 61.7388ZM58.6152 66.2206L65.7815 62.051L72.8302 66.1655L65.6703 70.3319L58.6141 66.2206H58.6152Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9986 62.8015L65.7615 62.9402L71.2259 66.12L71.463 65.9813L65.9986 62.8015Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M65.322 63.1952L70.7864 66.375L71.0236 66.2374L65.5591 63.0576L65.322 63.1952Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8823 63.4514L70.3467 66.6302L70.5839 66.4926L65.1195 63.3127L64.8823 63.4514Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5085 64.9089L69.907 66.8863L70.1441 66.7476L66.7457 64.7703L66.5085 64.9089Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7564 64.1067L63.5193 64.2454L68.9837 67.4252L69.2208 67.2865L63.7564 64.1067Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0796 64.5004L68.544 67.6802L68.7811 67.5426L63.3167 64.3628L63.0796 64.5004Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6389 64.7566L68.1044 67.9353L68.3415 67.7977L62.876 64.6179L62.6389 64.7566Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2664 66.2141L67.6648 68.1914L67.902 68.0528L64.5035 66.0754L64.2664 66.2141Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5142 65.4119L61.2771 65.5505L66.7415 68.7303L66.9787 68.5917L61.5142 65.4119Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8364 65.8056L66.3019 68.9854L66.539 68.8478L61.0736 65.668L60.8364 65.8056Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3967 66.0618L65.8622 69.2405L66.0993 69.1029L60.6339 65.9231L60.3967 66.0618Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0242 67.5195L65.4226 69.4969L65.6598 69.3582L62.2613 67.3809L62.0242 67.5195Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1641 66.7659L49.4617 71.2477L57.0529 75.6702L64.748 71.1926L57.1641 66.7659ZM49.9968 71.2477L57.1631 67.0781L64.2118 71.1926L57.0518 75.359L49.9957 71.2477H49.9968Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M57.38 67.8298L57.1428 67.9674L62.6072 71.1472L62.8444 71.0086L57.38 67.8298Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7034 68.2226L62.1678 71.4024L62.4049 71.2648L56.9405 68.085L56.7034 68.2226Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2637 68.4788L61.7281 71.6586L61.9652 71.5199L56.5008 68.3401L56.2637 68.4788Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8899 69.9364L61.2884 71.9138L61.5255 71.7751L58.127 69.7988L57.8899 69.9364Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M55.138 69.135L54.9009 69.2726L60.3653 72.4524L60.6024 72.3138L55.138 69.135Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4602 69.5277L59.9257 72.7076L60.1628 72.5699L54.6973 69.3901L54.4602 69.5277Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0205 69.7839L59.486 72.9638L59.7231 72.8251L54.2576 69.6453L54.0205 69.7839Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6479 71.2416L59.0464 73.2189L59.2835 73.0803L55.8851 71.104L55.6479 71.2416Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8946 70.4402L52.6575 70.5778L58.1229 73.7576L58.3601 73.6189L52.8946 70.4402Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M52.218 70.8329L57.6835 74.0127L57.9206 73.8751L52.4551 70.6953L52.218 70.8329Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7783 71.0891L57.2438 74.2689L57.4809 74.1302L52.0154 70.9504L51.7783 71.0891Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4058 72.5468L56.8032 74.5241L57.0403 74.3854L53.6429 72.4092L53.4058 72.5468Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5447 71.7937L40.8423 76.2755L48.4335 80.698L56.1286 76.2205L48.5447 71.7937ZM41.3774 76.2755L48.5437 72.106L55.5924 76.2205L48.4325 80.3868L41.3763 76.2755H41.3774Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9261 76.8208L32.2236 81.3026L39.8148 85.7251L47.5099 81.2475L39.9261 76.8208ZM32.7587 81.3026L39.925 77.1331L46.9738 81.2475L39.8138 85.4139L32.7577 81.3026H32.7587Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1432 77.8835L39.905 78.0212L45.3705 81.201L45.6076 81.0633L40.1432 77.8835Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4656 78.2773L44.931 81.4561L45.1682 81.3185L39.7027 78.1387L39.4656 78.2773Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0259 78.5325L44.4913 81.7123L44.7285 81.5736L39.263 78.3938L39.0259 78.5325Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6533 79.9901L44.0518 81.9675L44.2889 81.8299L40.8904 79.8525L40.6533 79.9901Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9 79.1887L37.6628 79.3263L43.1283 82.5061L43.3654 82.3685L37.9 79.1887Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2231 79.5825L42.6886 82.7612L42.9257 82.6236L37.4603 79.4438L37.2231 79.5825Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7837 79.8376L42.2481 83.0175L42.4863 82.8788L37.0208 79.699L36.7837 79.8376Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4109 81.2953L41.8083 83.2727L42.0454 83.135L38.648 81.1577L38.4109 81.2953Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M35.658 80.4939L35.4209 80.6315L40.8864 83.8113L41.1235 83.6737L35.658 80.4939Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9812 80.8877L40.4456 84.0664L40.6828 83.9288L35.2183 80.749L34.9812 80.8877Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5415 81.1428L40.0059 84.3226L40.2431 84.184L34.7786 81.0042L34.5415 81.1428Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M36.168 82.6005L39.5664 84.5778L39.8036 84.4402L36.4051 82.4629L36.168 82.6005Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M65.066 51.2542L57.3635 55.7359L64.9547 60.1585L72.6498 55.6809L65.066 51.2542ZM57.8986 55.7359L65.0649 51.5664L72.1137 55.6809L64.9537 59.8472L57.8976 55.7359H57.8986Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2821 52.3169L65.0449 52.4545L70.5104 55.6343L70.7475 55.4967L65.2821 52.3169Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6052 52.7107L70.0707 55.8905L70.3078 55.7518L64.8424 52.572L64.6052 52.7107Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1658 52.9657L69.6302 56.1455L69.8673 56.0069L64.4029 52.8281L64.1658 52.9657Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M65.793 54.4235L69.1904 56.4008L69.4275 56.2632L66.0301 54.2859L65.793 54.4235Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0401 53.6221L62.803 53.7597L68.2685 56.9395L68.5056 56.8019L63.0401 53.6221Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3633 54.0159L67.8277 57.1957L68.0648 57.057L62.6004 53.8772L62.3633 54.0159Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9236 54.2709L67.388 57.4507L67.6251 57.312L62.1607 54.1333L61.9236 54.2709Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M63.55 55.7287L66.9485 57.706L67.1857 57.5684L63.7872 55.5911L63.55 55.7287Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7979 54.9272L60.5608 55.0649L66.0252 58.2446L66.2623 58.107L60.7979 54.9272Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1211 55.321L65.5855 58.5009L65.8226 58.3622L60.3582 55.1824L60.1211 55.321Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6814 55.5761L65.1458 58.7559L65.3829 58.6172L59.9185 55.4385L59.6814 55.5761Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3076 57.0338L64.7061 59.0112L64.9432 58.8736L61.5447 56.8962L61.3076 57.0338Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4475 56.2812L48.7451 60.763L56.3363 65.1856L64.0314 60.708L56.4475 56.2812ZM49.2802 60.763L56.4465 56.5935L63.4953 60.708L56.3353 64.8743L49.2792 60.763H49.2802Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8289 61.3081L40.1265 65.7899L47.7177 70.2124L55.4128 65.7349L47.8289 61.3081ZM40.6616 65.7899L47.8279 61.6204L54.8766 65.7349L47.7166 69.9012L40.6605 65.7899H40.6616Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0452 62.3708L47.8081 62.5095L53.2725 65.6883L53.5097 65.5507L48.0452 62.3708Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3684 62.7646L52.8328 65.9444L53.0699 65.8058L47.6055 62.626L47.3684 62.7646Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9287 63.0197L52.3931 66.1995L52.6303 66.0619L47.1658 62.8821L46.9287 63.0197Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5549 64.4783L51.9534 66.4545L52.1905 66.3169L48.7921 64.3396L48.5549 64.4783Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8028 63.676L45.5657 63.8147L51.0301 66.9935L51.2672 66.8558L45.8028 63.676Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M45.126 64.0698L50.5904 67.2496L50.8275 67.111L45.3631 63.9312L45.126 64.0698Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6853 64.3249L50.1508 67.5047L50.3879 67.3671L44.9224 64.1873L44.6853 64.3249Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3127 65.7834L49.7112 67.7597L49.9483 67.6221L46.5499 65.6448L46.3127 65.7834Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5607 64.9812L43.3225 65.1199L48.788 68.2986L49.0251 68.161L43.5607 64.9812Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8828 65.375L48.3483 68.5548L48.5854 68.4161L43.1199 65.2363L42.8828 65.375Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4431 65.63L47.9086 68.8098L48.1457 68.6722L42.6802 65.4924L42.4431 65.63Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0706 67.0889L47.469 69.0651L47.7062 68.9275L44.3077 66.9502L44.0706 67.0889Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2107 66.335L31.5083 70.8168L39.0995 75.2393L46.7946 70.7617L39.2107 66.335ZM32.0434 70.8168L39.2097 66.6472L46.2585 70.7617L39.0985 74.9281L32.0424 70.8168H32.0434Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5911 71.3618L22.8887 75.8436L30.4799 80.2661L38.175 75.7886L30.5911 71.3618ZM23.4238 75.8436L30.5901 71.6741L37.6388 75.7886L30.4788 79.9549L23.4227 75.8436H23.4238Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8084 72.4246L30.5713 72.5632L36.0357 75.743L36.2728 75.6044L30.8084 72.4246Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1306 72.8183L35.5961 75.9981L35.8332 75.8594L30.3688 72.6807L30.1306 72.8183Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6909 73.0734L35.1564 76.2532L35.3935 76.1156L29.928 72.9358L29.6909 73.0734Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3184 74.532L34.7168 76.5093L34.954 76.3706L31.5555 74.3933L31.3184 74.532Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5653 73.7297L28.3281 73.8684L33.7936 77.0482L34.0307 76.9095L28.5653 73.7297Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8884 74.1234L33.3539 77.3033L33.591 77.1646L28.1256 73.9858L27.8884 74.1234Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4487 74.3786L32.9142 77.5584L33.1513 77.4208L27.6859 74.241L27.4487 74.3786Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0762 75.8372L32.4746 77.8145L32.7118 77.6758L29.3133 75.6985L29.0762 75.8372Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3231 75.0349L26.0859 75.1736L31.5514 78.3534L31.7885 78.2147L26.3231 75.0349Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6462 75.4286L31.1117 78.6084L31.3488 78.4698L25.8834 75.291L25.6462 75.4286Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2065 75.6837L30.671 78.8636L30.9081 78.7259L25.4437 75.5461L25.2065 75.6837Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8328 77.1426L30.2312 79.1199L30.4684 78.9812L27.0709 77.0039L26.8328 77.1426Z",
    fill: "white"
  }))))), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4722 74.5925L64.2351 74.7312L69.7006 77.9099L69.9377 77.7723L64.4722 74.5925Z",
    fill: "#F9CB69"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7954 74.9863L69.2609 78.1661L69.498 78.0275L64.0325 74.8477L63.7954 74.9863Z",
    fill: "#F9CB69"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3557 75.2414L68.8212 78.4212L69.0583 78.2836L63.5928 75.1038L63.3557 75.2414Z",
    fill: "#F9CB69"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9832 76.6999L68.3816 78.6762L68.6188 78.5386L65.2203 76.5613L64.9832 76.6999Z",
    fill: "#F9CB69"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6182 57.7747L74.3811 57.9123L79.8455 61.0921L80.0826 60.9545L74.6182 57.7747Z",
    fill: "#F9CB69"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9414 58.1685L79.4058 61.3483L79.6429 61.2096L74.1785 58.0298L73.9414 58.1685Z",
    fill: "#F9CB69"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5007 58.4235L78.9662 61.6033L79.2033 61.4646L73.7379 58.2859L73.5007 58.4235Z",
    fill: "#F9CB69"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1282 59.8813L78.5266 61.8586L78.7638 61.721L75.3653 59.7437L75.1282 59.8813Z",
    fill: "#F9CB69"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2942 60.1828C56.8367 59.9171 56.0991 59.9161 55.6448 60.1828C55.1905 60.4485 55.1936 60.8804 55.6501 61.1471C56.1075 61.4139 56.8451 61.4128 57.2995 61.1471C57.7538 60.8804 57.7517 60.4496 57.2942 60.1828Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2636 62.158C59.2584 61.2116 58.7852 60.458 57.8587 59.9181C57.8419 59.9086 57.8251 59.8991 57.8083 59.8895C56.9847 59.4249 55.9659 59.2174 55.2566 59.1264C54.4906 59.0268 53.9209 59.0364 53.8968 59.0364L53.6901 59.0406L53.6859 59.1613C53.6859 59.1761 53.6764 59.5201 53.86 59.9795C54.03 60.405 54.4046 61.0137 55.2314 61.4964C56.1589 62.0373 57.4442 62.3019 59.0496 62.285L59.2647 62.2829V62.1569L59.2636 62.158ZM55.5367 61.3143C54.7918 60.8793 54.4466 60.3214 54.2892 59.9298C54.1801 59.6598 54.1423 59.4291 54.1297 59.2936C54.711 59.3095 56.3362 59.4132 57.5051 60.0727C57.5208 60.0811 57.5355 60.0896 57.5502 60.0991C58.3508 60.5649 58.7778 61.2148 58.8219 62.0309C57.4411 62.0214 56.3383 61.7822 55.5367 61.3154V61.3143Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9351 85.6986L47.548 84.8857C47.4221 84.8116 47.2164 84.8116 47.0895 84.8857L46.6079 85.1662L46.1263 85.4467C45.9993 85.5208 45.9983 85.6404 46.1252 85.7145L47.5123 86.5274C47.5721 86.5624 47.6539 86.5825 47.7379 86.5825H48.8029C48.8637 86.5825 48.9193 86.5676 48.9602 86.5444C49.0001 86.5211 49.0253 86.4883 49.0263 86.4523L49.0295 85.8299C49.0295 85.7801 48.9959 85.7335 48.9361 85.6975L48.9351 85.6986Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6044 86.5825H50.6694C50.7544 86.5825 50.8352 86.5623 50.8961 86.5274L52.2926 85.7145C52.4195 85.6404 52.4206 85.5208 52.2936 85.4467L51.8152 85.1662L51.3367 84.8857C51.2108 84.8116 51.0052 84.8116 50.8782 84.8857L49.4817 85.6986C49.4219 85.7335 49.3873 85.7812 49.3873 85.8309L49.3831 86.4533C49.3831 86.5253 49.4817 86.5835 49.6044 86.5835V86.5825Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8007 86.7921H47.7358C47.6508 86.7921 47.57 86.8122 47.5091 86.8471L46.1126 87.6611C45.9856 87.7352 45.9846 87.8548 46.1115 87.9289L46.59 88.2094L47.0684 88.4899C47.1944 88.564 47.4 88.564 47.527 88.4899L48.9235 87.6759C48.9833 87.641 49.0179 87.5934 49.0179 87.5436L49.0221 86.9212C49.0221 86.8492 48.9235 86.7921 48.8007 86.791V86.7921Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M52.281 87.661L50.8939 86.848C50.8341 86.8131 50.7533 86.793 50.6683 86.793H49.6033C49.5425 86.793 49.4869 86.8078 49.446 86.8311C49.4061 86.8544 49.3809 86.8872 49.3799 86.9232L49.3767 87.5456C49.3767 87.5953 49.4092 87.643 49.4701 87.6779L50.8572 88.4908C50.9831 88.5649 51.1887 88.5649 51.3157 88.4908L51.7973 88.2103L52.2789 87.9298C52.4058 87.8557 52.4069 87.7361 52.2799 87.662L52.281 87.661Z",
    fill: "white"
  })))), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6276 67.9735L74.6255 68.958L74.6223 68.5282L74.6255 67.5427L74.6276 67.9735Z",
    fill: "#6B6F12"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4919 68.7188L79.4888 69.7042L78.9705 70.008L78.9726 69.0225L79.4919 68.7188Z",
    fill: "#F7AA67"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8271 69.0225L71.825 70.008L71.3025 69.7042L71.3056 68.7188L71.8271 69.0225Z",
    fill: "#F7AA67"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5046 70.0291C77.4826 69.9942 77.4595 69.9603 77.4322 69.9265C77.3241 69.792 77.1741 69.665 76.9831 69.5538C76.9579 69.539 76.9327 69.5253 76.9076 69.5115C76.8992 69.5073 76.8897 69.503 76.8813 69.4977C76.8645 69.4893 76.8467 69.4797 76.8299 69.4713C76.8194 69.466 76.8089 69.4618 76.7974 69.4565C76.7817 69.4491 76.7659 69.4416 76.7491 69.4342C76.7376 69.4289 76.7261 69.4247 76.7145 69.4194C76.6988 69.4131 76.683 69.4057 76.6673 69.3993C76.6641 69.3982 76.661 69.3961 76.6568 69.3951C76.6526 69.3929 76.6474 69.3919 76.6432 69.3898C76.6075 69.376 76.5708 69.3623 76.534 69.3496C76.5298 69.3485 76.5246 69.3464 76.5204 69.3443C76.4805 69.3305 76.4407 69.3189 76.3997 69.3061C76.3955 69.3051 76.3913 69.303 76.3872 69.3019C76.3725 69.2977 76.3588 69.2934 76.3441 69.2903C76.2864 69.2744 76.2277 69.2606 76.1679 69.2479L76.1595 69.2458C76.1532 69.2448 76.1458 69.2437 76.1395 69.2416C76.1133 69.2363 76.086 69.231 76.0587 69.2257C76.0461 69.2236 76.0346 69.2215 76.022 69.2193C75.9989 69.2151 75.9758 69.2119 75.9528 69.2088C75.9465 69.2088 75.9402 69.2067 75.9339 69.2056C75.9265 69.2056 75.9192 69.2035 75.9118 69.2024C75.8919 69.1992 75.8709 69.1971 75.851 69.195C75.8374 69.1929 75.8227 69.1918 75.809 69.1897C75.788 69.1876 75.7671 69.1855 75.7461 69.1834C75.7366 69.1834 75.7272 69.1812 75.7177 69.1802C75.7135 69.1802 75.7104 69.1802 75.7062 69.1802C75.6831 69.1781 75.659 69.177 75.6359 69.1749C75.6244 69.1749 75.6139 69.1738 75.6023 69.1728C75.5677 69.1707 75.5331 69.1696 75.4984 69.1685H75.4953C75.4607 69.1685 75.4261 69.1675 75.3914 69.1675C75.3799 69.1675 75.3683 69.1675 75.3568 69.1675C75.3327 69.1675 75.3085 69.1675 75.2844 69.1685C75.2792 69.1685 75.2739 69.1685 75.2697 69.1685C75.2624 69.1685 75.255 69.1685 75.2477 69.1696C75.2215 69.1707 75.1952 69.1717 75.169 69.1738C75.1564 69.1738 75.1449 69.1749 75.1323 69.176C75.1018 69.1781 75.0714 69.1802 75.041 69.1834C75.0347 69.1834 75.0294 69.1834 75.0231 69.1844H75.02C74.977 69.1887 74.935 69.1939 74.893 69.2003C74.8825 69.2014 74.872 69.2035 74.8616 69.2045C74.8227 69.2098 74.785 69.2162 74.7472 69.2225C74.744 69.2225 74.7398 69.2236 74.7367 69.2246H74.7336C74.701 69.231 74.6685 69.2373 74.636 69.2448C74.5762 69.2575 74.5174 69.2712 74.4597 69.2871C74.4188 69.2987 74.3779 69.3104 74.338 69.3231C74.3327 69.3241 74.3285 69.3263 74.3233 69.3273C74.3191 69.3284 74.316 69.3294 74.3128 69.3316C74.274 69.3443 74.2352 69.358 74.1974 69.3718C74.1911 69.3739 74.1848 69.3771 74.1796 69.3792C74.1449 69.3929 74.1103 69.4067 74.0767 69.4215C74.0704 69.4247 74.0641 69.4268 74.0589 69.4289C74.0222 69.4448 73.9865 69.4618 73.9519 69.4797C73.9445 69.484 73.9372 69.4872 73.9288 69.4914C73.8931 69.5094 73.8585 69.5284 73.8239 69.5486C73.8123 69.5549 73.8018 69.5613 73.7913 69.5676C73.7861 69.5708 73.7808 69.574 73.7756 69.5771C73.7599 69.5867 73.7452 69.5962 73.7305 69.6057C73.721 69.6121 73.7116 69.6184 73.7032 69.6248C73.6885 69.6354 73.6738 69.6459 73.6591 69.6565C73.6507 69.6618 73.6434 69.6682 73.635 69.6735C73.6182 69.6862 73.6014 69.6999 73.5857 69.7126C73.5815 69.7158 73.5762 69.72 73.572 69.7232C73.5521 69.7401 73.5322 69.7571 73.5143 69.774L73.5122 69.7761C73.5122 69.7761 73.508 69.7804 73.5059 69.7825C73.4871 69.8005 73.4682 69.8195 73.4514 69.8375C73.4461 69.8428 73.4409 69.8492 73.4356 69.8545C73.4168 69.8756 73.3979 69.8968 73.38 69.919L73.3758 69.9243C73.3674 69.9349 73.3601 69.9455 73.3528 69.955C73.3486 69.9603 73.3444 69.9656 73.3412 69.9709C73.3297 69.9878 73.3181 70.0048 73.3087 70.0207C73.3013 70.0334 73.294 70.0461 73.2867 70.0588C73.2856 70.0609 73.2846 70.0641 73.2825 70.0662C73.2751 70.0799 73.2678 70.0948 73.2604 70.1085C73.2573 70.1138 73.2541 70.1202 73.252 70.1254C73.2426 70.1456 73.2342 70.1657 73.2269 70.1858C73.2269 70.1858 73.2248 70.1943 73.2237 70.1985C73.2185 70.2144 73.2132 70.2302 73.208 70.2461C73.2059 70.2535 73.2038 70.2599 73.2027 70.2673C73.1996 70.28 73.1964 70.2927 73.1933 70.3065C73.1933 70.3096 73.1922 70.3118 73.1912 70.3149C73.1912 70.3202 73.1901 70.3255 73.1891 70.3298C73.187 70.3425 73.1849 70.3552 73.1828 70.3668C73.1828 70.3753 73.1807 70.3827 73.1796 70.3911C73.1786 70.4038 73.1775 70.4165 73.1765 70.4282C73.1765 70.4335 73.1765 70.4377 73.1765 70.443C73.1765 70.4494 73.1765 70.4568 73.1765 70.4631L73.1733 71.4486C73.1733 71.437 73.1733 71.4253 73.1744 71.4137C73.1744 71.401 73.1754 71.3883 73.1775 71.3766C73.1775 71.3682 73.1796 71.3608 73.1807 71.3523C73.1828 71.3396 73.1838 71.3269 73.187 71.3152C73.188 71.3078 73.1901 71.2994 73.1912 71.292C73.1943 71.2792 73.1975 71.2665 73.2006 71.2528C73.2027 71.2454 73.2038 71.239 73.2059 71.2316C73.2101 71.2157 73.2153 71.1999 73.2216 71.184C73.2226 71.1797 73.2237 71.1755 73.2258 71.1713C73.2331 71.1512 73.2415 71.1311 73.251 71.1109C73.2541 71.1057 73.2562 71.0993 73.2594 71.094C73.2667 71.0802 73.273 71.0654 73.2814 71.0517C73.2898 71.0368 73.2982 71.022 73.3076 71.0072C73.3181 70.9903 73.3286 70.9733 73.3402 70.9575C73.3444 70.9522 73.3475 70.9469 73.3517 70.9416C73.3601 70.9289 73.3695 70.9172 73.379 70.9045C73.3958 70.8823 73.4147 70.8611 73.4346 70.84C73.4398 70.8347 73.4451 70.8283 73.4503 70.823C73.4682 70.804 73.486 70.786 73.5049 70.768C73.508 70.7648 73.5112 70.7616 73.5143 70.7595C73.5332 70.7426 73.5521 70.7246 73.572 70.7076C73.5762 70.7045 73.5815 70.7002 73.5857 70.6971C73.6014 70.6844 73.6182 70.6706 73.635 70.6579C73.6423 70.6526 73.6507 70.6463 73.6581 70.641C73.6728 70.6304 73.6875 70.6198 73.7022 70.6092C73.7116 70.6028 73.72 70.5965 73.7294 70.5912C73.7441 70.5817 73.7588 70.5721 73.7746 70.5626C73.7903 70.5531 73.806 70.5425 73.8228 70.533C73.8564 70.5129 73.8921 70.4938 73.9277 70.4758C73.9351 70.4716 73.9424 70.4684 73.9508 70.4642C73.9854 70.4462 74.0211 70.4293 74.0578 70.4134C74.0641 70.4102 74.0704 70.4081 74.0767 70.406C74.1103 70.3911 74.1439 70.3774 74.1785 70.3636C74.1848 70.3615 74.1911 70.3583 74.1974 70.3562C74.2352 70.3425 74.274 70.3287 74.3128 70.316C74.3212 70.3128 74.3296 70.3107 74.339 70.3075C74.3789 70.2948 74.4198 70.2821 74.4608 70.2715C74.5185 70.2556 74.5772 70.2419 74.637 70.2292C74.6696 70.2228 74.7021 70.2165 74.7346 70.2101C74.7399 70.2101 74.744 70.2091 74.7493 70.208C74.7871 70.2017 74.8248 70.1953 74.8637 70.19C74.8742 70.189 74.8846 70.1868 74.8951 70.1858C74.9371 70.1805 74.9791 70.1752 75.0221 70.171C75.0294 70.171 75.0357 70.1699 75.0431 70.1689C75.0735 70.1657 75.1039 70.1636 75.1344 70.1614C75.147 70.1614 75.1585 70.1593 75.1711 70.1593C75.1973 70.1572 75.2235 70.1561 75.2498 70.1551C75.2624 70.1551 75.275 70.154 75.2875 70.154C75.3117 70.154 75.3358 70.153 75.3599 70.153C75.3715 70.153 75.383 70.153 75.3946 70.153C75.4292 70.153 75.4628 70.153 75.4974 70.153H75.5016C75.5362 70.153 75.5708 70.1551 75.6055 70.1572C75.617 70.1572 75.6275 70.1583 75.639 70.1593C75.6621 70.1604 75.6863 70.1625 75.7093 70.1646C75.723 70.1646 75.7356 70.1667 75.7492 70.1678C75.7702 70.1699 75.7912 70.172 75.8122 70.1741C75.8258 70.1752 75.8405 70.1773 75.8541 70.1794C75.8741 70.1816 75.8951 70.1847 75.915 70.1868C75.9286 70.189 75.9423 70.1911 75.9559 70.1932C75.979 70.1964 76.0021 70.2006 76.0252 70.2038C76.0378 70.2059 76.0503 70.208 76.0619 70.2101C76.0881 70.2154 76.1154 70.2197 76.1416 70.226C76.1511 70.2281 76.1605 70.2292 76.17 70.2313C76.2298 70.244 76.2885 70.2578 76.3462 70.2736C76.3651 70.2789 76.384 70.2842 76.4018 70.2895C76.4428 70.3012 76.4826 70.3139 76.5225 70.3276C76.5267 70.3287 76.5319 70.3308 76.5361 70.3329C76.5729 70.3456 76.6096 70.3594 76.6453 70.3731C76.6537 70.3763 76.661 70.3795 76.6694 70.3827C76.6851 70.389 76.7009 70.3954 76.7166 70.4028C76.7282 70.4081 76.7397 70.4123 76.7512 70.4176C76.768 70.425 76.7838 70.4324 76.7995 70.4398C76.81 70.4451 76.8205 70.4494 76.831 70.4547C76.8488 70.4631 76.8656 70.4727 76.8834 70.4811C76.8918 70.4854 76.9002 70.4896 76.9086 70.4938C76.9338 70.5076 76.959 70.5213 76.9842 70.5362C77.1751 70.6473 77.3241 70.7733 77.4332 70.9088C77.4605 70.9426 77.4846 70.9765 77.5056 71.0114C77.5864 71.1395 77.6315 71.274 77.641 71.4084C77.642 71.4274 77.6431 71.4465 77.6431 71.4666L77.6462 70.4811C77.6462 70.3276 77.6011 70.1731 77.5088 70.027L77.5046 70.0291Z",
    fill: "#F7AA67"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6955 70.9248L79.6934 71.9103H80.4299L80.4331 70.9248H79.6955Z",
    fill: "#FCC377"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3835 70.0293L70.3813 71.0148L70.3856 71.9103L70.3888 70.9248L70.3835 70.0293Z",
    fill: "#B8BCFC"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3886 70.9248L70.3855 71.9103H71.1231L71.1252 70.9248H70.3886Z",
    fill: "#FCC377"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6651 71.0168C79.662 71.0253 79.6588 71.0348 79.6557 71.0433C79.6515 71.0528 79.6483 71.0634 79.6441 71.0729C79.6399 71.0846 79.6347 71.0962 79.6294 71.1078C79.6252 71.1174 79.621 71.128 79.6158 71.1375C79.6105 71.1491 79.6053 71.1608 79.6001 71.1714C79.5959 71.1809 79.5906 71.1915 79.5854 71.201C79.5801 71.2126 79.5738 71.2243 79.5675 71.2349C79.5623 71.2444 79.557 71.2539 79.5518 71.2645C79.5455 71.2751 79.5403 71.2857 79.534 71.2963C79.5277 71.3079 79.5203 71.3185 79.514 71.3301C79.5077 71.3407 79.5014 71.3513 79.4951 71.3608C79.4878 71.3725 79.4804 71.3831 79.4741 71.3947C79.4668 71.4053 79.4605 71.4159 79.4532 71.4254C79.4458 71.436 79.4385 71.4476 79.4301 71.4582C79.4227 71.4688 79.4154 71.4783 79.408 71.4889C79.3997 71.4995 79.3913 71.5111 79.3829 71.5217C79.3755 71.5313 79.3682 71.5408 79.3608 71.5492C79.3493 71.5641 79.3367 71.5789 79.3241 71.5937C79.3168 71.6022 79.3105 71.6106 79.3031 71.6191C79.2895 71.635 79.2748 71.6519 79.2601 71.6678C79.2538 71.6742 79.2486 71.6805 79.2433 71.6869C79.2223 71.7091 79.2013 71.7313 79.1793 71.7535C79.1751 71.7578 79.1709 71.761 79.1678 71.7652C79.1489 71.7832 79.131 71.8022 79.1111 71.8202C79.0985 71.8319 79.0859 71.8435 79.0723 71.8562C79.066 71.8626 79.0587 71.8679 79.0524 71.8742C79.0324 71.8922 79.0114 71.9102 78.9905 71.9282L78.9873 72.9137C79.0083 72.8957 79.0293 72.8777 79.0503 72.8586C79.0566 72.8523 79.0639 72.8459 79.0702 72.8406C79.0807 72.8311 79.0912 72.8216 79.1017 72.8121C79.1038 72.8099 79.1059 72.8078 79.109 72.8057C79.1279 72.7877 79.1468 72.7697 79.1657 72.7507C79.1699 72.7464 79.1741 72.7433 79.1772 72.739C79.1992 72.7168 79.2202 72.6946 79.2412 72.6723C79.2475 72.666 79.2528 72.6596 79.2591 72.6533C79.2737 72.6374 79.2884 72.6205 79.3021 72.6046C79.3094 72.5961 79.3157 72.5877 79.3231 72.5802C79.3357 72.5654 79.3472 72.5506 79.3598 72.5358C79.3629 72.5316 79.3671 72.5263 79.3713 72.522C79.3745 72.5178 79.3787 72.5125 79.3818 72.5083C79.3902 72.4977 79.3986 72.486 79.407 72.4755C79.4143 72.4649 79.4217 72.4553 79.429 72.4448C79.4364 72.4342 79.4448 72.4225 79.4521 72.4119C79.4595 72.4014 79.4658 72.3918 79.4731 72.3812C79.4804 72.3696 79.4878 72.359 79.4941 72.3474C79.5004 72.3368 79.5067 72.3262 79.513 72.3167C79.5193 72.305 79.5266 72.2944 79.5329 72.2828C79.5371 72.2765 79.5413 72.269 79.5444 72.2627C79.5465 72.2585 79.5486 72.2542 79.5507 72.25C79.556 72.2405 79.5612 72.2309 79.5665 72.2214C79.5728 72.2098 79.578 72.1981 79.5843 72.1875C79.5896 72.178 79.5938 72.1674 79.599 72.1579C79.6043 72.1463 79.6095 72.1346 79.6147 72.124C79.6189 72.1145 79.6231 72.1039 79.6273 72.0944C79.6326 72.0827 79.6368 72.0711 79.642 72.0595C79.6462 72.0499 79.6504 72.0393 79.6536 72.0298C79.6557 72.0245 79.6578 72.0192 79.6599 72.0139C79.6609 72.0097 79.662 72.0065 79.6641 72.0023C79.6756 71.9716 79.685 71.9409 79.6945 71.9113L79.6976 70.9258C79.6882 70.9565 79.6777 70.9872 79.6672 71.0168H79.6651Z",
    fill: "#F7AA67"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1252 70.9248L71.1221 71.9103C71.2322 72.2649 71.4715 72.6089 71.8408 72.917L71.8439 71.9315C71.4757 71.6245 71.2354 71.2805 71.1252 70.9248Z",
    fill: "#F7AA67"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9087 72.5645L77.9055 73.5499L78.428 73.8537L78.4312 72.8693L77.9087 72.5645Z",
    fill: "#F7AA67"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4311 72.8692L78.428 73.8536L79.5087 73.2206L79.5108 72.2351L78.4311 72.8692Z",
    fill: "#FCC377"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9311 72.5654L72.928 73.5499L72.4097 73.8547L72.4128 72.8692L72.9311 72.5654Z",
    fill: "#F7AA67"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3246 72.2351L71.3225 73.2206L72.4095 73.8546L72.4127 72.8692L71.3246 72.2351Z",
    fill: "#FCC377"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9054 73.5499L77.9086 72.5645C77.8446 72.5909 77.7795 72.6153 77.7134 72.6396C77.6914 72.6481 77.6693 72.6544 77.6473 72.6629C77.6032 72.6788 77.5592 72.6936 77.5141 72.7084C77.4889 72.7169 77.4626 72.7243 77.4364 72.7317C77.3944 72.7444 77.3525 72.7571 77.3105 72.7698C77.2822 72.7783 77.2528 72.7857 77.2245 72.7931C77.1846 72.8037 77.1437 72.8143 77.1028 72.8248C77.0723 72.8323 77.0419 72.8386 77.0115 72.846C76.9716 72.8555 76.9317 72.864 76.8919 72.8725C76.8604 72.8788 76.8289 72.8852 76.7964 72.8915C76.7513 72.9 76.7061 72.9095 76.661 72.9169C76.6484 72.9191 76.6358 72.9212 76.6233 72.9233C76.5592 72.9339 76.4942 72.9445 76.4291 72.9529C76.4176 72.955 76.4061 72.9561 76.3945 72.9572C76.3263 72.9667 76.2581 72.9741 76.1899 72.9815L76.1868 73.967C76.255 73.9596 76.3242 73.9511 76.3914 73.9427C76.4029 73.9416 76.4145 73.9395 76.426 73.9384C76.491 73.9289 76.5561 73.9194 76.6201 73.9088C76.6327 73.9067 76.6453 73.9046 76.6579 73.9024C76.6768 73.8993 76.6957 73.8961 76.7156 73.8929C76.7418 73.8876 76.768 73.8823 76.7943 73.877C76.8258 73.8707 76.8572 73.8643 76.8887 73.858C76.9286 73.8495 76.9684 73.84 77.0094 73.8315C77.0398 73.8241 77.0702 73.8178 77.1007 73.8103C77.1416 73.8008 77.1814 73.7892 77.2224 73.7786C77.2507 73.7712 77.2801 73.7638 77.3084 73.7553C77.3514 73.7437 77.3934 73.7299 77.4354 73.7172C77.4605 73.7098 77.4868 73.7024 77.512 73.6939C77.5151 73.6928 77.5193 73.6918 77.5235 73.6907C77.5644 73.677 77.6053 73.6632 77.6463 73.6484C77.6683 73.641 77.6914 73.6336 77.7124 73.6251C77.7785 73.6008 77.8435 73.5764 77.9075 73.5499H77.9054Z",
    fill: "#FCC377"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6528 73.9669L74.656 72.9814C74.5878 72.974 74.5196 72.9655 74.4524 72.9571C74.4399 72.955 74.4273 72.9539 74.4147 72.9518C74.3717 72.9454 74.3297 72.9391 74.2867 72.9327C74.2531 72.9274 74.2195 72.9222 74.187 72.9169C74.1461 72.9095 74.1062 72.902 74.0653 72.8946C74.0328 72.8883 74.0013 72.883 73.9688 72.8766C73.9373 72.8703 73.9068 72.8629 73.8754 72.8555C73.8313 72.8459 73.7872 72.8364 73.7432 72.8258C73.7106 72.8184 73.6792 72.8089 73.6477 72.8015C73.6057 72.7909 73.5637 72.7803 73.5228 72.7676C73.4641 72.7507 73.4053 72.7337 73.3476 72.7157C73.3371 72.7126 73.3277 72.7094 73.3172 72.7062C73.2626 72.6882 73.2091 72.6702 73.1556 72.6512C73.1441 72.6469 73.1325 72.6427 73.121 72.6385C73.057 72.6152 72.994 72.5908 72.9321 72.5654L72.929 73.5509C72.9426 73.5562 72.9562 73.5615 72.9699 73.5679C73.0192 73.5869 73.0685 73.606 73.1178 73.624C73.1294 73.6282 73.1409 73.6324 73.1524 73.6356C73.206 73.6547 73.2595 73.6727 73.314 73.6907C73.3245 73.6938 73.334 73.697 73.3445 73.7002C73.3938 73.7161 73.4441 73.7309 73.4945 73.7457C73.5029 73.7478 73.5113 73.7499 73.5197 73.752C73.5606 73.7637 73.6026 73.7743 73.6445 73.7859C73.676 73.7944 73.7075 73.8029 73.74 73.8103C73.7841 73.8209 73.8281 73.8304 73.8722 73.8399C73.8984 73.8452 73.9247 73.8526 73.9509 73.8579C73.9562 73.8579 73.9614 73.86 73.9656 73.8611C73.9971 73.8674 74.0296 73.8738 74.0611 73.8791C74.102 73.8865 74.1419 73.8949 74.1828 73.9024C74.2153 73.9076 74.2489 73.9129 74.2825 73.9182C74.315 73.9235 74.3475 73.9288 74.3801 73.9341C74.3905 73.9352 74.401 73.9373 74.4105 73.9383C74.4231 73.9405 74.4357 73.9415 74.4482 73.9436C74.5164 73.9532 74.5836 73.9606 74.6518 73.968L74.6528 73.9669Z",
    fill: "#FCC377"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1911 73.4124L76.189 74.3968H74.655L74.6582 73.4124H76.1911Z",
    fill: "#F7AA67"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M74.656 72.9814L74.6528 73.9669L74.6549 74.3967L74.6581 73.4123L74.656 72.9814Z",
    fill: "#B8BCFC"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9893 71.9313L79.5118 72.2351L78.4311 72.8681L77.9086 72.5643C77.384 72.7792 76.7964 72.9178 76.1889 72.9813L76.192 73.4122H74.6591L74.656 72.9813C74.0485 72.9178 73.4588 72.7792 72.9321 72.5653L72.4137 72.8691L71.3267 72.2361L71.8451 71.9323C71.4768 71.6254 71.2365 71.2813 71.1263 70.9257H70.3898L70.3845 70.0302H71.1211C71.2271 69.6756 71.4621 69.3315 71.8283 69.0235L71.3058 68.7197L72.3865 68.0867L72.909 68.3905C73.4336 68.1756 74.0212 68.037 74.6287 67.9745L74.6266 67.5437H76.1595L76.1627 67.9745C76.7702 68.038 77.3598 68.1767 77.8866 68.3905L78.4049 68.0867L79.4919 68.7197L78.9736 69.0235C79.3429 69.3305 79.5821 69.6745 79.6923 70.0302H80.4289L80.4341 70.9257H79.6975C79.5916 71.2803 79.3565 71.6243 78.9904 71.9323L78.9893 71.9313ZM76.3578 71.6614C76.5887 71.5989 76.8037 71.5121 76.9937 71.401C77.1836 71.2898 77.3315 71.1638 77.4385 71.0284C77.4648 70.9945 77.4889 70.9606 77.5099 70.9257C77.6883 70.6367 77.6862 70.3191 77.5046 70.0302C77.4826 69.9952 77.4595 69.9614 77.4322 69.9275C77.3242 69.7931 77.1741 69.666 76.9832 69.5549C76.7922 69.4438 76.575 69.3569 76.3442 69.2934C76.2865 69.2776 76.2277 69.2638 76.1679 69.2511C75.6737 69.1463 75.1292 69.1463 74.635 69.2511C74.5752 69.2638 74.5164 69.2776 74.4587 69.2934C74.2279 69.3559 74.0128 69.4438 73.8229 69.5549C73.633 69.666 73.485 69.792 73.378 69.9275C73.3507 69.9614 73.3276 69.9963 73.3066 70.0302C73.1283 70.3191 73.1304 70.6378 73.3119 70.9257C73.3339 70.9606 73.357 70.9945 73.3853 71.0284C73.4934 71.1628 73.6424 71.2898 73.8344 71.401C74.0254 71.5121 74.2426 71.5989 74.4734 71.6614C74.5311 71.6772 74.5899 71.691 74.6497 71.7037C75.1449 71.8085 75.6884 71.8085 76.1826 71.7037C76.2414 71.691 76.3001 71.6772 76.3589 71.6614",
    fill: "#FAE468"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2765 62.9255L83.2734 63.911L83.2712 63.4801L83.2744 62.4946L83.2765 62.9255Z",
    fill: "#6B6F12"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1399 63.6707L88.1378 64.6561L87.6184 64.9599L87.6216 63.9755L88.1399 63.6707Z",
    fill: "#F7AA67"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M80.476 63.9755L80.4739 64.9599L79.9514 64.6561L79.9546 63.6707L80.476 63.9755Z",
    fill: "#F7AA67"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1535 64.981C86.1315 64.9461 86.1084 64.9122 86.0811 64.8784C85.973 64.7439 85.823 64.6169 85.632 64.5057C85.6069 64.4909 85.5817 64.4772 85.5565 64.4634C85.5481 64.4592 85.5387 64.4549 85.5303 64.4496C85.5135 64.4412 85.4956 64.4316 85.4789 64.4232C85.4684 64.4179 85.4579 64.4137 85.4463 64.4084C85.4306 64.401 85.4149 64.3935 85.3981 64.3861C85.3865 64.3808 85.375 64.3766 85.3634 64.3713C85.3477 64.365 85.332 64.3576 85.3162 64.3512C85.3131 64.3501 85.3099 64.348 85.3057 64.347C85.3015 64.3449 85.2963 64.3438 85.2921 64.3417C85.2564 64.3279 85.2197 64.3142 85.183 64.3015C85.1788 64.3004 85.1735 64.2983 85.1693 64.2962C85.1295 64.2824 85.0896 64.2708 85.0487 64.2581C85.0445 64.257 85.0403 64.2549 85.0361 64.2538C85.0214 64.2496 85.0077 64.2454 84.9931 64.2422C84.9353 64.2263 84.8766 64.2125 84.8168 64.1998L84.8084 64.1977C84.8021 64.1967 84.7948 64.1956 84.7885 64.1935C84.7622 64.1882 84.7349 64.1829 84.7077 64.1776C84.6951 64.1755 84.6835 64.1734 84.6709 64.1713C84.6479 64.167 84.6248 64.1638 84.6017 64.1607C84.5954 64.1607 84.5891 64.1586 84.5828 64.1575C84.5755 64.1575 84.5681 64.1554 84.5608 64.1543C84.5408 64.1511 84.5199 64.149 84.4999 64.1469C84.4863 64.1448 84.4716 64.1437 84.4579 64.1416C84.437 64.1395 84.416 64.1374 84.395 64.1353C84.3856 64.1353 84.3761 64.1331 84.3667 64.1321C84.3625 64.1321 84.3593 64.1321 84.3551 64.1321C84.332 64.13 84.3079 64.1289 84.2848 64.1268C84.2733 64.1268 84.2628 64.1257 84.2513 64.1247C84.2166 64.1226 84.182 64.1215 84.1474 64.1204H84.1442C84.1096 64.1204 84.075 64.1194 84.0404 64.1194C84.0288 64.1194 84.0173 64.1194 84.0057 64.1194C83.9816 64.1194 83.9575 64.1194 83.9333 64.1204C83.9281 64.1204 83.9228 64.1204 83.9186 64.1204C83.9113 64.1204 83.904 64.1204 83.8966 64.1215C83.8704 64.1215 83.8441 64.1236 83.8179 64.1257C83.8053 64.1257 83.7938 64.1268 83.7812 64.1279C83.7508 64.13 83.7203 64.1321 83.6899 64.1353C83.6836 64.1353 83.6784 64.1353 83.6721 64.1363H83.6689C83.6259 64.1406 83.5839 64.1458 83.542 64.1522C83.5315 64.1533 83.521 64.1554 83.5105 64.1564C83.4717 64.1617 83.4339 64.1681 83.3961 64.1744C83.393 64.1744 83.3888 64.1755 83.3856 64.1765H83.3825C83.35 64.1829 83.3174 64.1893 83.2849 64.1967C83.2251 64.2094 83.1663 64.2231 83.1086 64.239C83.0677 64.2506 83.0268 64.2623 82.9869 64.275C82.9817 64.276 82.9775 64.2782 82.9722 64.2792C82.968 64.2803 82.9649 64.2824 82.9617 64.2835C82.9229 64.2962 82.8841 64.3099 82.8463 64.3237C82.84 64.3258 82.8337 64.329 82.8285 64.3311C82.7939 64.3449 82.7592 64.3586 82.7257 64.3734C82.7194 64.3766 82.7131 64.3787 82.7078 64.3808C82.6711 64.3967 82.6365 64.4137 82.6008 64.4317C82.5935 64.4359 82.5861 64.4391 82.5777 64.4433C82.542 64.4613 82.5074 64.4803 82.4728 64.5005C82.4613 64.5068 82.4508 64.5132 82.4403 64.5195C82.435 64.5227 82.4298 64.5259 82.4245 64.529C82.4088 64.5386 82.3941 64.5481 82.3794 64.5576C82.37 64.564 82.3605 64.5703 82.3521 64.5767C82.3374 64.5873 82.3228 64.5978 82.3081 64.6084C82.2997 64.6137 82.2923 64.6201 82.2839 64.6254C82.2671 64.6381 82.2504 64.6518 82.2346 64.6645C82.2304 64.6677 82.2252 64.6719 82.221 64.6751C82.201 64.692 82.1811 64.709 82.1633 64.7259L82.1612 64.728C82.1612 64.728 82.157 64.7323 82.1549 64.7344C82.136 64.7524 82.1171 64.7714 82.1003 64.7894C82.0951 64.7947 82.0898 64.8011 82.0846 64.8064C82.0657 64.8275 82.0468 64.8487 82.029 64.8709L82.0248 64.8762C82.0164 64.8868 82.009 64.8974 82.0017 64.9069C81.9975 64.9122 81.9933 64.9175 81.9901 64.9228C81.9786 64.9397 81.9671 64.9567 81.9576 64.9726C81.9503 64.9853 81.9429 64.998 81.9356 65.0107C81.9345 65.0128 81.9335 65.016 81.9314 65.0181C81.924 65.0318 81.9167 65.0467 81.9094 65.0604C81.9062 65.0657 81.9031 65.0721 81.901 65.0774C81.8915 65.0975 81.8831 65.1176 81.8758 65.1377C81.8758 65.1377 81.8737 65.1462 81.8726 65.1504C81.8674 65.1663 81.8621 65.1821 81.8569 65.198C81.8548 65.2054 81.8527 65.2118 81.8516 65.2192C81.8485 65.2319 81.8453 65.2446 81.8422 65.2584C81.8422 65.2615 81.8412 65.2637 81.8401 65.2668C81.8401 65.2721 81.8391 65.2774 81.838 65.2816C81.8359 65.2944 81.8338 65.3071 81.8317 65.3187C81.8317 65.3272 81.8296 65.3346 81.8286 65.343C81.8275 65.3557 81.8265 65.3684 81.8254 65.3801C81.8254 65.3854 81.8254 65.3896 81.8254 65.3949C81.8254 65.4013 81.8254 65.4087 81.8254 65.415L81.8223 66.4005C81.8223 66.3889 81.8223 66.3772 81.8233 66.3656C81.8233 66.3529 81.8244 66.3402 81.8265 66.3285C81.8265 66.3201 81.8286 66.3126 81.8296 66.3042C81.8317 66.2915 81.8328 66.2788 81.8359 66.2671C81.837 66.2597 81.8391 66.2513 81.8401 66.2438C81.8432 66.2311 81.8464 66.2184 81.8495 66.2047C81.8516 66.1973 81.8527 66.1909 81.8548 66.1835C81.859 66.1676 81.8642 66.1518 81.8705 66.1359C81.8716 66.1316 81.8726 66.1274 81.8747 66.1232C81.8821 66.1031 81.8905 66.083 81.8999 66.0628C81.9031 66.0575 81.9052 66.0512 81.9083 66.0459C81.9156 66.0321 81.9219 66.0173 81.9303 66.0036C81.9387 65.9887 81.9471 65.9739 81.9566 65.9591C81.9671 65.9422 81.9776 65.9252 81.9891 65.9083C81.9933 65.903 81.9964 65.8977 82.0006 65.8924C82.009 65.8797 82.0185 65.8681 82.0279 65.8554C82.0447 65.8331 82.0636 65.812 82.0835 65.7908C82.0888 65.7855 82.094 65.7792 82.0993 65.7739C82.1171 65.7548 82.1349 65.7368 82.1538 65.7188C82.157 65.7156 82.1601 65.7125 82.1633 65.7103C82.1822 65.6934 82.201 65.6754 82.221 65.6585C82.2252 65.6553 82.2304 65.6511 82.2346 65.6479C82.2504 65.6352 82.2671 65.6214 82.2839 65.6087C82.2913 65.6034 82.2997 65.5971 82.307 65.5918C82.3217 65.5812 82.3364 65.5706 82.3511 65.56C82.3605 65.5537 82.3689 65.5473 82.3784 65.542C82.393 65.5325 82.4077 65.523 82.4235 65.5135C82.4392 65.5039 82.455 65.4934 82.4717 65.4838C82.5053 65.4637 82.541 65.4447 82.5767 65.4267C82.584 65.4224 82.5914 65.4193 82.5997 65.415C82.6344 65.397 82.67 65.3801 82.7068 65.3642C82.7131 65.361 82.7194 65.3589 82.7257 65.3568C82.7592 65.342 82.7928 65.3282 82.8274 65.3145C82.8337 65.3123 82.84 65.3092 82.8463 65.3071C82.8841 65.2933 82.9229 65.2795 82.9617 65.2668C82.9701 65.2637 82.9785 65.2615 82.988 65.2584C83.0278 65.2457 83.0688 65.233 83.1097 65.2224C83.1674 65.2065 83.2261 65.1927 83.286 65.18C83.3185 65.1737 83.351 65.1673 83.3835 65.161C83.3888 65.161 83.393 65.1599 83.3982 65.1589C83.436 65.1525 83.4738 65.1462 83.5126 65.1409C83.5231 65.1398 83.5336 65.1377 83.5441 65.1366C83.586 65.1313 83.628 65.126 83.671 65.1218C83.6784 65.1218 83.6847 65.1207 83.692 65.1197C83.7224 65.1165 83.7529 65.1144 83.7833 65.1123C83.7959 65.1123 83.8074 65.1102 83.82 65.1102C83.8462 65.1081 83.8725 65.107 83.8987 65.1059C83.9113 65.1059 83.9239 65.1049 83.9365 65.1049C83.9606 65.1049 83.9847 65.1038 84.0089 65.1038C84.0204 65.1038 84.032 65.1038 84.0435 65.1038C84.0781 65.1038 84.1117 65.1038 84.1463 65.1049H84.1505C84.1851 65.1049 84.2198 65.107 84.2544 65.1091C84.2659 65.1091 84.2764 65.1102 84.288 65.1112C84.3111 65.1123 84.3352 65.1144 84.3583 65.1165C84.3719 65.1176 84.3845 65.1186 84.3981 65.1197C84.4191 65.1218 84.4401 65.1239 84.4611 65.126C84.4747 65.1271 84.4894 65.1292 84.5031 65.1313C84.523 65.1335 84.544 65.1366 84.5639 65.1387C84.5776 65.1409 84.5912 65.143 84.6048 65.1451C84.6279 65.1483 84.651 65.1525 84.6741 65.1557C84.6867 65.1578 84.6993 65.1599 84.7108 65.162C84.737 65.1673 84.7643 65.1716 84.7906 65.1779C84.8 65.18 84.8094 65.1811 84.8189 65.1832C84.8787 65.1959 84.9374 65.2097 84.9952 65.2255C85.014 65.2308 85.0319 65.2361 85.0508 65.2414C85.0917 65.2531 85.1316 65.2658 85.1714 65.2795C85.1756 65.2806 85.1809 65.2827 85.1851 65.2848C85.2218 65.2975 85.2585 65.3113 85.2942 65.325C85.3026 65.3282 85.3099 65.3314 85.3183 65.3346C85.3341 65.3409 85.3498 65.3473 85.3655 65.3547C85.3771 65.36 85.3886 65.3642 85.4002 65.3695C85.4169 65.3769 85.4327 65.3843 85.4484 65.3917C85.4589 65.397 85.4694 65.4013 85.4799 65.4066C85.4977 65.415 85.5145 65.4235 85.5324 65.433C85.5408 65.4373 85.5492 65.4415 85.5575 65.4457C85.5827 65.4595 85.6079 65.4732 85.6331 65.4881C85.8241 65.5992 85.973 65.7252 86.0822 65.8607C86.1094 65.8945 86.1336 65.9284 86.1546 65.9633C86.2354 66.0914 86.2805 66.2259 86.2899 66.3603C86.291 66.3793 86.292 66.3984 86.292 66.4185L86.2952 65.433C86.2952 65.2795 86.25 65.125 86.1577 64.9789L86.1535 64.981Z",
    fill: "#F7AA67"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3444 65.8777L88.3423 66.8621H89.0788L89.0809 65.8777H88.3444Z",
    fill: "#FCC377"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0324 64.9812L79.0303 65.9667L79.0345 66.8622L79.0377 65.8778L79.0324 64.9812Z",
    fill: "#B8BCFC"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0376 65.8777L79.0344 66.8621H79.771L79.7741 65.8777H79.0376Z",
    fill: "#FCC377"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M88.314 65.9687C88.3109 65.9772 88.3077 65.9867 88.3046 65.9952C88.3004 66.0047 88.2973 66.0153 88.2931 66.0248C88.2889 66.0365 88.2836 66.0481 88.2784 66.0597C88.2742 66.0693 88.27 66.0799 88.2647 66.0894C88.2595 66.101 88.2542 66.1127 88.249 66.1233C88.2448 66.1328 88.2395 66.1434 88.2343 66.1529C88.2291 66.1645 88.2228 66.1762 88.2165 66.1868C88.2112 66.1963 88.206 66.2058 88.2007 66.2164C88.1944 66.227 88.1892 66.2376 88.1829 66.2482C88.1766 66.2598 88.1692 66.2704 88.163 66.282C88.1567 66.2926 88.1504 66.3032 88.1441 66.3127C88.1367 66.3244 88.1304 66.335 88.1231 66.3466C88.1157 66.3572 88.1094 66.3678 88.1021 66.3773C88.0948 66.3879 88.0874 66.3995 88.079 66.4101C88.0717 66.4207 88.0643 66.4302 88.057 66.4408C88.0486 66.4514 88.0402 66.463 88.0318 66.4736C88.0245 66.4832 88.0171 66.4927 88.0098 66.5011C87.9982 66.516 87.9856 66.5308 87.973 66.5456C87.9657 66.5541 87.9594 66.5625 87.9521 66.571C87.9384 66.5869 87.9237 66.6038 87.909 66.6197C87.9027 66.6261 87.8975 66.6324 87.8922 66.6388C87.8713 66.661 87.8503 66.6832 87.8282 66.7054C87.824 66.7097 87.8199 66.7129 87.8167 66.7171C87.7978 66.7351 87.78 66.7541 87.76 66.7721C87.7475 66.7838 87.7349 66.7954 87.7212 66.8081C87.7149 66.8145 87.7076 66.8198 87.7013 66.8261C87.6813 66.8441 87.6604 66.8621 87.6394 66.8801L87.6362 67.8656C87.6572 67.8476 87.6782 67.8296 87.6992 67.8105C87.7055 67.8042 87.7128 67.7978 87.7191 67.7925C87.7296 67.783 87.7401 67.7735 87.7506 67.764C87.7527 67.7618 87.7548 67.7597 87.7579 67.7576C87.7768 67.7396 87.7957 67.7216 87.8146 67.7026C87.8188 67.6983 87.823 67.6952 87.8261 67.6909C87.8482 67.6687 87.8692 67.6465 87.8902 67.6242C87.8964 67.6179 87.9017 67.6115 87.908 67.6052C87.9227 67.5893 87.9374 67.5724 87.951 67.5565C87.9583 67.548 87.9646 67.5396 87.972 67.5321C87.9846 67.5173 87.9961 67.5025 88.0087 67.4877C88.0119 67.4835 88.0161 67.4782 88.0203 67.4739C88.0234 67.4697 88.0276 67.4644 88.0307 67.4602C88.0391 67.4496 88.0475 67.4379 88.0559 67.4274C88.0633 67.4168 88.0706 67.4072 88.078 67.3967C88.0853 67.3861 88.0937 67.3744 88.1011 67.3638C88.1084 67.3533 88.1147 67.3437 88.122 67.3332C88.1294 67.3215 88.1367 67.3109 88.143 67.2993C88.1493 67.2887 88.1556 67.2781 88.1619 67.2686C88.1682 67.2569 88.1755 67.2463 88.1818 67.2347C88.186 67.2284 88.1902 67.2209 88.1934 67.2146C88.1955 67.2104 88.1976 67.2061 88.1997 67.2019C88.2049 67.1924 88.2102 67.1828 88.2154 67.1733C88.2217 67.1617 88.227 67.15 88.2333 67.1394C88.2385 67.1299 88.2427 67.1193 88.2479 67.1098C88.2532 67.0982 88.2584 67.0865 88.2637 67.0759C88.2679 67.0664 88.2721 67.0558 88.2763 67.0463C88.2815 67.0346 88.2857 67.023 88.291 67.0114C88.2952 67.0018 88.2994 66.9912 88.3025 66.9817C88.3046 66.9764 88.3067 66.9711 88.3088 66.9658C88.3098 66.9616 88.3109 66.9584 88.313 66.9542C88.3245 66.9235 88.334 66.8928 88.3434 66.8632L88.3466 65.8777C88.3371 65.9084 88.3266 65.9391 88.3161 65.9687H88.314Z",
    fill: "#F7AA67"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7741 65.8777L79.771 66.8632C79.8812 67.2178 80.1204 67.5618 80.4887 67.8698L80.4918 66.8843C80.1235 66.5774 79.8833 66.2323 79.7731 65.8777H79.7741Z",
    fill: "#F7AA67"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5576 67.5173L86.5544 68.5018L87.077 68.8066L87.0791 67.8211L86.5576 67.5173Z",
    fill: "#F7AA67"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M87.079 67.821L87.0769 68.8065L88.1566 68.1724L88.1597 67.188L87.079 67.821Z",
    fill: "#FCC377"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5798 67.5173L81.5767 68.5028L81.0583 68.8066L81.0605 67.8211L81.5798 67.5173Z",
    fill: "#F7AA67"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9736 67.188L79.9705 68.1724L81.0585 68.8065L81.0606 67.821L79.9736 67.188Z",
    fill: "#FCC377"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5543 68.5019L86.5575 67.5164C86.4935 67.5428 86.4284 67.5672 86.3623 67.5915C86.3403 67.6 86.3183 67.6063 86.2962 67.6148C86.2522 67.6307 86.2081 67.6455 86.163 67.6603C86.1378 67.6688 86.1116 67.6762 86.0853 67.6836C86.0434 67.6963 86.0014 67.709 85.9594 67.7217C85.9311 67.7302 85.9017 67.7376 85.8734 67.745C85.8335 67.7556 85.7926 67.7662 85.7517 67.7768C85.7212 67.7842 85.6908 67.7905 85.6604 67.7979C85.6205 67.8075 85.5806 67.8159 85.5408 67.8244C85.5093 67.8307 85.4778 67.8371 85.4453 67.8434C85.4002 67.8519 85.3551 67.8614 85.3099 67.8689C85.2974 67.871 85.2848 67.8731 85.2722 67.8752C85.2082 67.8858 85.1431 67.8964 85.0781 67.9048C85.0665 67.907 85.055 67.908 85.0434 67.9091C84.9752 67.9186 84.907 67.926 84.8388 67.9334L84.8357 68.9189C84.9039 68.9115 84.9731 68.903 85.0403 68.8946C85.0518 68.8935 85.0634 68.8914 85.0749 68.8903C85.14 68.8808 85.205 68.8713 85.269 68.8607C85.2816 68.8586 85.2942 68.8565 85.3068 68.8543C85.3257 68.8512 85.3456 68.848 85.3645 68.8448C85.3907 68.8395 85.417 68.8342 85.4432 68.8289C85.4747 68.8226 85.5062 68.8173 85.5376 68.8099C85.5775 68.8014 85.6174 68.7919 85.6572 68.7834C85.6877 68.776 85.7181 68.7697 85.7485 68.7623C85.7894 68.7527 85.8293 68.7411 85.8702 68.7305C85.8986 68.7231 85.9279 68.7157 85.9563 68.7072C85.9993 68.6956 86.0413 68.6818 86.0832 68.6691C86.1084 68.6617 86.1346 68.6543 86.1598 68.6458C86.163 68.6448 86.1672 68.6437 86.1714 68.6426C86.2123 68.6289 86.2532 68.6151 86.2941 68.6003C86.3162 68.5929 86.3392 68.5855 86.3602 68.577C86.4263 68.5527 86.4914 68.5283 86.5554 68.5019H86.5543Z",
    fill: "#FCC377"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3018 68.9187L83.3049 67.9332C83.2367 67.9258 83.1685 67.9174 83.1014 67.9089C83.0888 67.9068 83.0762 67.9057 83.0636 67.9036C83.0206 67.8973 82.9786 67.8909 82.9356 67.8846C82.902 67.8793 82.8684 67.874 82.8359 67.8687C82.795 67.8613 82.7551 67.8539 82.7142 67.8464C82.6817 67.8401 82.6502 67.8348 82.6177 67.8285C82.5862 67.8221 82.5558 67.8147 82.5243 67.8083C82.4802 67.7988 82.4361 67.7893 82.3921 67.7787C82.3596 67.7713 82.3281 67.7618 82.2966 67.7544C82.2546 67.7438 82.2127 67.7332 82.1717 67.7205C82.113 67.7035 82.0542 67.6866 81.9965 67.6686C81.986 67.6654 81.9766 67.6623 81.9661 67.6591C81.9115 67.6411 81.858 67.6231 81.8045 67.604C81.793 67.5998 81.7814 67.5956 81.7699 67.5913C81.7059 67.5681 81.6429 67.5437 81.581 67.5183L81.5779 68.5038C81.5915 68.5091 81.6052 68.5144 81.6188 68.5207C81.6681 68.5398 81.7174 68.5588 81.7667 68.5768C81.7783 68.5811 81.7898 68.5853 81.8014 68.5885C81.8549 68.6075 81.9084 68.6255 81.963 68.6435C81.9734 68.6467 81.9829 68.6499 81.9934 68.653C82.0427 68.6689 82.0931 68.6837 82.1434 68.6986C82.1518 68.7007 82.1602 68.7028 82.1686 68.7049C82.2095 68.7165 82.2515 68.7271 82.2935 68.7388C82.3249 68.7472 82.3564 68.7557 82.3889 68.7631C82.433 68.7737 82.4771 68.7832 82.5211 68.7928C82.5474 68.7981 82.5736 68.8055 82.5998 68.8108C82.6051 68.8108 82.6103 68.8129 82.6145 68.8139C82.646 68.8203 82.6785 68.8266 82.71 68.8319C82.7509 68.8393 82.7908 68.8478 82.8317 68.8552C82.8642 68.8605 82.8978 68.8658 82.9314 68.8711C82.9639 68.8764 82.9964 68.8817 83.029 68.887C83.0395 68.888 83.0499 68.8901 83.0594 68.8912C83.072 68.8933 83.0846 68.8944 83.0972 68.8965C83.1654 68.906 83.2325 68.9134 83.3007 68.9208L83.3018 68.9187Z",
    fill: "#FCC377"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M84.84 68.3643L84.8369 69.3498H83.304L83.3071 68.3643H84.84Z",
    fill: "#F7AA67"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3039 67.9333L83.3018 68.9188L83.3039 69.3497L83.3071 68.3642L83.3039 67.9333Z",
    fill: "#B8BCFC"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M87.637 66.8832L88.1595 67.187L87.0788 67.82L86.5563 67.5162C86.0317 67.7311 85.4441 67.8697 84.8366 67.9332L84.8397 68.3641H83.3068L83.3037 67.9332C82.6962 67.8697 82.1065 67.7311 81.5798 67.5172L81.0615 67.821L79.9744 67.188L80.4928 66.8842C80.1245 66.5773 79.8842 66.2332 79.774 65.8776H79.0375L79.0322 64.9821H79.7688C79.8748 64.6275 80.1098 64.2834 80.476 63.9754L79.9535 63.6716L81.0342 63.0386L81.5567 63.3424C82.0813 63.1275 82.6689 62.9889 83.2764 62.9264L83.2743 62.4956H84.8072L84.8104 62.9264C85.4179 62.9899 86.0075 63.1286 86.5343 63.3424L87.0526 63.0386L88.1396 63.6716L87.6213 63.9754C87.9906 64.2824 88.2298 64.6264 88.34 64.9821H89.0766L89.0818 65.8776H88.3452C88.2393 66.2322 88.0042 66.5762 87.6381 66.8842L87.637 66.8832ZM85.0055 66.6133C85.2364 66.5508 85.4515 66.464 85.6414 66.3529C85.8313 66.2417 85.9792 66.1158 86.0862 65.9803C86.1125 65.9464 86.1366 65.9125 86.1576 65.8776C86.336 65.5886 86.3339 65.2711 86.1523 64.9821C86.1303 64.9471 86.1072 64.9133 86.0799 64.8794C85.9719 64.745 85.8218 64.6179 85.6309 64.5068C85.4399 64.3957 85.2227 64.3089 84.9919 64.2453C84.9342 64.2295 84.8754 64.2157 84.8156 64.203C84.3214 64.0982 83.7758 64.0982 83.2827 64.203C83.2229 64.2157 83.1641 64.2295 83.1064 64.2453C82.8756 64.3078 82.6605 64.3957 82.4706 64.5068C82.2807 64.6179 82.1327 64.7439 82.0257 64.8794C81.9995 64.9133 81.9753 64.9482 81.9544 64.9821C81.776 65.2711 81.7781 65.5897 81.9596 65.8776C81.9816 65.9125 82.0047 65.9464 82.033 65.9803C82.1411 66.1147 82.2901 66.2417 82.4821 66.3529C82.6731 66.464 82.8903 66.5508 83.1211 66.6133C83.1788 66.6291 83.2376 66.6429 83.2974 66.6556C83.7926 66.7604 84.3361 66.7604 84.8303 66.6556C84.8891 66.6429 84.9478 66.6291 85.0066 66.6133",
    fill: "#FAE468"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2224 87.7859V85.3259L64.7093 85.7725C62.9508 82.0592 56.9135 77.7563 49.7357 77.7563C42.5579 77.7563 36.5195 82.0592 34.761 85.7725L34.7358 85.727L34.2427 85.5143V88.0071C34.2427 92.8033 41.1792 96.6923 49.7357 96.6923C58.2922 96.6923 65.2277 92.8033 65.2277 88.0071C65.2277 87.933 65.2256 87.86 65.2224 87.7869V87.7859ZM49.7346 80.8546C56.7446 80.8546 62.4325 84.0239 62.4902 87.9457L59.9049 90.6216L53.9452 92.9303L47.1483 93.1674L42.2358 92.4889L37.6275 90.2628C37.2068 89.5536 36.978 88.7946 36.978 88.006C36.978 84.0567 42.6901 80.8546 49.7346 80.8546Z",
    fill: "#474573"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6478 98.2007C31.8734 98.0197 31.9301 97.6715 31.9206 97.3941C31.8986 96.7241 31.5366 96.0752 31.0697 95.6073C30.8619 95.3988 30.5965 95.2358 30.3027 95.1797C30.1443 95.15 29.9795 95.15 29.8379 95.2337L36.6181 91.279C36.6327 91.2706 36.6485 91.2621 36.6632 91.2547C36.6684 91.2526 36.6737 91.2504 36.6789 91.2483C36.8499 91.1732 37.0524 91.1901 37.2266 91.2473C37.4008 91.3055 37.5697 91.405 37.7135 91.5193C37.7177 91.5225 37.7219 91.5267 37.726 91.5299C37.7344 91.5362 37.7428 91.5436 37.7512 91.55C38.2779 91.9893 38.6557 92.6805 38.706 93.3717C38.7302 93.702 38.6683 94.1127 38.3556 94.2958L31.5765 98.2505C31.5891 98.2431 31.6006 98.2356 31.6132 98.2272C31.6163 98.2251 31.6205 98.2219 31.6237 98.2198C31.6321 98.2134 31.6405 98.2071 31.6489 98.2007H31.6478Z",
    fill: "#4F4F7C"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7098 95.3204C31.3876 95.7152 31.9353 96.6721 31.9322 97.4576C31.9301 98.243 31.3792 98.5595 30.7014 98.1657C30.0236 97.7709 29.4759 96.814 29.478 96.0285C29.4801 95.2431 30.031 94.9266 30.7088 95.3204H30.7098Z",
    fill: "#474573"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9195 105.578C20.2049 105.348 20.2773 104.907 20.2658 104.555C20.2374 103.706 19.7789 102.883 19.1861 102.289C18.9217 102.024 18.5859 101.817 18.2134 101.747C18.013 101.71 17.8032 101.71 17.6238 101.815L29.4696 94.9014C29.4885 94.8908 29.5074 94.8802 29.5274 94.8707C29.5337 94.8675 29.541 94.8654 29.5473 94.8622C29.7645 94.7669 30.0215 94.7881 30.2419 94.8612C30.4633 94.9342 30.6773 95.0601 30.8588 95.2062C30.8641 95.2105 30.8693 95.2158 30.8756 95.22C30.8861 95.2285 30.8966 95.2369 30.9071 95.2464C31.5755 95.8032 32.0539 96.6808 32.1179 97.5572C32.1483 97.9764 32.0697 98.4972 31.673 98.729L19.8272 105.641C19.8429 105.632 19.8587 105.622 19.8733 105.612C19.8775 105.608 19.8828 105.605 19.887 105.602C19.8975 105.595 19.908 105.586 19.9185 105.578H19.9195Z",
    fill: "#5A5A8C"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7307 101.925C19.59 102.425 20.2846 103.638 20.2815 104.634C20.2783 105.63 19.5795 106.033 18.7202 105.532C17.8609 105.031 17.1663 103.818 17.1694 102.822C17.1726 101.826 17.8714 101.424 18.7307 101.925Z",
    fill: "#474573"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M49.7346 79.5432C42.69 79.5432 36.979 82.7452 36.979 86.6935C36.979 90.6418 42.69 93.8449 49.7346 93.8449C56.7791 93.8449 62.4901 90.6429 62.4901 86.6935C62.4901 82.7442 56.7791 79.5432 49.7346 79.5432Z",
    fill: "#27AAE1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5037 79.5569L56.1611 92.8721C59.9457 91.6315 62.4891 89.3292 62.4891 86.6945C62.4891 82.8902 57.1894 79.7802 50.5037 79.5569Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8452 80.6758C41.4371 81.1828 40.22 81.8423 39.2642 82.6108L43.6741 92.9885C45.1136 93.4246 46.72 93.7115 48.4261 93.8089L42.8452 80.6758Z",
    fill: "white"
  }))), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7347 76.8291C41.1782 76.8291 34.2417 80.7181 34.2417 85.5143C34.2417 90.3105 41.1782 94.1995 49.7347 94.1995C58.2912 94.1995 65.2267 90.3105 65.2267 85.5143C65.2267 80.7181 58.2902 76.8291 49.7347 76.8291ZM49.7347 92.6657C42.6891 92.6657 36.9781 89.4636 36.9781 85.5143C36.9781 81.5649 42.6901 78.3629 49.7347 78.3629C56.7793 78.3629 62.4913 81.5649 62.4913 85.5143C62.4913 89.4636 56.7803 92.6657 49.7347 92.6657Z",
    fill: "#5A5A8C"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M113.765 59.0863C113.798 59.0524 113.836 59.0228 113.88 58.9974L122.948 53.7175C123.257 53.5375 123.638 53.5375 123.946 53.7175L137.622 61.6924H138.131V62.2301C138.131 62.3741 138.062 62.517 137.921 62.5996L128.87 67.8689C128.451 68.1124 127.936 68.1124 127.518 67.8689L113.878 59.9141C113.703 59.8125 113.616 59.6357 113.615 59.4579V58.9085L113.764 59.0853L113.765 59.0863Z",
    fill: "#C9DAFC"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M113.88 58.4554L122.948 53.1755C123.257 52.9955 123.637 52.9955 123.946 53.1755L137.922 61.3261C138.201 61.4891 138.201 61.8956 137.922 62.0586L128.871 67.3279C128.452 67.5714 127.937 67.5714 127.519 67.3279L113.879 59.3731C113.529 59.1689 113.529 58.6597 113.879 58.4565L113.88 58.4554Z",
    fill: "white"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M135.294 58.0489V63.5881L120.197 54.7791V49.2451L135.294 58.0489Z",
    fill: "#C2E6F8"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M120.197 49.2451L135.294 58.0489L135.847 57.7271L120.75 48.9233L120.197 49.2451Z",
    fill: "#6BD7F5"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M135.294 58.0488V63.5881L135.847 63.2663V57.7271L135.294 58.0488Z",
    fill: "#C9DAFC"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M104.861 2.39905L106.242 1.59774H106.244C106.692 1.31829 107.28 1.26643 107.802 1.57022L153.053 27.901C154.056 28.4843 154.674 29.5639 154.674 30.7326V69.7254C154.674 70.1329 154.446 70.46 154.134 70.6273V70.6294L152.745 71.437L152.525 70.8549L152.926 70.4791L106.619 43.5333C105.945 43.1406 105.53 42.4155 105.53 41.6311V2.89444C105.53 2.87327 105.533 2.8521 105.534 2.83092L104.861 2.39905Z",
    fill: "white"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M149.547 32.0875L154.343 29.2962C154.064 28.7214 153.62 28.2313 153.052 27.9L152.518 27.5898L149.548 29.3226L149.546 32.0875H149.547Z",
    fill: "#C2E6F8"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M154.668 30.5718L152.509 31.8314V70.2379L152.925 70.4792L152.524 70.855L152.744 71.4372L154.133 70.6295V70.6274C154.445 70.4601 154.673 70.1331 154.673 69.7255V30.7327C154.673 30.6787 154.67 30.6258 154.668 30.5718Z",
    fill: "#C2E6F8"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M106.4 2.38429L151.65 28.7151C152.653 29.2983 153.271 30.378 153.271 31.5466V70.5395C153.271 71.327 152.426 71.8192 151.751 71.4255L105.216 44.3474C104.542 43.9546 104.127 43.2295 104.127 42.4452V3.7085C104.127 2.53248 105.389 1.79681 106.4 2.38429Z",
    fill: "white"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M153.272 31.5466C153.272 30.378 152.654 29.2994 151.651 28.7151L106.4 2.38429C105.389 1.79681 104.127 2.53248 104.127 3.7085V37.8491L153.271 66.4462V31.5466H153.272Z",
    fill: "#314467"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M106.113 36.4517L151.135 62.6502V30.8944L106.113 4.69702V36.4517Z",
    fill: "#2B6AB1"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M127.073 52.7838C127.788 53.2008 128.366 54.2107 128.364 55.0406C128.362 55.8704 127.78 56.2049 127.064 55.7879C126.349 55.3708 125.771 54.361 125.773 53.5311C125.775 52.7023 126.357 52.3667 127.073 52.7838Z",
    fill: "#C2E6F8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M125.402 33.6573C125.183 33.5292 124.963 33.4985 124.795 33.5948C124.459 33.7875 124.458 34.4173 124.791 35.0006C124.957 35.2927 125.177 35.5171 125.396 35.6452C125.615 35.7733 125.836 35.804 126.003 35.7077C126.339 35.514 126.341 34.8852 126.008 34.3019C125.841 34.0098 125.622 33.7854 125.402 33.6573Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M125.338 32.0207C125.339 31.4724 124.957 30.8034 124.483 30.5282C124.01 30.253 123.625 30.4742 123.624 31.0226C123.623 31.5719 124.005 32.2409 124.478 32.5161C124.951 32.7924 125.337 32.5701 125.338 32.0218V32.0207Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M125.417 28.4769C125.198 28.3488 124.977 28.3181 124.809 28.4144C124.474 28.6081 124.473 29.2369 124.805 29.8202C124.972 30.1123 125.191 30.3367 125.411 30.4648C125.63 30.5929 125.85 30.6236 126.018 30.5272C126.354 30.3346 126.356 29.7058 126.022 29.1215C125.855 28.8294 125.636 28.605 125.417 28.4769Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M127.654 28.7055C127.18 28.4292 126.795 28.6515 126.793 29.1998C126.792 29.7481 127.174 30.4171 127.649 30.6923C128.122 30.9686 128.508 30.7463 128.509 30.198C128.51 29.6486 128.128 28.9796 127.654 28.7044V28.7055Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M127.633 36.0316C127.159 35.7553 126.774 35.9765 126.772 36.5259C126.771 37.0753 127.153 37.7443 127.628 38.0195C128.101 38.2958 128.487 38.0735 128.488 37.5252C128.489 36.9758 128.107 36.3079 127.633 36.0326V36.0316Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8
  }, _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M129.871 36.2601C129.652 36.132 129.431 36.1013 129.263 36.1976C128.928 36.3903 128.926 37.0191 129.259 37.6034C129.426 37.8955 129.645 38.1199 129.865 38.248C130.084 38.3761 130.304 38.4068 130.472 38.3105C130.808 38.1167 130.809 37.4869 130.476 36.9047C130.309 36.6126 130.09 36.3882 129.871 36.2601Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M130.804 34.2089C130.331 33.9326 129.944 34.1549 129.943 34.7032C129.942 35.2526 130.324 35.9216 130.799 36.1968C131.272 36.472 131.657 36.2508 131.658 35.7014C131.659 35.1531 131.277 34.4841 130.804 34.2089Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8
  }, _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M129.879 33.0676C130.099 33.1957 130.319 33.2263 130.487 33.13C130.822 32.9363 130.824 32.3076 130.491 31.7243C130.324 31.4322 130.105 31.2077 129.886 31.0797C129.666 30.9516 129.446 30.9209 129.278 31.0172C128.942 31.2099 128.94 31.8386 129.274 32.4229C129.441 32.7151 129.66 32.9395 129.879 33.0676Z",
    fill: "white"
  }))), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M116.792 26.0603L109.999 22.0961C109.835 22.0008 109.631 22.1194 109.631 22.3099V25.0684C109.631 25.2569 109.731 25.4315 109.893 25.5257L116.746 29.5248C116.935 29.6349 117.171 29.4973 117.171 29.2771V26.7229C117.171 26.4498 117.026 26.1979 116.792 26.0613V26.0603ZM110.191 22.9027L111.983 23.9496V24.1528L110.191 23.1059V22.9027ZM110.191 23.2965L113.785 25.3966V25.5998L110.191 23.4997V23.2965ZM110.191 24.0935L111.983 25.1404V25.3437L110.191 24.2968V24.0935ZM110.191 24.4873L113.785 26.5874V26.7907L110.191 24.6905V24.4873ZM116.612 28.8347L110.191 25.0833V24.88L116.612 28.6314V28.8347ZM116.612 28.4409L114.009 26.9198V26.7166L116.612 28.2377V28.4409ZM116.612 28.0471L112.205 25.4728V25.2696L116.612 27.8439V28.0471ZM116.612 27.6438L110.191 23.8924V23.6892L116.612 27.4406V27.6438ZM116.612 27.2501L114.009 25.729V25.5257L116.612 27.0468V27.2501ZM116.612 26.8563L112.205 24.282V24.0787L116.612 26.6531V26.8563Z",
    fill: "#FAE468"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M109.011 21.5214L107.348 20.5539C107.24 20.4904 107.105 20.5697 107.105 20.6957V22.5269C107.105 22.6519 107.171 22.7672 107.278 22.8307L108.981 23.8215C109.107 23.8946 109.263 23.8035 109.263 23.6575V21.9617C109.263 21.7807 109.168 21.6134 109.011 21.5224V21.5214ZM108.188 21.3266C108.403 21.4515 108.576 21.7553 108.576 22.004C108.576 22.2528 108.401 22.3534 108.185 22.2284C107.97 22.1035 107.796 21.7997 107.797 21.5499C107.797 21.3012 107.972 21.2006 108.189 21.3255L108.188 21.3266ZM108.799 23.4045L107.565 22.6857V22.275C107.567 22.0951 107.693 22.022 107.849 22.1131L108.521 22.5047C108.676 22.5958 108.801 22.8138 108.801 22.9938V23.4055L108.799 23.4045Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M116.919 30.287L115.256 29.3195C115.148 29.256 115.013 29.3354 115.013 29.4613V31.2926C115.013 31.4175 115.079 31.5329 115.186 31.5964L116.889 32.5871C117.015 32.6602 117.171 32.5692 117.171 32.4231V30.7273C117.171 30.5463 117.075 30.3791 116.919 30.288V30.287ZM116.096 30.0922C116.311 30.2171 116.484 30.5209 116.484 30.7697C116.484 31.0184 116.308 31.119 116.093 30.9941C115.878 30.8692 115.704 30.5654 115.705 30.3156C115.705 30.0668 115.88 29.9662 116.097 30.0912L116.096 30.0922ZM116.707 32.1701L115.473 31.4514V31.0396C115.475 30.8596 115.601 30.7866 115.757 30.8776L116.429 31.2693C116.584 31.3603 116.709 31.5784 116.709 31.7583V32.1701H116.707Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M114.266 28.7405L107.472 24.7763C107.308 24.681 107.105 24.7996 107.105 24.9901V27.4406C107.105 27.629 107.204 27.8037 107.366 27.8979L114.22 31.897C114.408 32.0071 114.645 31.8695 114.645 31.6493V29.4031C114.645 29.13 114.5 28.8781 114.266 28.7415V28.7405ZM107.664 25.5829L109.456 26.6298V26.833L107.664 25.7861V25.5829ZM107.664 25.9766L111.259 28.0768V28.28L107.664 26.1799V25.9766ZM107.664 26.7737L109.456 27.8206V28.0238L107.664 26.977V26.7737ZM111.259 29.4708L107.664 27.3707V27.1675L111.259 29.2676V29.4708ZM114.084 30.7284L109.677 28.154V27.9508L114.084 30.5251V30.7284ZM114.084 30.3251L107.664 26.5737V26.3704L114.084 30.1218V30.3251ZM114.084 29.9313L111.481 28.4102V28.207L114.084 29.7281V29.9313ZM114.084 29.5375L109.677 26.9632V26.76L114.084 29.3343V29.5375Z",
    fill: "white"
  }))), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M116.792 34.0923L109.999 30.1281C109.835 30.0328 109.631 30.1514 109.631 30.3419V33.1004C109.631 33.2888 109.731 33.4635 109.893 33.5577L116.746 37.5568C116.935 37.6669 117.171 37.5293 117.171 37.3091V34.7549C117.171 34.4818 117.026 34.2299 116.792 34.0933V34.0923ZM110.191 30.9347L111.983 31.9816V32.1848L110.191 31.1379V30.9347ZM110.191 31.3285L113.785 33.4286V33.6318L110.191 31.5317V31.3285ZM110.191 32.1255L111.983 33.1724V33.3756L110.191 32.3288V32.1255ZM110.191 32.5193L113.785 34.6194V34.8226L110.191 32.7225V32.5193ZM116.612 36.8667L110.191 33.1152V32.912L116.612 36.6634V36.8667ZM116.612 36.4729L114.009 34.9518V34.7486L116.612 36.2697V36.4729ZM116.612 36.0791L112.205 33.5048V33.3015L116.612 35.8759V36.0791ZM116.612 35.6758L110.191 31.9244V31.7212L116.612 35.4726V35.6758ZM116.612 35.282L114.009 33.7609V33.5577L116.612 35.0788V35.282ZM116.612 34.8883L112.205 32.3139V32.1107L116.612 34.685V34.8883Z",
    fill: "#FAE468"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M109.011 29.5533L107.348 28.5858C107.24 28.5223 107.105 28.6017 107.105 28.7277V30.5589C107.105 30.6838 107.171 30.7992 107.278 30.8627L108.981 31.8535C109.107 31.9265 109.263 31.8355 109.263 31.6894V29.9937C109.263 29.8127 109.168 29.6454 109.011 29.5544V29.5533ZM108.188 29.3586C108.403 29.4835 108.576 29.7873 108.576 30.036C108.576 30.2848 108.401 30.3853 108.185 30.2604C107.97 30.1355 107.796 29.8317 107.797 29.5819C107.797 29.3332 107.972 29.2326 108.189 29.3575L108.188 29.3586ZM108.799 31.4364L107.565 30.7177V30.307C107.567 30.1271 107.693 30.054 107.849 30.145L108.521 30.5367C108.676 30.6277 108.801 30.8458 108.801 31.0257V31.4364H108.799Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M116.919 38.319L115.256 37.3515C115.148 37.288 115.013 37.3673 115.013 37.4933V39.3246C115.013 39.4495 115.079 39.5648 115.186 39.6284L116.889 40.6191C117.015 40.6922 117.171 40.6011 117.171 40.4551V38.7593C117.171 38.5783 117.075 38.4111 116.919 38.32V38.319ZM116.096 38.1242C116.311 38.2491 116.484 38.5529 116.484 38.8016C116.484 39.0504 116.308 39.151 116.093 39.0261C115.878 38.9011 115.704 38.5974 115.705 38.3475C115.705 38.0988 115.88 37.9982 116.097 38.1231L116.096 38.1242ZM116.707 40.2021L115.473 39.4833V39.0726C115.475 38.8927 115.601 38.8196 115.757 38.9107L116.429 39.3023C116.584 39.3934 116.709 39.6114 116.709 39.7914V40.2031L116.707 40.2021Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M114.266 36.7737L107.472 32.8095C107.308 32.7142 107.105 32.8328 107.105 33.0233V35.4738C107.105 35.6622 107.204 35.8369 107.366 35.9311L114.22 39.9302C114.408 40.0403 114.645 39.9027 114.645 39.6825V37.4363C114.645 37.1632 114.5 36.9113 114.266 36.7747V36.7737ZM107.664 33.6161L109.456 34.663V34.8662L107.664 33.8193V33.6161ZM107.664 34.0099L111.259 36.11V36.3132L107.664 34.2131V34.0099ZM107.664 34.8069L109.456 35.8538V36.057L107.664 35.0102V34.8069ZM111.259 37.504L107.664 35.4039V35.2007L111.259 37.3008V37.504ZM114.084 38.7616L109.677 36.1872V35.984L114.084 38.5583V38.7616ZM114.084 38.3583L107.664 34.6069V34.4036L114.084 38.155V38.3583ZM114.084 37.9645L111.481 36.4434V36.2402L114.084 37.7613V37.9645ZM114.084 37.5707L109.677 34.9964V34.7932L114.084 37.3675V37.5707Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M149.983 58.118L147.125 56.4519V56.8055L149.983 58.4716V58.118Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 55.6346V55.281L146.336 55.9955V56.3491L145.11 55.6346Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 56.2019V55.8484L146.336 56.5629V56.9164L145.11 56.2019Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 57.9031V57.5496L146.336 58.2641V58.6176L145.11 57.9031Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M146.149 57.0212V57.3748L145.11 56.7693V56.4158L146.149 57.0212Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 58.5676L149.983 59.2525V59.606L148.809 58.9212V58.5676Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M148.614 58.4545V58.808L147.125 57.939V57.5854L148.614 58.4545Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M148.614 57.887V58.2406L147.125 57.3726V57.019L148.614 57.887Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 58.0002L149.983 58.6851V59.0387L148.809 58.3538V58.0002Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M147.884 56.3281L149.982 57.5507V57.9043L147.884 56.6817V56.3281Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M147.69 56.2148V56.5683L147.125 56.2381V55.8845L147.69 56.2148Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M147.69 59.0495V59.402L147.125 59.0728V58.7192L147.69 59.0495Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 59.7014L149.983 60.3863V60.7398L148.809 60.055V59.7014Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M147.884 58.5952L149.983 59.8189V60.1724L147.884 58.9488V58.5952Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M145.83 57.4014V57.7549L145.11 57.3357V56.9822L145.83 57.4014Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M145.723 55.0714V55.425L145.11 55.0672V54.7136L145.723 55.0714Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M149.983 54.0731L147.125 52.407V52.7605L149.983 54.4267V54.0731Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 51.5899V51.2363L146.336 51.9508V52.3044L145.11 51.5899Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 52.1563V51.8027L146.336 52.5172V52.8708L145.11 52.1563Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 53.8572V53.5037L146.336 54.2192V54.5717L145.11 53.8572Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M146.149 52.9754V53.3289L145.11 52.7234V52.3699L146.149 52.9754Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 54.522L149.983 55.2068V55.5604L148.809 54.8755V54.522Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M148.614 54.4088V54.7623L147.125 53.8943V53.5408L148.614 54.4088Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M148.614 53.8424V54.196L147.125 53.3269V52.9734L148.614 53.8424Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 53.9556L149.983 54.6394V54.9929L148.809 54.3091V53.9556Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M147.884 52.2822L149.982 53.5059V53.8594L147.884 52.6358V52.2822Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M147.69 52.1688V52.5223L147.125 52.1931V51.8396L147.69 52.1688Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M147.69 55.0035V55.3571L147.125 55.0279V54.6743L147.69 55.0035Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 55.6567L149.983 56.3416V56.6941L148.809 56.0103V55.6567Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M147.884 54.5505L149.983 55.7742V56.1277L147.884 54.9041V54.5505Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M145.83 53.3564V53.71L145.11 53.2908V52.9373L145.83 53.3564Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M145.723 51.0267V51.3792L145.11 51.0225V50.6689L145.723 51.0267Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M149.983 50.0274L147.125 48.3613V48.7149L149.983 50.381V50.0274Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 47.544V47.1904L146.336 47.9049V48.2585L145.11 47.544Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 48.1114V47.7578L146.336 48.4723V48.8259L145.11 48.1114Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 49.8125V49.459L146.336 50.1735V50.527L145.11 49.8125Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M146.149 48.9307V49.2842L145.11 48.6787V48.3252L146.149 48.9307Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 50.4771L149.983 51.1619V51.5155L148.809 50.8306V50.4771Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M148.614 50.3638V50.7174L147.125 49.8483V49.4958L148.614 50.3638Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M148.614 49.7967V50.1502L147.125 49.2823V48.9287L148.614 49.7967Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 49.9099L149.983 50.5948V50.9483L148.809 50.2635V49.9099Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M147.884 48.2375L149.982 49.4612V49.8148L147.884 48.5911V48.2375Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M147.69 48.1242V48.4777L147.125 48.1475V47.7939L147.69 48.1242Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M147.69 50.9589V51.3125L147.125 50.9822V50.6287L147.69 50.9589Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 51.6108L149.983 52.2957V52.6493L148.809 51.9644V51.6108Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M147.884 50.5046L149.983 51.7283V52.0818L147.884 50.8582V50.5046Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M145.83 49.3108V49.6643L145.11 49.2451V48.8916L145.83 49.3108Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M145.723 46.981V47.3345L145.11 46.9778V46.6243L145.723 46.981Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M149.983 45.9828L147.125 44.3167V44.6702L149.983 46.3363V45.9828Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 43.4995V43.146L146.336 43.8605V44.2141L145.11 43.4995Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 44.0659V43.7134L146.336 44.4279V44.7814L145.11 44.0659Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 45.7681V45.4146L146.336 46.129V46.4826L145.11 45.7681Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M146.149 44.8853V45.2388L145.11 44.6333V44.2798L146.149 44.8853Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 46.4316L149.983 47.1165V47.4701L148.809 46.7852V46.4316Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M148.615 46.3184V46.672L147.125 45.804V45.4504L148.615 46.3184Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M148.615 45.7521V46.1057L147.125 45.2366V44.8831L148.615 45.7521Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 45.8652L149.983 46.5501V46.9036L148.809 46.2188V45.8652Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M147.884 44.1917L149.983 45.4153V45.7689L147.884 44.5452V44.1917Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M147.69 44.0785V44.432L147.125 44.1028V43.7493L147.69 44.0785Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M147.69 46.9132V47.2667L147.125 46.9375V46.584L147.69 46.9132Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 47.5664L149.983 48.2513V48.6048L148.809 47.92V47.5664Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M147.884 46.4602L149.983 47.6839V48.0374L147.884 46.8138V46.4602Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M145.83 45.2663V45.6199L145.11 45.2007V44.8472L145.83 45.2663Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M145.723 42.9364V43.2899L145.11 42.9322V42.5786L145.723 42.9364Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M149.983 41.794L147.125 40.1279V40.4815L149.983 42.1476V41.794Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 39.3108V38.9573L146.336 39.6718V40.0253L145.11 39.3108Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 39.8782V39.5247L146.336 40.2392V40.5927L145.11 39.8782Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 41.5794V41.2258L146.336 41.9403V42.2939L145.11 41.5794Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M146.149 40.6976V41.0501L145.11 40.4446V40.0911L146.149 40.6976Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 42.2429L149.983 42.9278V43.2813L148.809 42.5965V42.2429Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M148.614 42.1297V42.4833L147.125 41.6153V41.2617L148.614 42.1297Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M148.614 41.5634V41.9169L147.125 41.0479V40.6943L148.614 41.5634Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 41.6768L149.983 42.3616V42.7152L148.809 42.0303V41.6768Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M147.884 40.0029L149.982 41.2266V41.5801L147.884 40.3565V40.0029Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M147.69 39.8897V40.2433L147.125 39.9141V39.5605L147.69 39.8897Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M147.69 42.7247V43.0783L147.125 42.7491V42.3955L147.69 42.7247Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 43.3777L149.983 44.0625V44.4161L148.809 43.7312V43.3777Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M147.884 42.2715L149.983 43.4951V43.8487L147.884 42.625V42.2715Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M145.83 41.0776V41.4312L145.11 41.012V40.6584L145.83 41.0776Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M145.723 38.7477V39.1012L145.11 38.7434V38.3899L145.723 38.7477Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M149.983 37.7495L147.125 36.0823V36.4358L149.983 38.1019V37.7495Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 35.2652V34.9116L146.336 35.6272V35.9797L145.11 35.2652Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 35.8326V35.479L146.336 36.1935V36.5471L145.11 35.8326Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 37.5335V37.1799L146.336 37.8944V38.248L145.11 37.5335Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M146.149 36.6519V37.0054L145.11 36.3999V36.0464L146.149 36.6519Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 38.1982L149.983 38.8831V39.2367L148.809 38.5518V38.1982Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M148.614 38.085V38.4386L147.125 37.5706V37.217L148.614 38.085Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M148.614 37.5177V37.8712L147.125 37.0032V36.6497L148.614 37.5177Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 37.6309L149.983 38.3157V38.6693L148.809 37.9844V37.6309Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M147.884 35.9583L149.982 37.1819V37.5355L147.884 36.3118V35.9583Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M147.69 35.8451V36.1986L147.125 35.8694V35.5159L147.69 35.8451Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M147.69 38.6798V39.0333L147.125 38.7041V38.3506L147.69 38.6798Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 39.332L149.983 40.0169V40.3704L148.809 39.6856V39.332Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M147.884 38.2268L149.983 39.4505V39.804L147.884 38.5804V38.2268Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M145.83 37.0327V37.3862L145.11 36.9671V36.6135L145.83 37.0327Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M145.723 34.7019V35.0555L145.11 34.6988V34.3452L145.723 34.7019Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M149.983 33.7037L147.125 32.0376V32.3911L149.983 34.0573V33.7037Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 31.2205V30.8669L146.336 31.5814V31.935L145.11 31.2205Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 31.7879V31.4343L146.336 32.1488V32.5024L145.11 31.7879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M145.11 33.4888V33.1353L146.336 33.8498V34.2033L145.11 33.4888Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M146.149 32.607V32.9606L145.11 32.354V32.0005L146.149 32.607Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 34.1538L149.983 34.8376V35.1912L148.809 34.5074V34.1538Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M148.615 34.0404V34.394L147.125 33.5249V33.1714L148.615 34.0404Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M148.615 33.473V33.8265L147.125 32.9585V32.605L148.615 33.473Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 33.5862L149.983 34.271V34.6246L148.809 33.9397V33.5862Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M147.884 31.9126L149.983 33.1362V33.4898L147.884 32.2661V31.9126Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M147.69 31.7994V32.153L147.125 31.8238V31.4702L147.69 31.7994Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M147.69 34.6341V34.9877L147.125 34.6585V34.3049L147.69 34.6341Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M148.809 35.2874L149.983 35.9722V36.3258L148.809 35.6409V35.2874Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M147.884 34.1812L149.983 35.4048V35.7584L147.884 34.5347V34.1812Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M145.83 32.987V33.3406L145.11 32.9214V32.5679L145.83 32.987Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M145.723 30.6573V31.0109L145.11 30.6531V30.2996L145.723 30.6573Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M121.59 16.9642L121.325 16.8097C121.299 16.7938 121.276 16.7589 121.272 16.7261C121.223 16.4043 121.124 16.0751 120.984 15.7554C120.969 15.7215 120.972 15.6887 120.99 15.6771L121.18 15.568C121.202 15.5553 121.202 15.5151 121.18 15.4781L120.829 14.8641C120.818 14.8451 120.804 14.8313 120.79 14.8228C120.776 14.8144 120.762 14.8122 120.751 14.8186L120.559 14.9287C120.549 14.935 120.535 14.9329 120.52 14.9244C120.51 14.9181 120.498 14.9075 120.489 14.8948C120.284 14.6154 120.051 14.3645 119.8 14.1623C119.773 14.1411 119.754 14.1041 119.754 14.0734V13.759C119.754 13.7241 119.73 13.6807 119.701 13.6627L119.202 13.3716C119.172 13.3536 119.147 13.3684 119.147 13.4034V13.7177C119.147 13.7484 119.127 13.7632 119.101 13.7537C118.849 13.6627 118.615 13.6405 118.409 13.6817C118.4 13.6839 118.388 13.6817 118.378 13.6743C118.364 13.6659 118.349 13.6521 118.339 13.6331L118.149 13.3007C118.139 13.2816 118.124 13.2679 118.11 13.2594C118.097 13.2509 118.082 13.2488 118.071 13.2552L117.717 13.4584C117.695 13.4711 117.695 13.5113 117.717 13.5484L117.906 13.8786C117.925 13.9114 117.927 13.9474 117.912 13.9633C117.771 14.1189 117.67 14.3317 117.62 14.5963C117.615 14.6238 117.593 14.6323 117.567 14.6175L117.302 14.4629C117.272 14.4449 117.247 14.4598 117.247 14.4947L117.245 15.0726C117.245 15.1076 117.269 15.151 117.299 15.169L117.56 15.3214C117.587 15.3373 117.61 15.3722 117.614 15.4061C117.66 15.7289 117.759 16.0613 117.898 16.382C117.913 16.4159 117.911 16.4487 117.892 16.4593L117.708 16.5652C117.686 16.5779 117.686 16.6181 117.708 16.6551L118.06 17.2701C118.07 17.2892 118.085 17.303 118.099 17.3114C118.112 17.3199 118.127 17.322 118.138 17.3157L118.319 17.2109C118.33 17.2045 118.343 17.2066 118.358 17.2151C118.369 17.2214 118.38 17.232 118.389 17.2447C118.596 17.5295 118.832 17.7846 119.088 17.9899C119.114 18.0111 119.133 18.0482 119.133 18.0789V18.3742C119.133 18.4091 119.157 18.4525 119.187 18.4705L119.685 18.7616C119.716 18.7796 119.741 18.7648 119.741 18.7298V18.4345C119.741 18.4038 119.761 18.389 119.787 18.3985C120.043 18.4906 120.28 18.5118 120.488 18.4684C120.497 18.4663 120.509 18.4684 120.519 18.4758C120.533 18.4843 120.548 18.498 120.558 18.5171L120.739 18.8336C120.749 18.8526 120.764 18.8664 120.777 18.8749C120.791 18.8833 120.806 18.8854 120.816 18.8791L121.17 18.6759C121.192 18.6632 121.192 18.6229 121.17 18.5859L120.987 18.2673C120.968 18.2345 120.966 18.1995 120.981 18.1826C121.122 18.0238 121.221 17.8079 121.269 17.5401C121.275 17.5125 121.297 17.503 121.324 17.5189L121.585 17.6713C121.616 17.6893 121.64 17.6745 121.64 17.6396L121.642 17.0616C121.642 17.0267 121.618 16.9833 121.587 16.9663L121.59 16.9642ZM119.442 17.0182C118.994 16.7568 118.631 16.1238 118.633 15.604C118.634 15.0843 118.999 14.8747 119.447 15.1362C119.895 15.3976 120.257 16.0306 120.256 16.5503C120.255 17.0701 119.89 17.2797 119.442 17.0193V17.0182Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M116.522 14.0109L116.257 13.8563C116.231 13.8404 116.208 13.8055 116.204 13.7727C116.155 13.4509 116.056 13.1217 115.916 12.802C115.902 12.7681 115.904 12.7353 115.923 12.7237L116.112 12.6147C116.134 12.602 116.134 12.5617 116.112 12.5247L115.761 11.9107C115.75 11.8917 115.736 11.8779 115.722 11.8695C115.708 11.861 115.694 11.8589 115.683 11.8652L115.491 11.9753C115.481 11.9817 115.467 11.9795 115.452 11.9711C115.442 11.9647 115.43 11.9541 115.421 11.9414C115.216 11.662 114.983 11.4111 114.732 11.2089C114.705 11.1878 114.687 11.1507 114.687 11.12V10.8056C114.687 10.7707 114.663 10.7273 114.633 10.7093L114.135 10.4182C114.104 10.4002 114.079 10.4151 114.079 10.45V10.7644C114.079 10.7951 114.059 10.8099 114.033 10.8004C113.781 10.7093 113.547 10.6871 113.341 10.7284C113.332 10.7305 113.32 10.7284 113.31 10.721C113.296 10.7125 113.282 10.6987 113.271 10.6797L113.081 10.3473C113.071 10.3283 113.056 10.3145 113.042 10.306C113.029 10.2976 113.014 10.2954 113.004 10.3018L112.649 10.505C112.627 10.5177 112.627 10.558 112.649 10.595L112.838 10.9253C112.857 10.9581 112.859 10.9941 112.844 11.0099C112.703 11.1655 112.602 11.3783 112.552 11.6429C112.547 11.6705 112.525 11.6789 112.499 11.6641L112.234 11.5096C112.204 11.4916 112.179 11.5064 112.179 11.5413L112.177 12.1193C112.177 12.1542 112.201 12.1976 112.231 12.2156L112.493 12.368C112.519 12.3839 112.542 12.4188 112.546 12.4527C112.592 12.7756 112.691 13.1079 112.83 13.4287C112.845 13.4625 112.843 13.4954 112.824 13.5059L112.641 13.6118C112.618 13.6245 112.618 13.6647 112.641 13.7018L112.992 14.3168C113.003 14.3358 113.017 14.3496 113.031 14.3581C113.044 14.3665 113.059 14.3686 113.07 14.3623L113.251 14.2575C113.262 14.2511 113.275 14.2533 113.29 14.2617C113.302 14.2681 113.312 14.2787 113.321 14.2914C113.528 14.5761 113.764 14.8312 114.02 15.0366C114.047 15.0577 114.065 15.0948 114.065 15.1255V15.4208C114.065 15.4557 114.09 15.4991 114.119 15.5171L114.617 15.8082C114.648 15.8262 114.673 15.8114 114.673 15.7765V15.4811C114.673 15.4504 114.693 15.4356 114.719 15.4452C114.975 15.5372 115.212 15.5584 115.42 15.515C115.429 15.5129 115.441 15.515 115.451 15.5224C115.465 15.5309 115.48 15.5447 115.49 15.5637L115.671 15.8802C115.681 15.8993 115.696 15.913 115.71 15.9215C115.723 15.93 115.738 15.9321 115.748 15.9257L116.102 15.7225C116.124 15.7098 116.124 15.6696 116.102 15.6325L115.919 15.3139C115.9 15.2811 115.898 15.2462 115.913 15.2292C116.054 15.0704 116.153 14.8545 116.202 14.5867C116.207 14.5592 116.229 14.5496 116.256 14.5655L116.517 14.7179C116.548 14.7359 116.572 14.7211 116.572 14.6862L116.574 14.1082C116.574 14.0733 116.55 14.0299 116.52 14.013L116.522 14.0109ZM114.374 14.0648C113.926 13.8034 113.563 13.1704 113.565 12.6507C113.566 12.1309 113.931 11.9213 114.379 12.1828C114.827 12.4442 115.189 13.0772 115.188 13.597C115.187 14.1167 114.822 14.3263 114.374 14.0659V14.0648Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M111.454 11.0577L111.189 10.9032C111.163 10.8873 111.14 10.8524 111.136 10.8196C111.088 10.4978 110.988 10.1686 110.848 9.8489C110.834 9.81502 110.836 9.78221 110.855 9.77057L111.045 9.66154C111.067 9.64884 111.067 9.60861 111.045 9.57156L110.693 8.95762C110.683 8.93857 110.668 8.92481 110.654 8.91634C110.641 8.90787 110.626 8.90575 110.615 8.9121L110.423 9.02219C110.413 9.02854 110.399 9.02642 110.385 9.01796C110.374 9.0116 110.363 9.00102 110.353 8.98832C110.149 8.70887 109.916 8.458 109.664 8.25582C109.638 8.23465 109.619 8.1976 109.619 8.1669V7.85252C109.619 7.81759 109.596 7.77419 109.565 7.7562L109.067 7.4651C109.036 7.44711 109.011 7.46193 109.011 7.49686V7.81124C109.011 7.84194 108.991 7.85676 108.965 7.84723C108.713 7.7562 108.479 7.73397 108.274 7.77525C108.264 7.77737 108.253 7.77525 108.242 7.76784C108.228 7.75937 108.214 7.74561 108.203 7.72656L108.013 7.39418C108.003 7.37513 107.988 7.36137 107.975 7.3529C107.961 7.34443 107.946 7.34231 107.936 7.34866L107.581 7.5519C107.559 7.5646 107.559 7.60483 107.581 7.64187L107.77 7.97213C107.789 8.00495 107.791 8.04094 107.776 8.05682C107.636 8.21242 107.534 8.42518 107.485 8.68981C107.479 8.71733 107.457 8.7258 107.431 8.71098L107.167 8.55644C107.136 8.53844 107.111 8.55326 107.111 8.5882L107.109 9.16615C107.109 9.20108 107.133 9.24448 107.163 9.26247L107.425 9.4149C107.451 9.43078 107.474 9.46571 107.478 9.49958C107.524 9.82243 107.623 10.1548 107.763 10.4755C107.777 10.5094 107.775 10.5422 107.756 10.5528L107.573 10.6587C107.551 10.6714 107.551 10.7116 107.573 10.7486L107.924 11.3636C107.935 11.3827 107.949 11.3965 107.963 11.4049C107.977 11.4134 107.991 11.4155 108.002 11.4092L108.183 11.3044C108.194 11.298 108.207 11.3001 108.222 11.3086C108.233 11.315 108.244 11.3255 108.254 11.3382C108.46 11.623 108.696 11.8781 108.952 12.0834C108.979 12.1046 108.998 12.1417 108.998 12.1724V12.4677C108.998 12.5026 109.022 12.546 109.051 12.564L109.549 12.8551C109.58 12.8731 109.605 12.8583 109.605 12.8233V12.528C109.605 12.4973 109.625 12.4825 109.651 12.492C109.907 12.5841 110.144 12.6053 110.352 12.5619C110.362 12.5598 110.373 12.5619 110.384 12.5693C110.397 12.5778 110.412 12.5915 110.422 12.6106L110.603 12.9271C110.613 12.9461 110.628 12.9599 110.642 12.9684C110.655 12.9768 110.67 12.979 110.68 12.9726L111.034 12.7694C111.056 12.7567 111.056 12.7164 111.034 12.6794L110.852 12.3608C110.833 12.328 110.831 12.293 110.845 12.2761C110.986 12.1173 111.086 11.9014 111.134 11.6336C111.139 11.606 111.161 11.5965 111.188 11.6124L111.45 11.7648C111.48 11.7828 111.504 11.768 111.504 11.7331L111.506 11.1551C111.506 11.1202 111.482 11.0768 111.452 11.0598L111.454 11.0577ZM109.306 11.1117C108.858 10.8503 108.495 10.2173 108.497 9.69753C108.498 9.17779 108.863 8.9682 109.311 9.22966C109.759 9.49112 110.121 10.1241 110.12 10.6438C110.119 11.1636 109.754 11.3732 109.306 11.1128V11.1117Z",
    fill: "white"
  })))), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M134.98 39.0906L148.957 47.2232V59.3412L134.98 51.2086V39.0906Z",
    fill: "#C9DAFC"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M134.98 40.1787L148.957 48.3114V47.2232L134.98 39.0906V40.1787Z",
    fill: "#4E5EA6"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M135.422 40.9441L140.153 43.6963V47.798L135.422 45.0459V40.9441Z",
    fill: "#4E5EA6"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M135.422 47.5015L140.153 50.2547V53.7065L135.422 50.9533V47.5015Z",
    fill: "#939DE2"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M135.422 45.2852L137.686 46.602V48.5645L135.422 47.2477V45.2852Z",
    fill: "#939DE2"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M137.889 46.7205L140.153 48.0373V49.9998L137.889 48.683V46.7205Z",
    fill: "#939DE2"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M135.521 39.6695C135.657 39.7479 135.766 39.9395 135.766 40.0961C135.766 40.2528 135.655 40.3163 135.52 40.238C135.385 40.1586 135.276 39.968 135.276 39.8114C135.276 39.6547 135.386 39.5912 135.521 39.6695Z",
    fill: "white"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M136.21 40.0697C136.346 40.1491 136.455 40.3396 136.455 40.4963C136.455 40.6529 136.345 40.7164 136.209 40.6381C136.074 40.5587 135.965 40.3682 135.965 40.2115C135.965 40.0549 136.075 39.9914 136.21 40.0697Z",
    fill: "white"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M136.901 40.4708C137.036 40.5491 137.145 40.7407 137.145 40.8974C137.145 41.0541 137.035 41.1176 136.9 41.0392C136.764 40.9598 136.655 40.7693 136.655 40.6126C136.655 40.456 136.765 40.3925 136.901 40.4708Z",
    fill: "white"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 47.5461V47.6721L142.28 45.3275V45.2004L146.295 47.5461Z",
    fill: "#4E5EA6"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 48.0373V48.1643L142.28 45.8197V45.6926L146.295 48.0373Z",
    fill: "#4E5EA6"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 49.0216V49.1487L142.28 46.803V46.677L146.295 49.0216Z",
    fill: "#4E5EA6"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 50.4972V50.6242L142.28 48.2796V48.1526L146.295 50.4972Z",
    fill: "#4E5EA6"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M144.528 46.2673L146.295 47.2994V47.4264L144.528 46.3944V46.2673Z",
    fill: "#4E5EA6"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M144.388 46.187V46.3129L142.28 45.0819V44.9548L144.388 46.187Z",
    fill: "#4E5EA6"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M143.672 46.2588L146.295 47.7915V47.9186L143.672 46.3858V46.2588Z",
    fill: "#4E5EA6"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M143.532 46.1785V46.3044L142.28 45.573V45.447L143.532 46.1785Z",
    fill: "#4E5EA6"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M144.287 47.1111V47.2381L142.28 46.0653V45.9382L144.287 47.1111Z",
    fill: "#4E5EA6"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M143.539 46.9204L146.295 48.5294V48.6564L143.539 47.0474V46.9204Z",
    fill: "#4E5EA6"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M143.401 46.839V46.966L142.28 46.3118V46.1848L143.401 46.839Z",
    fill: "#4E5EA6"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M144.667 47.8245L146.295 48.7761V48.902L144.667 47.9515V47.8245Z",
    fill: "#4E5EA6"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M144.528 47.744V47.87L142.28 46.5574V46.4304L144.528 47.744Z",
    fill: "#4E5EA6"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M144.218 48.3008V48.4279L142.28 47.2952V47.1682L144.218 48.3008Z",
    fill: "#4E5EA6"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M145.062 49.0396V49.1667L142.28 47.5418V47.4148L145.062 49.0396Z",
    fill: "#4E5EA6"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M143.343 48.2817L146.295 50.0061V50.132L143.343 48.4088V48.2817Z",
    fill: "#4E5EA6"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M143.204 48.2003V48.3273L142.28 47.7874V47.6604L143.204 48.2003Z",
    fill: "#4E5EA6"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M144.806 49.3794L146.287 50.2442V50.3712L144.806 49.5054V49.3794Z",
    fill: "#4E5EA6"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M144.667 49.298V49.425L142.273 48.0256V47.8997L144.667 49.298Z",
    fill: "#4E5EA6"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M143.969 49.3848L146.295 50.7439V50.8709L143.969 49.5118V49.3848Z",
    fill: "#4E5EA6"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M143.83 49.3043V49.4302L142.28 48.5252V48.3982L143.83 49.3043Z",
    fill: "#4E5EA6"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M145.131 50.3098V50.4369L142.28 48.7718V48.6448L145.131 50.3098Z",
    fill: "#4E5EA6"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 51.7665V51.8935L142.28 49.5489V49.4219L146.295 51.7665Z",
    fill: "#4E5EA6"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 52.2587V52.3857L142.28 50.0411V49.9141L146.295 52.2587Z",
    fill: "#4E5EA6"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M144.388 50.4073V50.5344L142.28 49.3033V49.1763L144.388 50.4073Z",
    fill: "#4E5EA6"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M143.672 50.4805L146.295 52.0132V52.1402L143.672 50.6075V50.4805Z",
    fill: "#4E5EA6"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M143.532 50.3989V50.5259L142.28 49.7945V49.6675L143.532 50.3989Z",
    fill: "#4E5EA6"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M144.287 51.3325V51.4595L142.28 50.2867V50.1597L144.287 51.3325Z",
    fill: "#4E5EA6"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M143.401 51.0604V51.1874L142.28 50.5322V50.4062L143.401 51.0604Z",
    fill: "#4E5EA6"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 44.3292L140.603 43.9778V44.1048L141.205 44.4562V44.3292Z",
    fill: "#258BE0"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 44.5685L140.603 44.217V44.3441L141.205 44.6955V44.5685Z",
    fill: "#258BE0"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 44.8077L140.603 44.4563V44.5833L141.205 44.9348V44.8077Z",
    fill: "#258BE0"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 45.047L140.603 44.6956V44.8226L141.205 45.174V45.047Z",
    fill: "#258BE0"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 45.286L140.603 44.9346V45.0616L141.205 45.413V45.286Z",
    fill: "#258BE0"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 45.5253L140.603 45.1738V45.3009L141.205 45.6523V45.5253Z",
    fill: "#258BE0"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 45.7645L140.603 45.4131V45.5391L141.205 45.8915V45.7645Z",
    fill: "#258BE0"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 46.0038L140.603 45.6523V45.7783L141.205 46.1297V46.0038Z",
    fill: "#258BE0"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 46.243L140.603 45.8916V46.0176L141.205 46.369V46.243Z",
    fill: "#ED5D68"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 46.4821L140.603 46.1296V46.2567L141.205 46.6081V46.4821Z",
    fill: "#258BE0"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 46.7214L140.603 46.3689V46.4959L141.205 46.8473V46.7214Z",
    fill: "#258BE0"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 46.9596L140.603 46.6082V46.7352L141.205 47.0866V46.9596Z",
    fill: "#258BE0"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 47.1988L140.603 46.8474V46.9744L141.205 47.3259V47.1988Z",
    fill: "#ED5D68"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 47.4381L140.603 47.0867V47.2137L141.205 47.5651V47.4381Z",
    fill: "#258BE0"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 47.6774L140.603 47.3259V47.453L141.205 47.8044V47.6774Z",
    fill: "#258BE0"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 47.9166L140.603 47.5652V47.6922L141.205 48.0436V47.9166Z",
    fill: "#258BE0"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 48.1559L140.603 47.8044V47.9315L141.205 48.2829V48.1559Z",
    fill: "#258BE0"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 48.3949L140.603 48.0435V48.1705L141.205 48.5219V48.3949Z",
    fill: "#258BE0"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 48.6341L140.603 48.2827V48.4097L141.205 48.7612V48.6341Z",
    fill: "#258BE0"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 48.8734L140.603 48.522V48.649L141.205 49.0004V48.8734Z",
    fill: "#258BE0"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 44.7442L141.316 44.3928V44.5198L141.917 44.8713V44.7442Z",
    fill: "#258BE0"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 44.9835L141.316 44.6321V44.7591L141.917 45.1105V44.9835Z",
    fill: "#258BE0"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 45.2228L141.316 44.8713V44.9984L141.917 45.3498V45.2228Z",
    fill: "#258BE0"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 45.462L141.316 45.1106V45.2376L141.917 45.589V45.462Z",
    fill: "#258BE0"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 45.9403L141.316 45.5889V45.7148L141.917 46.0673V45.9403Z",
    fill: "#258BE0"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 46.1796L141.316 45.8281V45.9541L141.917 46.3055V46.1796Z",
    fill: "#258BE0"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 46.4188L141.316 46.0674V46.1933L141.917 46.5448V46.4188Z",
    fill: "#258BE0"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 46.6581L141.316 46.3057V46.4327L141.917 46.7841V46.6581Z",
    fill: "#258BE0"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 46.8963L141.316 46.5449V46.6719L141.917 47.0234V46.8963Z",
    fill: "#258BE0"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 47.1354L141.316 46.7839V46.911L141.917 47.2624V47.1354Z",
    fill: "#ED5D68"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 47.8531L141.316 47.5017V47.6287L141.917 47.9802V47.8531Z",
    fill: "#258BE0"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 48.0924L141.316 47.741V47.868L141.917 48.2194V48.0924Z",
    fill: "#258BE0"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 48.3317L141.316 47.9802V48.1072L141.917 48.4587V48.3317Z",
    fill: "#258BE0"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 48.5709L141.316 48.2195V48.3465L141.917 48.6979V48.5709Z",
    fill: "#ED5D68"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 49.0492L141.316 48.6978V48.8248L141.917 49.1762V49.0492Z",
    fill: "#258BE0"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 49.2884L141.316 48.937V49.064L141.917 49.4155V49.2884Z",
    fill: "#258BE0"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 53.5915V53.7185L142.28 51.3739V51.2468L146.295 53.5915Z",
    fill: "#4E5EA6"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 54.0836V54.2107L142.28 51.865V51.739L146.295 54.0836Z",
    fill: "#4E5EA6"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 55.0681V55.1941L142.28 52.8494V52.7224L146.295 55.0681Z",
    fill: "#4E5EA6"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 56.5436V56.6706L142.28 54.3249V54.199L146.295 56.5436Z",
    fill: "#4E5EA6"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M144.528 52.3137L146.295 53.3458V53.4728L144.528 52.4407V52.3137Z",
    fill: "#4E5EA6"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M144.388 52.2323V52.3593L142.28 51.1272V51.0012L144.388 52.2323Z",
    fill: "#4E5EA6"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M143.672 52.3054L146.295 53.8382V53.9641L143.672 52.4324V52.3054Z",
    fill: "#4E5EA6"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M143.532 52.2239V52.3509L142.28 51.6195V51.4924L143.532 52.2239Z",
    fill: "#4E5EA6"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M144.287 53.1575V53.2845L142.28 52.1116V51.9846L144.287 53.1575Z",
    fill: "#4E5EA6"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M143.539 52.9658L146.295 54.5758V54.7029L143.539 53.0928V52.9658Z",
    fill: "#4E5EA6"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M143.401 52.8855V53.0114L142.28 52.3572V52.2302L143.401 52.8855Z",
    fill: "#4E5EA6"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M144.667 53.8708L146.295 54.8214V54.9484L144.667 53.9979V53.8708Z",
    fill: "#4E5EA6"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M144.528 53.7894V53.9164L142.28 52.6038V52.4768L144.528 53.7894Z",
    fill: "#4E5EA6"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M144.218 54.3462V54.4732L142.28 53.3416V53.2146L144.218 54.3462Z",
    fill: "#4E5EA6"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M145.062 55.0861V55.2121L142.28 53.5872V53.4602L145.062 55.0861Z",
    fill: "#4E5EA6"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M143.343 54.3271L146.295 56.0515V56.1785L143.343 54.4542V54.3271Z",
    fill: "#4E5EA6"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M143.204 54.2466V54.3726L142.28 53.8338V53.7068L143.204 54.2466Z",
    fill: "#4E5EA6"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M144.806 55.4248L146.287 56.2907V56.4166L144.806 55.5518V55.4248Z",
    fill: "#4E5EA6"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M144.667 55.3434V55.4704L142.273 54.0721V53.9451L144.667 55.3434Z",
    fill: "#4E5EA6"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M143.969 55.4312L146.295 56.7892V56.9163L143.969 55.5582V55.4312Z",
    fill: "#4E5EA6"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M143.83 55.3496V55.4766L142.28 54.5716V54.4446L143.83 55.3496Z",
    fill: "#4E5EA6"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M145.131 56.3563V56.4823L142.28 54.8172V54.6902L145.131 56.3563Z",
    fill: "#4E5EA6"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 50.3756L140.603 50.0242V50.1501L141.205 50.5026V50.3756Z",
    fill: "#258BE0"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 50.6149L140.603 50.2634V50.3894L141.205 50.7408V50.6149Z",
    fill: "#258BE0"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 50.8541L140.603 50.5027V50.6286L141.205 50.9801V50.8541Z",
    fill: "#258BE0"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 51.0932L140.603 50.7407V50.8677L141.205 51.2192V51.0932Z",
    fill: "#258BE0"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 51.3314L140.603 50.98V51.107L141.205 51.4584V51.3314Z",
    fill: "#258BE0"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 51.5707L140.603 51.2192V51.3463L141.205 51.6977V51.5707Z",
    fill: "#258BE0"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 51.8099L140.603 51.4585V51.5855L141.205 51.937V51.8099Z",
    fill: "#258BE0"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 52.0492L140.603 51.6978V51.8248L141.205 52.1762V52.0492Z",
    fill: "#258BE0"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 52.2884L140.603 51.937V52.064L141.205 52.4155V52.2884Z",
    fill: "#ED5D68"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 52.5277L140.603 52.1763V52.3033L141.205 52.6547V52.5277Z",
    fill: "#258BE0"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 52.7667L140.603 52.4153V52.5423L141.205 52.8937V52.7667Z",
    fill: "#258BE0"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 53.006L140.603 52.6545V52.7816L141.205 53.133V53.006Z",
    fill: "#258BE0"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 53.2452L140.603 52.8938V53.0208L141.205 53.3723V53.2452Z",
    fill: "#ED5D68"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 50.7906L141.316 50.4392V50.5652L141.917 50.9166V50.7906Z",
    fill: "#258BE0"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 51.03L141.316 50.6775V50.8045L141.917 51.1559V51.03Z",
    fill: "#258BE0"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 51.2682L141.316 50.9167V51.0438L141.917 51.3952V51.2682Z",
    fill: "#258BE0"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 51.5074L141.316 51.156V51.283L141.917 51.6345V51.5074Z",
    fill: "#258BE0"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 51.9857L141.316 51.6343V51.7613L141.917 52.1127V51.9857Z",
    fill: "#258BE0"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 52.225L141.316 51.8735V52.0006L141.917 52.352V52.225Z",
    fill: "#258BE0"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 52.4642L141.316 52.1128V52.2398L141.917 52.5912V52.4642Z",
    fill: "#258BE0"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 52.7035L141.316 52.3521V52.4791L141.917 52.8305V52.7035Z",
    fill: "#258BE0"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 52.9427L141.316 52.5913V52.7183L141.917 53.0698V52.9427Z",
    fill: "#258BE0"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 53.182L141.316 52.8306V52.9576L141.917 53.309V53.182Z",
    fill: "#ED5D68"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M134.98 25.7766L148.957 33.9103V46.0283L134.98 37.8946V25.7766Z",
    fill: "#C9DAFC"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M134.98 26.8658L148.957 34.9985V33.9103L134.98 25.7766V26.8658Z",
    fill: "#4E5EA6"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M135.422 27.6301L140.153 30.3833V34.4851L135.422 31.7319V27.6301Z",
    fill: "#ED5D68"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M135.422 34.1887L140.153 36.9419V40.3938L135.422 37.6406V34.1887Z",
    fill: "#939DE2"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M135.422 31.9722L137.686 33.289V35.2515L135.422 33.9347V31.9722Z",
    fill: "#ED5D68"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M137.889 33.4075L140.153 34.7243V36.6868L137.889 35.37V33.4075Z",
    fill: "#ED5D68"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M135.521 26.3565C135.657 26.4349 135.766 26.6265 135.766 26.7831C135.766 26.9398 135.655 27.0033 135.52 26.925C135.385 26.8456 135.276 26.655 135.276 26.4984C135.276 26.3417 135.386 26.2782 135.521 26.3565Z",
    fill: "white"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M136.21 26.7567C136.346 26.835 136.455 27.0266 136.455 27.1833C136.455 27.3399 136.345 27.4035 136.209 27.3251C136.074 27.2457 135.965 27.0552 135.965 26.8985C135.965 26.7419 136.075 26.6784 136.21 26.7567Z",
    fill: "white"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M136.901 27.1581C137.036 27.2364 137.145 27.428 137.145 27.5846C137.145 27.7413 137.035 27.8048 136.9 27.7265C136.764 27.6471 136.655 27.4566 136.655 27.2999C136.655 27.1432 136.765 27.0797 136.901 27.1581Z",
    fill: "white"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 34.2321V34.3591L142.28 32.0145V31.8875L146.295 34.2321Z",
    fill: "#4E5EA6"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 34.7243V34.8513L142.28 32.5067V32.3796L146.295 34.7243Z",
    fill: "#4E5EA6"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 35.7087V35.8358L142.28 33.4901V33.363L146.295 35.7087Z",
    fill: "#4E5EA6"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 37.1842V37.3113L142.28 34.9666V34.8396L146.295 37.1842Z",
    fill: "#4E5EA6"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M144.528 32.9543L146.295 33.9864V34.1134L144.528 33.0814V32.9543Z",
    fill: "#4E5EA6"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M144.388 32.8729V32.9999L142.28 31.7678V31.6418L144.388 32.8729Z",
    fill: "#4E5EA6"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M143.672 32.946L146.295 34.4788V34.6058L143.672 33.0731V32.946Z",
    fill: "#4E5EA6"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M143.532 32.8645V32.9915L142.28 32.2601V32.1331L143.532 32.8645Z",
    fill: "#4E5EA6"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M144.287 33.7981V33.9251L142.28 32.7523V32.6252L144.287 33.7981Z",
    fill: "#4E5EA6"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M143.539 33.6074L146.295 35.2164V35.3434L143.539 33.7334V33.6074Z",
    fill: "#4E5EA6"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M143.401 33.526V33.653L142.28 32.9978V32.8718L143.401 33.526Z",
    fill: "#4E5EA6"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M144.667 34.5115L146.295 35.462V35.5891L144.667 34.6385V34.5115Z",
    fill: "#4E5EA6"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M144.528 34.43V34.557L142.28 33.2445V33.1174L144.528 34.43Z",
    fill: "#4E5EA6"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M144.218 34.9868V35.1138L142.28 33.9822V33.8552L144.218 34.9868Z",
    fill: "#4E5EA6"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M145.062 35.7266V35.8537L142.28 34.2278V34.1018L145.062 35.7266Z",
    fill: "#4E5EA6"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M143.343 34.9688L146.295 36.692V36.819L143.343 35.0947V34.9688Z",
    fill: "#4E5EA6"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M143.204 34.8873V35.0143L142.28 34.4744V34.3474L143.204 34.8873Z",
    fill: "#4E5EA6"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M144.806 36.0654L146.287 36.9313V37.0583L144.806 36.1925V36.0654Z",
    fill: "#4E5EA6"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M144.667 35.9851V36.111L142.273 34.7127V34.5857L144.667 35.9851Z",
    fill: "#4E5EA6"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M143.969 36.0718L146.295 37.4299V37.5569L143.969 36.1988V36.0718Z",
    fill: "#4E5EA6"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M143.83 35.9902V36.1173L142.28 35.2122V35.0852L143.83 35.9902Z",
    fill: "#4E5EA6"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M145.131 36.9969V37.124L142.28 35.4578V35.3308L145.131 36.9969Z",
    fill: "#4E5EA6"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 38.4535V38.5805L142.28 36.2359V36.1089L146.295 38.4535Z",
    fill: "#4E5EA6"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 38.9457V39.0727L142.28 36.727V36.6011L146.295 38.9457Z",
    fill: "#4E5EA6"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M144.388 37.0944V37.2214L142.28 35.9893V35.8623L144.388 37.0944Z",
    fill: "#4E5EA6"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M143.672 37.1675L146.295 38.7002V38.8262L143.672 37.2945V37.1675Z",
    fill: "#4E5EA6"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M143.532 37.0859V37.213L142.28 36.4815V36.3545L143.532 37.0859Z",
    fill: "#4E5EA6"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M144.287 38.0195V38.1465L142.28 36.9737V36.8467L144.287 38.0195Z",
    fill: "#4E5EA6"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M143.401 37.7475V37.8735L142.28 37.2193V37.0923L143.401 37.7475Z",
    fill: "#4E5EA6"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 31.0162L140.603 30.6648V30.7918L141.205 31.1432V31.0162Z",
    fill: "#258BE0"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 31.2555L140.603 30.9041V31.0311L141.205 31.3825V31.2555Z",
    fill: "#258BE0"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 31.4947L140.603 31.1433V31.2693L141.205 31.6218V31.4947Z",
    fill: "#258BE0"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 31.734L140.603 31.3826V31.5085L141.205 31.86V31.734Z",
    fill: "#258BE0"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 31.9733L140.603 31.6218V31.7478L141.205 32.0992V31.9733Z",
    fill: "#258BE0"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 32.2124L140.603 31.8599V31.9869L141.205 32.3383V32.2124Z",
    fill: "#258BE0"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 32.4516L140.603 32.0991V32.2261L141.205 32.5776V32.4516Z",
    fill: "#258BE0"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 32.6898L140.603 32.3384V32.4654L141.205 32.8168V32.6898Z",
    fill: "#258BE0"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 32.9291L140.603 32.5776V32.7047L141.205 33.0561V32.9291Z",
    fill: "#ED5D68"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 33.1683L140.603 32.8169V32.9439L141.205 33.2953V33.1683Z",
    fill: "#258BE0"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 33.4076L140.603 33.0562V33.1832L141.205 33.5346V33.4076Z",
    fill: "#258BE0"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 33.6468L140.603 33.2954V33.4224L141.205 33.7739V33.6468Z",
    fill: "#258BE0"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 33.8858L140.603 33.5344V33.6614L141.205 34.0129V33.8858Z",
    fill: "#ED5D68"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 34.1251L140.603 33.7737V33.9007L141.205 34.2521V34.1251Z",
    fill: "#258BE0"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 34.3644L140.603 34.0129V34.14L141.205 34.4914V34.3644Z",
    fill: "#258BE0"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 34.6036L140.603 34.2522V34.3792L141.205 34.7306V34.6036Z",
    fill: "#258BE0"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 34.8429L140.603 34.4915V34.6185L141.205 34.9699V34.8429Z",
    fill: "#258BE0"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 35.0821L140.603 34.7307V34.8577L141.205 35.2092V35.0821Z",
    fill: "#258BE0"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 35.3214L140.603 34.97V35.0959L141.205 35.4484V35.3214Z",
    fill: "#258BE0"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 35.5604L140.603 35.209V35.3349L141.205 35.6864V35.5604Z",
    fill: "#258BE0"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 31.4313L141.316 31.0798V31.2069L141.917 31.5583V31.4313Z",
    fill: "#258BE0"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 31.6705L141.316 31.3191V31.4451L141.917 31.7975V31.6705Z",
    fill: "#258BE0"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 31.9098L141.316 31.5583V31.6843L141.917 32.0358V31.9098Z",
    fill: "#258BE0"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 32.149L141.316 31.7976V31.9236L141.917 32.275V32.149Z",
    fill: "#258BE0"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 32.6263L141.316 32.2749V32.4019L141.917 32.7533V32.6263Z",
    fill: "#258BE0"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 32.8656L141.316 32.5142V32.6412L141.917 32.9926V32.8656Z",
    fill: "#258BE0"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 33.1049L141.316 32.7534V32.8804L141.917 33.2319V33.1049Z",
    fill: "#258BE0"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 33.3441L141.316 32.9927V33.1197L141.917 33.4711V33.3441Z",
    fill: "#258BE0"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 33.5831L141.316 33.2317V33.3587L141.917 33.7101V33.5831Z",
    fill: "#258BE0"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 33.8224L141.316 33.4709V33.598L141.917 33.9494V33.8224Z",
    fill: "#ED5D68"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 34.5402L141.316 34.1887V34.3157L141.917 34.6672V34.5402Z",
    fill: "#258BE0"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 34.7794L141.316 34.428V34.555L141.917 34.9064V34.7794Z",
    fill: "#258BE0"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 35.0187L141.316 34.6672V34.7943L141.917 35.1457V35.0187Z",
    fill: "#258BE0"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 35.2579L141.316 34.9065V35.0335L141.917 35.3849V35.2579Z",
    fill: "#ED5D68"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 35.7362L141.316 35.3848V35.5107L141.917 35.8622V35.7362Z",
    fill: "#258BE0"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 35.9755L141.316 35.624V35.75L141.917 36.1014V35.9755Z",
    fill: "#258BE0"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 40.2785V40.4055L142.28 38.0598V37.9338L146.295 40.2785Z",
    fill: "#4E5EA6"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 40.7707V40.8978L142.28 38.5521V38.425L146.295 40.7707Z",
    fill: "#4E5EA6"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 41.7541V41.8811L142.28 39.5364V39.4094L146.295 41.7541Z",
    fill: "#4E5EA6"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M146.295 43.2307V43.3567L142.28 41.012V40.885L146.295 43.2307Z",
    fill: "#4E5EA6"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M144.528 39.001L146.295 40.033V40.159L144.528 39.1269V39.001Z",
    fill: "#4E5EA6"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M144.388 38.9194V39.0464L142.28 37.8143V37.6873L144.388 38.9194Z",
    fill: "#4E5EA6"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M143.672 38.9924L146.295 40.5241V40.6511L143.672 39.1184V38.9924Z",
    fill: "#4E5EA6"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M143.532 38.9109V39.0379L142.28 38.3065V38.1794L143.532 38.9109Z",
    fill: "#4E5EA6"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M144.287 39.8434V39.9704L142.28 38.7987V38.6716L144.287 39.8434Z",
    fill: "#4E5EA6"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M143.539 39.6528L146.295 41.2628V41.3888L143.539 39.7799V39.6528Z",
    fill: "#4E5EA6"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M143.401 39.5714V39.6984L142.28 39.0443V38.9172L143.401 39.5714Z",
    fill: "#4E5EA6"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M144.667 40.5579L146.295 41.5084V41.6354L144.667 40.6849V40.5579Z",
    fill: "#4E5EA6"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M144.528 40.4764V40.6034L142.28 39.2898V39.1638L144.528 40.4764Z",
    fill: "#4E5EA6"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M144.218 41.0332V41.1602L142.28 40.0286V39.9016L144.218 41.0332Z",
    fill: "#4E5EA6"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M145.062 41.772V41.8991L142.28 40.2742V40.1472L145.062 41.772Z",
    fill: "#4E5EA6"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M143.343 41.0142L146.295 42.7385V42.8655L143.343 41.1412V41.0142Z",
    fill: "#4E5EA6"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M143.204 40.9327V41.0597L142.28 40.5198V40.3928L143.204 40.9327Z",
    fill: "#4E5EA6"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M144.806 42.1118L146.287 42.9766V43.1037L144.806 42.2388V42.1118Z",
    fill: "#4E5EA6"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M144.667 42.0304V42.1574L142.273 40.7591V40.6321L144.667 42.0304Z",
    fill: "#4E5EA6"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M143.969 42.1182L146.295 43.4762V43.6033L143.969 42.2441V42.1182Z",
    fill: "#4E5EA6"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M143.83 42.0366V42.1637L142.28 41.2576V41.1316L143.83 42.0366Z",
    fill: "#4E5EA6"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M145.131 43.0422V43.1693L142.28 41.5042V41.3772L145.131 43.0422Z",
    fill: "#4E5EA6"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 37.0616L140.603 36.7102V36.8372L141.205 37.1887V37.0616Z",
    fill: "#258BE0"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 37.3009L140.603 36.9495V37.0765L141.205 37.4279V37.3009Z",
    fill: "#258BE0"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 37.5402L140.603 37.1887V37.3157L141.205 37.6672V37.5402Z",
    fill: "#258BE0"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 37.7794L140.603 37.428V37.555L141.205 37.9064V37.7794Z",
    fill: "#258BE0"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 38.0184L140.603 37.667V37.794L141.205 38.1454V38.0184Z",
    fill: "#258BE0"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 38.2577L140.603 37.9062V38.0333L141.205 38.3847V38.2577Z",
    fill: "#258BE0"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 38.4969L140.603 38.1455V38.2725L141.205 38.624V38.4969Z",
    fill: "#258BE0"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 38.7362L140.603 38.3848V38.5118L141.205 38.8632V38.7362Z",
    fill: "#258BE0"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 38.9755L140.603 38.624V38.751L141.205 39.1025V38.9755Z",
    fill: "#ED5D68"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 39.2147L140.603 38.8633V38.9903L141.205 39.3417V39.2147Z",
    fill: "#258BE0"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 39.454L140.603 39.1025V39.2296L141.205 39.581V39.454Z",
    fill: "#258BE0"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 39.6932L140.603 39.3418V39.4678L141.205 39.8202V39.6932Z",
    fill: "#258BE0"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M141.205 39.9322L140.603 39.5808V39.7068L141.205 40.0582V39.9322Z",
    fill: "#ED5D68"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 37.4767L141.316 37.1252V37.2523L141.917 37.6037V37.4767Z",
    fill: "#258BE0"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 37.7159L141.316 37.3645V37.4915L141.917 37.843V37.7159Z",
    fill: "#258BE0"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 37.9552L141.316 37.6038V37.7308L141.917 38.0822V37.9552Z",
    fill: "#258BE0"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 38.1944L141.316 37.843V37.97L141.917 38.3215V38.1944Z",
    fill: "#258BE0"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 38.6727L141.316 38.3213V38.4483L141.917 38.7997V38.6727Z",
    fill: "#258BE0"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 38.912L141.316 38.5605V38.6876L141.917 39.039V38.912Z",
    fill: "#258BE0"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 39.1512L141.316 38.7998V38.9268L141.917 39.2783V39.1512Z",
    fill: "#258BE0"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 39.3905L141.316 39.0391V39.1661L141.917 39.5175V39.3905Z",
    fill: "#258BE0"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 39.6297L141.316 39.2783V39.4053L141.917 39.7568V39.6297Z",
    fill: "#258BE0"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M141.917 39.869L141.316 39.5176V39.6435L141.917 39.996V39.869Z",
    fill: "#ED5D68"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M114.084 17.1167V17.3369L107.117 13.2658V13.0457L114.084 17.1167Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M114.084 17.971V18.1912L107.117 14.1201V13.8999L114.084 17.971Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M114.084 19.6784V19.8986L107.117 15.8286V15.6084L114.084 19.6784Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M114.084 22.241V22.4612L107.117 18.3901V18.1699L114.084 22.241Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M111.018 14.8982L114.084 16.6892V16.9094L111.018 15.1184V14.8982Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M110.777 14.7574V14.9775L107.117 12.8393V12.6191L110.777 14.7574Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M109.531 14.8833L114.084 17.5434V17.7635L109.531 15.1035V14.8833Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M109.29 14.7426V14.9627L107.117 13.6936V13.4734L109.29 14.7426Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M110.601 16.3622V16.5824L107.117 14.5468V14.3267L110.601 16.3622Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M109.303 16.0308L114.084 18.8253V19.0444L109.303 16.2509V16.0308Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M109.061 15.8899V16.1101L107.117 14.9743V14.7542L109.061 15.8899Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M111.26 17.6016L114.084 19.2518V19.472L111.26 17.8217V17.6016Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M111.018 17.4597V17.6798L107.117 15.4008V15.1807L111.018 17.4597Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M110.48 18.4274V18.6475L107.117 16.6818V16.4617L110.48 18.4274Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M111.946 19.7101V19.9303L107.117 17.1093V16.8892L111.946 19.7101Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M108.962 18.3936L114.084 21.3871V21.6072L108.962 18.6137V18.3936Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M108.72 18.2527V18.4729L107.117 17.5361V17.3159L108.72 18.2527Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M111.501 20.2988L114.072 21.8009V22.021L111.501 20.519V20.2988Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M111.26 20.1579V20.3781L107.105 17.9509V17.7307L111.26 20.1579Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M110.048 20.3093L114.084 22.6677V22.8879L110.048 20.5295V20.3093Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M109.806 20.1686V20.3888L107.117 18.8169V18.5967L109.806 20.1686Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M112.065 21.915V22.1352L107.117 19.2443V19.0242L112.065 21.915Z",
    fill: "white"
  })))), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M1.36059 30.9305L9.50056 26.1904C9.72719 26.0581 9.98215 26.0729 10.1815 26.1862L10.1889 26.1904H10.191L11.1709 26.7652L10.2182 30.2044V36.7905C10.2182 37.614 9.7828 38.3751 9.07562 38.7879L2.17269 42.8082L1.79392 43.8413L0.805541 43.2634C0.437259 43.0527 0.172852 42.6579 0.172852 42.171V33.0084C0.172852 32.152 0.626121 31.3603 1.36164 30.9316L1.36059 30.9305Z",
    fill: "#258BE0"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12971 33.5695V42.7321C1.12971 43.6974 2.16636 44.3018 2.99525 43.8192L10.3504 39.5364C11.0576 39.1246 11.493 38.3635 11.493 37.5389V27.3559C11.493 26.8203 10.918 26.4848 10.4574 26.7526L2.31745 31.4927C1.58193 31.9214 1.12866 32.7131 1.12866 33.5695H1.12971Z",
    fill: "white"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23302 29.9387C8.74932 30.2203 8.35796 30.9052 8.35901 31.4662C8.35901 31.788 8.49016 31.9986 8.69266 32.0674L7.28669 37.232C7.25416 37.2468 7.22058 37.2637 7.18596 37.2828C6.96877 37.4087 6.77046 37.6173 6.61727 37.8586L3.95956 36.2666C4.05819 36.0443 4.1159 35.8114 4.11485 35.5955C4.11275 35.0345 3.71929 34.8079 3.23559 35.0895C2.75189 35.3711 2.36053 36.0559 2.36157 36.6169C2.36367 37.178 2.75714 37.4045 3.24083 37.1229C3.42025 37.0181 3.58603 36.8583 3.72558 36.6709L6.41057 38.2799C6.34657 38.4588 6.3109 38.6408 6.3109 38.8113C6.31195 39.3723 6.70646 39.5988 7.19016 39.3172C7.67385 39.0357 8.06522 38.3508 8.06417 37.7898C8.06417 37.4913 7.95085 37.2891 7.77248 37.2055L9.19105 31.9954C9.20679 31.987 9.22148 31.9806 9.23722 31.9711C9.72091 31.6895 10.1123 31.0047 10.1112 30.4436C10.1091 29.8826 9.71567 29.6561 9.23197 29.9377L9.23302 29.9387Z",
    fill: "#258BE0"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M13.709 23.7252L21.8489 18.9851C22.0756 18.8528 22.3305 18.8676 22.5299 18.9809L22.5372 18.9851H22.5393L23.5193 19.5599L22.5666 22.999V29.5852C22.5666 30.4087 22.1312 31.1698 21.424 31.5826L14.5211 35.6029L14.1423 36.636L13.1539 36.0581C12.7856 35.8474 12.5212 35.4526 12.5212 34.9657V25.8031C12.5212 24.9467 12.9745 24.155 13.71 23.7262L13.709 23.7252Z",
    fill: "#258BE0"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4781 26.3642V35.5267C13.4781 36.4921 14.5147 37.0965 15.3436 36.6138L22.6988 32.3311C23.406 31.9193 23.8414 31.1582 23.8414 30.3336V20.1506C23.8414 19.615 23.2664 19.2795 22.8058 19.5473L14.6658 24.2873C13.9303 24.716 13.4771 25.5078 13.4771 26.3642H13.4781Z",
    fill: "white"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3298 24.7213C19.0349 24.3106 19.741 24.2122 20.2803 24.5223C21.2341 25.0696 21.3495 26.7124 20.6234 28.3785L22.2078 29.2888C22.3117 29.3481 22.3117 29.5439 22.2088 29.725L21.8521 30.3484C21.8007 30.4395 21.7325 30.5093 21.6643 30.5485C21.5961 30.5877 21.5279 30.5972 21.4754 30.5675L19.8921 29.6572C19.4273 30.2944 18.888 30.793 18.3466 31.1084C17.6415 31.5192 16.9364 31.6176 16.3961 31.3074C15.3164 30.6872 15.3112 28.6643 16.3835 26.7907C16.9196 25.8539 17.6237 25.131 18.3288 24.7203L18.3298 24.7213ZM17.0539 30.16C17.4117 30.3654 17.8786 30.2997 18.3455 30.0288C18.8125 29.7567 19.2783 29.2783 19.633 28.658C20.3433 27.4174 20.3391 26.0794 19.6246 25.6687C19.2678 25.4633 18.7999 25.529 18.333 25.801C17.866 26.073 17.4002 26.5504 17.0455 27.1707C16.3352 28.4113 16.3394 29.7493 17.0539 30.16Z",
    fill: "#258BE0"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M136.838 50.039C136.801 49.9829 136.744 49.9141 136.669 49.8336C136.567 49.7278 136.505 49.6611 136.484 49.6336C136.463 49.606 136.453 49.5817 136.453 49.5605C136.453 49.5256 136.483 49.5266 136.545 49.5616C136.58 49.5817 136.626 49.6177 136.68 49.6674C136.736 49.7182 136.789 49.7701 136.838 49.8251L136.94 49.605C136.872 49.5309 136.807 49.4663 136.744 49.4123C136.682 49.3573 136.614 49.3096 136.543 49.2673C136.401 49.1847 136.291 49.153 136.212 49.1731C136.135 49.1932 136.096 49.2609 136.095 49.3774C136.095 49.4695 136.114 49.5573 136.154 49.641C136.193 49.7235 136.263 49.8177 136.361 49.9236C136.471 50.0368 136.536 50.1088 136.559 50.1395C136.581 50.1702 136.592 50.1967 136.592 50.2189C136.592 50.2613 136.551 50.2602 136.471 50.2126C136.417 50.1808 136.355 50.1353 136.286 50.076C136.217 50.0167 136.154 49.9553 136.096 49.8918V50.239C136.157 50.3015 136.217 50.3555 136.277 50.3999C136.335 50.4444 136.406 50.4899 136.486 50.5365C136.634 50.6222 136.748 50.654 136.827 50.6317C136.907 50.6095 136.946 50.5312 136.947 50.3957C136.947 50.3279 136.939 50.2665 136.921 50.2094C136.903 50.1522 136.876 50.0961 136.839 50.039H136.838Z",
    fill: "#4E5EA6"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M137.644 49.9077C137.473 49.8082 137.34 49.7881 137.247 49.8474C137.155 49.9067 137.107 50.0432 137.107 50.2549C137.107 50.4603 137.157 50.6476 137.255 50.817C137.355 50.9864 137.495 51.1229 137.675 51.2288C137.761 51.2796 137.837 51.3156 137.899 51.3389C137.962 51.3622 138.021 51.3727 138.08 51.3727V51.0615C138.016 51.0584 137.956 51.0488 137.902 51.0308C137.846 51.0128 137.786 50.9853 137.72 50.9472C137.648 50.9049 137.591 50.8519 137.549 50.7884C137.507 50.7239 137.486 50.6561 137.483 50.5841L138.151 50.9737V50.781C138.152 50.5958 138.108 50.4275 138.02 50.2772C137.931 50.1269 137.806 50.0041 137.643 49.9088L137.644 49.9077ZM137.493 50.3153C137.498 50.2496 137.516 50.2094 137.545 50.1946C137.574 50.1798 137.611 50.1851 137.655 50.2105C137.703 50.238 137.741 50.2782 137.77 50.3312C137.798 50.3841 137.813 50.4412 137.814 50.5026L137.493 50.3153Z",
    fill: "#4E5EA6"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M139.333 51.197C139.289 51.0732 139.226 50.962 139.145 50.8615C139.063 50.762 138.97 50.6804 138.863 50.618C138.691 50.5174 138.556 50.4963 138.461 50.5545C138.365 50.6127 138.317 50.744 138.316 50.9483C138.316 51.1483 138.364 51.3357 138.461 51.5093C138.557 51.6829 138.689 51.8184 138.852 51.9136C139.023 52.0131 139.157 52.0333 139.253 51.974C139.349 51.9147 139.397 51.7824 139.397 51.577C139.397 51.4458 139.376 51.3187 139.332 51.1949L139.333 51.197ZM138.981 51.5834C138.957 51.6257 138.916 51.63 138.859 51.5961C138.8 51.5622 138.758 51.5093 138.734 51.4384C138.71 51.3674 138.697 51.2775 138.697 51.1705C138.697 51.0626 138.71 50.9885 138.735 50.9493C138.76 50.9091 138.801 50.9059 138.859 50.9398C138.917 50.9737 138.958 51.0255 138.982 51.0943C139.007 51.1631 139.018 51.251 139.018 51.3579C139.018 51.4659 139.006 51.541 138.981 51.5834Z",
    fill: "#4E5EA6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.08
  }, _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M140.36 93.0774C141.073 93.4924 141.077 94.1666 140.369 94.5816L123.283 104.598C122.575 105.014 121.422 105.013 120.709 104.598L101.033 93.142C100.32 92.726 100.315 92.0528 101.024 91.6378L118.109 81.621C118.818 81.2061 119.971 81.2061 120.684 81.621L140.36 93.0774Z",
    fill: "#2B6AB1"
  })))), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M101.033 78.7652C100.674 78.5556 100.495 78.2815 100.495 78.0073L100.491 80.6685C100.491 80.9426 100.67 81.2168 101.03 81.4264L120.706 92.8828L120.709 90.2216L101.033 78.7652Z",
    fill: "#C2E6F8"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M140.893 79.5126C140.891 79.5316 140.89 79.5507 140.887 79.5697C140.884 79.5856 140.88 79.6004 140.876 79.6163C140.87 79.6343 140.866 79.6533 140.86 79.6713C140.855 79.6862 140.847 79.701 140.841 79.7169C140.833 79.7359 140.824 79.755 140.815 79.774C140.807 79.7878 140.799 79.8015 140.791 79.8153C140.778 79.8365 140.763 79.8587 140.748 79.8799C140.733 79.9 140.717 79.9201 140.699 79.9402C140.695 79.9455 140.692 79.9497 140.687 79.955C140.664 79.9804 140.637 80.0058 140.61 80.0312C140.592 80.0471 140.573 80.0619 140.555 80.0778C140.538 80.0916 140.522 80.1053 140.504 80.118C140.483 80.1329 140.461 80.1477 140.439 80.1625C140.416 80.1773 140.394 80.1932 140.37 80.207L123.284 90.2238C123.23 90.2555 123.172 90.2841 123.112 90.3116C123.095 90.319 123.077 90.3264 123.061 90.3339C123.014 90.354 122.966 90.372 122.918 90.3889C122.9 90.3953 122.883 90.4016 122.865 90.4069C122.835 90.4164 122.804 90.4249 122.771 90.4344C122.747 90.4408 122.724 90.4482 122.7 90.4535C122.666 90.4619 122.633 90.4683 122.599 90.4746C122.576 90.4799 122.553 90.4852 122.53 90.4884C122.462 90.5011 122.392 90.5106 122.323 90.518C122.302 90.5202 122.28 90.5212 122.259 90.5233C122.218 90.5265 122.177 90.5297 122.136 90.5318C122.11 90.5329 122.084 90.5339 122.058 90.5339C122.024 90.5339 121.991 90.5339 121.958 90.5339C121.931 90.5339 121.902 90.5329 121.875 90.5318C121.844 90.5307 121.813 90.5286 121.783 90.5265C121.754 90.5244 121.726 90.5223 121.699 90.5191C121.668 90.5159 121.638 90.5128 121.607 90.5085C121.58 90.5053 121.553 90.5011 121.526 90.4969C121.493 90.4916 121.462 90.4863 121.429 90.4799C121.404 90.4746 121.379 90.4704 121.354 90.4641C121.316 90.4556 121.278 90.4461 121.24 90.4365C121.219 90.4312 121.198 90.4259 121.178 90.4196C121.112 90.3995 121.046 90.3773 120.983 90.3529C120.952 90.3402 120.922 90.3275 120.892 90.3137C120.876 90.3063 120.86 90.3 120.845 90.2926C120.798 90.2703 120.754 90.2471 120.711 90.2227L120.708 92.8838C120.751 92.9092 120.795 92.9325 120.841 92.9537C120.856 92.9611 120.873 92.9675 120.889 92.9749C120.916 92.9865 120.943 92.9992 120.971 93.0109C120.974 93.0119 120.977 93.013 120.98 93.014C121.043 93.0384 121.109 93.0606 121.175 93.0807C121.18 93.0818 121.186 93.0839 121.191 93.086C121.206 93.0903 121.222 93.0934 121.237 93.0977C121.275 93.1072 121.312 93.1167 121.35 93.1252C121.361 93.1273 121.37 93.1305 121.381 93.1326C121.395 93.1358 121.411 93.1379 121.426 93.14C121.458 93.1464 121.49 93.1516 121.522 93.1569C121.535 93.1591 121.549 93.1622 121.561 93.1633C121.576 93.1654 121.59 93.1665 121.604 93.1686C121.635 93.1728 121.665 93.176 121.696 93.1792C121.71 93.1802 121.725 93.1823 121.739 93.1845C121.752 93.1855 121.766 93.1855 121.78 93.1866C121.81 93.1887 121.841 93.1898 121.872 93.1919C121.888 93.1919 121.902 93.194 121.918 93.194C121.931 93.194 121.942 93.194 121.955 93.194C121.988 93.194 122.022 93.194 122.054 93.194C122.071 93.194 122.088 93.194 122.105 93.194C122.114 93.194 122.124 93.1929 122.134 93.1919C122.175 93.1898 122.216 93.1866 122.257 93.1834C122.274 93.1823 122.29 93.1813 122.306 93.1802C122.311 93.1802 122.317 93.1792 122.321 93.1781C122.39 93.1707 122.459 93.1612 122.528 93.1485C122.531 93.1485 122.534 93.1485 122.538 93.1474C122.558 93.1442 122.577 93.1389 122.597 93.1347C122.63 93.1273 122.665 93.121 122.698 93.1125C122.722 93.1061 122.745 93.0998 122.769 93.0934C122.8 93.085 122.832 93.0765 122.863 93.067C122.87 93.0649 122.877 93.0638 122.883 93.0617C122.895 93.0585 122.904 93.0532 122.916 93.049C122.965 93.032 123.012 93.014 123.06 92.9939C123.076 92.9865 123.094 92.9791 123.111 92.9717C123.171 92.9442 123.229 92.9156 123.283 92.8838L140.369 82.867C140.376 82.8628 140.384 82.8586 140.391 82.8543C140.408 82.8437 140.422 82.8332 140.438 82.8226C140.46 82.8077 140.483 82.794 140.503 82.7792C140.521 82.7665 140.538 82.7527 140.555 82.7379C140.573 82.7231 140.593 82.7072 140.61 82.6913C140.613 82.6881 140.617 82.685 140.622 82.6818C140.645 82.6606 140.667 82.6373 140.687 82.6151C140.691 82.6109 140.694 82.6056 140.698 82.6003C140.71 82.5865 140.722 82.5728 140.734 82.559C140.738 82.5526 140.741 82.5463 140.747 82.5399C140.762 82.5188 140.776 82.4976 140.79 82.4754C140.795 82.4658 140.802 82.4574 140.807 82.4489C140.811 82.4436 140.812 82.4394 140.814 82.4351C140.824 82.4161 140.832 82.397 140.84 82.378C140.845 82.3663 140.851 82.3558 140.856 82.3441C140.857 82.3409 140.858 82.3367 140.859 82.3325C140.865 82.3145 140.869 82.2965 140.875 82.2774C140.878 82.2647 140.883 82.2531 140.885 82.2404C140.885 82.2372 140.885 82.234 140.886 82.2298C140.889 82.2107 140.891 82.1917 140.892 82.1726C140.893 82.1599 140.897 82.1472 140.897 82.1345C140.897 82.1292 140.897 82.1239 140.897 82.1187L140.9 79.4575C140.9 79.4755 140.897 79.4935 140.896 79.5115L140.893 79.5126Z",
    fill: "#39BAE9"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M140.36 78.7017C141.073 79.1166 141.077 79.7909 140.369 80.2059L123.283 90.2227C122.575 90.6387 121.421 90.6376 120.709 90.2227L101.033 78.7663C100.319 78.3503 100.315 77.677 101.023 77.2621L118.109 67.2453C118.817 66.8303 119.97 66.8303 120.684 67.2453L140.36 78.7017Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.08
  }, _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M111.236 104.71C111.236 107.112 106.471 109.06 100.594 109.06C94.7175 109.06 89.9529 107.112 89.9529 104.71C89.9529 102.307 94.7164 100.36 100.594 100.36C106.472 100.36 111.236 102.308 111.236 104.71Z",
    fill: "#2B6AB1"
  }))), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M131.848 74.7207L126.623 77.764L134.36 82.2532L139.57 79.2014L131.848 74.7207Z",
    fill: "#39BAE9"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M129.27 74.978L124.045 78.0213L131.782 82.5105L136.991 79.4588L129.27 74.978Z",
    fill: "#F9E268"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M108.166 79.2161C108.19 79.1907 108.219 79.1684 108.252 79.1494L115.084 75.1714C115.317 75.036 115.604 75.036 115.837 75.1714L126.141 81.1807H126.525V81.5861C126.525 81.6941 126.474 81.8031 126.368 81.8645L119.549 85.835C119.233 86.0181 118.845 86.0181 118.53 85.835L108.253 79.8417C108.122 79.7654 108.055 79.6321 108.055 79.4976V79.0837L108.168 79.2171L108.166 79.2161Z",
    fill: "#39BAE9"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M118.719 85.9197C118.654 85.8975 118.59 85.8689 118.529 85.834L108.252 79.8406C108.121 79.7644 108.054 79.631 108.054 79.4966V79.0827L108.167 79.2161C108.191 79.1907 108.22 79.1685 108.253 79.1494L108.73 78.8721L118.72 84.5775V85.9208L118.719 85.9197Z",
    fill: "#C9DAFC"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M110.648 81.2389V80.5339H111.125V81.5162L110.648 81.2389Z",
    fill: "#39BAE9"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M109.935 80.8229V80.1179H110.411V81.1002L109.935 80.8229Z",
    fill: "#39BAE9"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M123.842 80.0292C123.765 79.9668 123.745 79.8461 123.748 79.7508C123.755 79.5201 123.88 79.2957 124.042 79.1337C124.114 79.0617 124.205 79.0056 124.306 78.9866C124.361 78.976 124.417 78.976 124.466 79.0046L118.249 75.3749C118.249 75.3749 118.238 75.3696 118.233 75.3664C118.231 75.3664 118.23 75.3654 118.228 75.3643C118.169 75.3389 118.099 75.3442 118.039 75.3643C117.979 75.3844 117.92 75.4183 117.871 75.4585L117.867 75.4617C117.867 75.4617 117.862 75.4659 117.858 75.4691C117.677 75.6205 117.546 75.8597 117.529 76.0979C117.521 76.2122 117.543 76.354 117.65 76.4165L123.867 80.0461C123.867 80.0461 123.859 80.0408 123.855 80.0377L123.852 80.0356C123.852 80.0356 123.845 80.0313 123.843 80.0292H123.842Z",
    fill: "#3D304D"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M124.166 79.0352C123.932 79.1718 123.744 79.502 123.745 79.773C123.745 80.044 123.936 80.153 124.17 80.0175C124.404 79.881 124.592 79.5507 124.591 79.2798C124.591 79.0088 124.4 78.8998 124.166 79.0352Z",
    fill: "#4F465E"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M119.309 85.9357C119.211 85.9622 119.111 85.9749 119.012 85.9717V85.3218H119.309V85.9357Z",
    fill: "#C9DAFC"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M115.658 65.467L115.972 65.285C116.074 65.2214 116.207 65.2098 116.326 65.2786L126.6 71.2571C126.827 71.3895 126.968 71.635 126.968 71.8997V80.2779C126.968 80.37 126.917 80.4451 126.845 80.4832L126.529 80.6674L126.479 80.5351L126.57 80.4494L116.056 74.3311C115.903 74.2422 115.808 74.0771 115.808 73.8992V65.5792C115.808 65.5792 115.808 65.5697 115.808 65.5644L115.656 65.466L115.658 65.467Z",
    fill: "#C9DAFC"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M125.469 72.4332L125.471 72.0574L126.708 71.3354C126.792 71.4074 126.859 71.4974 126.903 71.598L125.469 72.4332Z",
    fill: "#39BAE9"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M124.375 73.369L126.966 71.8574C126.966 71.8722 126.967 71.8871 126.967 71.9008V80.2791C126.967 80.3711 126.916 80.4463 126.844 80.4844L126.528 80.6686L126.478 80.5363L126.569 80.4505L124.37 79.1708L124.374 73.3701L124.375 73.369Z",
    fill: "#39BAE9"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M108.252 78.7419L115.084 74.764C115.317 74.6285 115.604 74.6285 115.837 74.764L126.367 80.9045C126.578 81.0272 126.577 81.3332 126.367 81.456L119.548 85.4265C119.232 85.6096 118.844 85.6096 118.529 85.4265L108.252 79.4331C107.988 79.2796 107.988 78.8954 108.252 78.7419Z",
    fill: "#E3E8FE"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M116.008 65.4639L126.282 71.4424C126.509 71.5747 126.65 71.8203 126.65 72.0849V80.4631C126.65 80.642 126.458 80.7532 126.305 80.6643L115.739 74.5164C115.586 74.4274 115.491 74.2623 115.491 74.0845V65.7645C115.491 65.4977 115.778 65.3305 116.008 65.4639Z",
    fill: "#314467"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M115.712 73.7097L126.429 79.9455V72.304L115.712 66.0671V73.7097Z",
    fill: "#2B6AB1"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M120.751 68.4553C120.673 68.4098 120.611 68.4468 120.611 68.5358C120.611 68.6257 120.673 68.7348 120.75 68.7803C120.827 68.8258 120.89 68.7888 120.89 68.6998C120.89 68.6099 120.828 68.5008 120.751 68.4553Z",
    fill: "#3D304D"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M121.607 68.9526C121.53 68.9071 121.467 68.9442 121.467 69.0331C121.467 69.123 121.53 69.2321 121.606 69.2776C121.683 69.3231 121.746 69.2861 121.746 69.1971C121.746 69.1072 121.684 68.9981 121.607 68.9526Z",
    fill: "#3D304D"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M116.179 75.2331L116.41 75.0986L125.552 80.4304L125.217 80.6262C125.068 80.713 124.884 80.7141 124.736 80.6262L116.179 75.6321C116.027 75.5432 116.027 75.3209 116.179 75.232V75.2331Z",
    fill: "#39BAE9"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M111.393 77.6104L114.784 75.632C114.92 75.5537 115.087 75.5537 115.222 75.632L124.769 81.1871C124.902 81.2644 124.902 81.4592 124.769 81.5364L121.427 83.4852C121.263 83.5805 121.063 83.5805 120.899 83.4852L111.392 77.9385C111.267 77.8655 111.267 77.6834 111.392 77.6104H111.393Z",
    fill: "#C9DAFC"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M124.77 81.2729L115.223 75.7177C115.088 75.6394 114.921 75.6394 114.785 75.7177L111.394 77.6961C111.346 77.7247 111.316 77.7692 111.305 77.8178C111.288 77.7416 111.318 77.6559 111.394 77.6104L114.785 75.632C114.921 75.5537 115.088 75.5537 115.223 75.632L124.77 81.1871C124.851 81.2337 124.882 81.3237 124.865 81.4041C124.854 81.3512 124.822 81.3025 124.77 81.2718V81.2729Z",
    fill: "#39BAE9"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M123.289 81.5736C123.289 81.5736 123.297 81.5662 123.302 81.564L123.715 81.3227C123.749 81.3026 123.791 81.3026 123.825 81.3227L124.31 81.6043H124.366V81.6688C124.366 81.6847 124.358 81.7006 124.343 81.7091L123.931 81.9483C123.885 81.9747 123.829 81.9747 123.782 81.9483L123.302 81.6688C123.283 81.6572 123.274 81.6381 123.272 81.6191V81.5535L123.289 81.5725V81.5736Z",
    fill: "#39BAE9"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M123.302 81.5047L123.715 81.2634C123.749 81.2433 123.791 81.2433 123.826 81.2634L124.343 81.5651C124.373 81.583 124.373 81.6275 124.343 81.6455L123.932 81.8847C123.885 81.9112 123.829 81.9112 123.783 81.8847L123.302 81.6053C123.263 81.583 123.263 81.5269 123.302 81.5047Z",
    fill: "#ECF5FF"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M123.926 81.203C123.926 81.203 123.934 81.1956 123.939 81.1934L124.098 81.1003C124.132 81.0802 124.174 81.0802 124.208 81.1003L124.693 81.3829H124.749V81.4475C124.749 81.4634 124.741 81.4792 124.726 81.4877L124.568 81.5787C124.522 81.6052 124.466 81.6052 124.419 81.5787L123.939 81.2993C123.92 81.2877 123.91 81.2686 123.909 81.2495V81.1839L123.926 81.203Z",
    fill: "#39BAE9"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M123.939 81.1331L124.099 81.04C124.132 81.0199 124.174 81.0199 124.209 81.04L124.726 81.3417C124.756 81.3597 124.756 81.4041 124.726 81.4221L124.569 81.5132C124.522 81.5396 124.466 81.5396 124.42 81.5132L123.939 81.2337C123.9 81.2115 123.9 81.1554 123.939 81.1331Z",
    fill: "#ECF5FF"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M122.585 81.1607C122.585 81.1607 122.593 81.1533 122.598 81.1512L123.011 80.9099C123.045 80.8897 123.087 80.8897 123.122 80.9099L123.606 81.1925H123.662V81.2571C123.662 81.2729 123.655 81.2888 123.639 81.2973L123.228 81.5365C123.181 81.563 123.125 81.563 123.079 81.5365L122.598 81.2571C122.579 81.2454 122.57 81.2264 122.569 81.2073V81.1417L122.585 81.1607Z",
    fill: "#39BAE9"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M122.598 81.0919L123.011 80.8505C123.045 80.8304 123.087 80.8304 123.122 80.8505L123.639 81.1522C123.669 81.1702 123.669 81.2147 123.639 81.2327L123.228 81.4719C123.181 81.4983 123.125 81.4983 123.079 81.4719L122.598 81.1924C122.559 81.1702 122.559 81.1141 122.598 81.0919Z",
    fill: "#ECF5FF"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M123.222 80.7901C123.222 80.7901 123.229 80.7827 123.235 80.7806L123.394 80.6874C123.428 80.6673 123.47 80.6673 123.504 80.6874L123.989 80.9701H124.045V81.0346C124.045 81.0505 124.037 81.0664 124.022 81.0749L123.864 81.1659C123.818 81.1924 123.761 81.1924 123.715 81.1659L123.235 80.8864C123.216 80.8748 123.206 80.8557 123.205 80.8367V80.7711L123.222 80.7901Z",
    fill: "#39BAE9"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M123.235 80.7213L123.394 80.6281C123.428 80.608 123.47 80.608 123.504 80.6281L124.022 80.9298C124.052 80.9478 124.052 80.9923 124.022 81.0102L123.864 81.1013C123.818 81.1277 123.761 81.1277 123.715 81.1013L123.235 80.8218C123.196 80.7996 123.196 80.7435 123.235 80.7213Z",
    fill: "#ECF5FF"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M121.88 80.7511C121.88 80.7511 121.888 80.7437 121.893 80.7415L122.306 80.5002C122.34 80.4801 122.382 80.4801 122.416 80.5002L122.901 80.7828H122.957V80.8474C122.957 80.8633 122.949 80.8792 122.934 80.8876L122.522 81.1269C122.476 81.1533 122.42 81.1533 122.373 81.1269L121.893 80.8474C121.874 80.8358 121.865 80.8167 121.864 80.7976V80.732L121.88 80.7511Z",
    fill: "#39BAE9"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M121.893 80.6822L122.307 80.4409C122.34 80.4208 122.382 80.4208 122.417 80.4409L122.934 80.7425C122.964 80.7605 122.964 80.805 122.934 80.823L122.523 81.0622C122.477 81.0887 122.42 81.0887 122.374 81.0622L121.893 80.7828C121.854 80.7605 121.854 80.7044 121.893 80.6822Z",
    fill: "#ECF5FF"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M122.517 80.3807C122.517 80.3807 122.524 80.3733 122.53 80.3712L122.689 80.278C122.723 80.2579 122.765 80.2579 122.799 80.278L123.284 80.5596H123.34V80.6242C123.34 80.64 123.332 80.6559 123.317 80.6644L123.159 80.7554C123.113 80.7819 123.056 80.7819 123.01 80.7554L122.53 80.476C122.511 80.4643 122.501 80.4453 122.5 80.4262V80.3606L122.517 80.3796V80.3807Z",
    fill: "#39BAE9"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M122.53 80.3118L122.689 80.2187C122.723 80.1986 122.765 80.1986 122.799 80.2187L123.317 80.5204C123.347 80.5384 123.347 80.5828 123.317 80.6008L123.159 80.6919C123.113 80.7183 123.057 80.7183 123.01 80.6919L122.53 80.4124C122.491 80.3902 122.491 80.3341 122.53 80.3118Z",
    fill: "#ECF5FF"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M121.175 80.3392C121.175 80.3392 121.183 80.3318 121.188 80.3297L121.601 80.0883C121.635 80.0682 121.677 80.0682 121.711 80.0883L122.196 80.371H122.252V80.4355C122.252 80.4514 122.244 80.4673 122.229 80.4758L121.817 80.715C121.771 80.7414 121.715 80.7414 121.668 80.715L121.188 80.4355C121.169 80.4239 121.159 80.4048 121.158 80.3858V80.3201L121.175 80.3392Z",
    fill: "#39BAE9"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M121.188 80.2694L121.601 80.028C121.635 80.0079 121.677 80.0079 121.712 80.028L122.229 80.3297C122.259 80.3477 122.259 80.3922 122.229 80.4101L121.818 80.6494C121.771 80.6758 121.715 80.6758 121.669 80.6494L121.188 80.3699C121.149 80.3477 121.149 80.2916 121.188 80.2694Z",
    fill: "#ECF5FF"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M121.812 79.9688C121.812 79.9688 121.819 79.9614 121.825 79.9593L121.984 79.8662C122.018 79.846 122.06 79.846 122.094 79.8662L122.579 80.1488H122.635V80.2134C122.635 80.2292 122.627 80.2451 122.611 80.2536L122.454 80.3446C122.408 80.3711 122.351 80.3711 122.305 80.3446L121.825 80.0652C121.806 80.0535 121.796 80.0345 121.795 80.0154V79.9498L121.812 79.9688Z",
    fill: "#39BAE9"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M121.825 79.899L121.984 79.8059C122.018 79.7857 122.06 79.7857 122.094 79.8059L122.612 80.1075C122.642 80.1255 122.642 80.17 122.612 80.188L122.454 80.279C122.408 80.3055 122.351 80.3055 122.305 80.279L121.825 79.9996C121.786 79.9773 121.786 79.9212 121.825 79.899Z",
    fill: "#ECF5FF"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M120.471 79.9285C120.471 79.9285 120.478 79.9211 120.484 79.919L120.897 79.6777C120.931 79.6576 120.973 79.6576 121.007 79.6777L121.492 79.9603H121.548V80.0249C121.548 80.0407 121.54 80.0566 121.525 80.0651L121.113 80.3043C121.067 80.3308 121.01 80.3308 120.964 80.3043L120.484 80.0249C120.465 80.0132 120.455 79.9942 120.454 79.9751V79.9095L120.471 79.9285Z",
    fill: "#39BAE9"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M120.484 79.8587L120.897 79.6174C120.931 79.5973 120.973 79.5973 121.008 79.6174L121.525 79.9191C121.555 79.9371 121.555 79.9815 121.525 79.9995L121.113 80.2387C121.067 80.2652 121.011 80.2652 120.964 80.2387L120.484 79.9593C120.445 79.9371 120.445 79.881 120.484 79.8587Z",
    fill: "#ECF5FF"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M121.108 79.5579C121.108 79.5579 121.115 79.5505 121.121 79.5484L121.28 79.4553C121.314 79.4352 121.356 79.4352 121.39 79.4553L121.875 79.7379H121.931V79.8025C121.931 79.8183 121.923 79.8342 121.908 79.8427L121.75 79.9337C121.704 79.9602 121.647 79.9602 121.601 79.9337L121.121 79.6543C121.102 79.6426 121.092 79.6236 121.091 79.6045V79.5389L121.108 79.5579Z",
    fill: "#39BAE9"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M121.121 79.4881L121.28 79.395C121.314 79.3749 121.356 79.3749 121.391 79.395L121.908 79.6967C121.938 79.7147 121.938 79.7591 121.908 79.7771L121.75 79.8681C121.704 79.8946 121.648 79.8946 121.601 79.8681L121.121 79.5887C121.082 79.5665 121.082 79.5103 121.121 79.4881Z",
    fill: "#ECF5FF"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M119.766 79.5179C119.766 79.5179 119.773 79.5105 119.779 79.5084L120.192 79.267C120.226 79.2469 120.268 79.2469 120.302 79.267L120.787 79.5486H120.843V79.6132C120.843 79.629 120.835 79.6449 120.819 79.6534L120.408 79.8937C120.362 79.9201 120.305 79.9201 120.259 79.8937L119.779 79.6142C119.76 79.6026 119.75 79.5835 119.749 79.5645V79.4988L119.766 79.5179Z",
    fill: "#39BAE9"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M119.779 79.4481L120.192 79.2067C120.226 79.1866 120.268 79.1866 120.302 79.2067L120.82 79.5084C120.85 79.5264 120.85 79.5709 120.82 79.5889L120.408 79.8291C120.362 79.8556 120.306 79.8556 120.259 79.8291L119.779 79.5497C119.74 79.5275 119.74 79.4714 119.779 79.4491V79.4481Z",
    fill: "#ECF5FF"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M120.403 79.1473C120.403 79.1473 120.41 79.1399 120.415 79.1378L120.575 79.0446C120.608 79.0245 120.65 79.0245 120.685 79.0446L121.17 79.3262H121.225V79.3908C121.225 79.4066 121.218 79.4225 121.202 79.431L121.045 79.522C120.999 79.5485 120.942 79.5485 120.896 79.522L120.415 79.2426C120.396 79.2309 120.387 79.2119 120.386 79.1928V79.1272L120.403 79.1462V79.1473Z",
    fill: "#39BAE9"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M120.415 79.0775L120.575 78.9843C120.608 78.9642 120.65 78.9642 120.685 78.9843L121.202 79.286C121.233 79.304 121.233 79.3485 121.202 79.3665L121.045 79.4575C120.999 79.484 120.942 79.484 120.896 79.4575L120.415 79.178C120.377 79.1558 120.377 79.0997 120.415 79.0775Z",
    fill: "#ECF5FF"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M119.061 79.106C119.061 79.106 119.068 79.0986 119.074 79.0965L119.487 78.8552C119.521 78.8351 119.563 78.8351 119.597 78.8552L120.082 79.1378H120.137V79.2024C120.137 79.2182 120.13 79.2341 120.114 79.2426L119.703 79.4818C119.657 79.5083 119.6 79.5083 119.554 79.4818L119.074 79.2024C119.055 79.1907 119.045 79.1717 119.044 79.1526V79.087L119.061 79.106Z",
    fill: "#39BAE9"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M119.074 79.0372L119.487 78.7958C119.521 78.7757 119.563 78.7757 119.597 78.7958L120.115 79.0975C120.145 79.1155 120.145 79.16 120.115 79.178L119.703 79.4172C119.657 79.4437 119.601 79.4437 119.554 79.4172L119.074 79.1377C119.035 79.1155 119.035 79.0594 119.074 79.0372Z",
    fill: "#ECF5FF"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M119.698 78.7357C119.698 78.7357 119.705 78.7283 119.711 78.7261L119.87 78.633C119.904 78.6129 119.946 78.6129 119.98 78.633L120.465 78.9146H120.521V78.9791C120.521 78.995 120.513 79.0109 120.497 79.0194L120.34 79.1104C120.294 79.1369 120.237 79.1369 120.191 79.1104L119.711 78.8309C119.692 78.8193 119.682 78.8002 119.681 78.7812V78.7156L119.698 78.7346V78.7357Z",
    fill: "#39BAE9"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M119.711 78.6668L119.87 78.5737C119.904 78.5536 119.946 78.5536 119.98 78.5737L120.498 78.8754C120.528 78.8934 120.528 78.9378 120.498 78.9558L120.34 79.0468C120.294 79.0733 120.237 79.0733 120.191 79.0468L119.711 78.7674C119.672 78.7452 119.672 78.6891 119.711 78.6668Z",
    fill: "#ECF5FF"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M118.357 78.6954C118.357 78.6954 118.364 78.688 118.369 78.6859L118.783 78.4445C118.816 78.4244 118.858 78.4244 118.893 78.4445L119.378 78.7272H119.433V78.7917C119.433 78.8076 119.426 78.8235 119.41 78.832L118.999 79.0722C118.953 79.0987 118.896 79.0987 118.85 79.0722L118.369 78.7928C118.351 78.7811 118.341 78.7621 118.34 78.743V78.6774L118.357 78.6965V78.6954Z",
    fill: "#39BAE9"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M118.37 78.6256L118.783 78.3842C118.817 78.3641 118.859 78.3641 118.893 78.3842L119.411 78.6859C119.441 78.7039 119.441 78.7484 119.411 78.7664L118.999 79.0056C118.953 79.032 118.896 79.032 118.85 79.0056L118.37 78.7261C118.331 78.7039 118.331 78.6478 118.37 78.6256Z",
    fill: "#ECF5FF"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M118.994 78.3248C118.994 78.3248 119.001 78.3174 119.006 78.3153L119.166 78.2221C119.199 78.202 119.241 78.202 119.276 78.2221L119.761 78.5037H119.816V78.5683C119.816 78.5841 119.809 78.6 119.793 78.6085L119.636 78.6995C119.59 78.726 119.533 78.726 119.487 78.6995L119.006 78.4201C118.988 78.4084 118.978 78.3894 118.977 78.3703V78.3047L118.994 78.3237V78.3248Z",
    fill: "#39BAE9"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M119.007 78.255L119.166 78.1618C119.2 78.1417 119.242 78.1417 119.276 78.1618L119.794 78.4635C119.824 78.4815 119.824 78.5259 119.794 78.5439L119.636 78.635C119.59 78.6614 119.533 78.6614 119.487 78.635L119.007 78.3555C118.968 78.3333 118.968 78.2772 119.007 78.255Z",
    fill: "#ECF5FF"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M117.652 78.2838C117.652 78.2838 117.659 78.2764 117.664 78.2743L118.078 78.0329C118.111 78.0128 118.153 78.0128 118.188 78.0329L118.673 78.3155H118.728V78.3801C118.728 78.396 118.721 78.4119 118.705 78.4203L118.294 78.6596C118.248 78.686 118.191 78.686 118.145 78.6596L117.664 78.3801C117.646 78.3685 117.636 78.3494 117.635 78.3304V78.2647L117.652 78.2838Z",
    fill: "#39BAE9"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M117.665 78.2149L118.078 77.9736C118.112 77.9535 118.154 77.9535 118.188 77.9736L118.705 78.2753C118.736 78.2933 118.736 78.3377 118.705 78.3557L118.294 78.5949C118.248 78.6214 118.191 78.6214 118.145 78.5949L117.665 78.3155C117.626 78.2933 117.626 78.2372 117.665 78.2149Z",
    fill: "#ECF5FF"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M118.289 77.9132C118.289 77.9132 118.296 77.9058 118.301 77.9036L118.461 77.8105C118.494 77.7904 118.536 77.7904 118.571 77.8105L119.056 78.0921H119.111V78.1566C119.111 78.1725 119.104 78.1884 119.088 78.1969L118.931 78.2879C118.885 78.3144 118.828 78.3144 118.782 78.2879L118.301 78.0084C118.282 77.9968 118.273 77.9777 118.272 77.9587V77.8931L118.289 77.9121V77.9132Z",
    fill: "#39BAE9"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M118.301 77.8443L118.461 77.7512C118.494 77.7311 118.536 77.7311 118.571 77.7512L119.088 78.0528C119.119 78.0708 119.119 78.1153 119.088 78.1333L118.931 78.2243C118.885 78.2508 118.828 78.2508 118.782 78.2243L118.301 77.9449C118.263 77.9227 118.263 77.8665 118.301 77.8443Z",
    fill: "#ECF5FF"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M116.947 77.8729C116.947 77.8729 116.954 77.8655 116.959 77.8634L117.373 77.622C117.406 77.6019 117.448 77.6019 117.483 77.622L117.968 77.9036H118.023V77.9682C118.023 77.984 118.016 77.9999 118 78.0084L117.589 78.2487C117.543 78.2751 117.486 78.2751 117.44 78.2487L116.959 77.9692C116.94 77.9576 116.931 77.9385 116.93 77.9195V77.8538L116.947 77.8729Z",
    fill: "#39BAE9"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M116.959 77.804L117.373 77.5627C117.406 77.5426 117.448 77.5426 117.483 77.5627L118 77.8644C118.031 77.8824 118.031 77.9268 118 77.9448L117.589 78.1841C117.543 78.2105 117.486 78.2105 117.44 78.1841L116.959 77.9046C116.92 77.8824 116.92 77.8263 116.959 77.804Z",
    fill: "#ECF5FF"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M117.584 77.5023C117.584 77.5023 117.591 77.4949 117.596 77.4928L117.756 77.3996C117.789 77.3795 117.831 77.3795 117.866 77.3996L118.351 77.6812H118.406V77.7458C118.406 77.7616 118.399 77.7775 118.383 77.786L118.226 77.877C118.18 77.9035 118.123 77.9035 118.077 77.877L117.596 77.5976C117.577 77.5859 117.568 77.5669 117.567 77.5478V77.4822L117.584 77.5012V77.5023Z",
    fill: "#39BAE9"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M117.596 77.4325L117.756 77.3393C117.79 77.3192 117.832 77.3192 117.866 77.3393L118.383 77.641C118.414 77.659 118.414 77.7034 118.383 77.7214L118.226 77.8125C118.18 77.8389 118.123 77.8389 118.077 77.8125L117.596 77.533C117.558 77.5108 117.558 77.4547 117.596 77.4325Z",
    fill: "#ECF5FF"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M116.243 77.4622C116.243 77.4622 116.25 77.4548 116.255 77.4527L116.669 77.2114C116.702 77.1913 116.744 77.1913 116.779 77.2114L117.264 77.494H117.319V77.5586C117.319 77.5744 117.312 77.5903 117.296 77.5988L116.885 77.8391C116.839 77.8655 116.782 77.8655 116.736 77.8391L116.255 77.5596C116.236 77.548 116.227 77.5289 116.226 77.5099V77.4442L116.243 77.4633V77.4622Z",
    fill: "#39BAE9"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M116.255 77.3924L116.669 77.1511C116.702 77.131 116.744 77.131 116.779 77.1511L117.296 77.4528C117.326 77.4707 117.326 77.5152 117.296 77.5332L116.885 77.7724C116.839 77.7989 116.782 77.7989 116.736 77.7724L116.255 77.493C116.216 77.4707 116.216 77.4146 116.255 77.3924Z",
    fill: "#ECF5FF"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M116.88 77.0907C116.88 77.0907 116.887 77.0833 116.892 77.0811L117.052 76.988C117.085 76.9679 117.127 76.9679 117.162 76.988L117.647 77.2706H117.702V77.3352C117.702 77.3511 117.695 77.3669 117.679 77.3754L117.522 77.4664C117.476 77.4929 117.419 77.4929 117.373 77.4664L116.892 77.187C116.873 77.1753 116.864 77.1563 116.863 77.1372V77.0716L116.88 77.0907Z",
    fill: "#39BAE9"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M116.892 77.0218L117.052 76.9287C117.085 76.9085 117.127 76.9085 117.162 76.9287L117.679 77.2303C117.71 77.2483 117.71 77.2928 117.679 77.3108L117.522 77.4018C117.476 77.4283 117.419 77.4283 117.373 77.4018L116.892 77.1224C116.854 77.1001 116.854 77.044 116.892 77.0218Z",
    fill: "#ECF5FF"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M115.538 77.0504C115.538 77.0504 115.545 77.043 115.55 77.0408L115.964 76.7995C115.997 76.7794 116.039 76.7794 116.074 76.7995L116.558 77.0821H116.614V77.1467C116.614 77.1626 116.607 77.1785 116.591 77.1869L116.18 77.4261C116.134 77.4526 116.077 77.4526 116.031 77.4261L115.55 77.1467C115.531 77.1351 115.522 77.116 115.521 77.0969V77.0313L115.538 77.0504Z",
    fill: "#39BAE9"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M115.55 76.9805L115.964 76.7392C115.997 76.7191 116.039 76.7191 116.074 76.7392L116.591 77.0409C116.622 77.0589 116.622 77.1033 116.591 77.1213L116.18 77.3606C116.134 77.387 116.077 77.387 116.031 77.3606L115.55 77.0811C115.512 77.0589 115.512 77.0028 115.55 76.9805Z",
    fill: "#ECF5FF"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M116.174 76.6798C116.174 76.6798 116.182 76.6724 116.187 76.6702L116.347 76.5771C116.38 76.557 116.422 76.557 116.457 76.5771L116.941 76.8587H116.997V76.9232C116.997 76.9391 116.99 76.955 116.974 76.9635L116.817 77.0545C116.77 77.0809 116.714 77.0809 116.668 77.0545L116.187 76.775C116.168 76.7634 116.159 76.7443 116.158 76.7253V76.6597L116.174 76.6787V76.6798Z",
    fill: "#39BAE9"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M116.187 76.6099L116.347 76.5168C116.38 76.4967 116.422 76.4967 116.457 76.5168L116.974 76.8185C117.004 76.8365 117.004 76.8809 116.974 76.8989L116.817 76.99C116.77 77.0164 116.714 77.0164 116.668 76.99L116.187 76.7105C116.148 76.6883 116.148 76.6322 116.187 76.6099Z",
    fill: "#ECF5FF"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M114.832 76.6388C114.832 76.6388 114.84 76.6313 114.845 76.6292L115.258 76.3879C115.292 76.3678 115.334 76.3678 115.369 76.3879L115.853 76.6694H115.909V76.734C115.909 76.7499 115.902 76.7658 115.886 76.7742L115.475 77.0135C115.428 77.0399 115.372 77.0399 115.326 77.0135L114.845 76.734C114.826 76.7224 114.817 76.7033 114.816 76.6843V76.6186L114.832 76.6377V76.6388Z",
    fill: "#39BAE9"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M114.845 76.5699L115.259 76.3286C115.292 76.3084 115.334 76.3084 115.369 76.3286L115.886 76.6302C115.917 76.6482 115.917 76.6927 115.886 76.7107L115.475 76.9499C115.429 76.9764 115.372 76.9764 115.326 76.9499L114.845 76.6705C114.806 76.6482 114.806 76.5921 114.845 76.5699Z",
    fill: "#ECF5FF"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M115.469 76.2681C115.469 76.2681 115.477 76.2607 115.482 76.2586L115.642 76.1655C115.675 76.1454 115.717 76.1454 115.752 76.1655L116.236 76.4481H116.292V76.5127C116.292 76.5285 116.285 76.5444 116.269 76.5529L116.112 76.6439C116.065 76.6704 116.009 76.6704 115.963 76.6439L115.482 76.3645C115.463 76.3528 115.454 76.3338 115.453 76.3147V76.2491L115.469 76.2681Z",
    fill: "#39BAE9"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M115.482 76.1993L115.642 76.1061C115.675 76.086 115.717 76.086 115.752 76.1061L116.269 76.4078C116.3 76.4258 116.3 76.4703 116.269 76.4883L116.112 76.5793C116.066 76.6058 116.009 76.6058 115.963 76.5793L115.482 76.2999C115.443 76.2776 115.443 76.2215 115.482 76.1993Z",
    fill: "#ECF5FF"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M114.128 76.2279C114.128 76.2279 114.136 76.2205 114.141 76.2183L114.554 75.977C114.588 75.9569 114.63 75.9569 114.665 75.977L115.149 76.2586H115.205V76.3231C115.205 76.339 115.198 76.3549 115.182 76.3634L114.77 76.6026C114.724 76.629 114.668 76.629 114.621 76.6026L114.141 76.3231C114.122 76.3115 114.113 76.2924 114.112 76.2734V76.2078L114.128 76.2268V76.2279Z",
    fill: "#39BAE9"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M114.141 76.158L114.555 75.9167C114.588 75.8966 114.63 75.8966 114.665 75.9167L115.182 76.2184C115.212 76.2364 115.212 76.2808 115.182 76.2988L114.771 76.5381C114.725 76.5645 114.668 76.5645 114.622 76.5381L114.141 76.2586C114.102 76.2364 114.102 76.1803 114.141 76.158Z",
    fill: "#ECF5FF"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M120.741 83.0606C120.741 83.0606 120.748 83.0532 120.753 83.0511L121.167 82.8098C121.2 82.7896 121.242 82.7896 121.277 82.8098L121.762 83.0924H121.817V83.157C121.817 83.1728 121.81 83.1887 121.794 83.1972L121.383 83.4364C121.337 83.4629 121.28 83.4629 121.234 83.4364L120.753 83.157C120.734 83.1453 120.725 83.1263 120.724 83.1072V83.0416L120.741 83.0606Z",
    fill: "#39BAE9"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M120.753 82.9908L121.167 82.7495C121.2 82.7293 121.242 82.7293 121.277 82.7495L121.794 83.0511C121.824 83.0691 121.824 83.1136 121.794 83.1316L121.383 83.3708C121.337 83.3973 121.28 83.3973 121.234 83.3708L120.753 83.0914C120.714 83.0691 120.714 83.013 120.753 82.9908Z",
    fill: "#ECF5FF"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M121.065 82.504C121.065 82.504 121.072 82.4966 121.077 82.4945L121.491 82.2531C121.524 82.233 121.566 82.233 121.601 82.2531L122.402 82.7189H122.457V82.7835C122.457 82.7993 122.45 82.8152 122.434 82.8237L122.023 83.0629C121.977 83.0894 121.92 83.0894 121.874 83.0629L121.077 82.5993C121.059 82.5876 121.049 82.5686 121.048 82.5495V82.4839L121.065 82.5029V82.504Z",
    fill: "#39BAE9"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M121.078 82.4342L121.491 82.1928C121.525 82.1727 121.567 82.1727 121.601 82.1928L122.434 82.6776C122.465 82.6956 122.465 82.7401 122.434 82.7581L122.023 82.9984C121.977 83.0248 121.92 83.0248 121.874 82.9984L121.078 82.5347C121.039 82.5125 121.039 82.4564 121.078 82.4342Z",
    fill: "#ECF5FF"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M122.338 81.7608C122.338 81.7608 122.345 81.7534 122.35 81.7513L122.764 81.51C122.797 81.4898 122.839 81.4898 122.874 81.51L123.674 81.9757H123.73V82.0403C123.73 82.0562 123.723 82.072 123.707 82.0805L123.296 82.3197C123.249 82.3462 123.193 82.3462 123.147 82.3197L122.35 81.8561C122.331 81.8444 122.322 81.8254 122.321 81.8063V81.7407L122.338 81.7598V81.7608Z",
    fill: "#39BAE9"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M122.35 81.691L122.764 81.4497C122.797 81.4295 122.839 81.4295 122.874 81.4497L123.707 81.9345C123.738 81.9525 123.738 81.9969 123.707 82.0149L123.296 82.2541C123.25 82.2806 123.193 82.2806 123.147 82.2541L122.35 81.7905C122.312 81.7683 122.312 81.7122 122.35 81.6899V81.691Z",
    fill: "#ECF5FF"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M113.493 76.6016C113.493 76.6016 113.5 76.5942 113.505 76.5921L113.919 76.3508C113.952 76.3307 113.994 76.3307 114.029 76.3508L114.893 76.8525H114.949V76.9171C114.949 76.933 114.942 76.9488 114.926 76.9573L114.515 77.1965C114.468 77.223 114.412 77.223 114.366 77.1965L113.505 76.6969C113.486 76.6853 113.477 76.6662 113.476 76.6472V76.5815L113.493 76.6006V76.6016Z",
    fill: "#39BAE9"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M113.505 76.5318L113.919 76.2905C113.952 76.2704 113.994 76.2704 114.029 76.2905L114.926 76.8123C114.956 76.8303 114.956 76.8748 114.926 76.8928L114.515 77.132C114.469 77.1584 114.412 77.1584 114.366 77.132L113.505 76.6324C113.467 76.6101 113.467 76.554 113.505 76.5318Z",
    fill: "#ECF5FF"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M112.218 77.3436C112.218 77.3436 112.225 77.3362 112.23 77.3341L112.644 77.0927C112.677 77.0726 112.719 77.0726 112.754 77.0927L113.622 77.5976H113.677V77.6622C113.677 77.6781 113.67 77.694 113.654 77.7024L113.243 77.9417C113.197 77.9681 113.14 77.9681 113.094 77.9417L112.23 77.4389C112.211 77.4272 112.202 77.4082 112.201 77.3891V77.3235L112.218 77.3425V77.3436Z",
    fill: "#39BAE9"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M112.231 77.2738L112.644 77.0324C112.677 77.0123 112.719 77.0123 112.754 77.0324L113.654 77.5564C113.685 77.5744 113.685 77.6188 113.654 77.6368L113.243 77.8761C113.197 77.9025 113.14 77.9025 113.094 77.8761L112.231 77.3733C112.192 77.351 112.192 77.2949 112.231 77.2727V77.2738Z",
    fill: "#ECF5FF"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M121.421 81.9683C121.421 81.9683 121.428 81.9609 121.433 81.9588L121.847 81.7175C121.88 81.6974 121.922 81.6974 121.957 81.7175L123.038 82.3462H123.093V82.4108C123.093 82.4267 123.086 82.4426 123.07 82.451L122.659 82.6903C122.613 82.7167 122.556 82.7167 122.51 82.6903L121.432 82.0636C121.413 82.052 121.404 82.0329 121.403 82.0139V81.9482L121.42 81.9673L121.421 81.9683Z",
    fill: "#39BAE9"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M121.433 81.8985L121.847 81.6572C121.88 81.6371 121.922 81.6371 121.957 81.6572L123.071 82.306C123.101 82.324 123.101 82.3685 123.071 82.3865L122.66 82.6268C122.614 82.6532 122.557 82.6532 122.511 82.6268L121.433 82.0001C121.394 81.9779 121.394 81.9218 121.433 81.8996V81.8985Z",
    fill: "#ECF5FF"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M112.854 76.9742C112.854 76.9742 112.861 76.9668 112.866 76.9647L113.28 76.7233C113.313 76.7032 113.355 76.7032 113.39 76.7233L114.681 77.4738H114.737V77.5384C114.737 77.5543 114.73 77.5701 114.714 77.5786L114.303 77.8178C114.257 77.8443 114.2 77.8443 114.154 77.8178L112.866 77.0695C112.847 77.0578 112.838 77.0388 112.837 77.0197V76.9541L112.854 76.9731V76.9742Z",
    fill: "#39BAE9"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M112.867 76.9044L113.28 76.663C113.313 76.6429 113.355 76.6429 113.39 76.663L114.714 77.4326C114.745 77.4506 114.745 77.495 114.714 77.513L114.303 77.7533C114.257 77.7798 114.2 77.7798 114.154 77.7533L112.867 77.0049C112.828 76.9827 112.828 76.9266 112.867 76.9044Z",
    fill: "#ECF5FF"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M120.036 82.648C120.036 82.648 120.043 82.6406 120.048 82.6385L120.462 82.3972C120.495 82.3771 120.537 82.3771 120.572 82.3972L121.056 82.6798H121.112V82.7444C121.112 82.7602 121.105 82.7761 121.089 82.7846L120.678 83.0249C120.632 83.0513 120.575 83.0513 120.529 83.0249L120.048 82.7454C120.029 82.7338 120.02 82.7147 120.019 82.6957V82.63L120.036 82.6491V82.648Z",
    fill: "#39BAE9"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M120.048 82.5792L120.462 82.3378C120.495 82.3177 120.537 82.3177 120.572 82.3378L121.089 82.6395C121.12 82.6575 121.12 82.702 121.089 82.72L120.678 82.9592C120.632 82.9857 120.575 82.9857 120.529 82.9592L120.048 82.6797C120.01 82.6575 120.01 82.6014 120.048 82.5792Z",
    fill: "#ECF5FF"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M119.332 82.2381C119.332 82.2381 119.339 82.2307 119.344 82.2286L119.758 81.9873C119.791 81.9671 119.833 81.9671 119.868 81.9873L120.353 82.2688H120.408V82.3334C120.408 82.3493 120.401 82.3651 120.385 82.3736L119.974 82.6128C119.928 82.6393 119.871 82.6393 119.825 82.6128L119.344 82.3334C119.325 82.3217 119.316 82.3027 119.315 82.2836V82.218L119.332 82.2371V82.2381Z",
    fill: "#39BAE9"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M119.345 82.1683L119.758 81.9269C119.792 81.9068 119.833 81.9068 119.868 81.9269L120.385 82.2286C120.416 82.2466 120.416 82.2911 120.385 82.3091L119.974 82.5483C119.928 82.5748 119.871 82.5748 119.825 82.5483L119.345 82.2689C119.306 82.2466 119.306 82.1905 119.345 82.1683Z",
    fill: "#ECF5FF"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M115.106 79.7708C115.106 79.7708 115.114 79.7634 115.119 79.7613L115.532 79.52C115.566 79.4999 115.608 79.4999 115.643 79.52L119.647 81.8572H119.703V81.9217C119.703 81.9376 119.696 81.9535 119.68 81.962L119.269 82.2012C119.223 82.2276 119.166 82.2276 119.12 82.2012L115.119 79.8661C115.1 79.8545 115.091 79.8354 115.09 79.8164V79.7507L115.106 79.7698V79.7708Z",
    fill: "#39BAE9"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M115.119 79.702L115.533 79.4606C115.566 79.4405 115.608 79.4405 115.643 79.4606L119.681 81.8169C119.712 81.8349 119.712 81.8794 119.681 81.8974L119.27 82.1366C119.224 82.1631 119.167 82.1631 119.121 82.1366L115.12 79.8015C115.081 79.7793 115.081 79.7232 115.12 79.7009L115.119 79.702Z",
    fill: "#ECF5FF"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M114.398 79.3602C114.398 79.3602 114.405 79.3528 114.411 79.3507L114.824 79.1093C114.858 79.0892 114.9 79.0892 114.934 79.1093L115.419 79.3909H115.475V79.4555C115.475 79.4713 115.467 79.4872 115.452 79.4957L115.04 79.7349C114.994 79.7614 114.937 79.7614 114.891 79.7349L114.411 79.4555C114.392 79.4438 114.382 79.4248 114.381 79.4057V79.3401L114.398 79.3591V79.3602Z",
    fill: "#39BAE9"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M114.411 79.2904L114.824 79.049C114.858 79.0289 114.9 79.0289 114.935 79.049L115.452 79.3507C115.482 79.3687 115.482 79.4132 115.452 79.4311L115.04 79.6704C114.994 79.6968 114.938 79.6968 114.891 79.6704L114.411 79.3909C114.372 79.3687 114.372 79.3126 114.411 79.2904Z",
    fill: "#ECF5FF"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M113.693 78.9483C113.693 78.9483 113.7 78.9409 113.706 78.9388L114.119 78.6975C114.153 78.6773 114.195 78.6773 114.229 78.6975L114.714 78.9801H114.77V79.0447C114.77 79.0605 114.762 79.0764 114.746 79.0849L114.335 79.3241C114.289 79.3506 114.232 79.3506 114.186 79.3241L113.706 79.0447C113.687 79.033 113.677 79.014 113.676 78.9949V78.9293L113.693 78.9483Z",
    fill: "#39BAE9"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M113.706 78.8795L114.119 78.6381C114.153 78.618 114.195 78.618 114.229 78.6381L114.747 78.9398C114.777 78.9578 114.777 79.0023 114.747 79.0203L114.335 79.2595C114.289 79.286 114.233 79.286 114.186 79.2595L113.706 78.98C113.667 78.9578 113.667 78.9017 113.706 78.8795Z",
    fill: "#ECF5FF"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M112.989 78.5377C112.989 78.5377 112.996 78.5303 113.002 78.5282L113.415 78.2868C113.449 78.2667 113.49 78.2667 113.525 78.2868L114.01 78.5684H114.065V78.633C114.065 78.6488 114.058 78.6647 114.042 78.6732L113.631 78.9135C113.585 78.9399 113.528 78.9399 113.482 78.9135L113.002 78.634C112.983 78.6224 112.973 78.6033 112.972 78.5843V78.5186L112.989 78.5377Z",
    fill: "#39BAE9"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M113.002 78.4679L113.415 78.2265C113.449 78.2064 113.491 78.2064 113.525 78.2265L114.043 78.5282C114.073 78.5462 114.073 78.5906 114.043 78.6086L113.631 78.8479C113.585 78.8743 113.528 78.8743 113.482 78.8479L113.002 78.5684C112.963 78.5462 112.963 78.4901 113.002 78.4679Z",
    fill: "#ECF5FF"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M112.284 78.1258C112.284 78.1258 112.291 78.1184 112.296 78.1163L112.71 77.8749C112.743 77.8548 112.785 77.8548 112.82 77.8749L113.305 78.1576H113.36V78.2221C113.36 78.238 113.353 78.2539 113.337 78.2624L112.926 78.5016C112.88 78.5281 112.823 78.5281 112.777 78.5016L112.296 78.2221C112.278 78.2105 112.268 78.1914 112.267 78.1724V78.1068L112.284 78.1258Z",
    fill: "#39BAE9"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M112.297 78.057L112.71 77.8156C112.744 77.7955 112.786 77.7955 112.82 77.8156L113.338 78.1173C113.368 78.1353 113.368 78.1798 113.338 78.1977L112.926 78.437C112.88 78.4634 112.823 78.4634 112.777 78.437L112.297 78.1575C112.258 78.1353 112.258 78.0792 112.297 78.057Z",
    fill: "#ECF5FF"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M111.579 77.7152C111.579 77.7152 111.586 77.7078 111.591 77.7056L112.005 77.4643C112.038 77.4442 112.08 77.4442 112.115 77.4643L112.6 77.7459H112.655V77.8104C112.655 77.8263 112.648 77.8422 112.632 77.8507L112.221 78.0899C112.175 78.1163 112.118 78.1163 112.072 78.0899L111.591 77.8104C111.573 77.7988 111.563 77.7797 111.562 77.7607V77.6951L111.579 77.7141V77.7152Z",
    fill: "#39BAE9"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M111.591 77.6453L112.005 77.404C112.038 77.3839 112.08 77.3839 112.115 77.404L112.632 77.7057C112.663 77.7237 112.663 77.7681 112.632 77.7861L112.221 78.0254C112.175 78.0518 112.118 78.0518 112.072 78.0254L111.591 77.7459C111.553 77.7237 111.553 77.6676 111.591 77.6453Z",
    fill: "#ECF5FF"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M121.634 81.3502C121.634 81.3502 121.641 81.3428 121.646 81.3407L122.06 81.0993C122.093 81.0792 122.135 81.0792 122.17 81.0993L122.655 81.3809H122.71V81.4454C122.71 81.4613 122.703 81.4772 122.687 81.4857L122.276 81.7249C122.23 81.7514 122.173 81.7514 122.127 81.7249L121.646 81.4454C121.627 81.4338 121.618 81.4148 121.617 81.3957V81.3301L121.634 81.3491V81.3502Z",
    fill: "#39BAE9"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M121.645 81.2813L122.059 81.04C122.092 81.0199 122.134 81.0199 122.169 81.04L122.686 81.3417C122.717 81.3597 122.717 81.4041 122.686 81.4221L122.275 81.6613C122.229 81.6878 122.172 81.6878 122.126 81.6613L121.645 81.3819C121.607 81.3597 121.607 81.3036 121.645 81.2813Z",
    fill: "#ECF5FF"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M120.929 80.9383C120.929 80.9383 120.936 80.9309 120.941 80.9288L121.355 80.6874C121.388 80.6673 121.43 80.6673 121.465 80.6874L121.95 80.9701H122.005V81.0346C122.005 81.0505 121.998 81.0664 121.982 81.0749L121.571 81.3141C121.525 81.3406 121.468 81.3406 121.422 81.3141L120.941 81.0346C120.922 81.023 120.913 81.0039 120.912 80.9849V80.9193L120.929 80.9383Z",
    fill: "#39BAE9"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M120.941 80.8685L121.355 80.6271C121.388 80.607 121.43 80.607 121.465 80.6271L121.982 80.9288C122.012 80.9468 122.012 80.9913 121.982 81.0093L121.571 81.2496C121.525 81.276 121.468 81.276 121.422 81.2496L120.941 80.9701C120.902 80.9479 120.902 80.8918 120.941 80.8695V80.8685Z",
    fill: "#ECF5FF"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M120.224 80.5277C120.224 80.5277 120.231 80.5203 120.236 80.5182L120.65 80.2768C120.683 80.2567 120.725 80.2567 120.76 80.2768L121.244 80.5584H121.3V80.623C121.3 80.6388 121.293 80.6547 121.277 80.6632L120.866 80.9024C120.82 80.9289 120.763 80.9289 120.717 80.9024L120.236 80.623C120.217 80.6113 120.208 80.5923 120.207 80.5732V80.5076L120.224 80.5266V80.5277Z",
    fill: "#39BAE9"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M120.236 80.4588L120.65 80.2175C120.683 80.1974 120.725 80.1974 120.76 80.2175L121.277 80.5192C121.308 80.5372 121.308 80.5816 121.277 80.5996L120.866 80.8388C120.82 80.8653 120.763 80.8653 120.717 80.8388L120.236 80.5594C120.198 80.5372 120.198 80.4811 120.236 80.4588Z",
    fill: "#ECF5FF"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M119.519 80.117C119.519 80.117 119.527 80.1096 119.532 80.1075L119.945 79.8662C119.979 79.846 120.021 79.846 120.056 79.8662L120.54 80.1477H120.596V80.2123C120.596 80.2282 120.589 80.2441 120.573 80.2525L120.162 80.4918C120.115 80.5182 120.059 80.5182 120.013 80.4918L119.532 80.2123C119.513 80.2007 119.504 80.1816 119.503 80.1626V80.0969L119.519 80.116V80.117Z",
    fill: "#39BAE9"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M119.531 80.0472L119.944 79.8059C119.978 79.7857 120.02 79.7857 120.055 79.8059L120.572 80.1075C120.602 80.1255 120.602 80.17 120.572 80.188L120.161 80.4272C120.114 80.4537 120.058 80.4537 120.012 80.4272L119.531 80.1478C119.492 80.1255 119.492 80.0694 119.531 80.0472Z",
    fill: "#ECF5FF"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M118.814 79.7052C118.814 79.7052 118.822 79.6978 118.827 79.6956L119.24 79.4543C119.274 79.4342 119.316 79.4342 119.351 79.4543L119.835 79.7369H119.891V79.8015C119.891 79.8174 119.884 79.8333 119.868 79.8417L119.457 80.081C119.41 80.1074 119.354 80.1074 119.308 80.081L118.827 79.8015C118.808 79.7899 118.799 79.7708 118.798 79.7517V79.6861L118.814 79.7052Z",
    fill: "#39BAE9"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M118.827 79.6363L119.241 79.395C119.274 79.3749 119.316 79.3749 119.351 79.395L119.868 79.6967C119.898 79.7146 119.898 79.7591 119.868 79.7771L119.457 80.0163C119.411 80.0428 119.354 80.0428 119.308 80.0163L118.827 79.7369C118.788 79.7146 118.788 79.6585 118.827 79.6363Z",
    fill: "#ECF5FF"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M118.109 79.2945C118.109 79.2945 118.117 79.2871 118.122 79.285L118.535 79.0436C118.569 79.0235 118.611 79.0235 118.645 79.0436L119.13 79.3263H119.186V79.3908C119.186 79.4067 119.178 79.4226 119.163 79.4311L118.751 79.6703C118.705 79.6968 118.649 79.6968 118.602 79.6703L118.122 79.3908C118.103 79.3792 118.094 79.3601 118.093 79.3411V79.2755L118.109 79.2945Z",
    fill: "#39BAE9"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M118.122 79.2247L118.536 78.9833C118.569 78.9632 118.611 78.9632 118.646 78.9833L119.163 79.285C119.193 79.303 119.193 79.3475 119.163 79.3655L118.752 79.6047C118.706 79.6312 118.649 79.6312 118.603 79.6047L118.122 79.3253C118.083 79.303 118.083 79.2469 118.122 79.2247Z",
    fill: "#ECF5FF"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M117.405 78.8829C117.405 78.8829 117.413 78.8755 117.418 78.8734L117.831 78.632C117.865 78.6119 117.907 78.6119 117.941 78.632L118.426 78.9136H118.482V78.9782C118.482 78.994 118.474 79.0099 118.459 79.0184L118.047 79.2587C118.001 79.2851 117.945 79.2851 117.898 79.2587L117.418 78.9792C117.399 78.9676 117.389 78.9485 117.388 78.9295V78.8638L117.405 78.8829Z",
    fill: "#39BAE9"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M117.417 78.814L117.83 78.5727C117.864 78.5526 117.906 78.5526 117.94 78.5727L118.458 78.8744C118.488 78.8924 118.488 78.9368 118.458 78.9548L118.046 79.1941C118 79.2205 117.944 79.2205 117.897 79.1941L117.417 78.9146C117.378 78.8924 117.378 78.8363 117.417 78.814Z",
    fill: "#ECF5FF"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M116.7 78.472C116.7 78.472 116.707 78.4646 116.713 78.4625L117.126 78.2211C117.16 78.201 117.202 78.201 117.236 78.2211L117.721 78.5038H117.777V78.5683C117.777 78.5842 117.769 78.6001 117.754 78.6086L117.342 78.8478C117.296 78.8743 117.239 78.8743 117.193 78.8478L116.713 78.5683C116.694 78.5567 116.684 78.5376 116.683 78.5186V78.453L116.7 78.472Z",
    fill: "#39BAE9"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M116.713 78.4032L117.126 78.1618C117.16 78.1417 117.202 78.1417 117.236 78.1618L117.754 78.4635C117.784 78.4815 117.784 78.5259 117.754 78.5439L117.342 78.7832C117.296 78.8096 117.239 78.8096 117.193 78.7832L116.713 78.5037C116.674 78.4815 116.674 78.4254 116.713 78.4032Z",
    fill: "#ECF5FF"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M115.995 78.0614C115.995 78.0614 116.002 78.054 116.008 78.0518L116.421 77.8105C116.455 77.7904 116.497 77.7904 116.531 77.8105L117.016 78.0931H117.072V78.1577C117.072 78.1736 117.064 78.1895 117.048 78.1979L116.637 78.4382C116.591 78.4647 116.534 78.4647 116.488 78.4382L116.008 78.1588C115.989 78.1471 115.979 78.1281 115.978 78.109V78.0434L115.995 78.0624V78.0614Z",
    fill: "#39BAE9"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M116.008 77.9915L116.421 77.7502C116.455 77.7301 116.497 77.7301 116.531 77.7502L117.048 78.0519C117.079 78.0699 117.079 78.1143 117.048 78.1323L116.637 78.3715C116.591 78.398 116.534 78.398 116.488 78.3715L116.008 78.0921C115.969 78.0699 115.969 78.0138 116.008 77.9915Z",
    fill: "#ECF5FF"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M115.291 77.6495C115.291 77.6495 115.298 77.6421 115.304 77.64L115.717 77.3986C115.751 77.3785 115.792 77.3785 115.827 77.3986L116.312 77.6813H116.367V77.7458C116.367 77.7617 116.36 77.7776 116.344 77.7861L115.933 78.0253C115.887 78.0518 115.83 78.0518 115.784 78.0253L115.304 77.7458C115.285 77.7342 115.275 77.7151 115.274 77.6961V77.6305L115.291 77.6495Z",
    fill: "#39BAE9"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M115.303 77.5807L115.716 77.3393C115.75 77.3192 115.791 77.3192 115.826 77.3393L116.343 77.641C116.374 77.659 116.374 77.7034 116.343 77.7214L115.932 77.9607C115.886 77.9871 115.829 77.9871 115.783 77.9607L115.303 77.6812C115.264 77.659 115.264 77.6029 115.303 77.5807Z",
    fill: "#ECF5FF"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M114.586 77.2389C114.586 77.2389 114.593 77.2314 114.598 77.2293L115.012 76.988C115.045 76.9679 115.087 76.9679 115.122 76.988L115.607 77.2696H115.662V77.3341C115.662 77.35 115.655 77.3659 115.639 77.3743L115.228 77.6136C115.182 77.64 115.125 77.64 115.079 77.6136L114.598 77.3341C114.58 77.3225 114.57 77.3034 114.569 77.2844V77.2187L114.586 77.2378V77.2389Z",
    fill: "#39BAE9"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M114.598 77.169L115.012 76.9277C115.045 76.9076 115.087 76.9076 115.122 76.9277L115.639 77.2294C115.67 77.2474 115.67 77.2918 115.639 77.3098L115.228 77.549C115.182 77.5755 115.125 77.5755 115.079 77.549L114.598 77.2696C114.56 77.2474 114.56 77.1913 114.598 77.169Z",
    fill: "#ECF5FF"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M120.36 82.0921C120.36 82.0921 120.367 82.0847 120.372 82.0826L120.786 81.8413C120.819 81.8211 120.861 81.8211 120.896 81.8413L121.381 82.1239H121.436V82.1885C121.436 82.2043 121.429 82.2202 121.413 82.2287L121.002 82.4679C120.956 82.4944 120.899 82.4944 120.853 82.4679L120.372 82.1885C120.354 82.1768 120.344 82.1578 120.343 82.1387V82.0731L120.36 82.0921Z",
    fill: "#39BAE9"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M120.372 82.0233L120.786 81.7819C120.819 81.7618 120.861 81.7618 120.896 81.7819L121.413 82.0836C121.444 82.1016 121.444 82.1461 121.413 82.1641L121.002 82.4033C120.956 82.4297 120.899 82.4297 120.853 82.4033L120.372 82.1238C120.334 82.1016 120.334 82.0455 120.372 82.0233Z",
    fill: "#ECF5FF"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M119.655 81.6805C119.655 81.6805 119.662 81.6731 119.667 81.671L120.081 81.4296C120.114 81.4095 120.156 81.4095 120.191 81.4296L120.676 81.7123H120.731V81.7768C120.731 81.7927 120.724 81.8086 120.708 81.8171L120.297 82.0563C120.251 82.0827 120.194 82.0827 120.148 82.0563L119.667 81.7768C119.648 81.7652 119.639 81.7461 119.638 81.7271V81.6615L119.655 81.6805Z",
    fill: "#39BAE9"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M119.668 81.6116L120.081 81.3703C120.115 81.3502 120.156 81.3502 120.191 81.3703L120.708 81.672C120.739 81.69 120.739 81.7344 120.708 81.7524L120.297 81.9917C120.251 82.0181 120.194 82.0181 120.148 81.9917L119.668 81.7122C119.629 81.69 119.629 81.6339 119.668 81.6116Z",
    fill: "#ECF5FF"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M118.951 81.2699C118.951 81.2699 118.958 81.2624 118.963 81.2603L119.377 81.019C119.41 80.9989 119.452 80.9989 119.487 81.019L119.972 81.3016H120.027V81.3662C120.027 81.3821 120.02 81.3979 120.004 81.4064L119.593 81.6456C119.547 81.6721 119.49 81.6721 119.444 81.6456L118.963 81.3662C118.945 81.3545 118.935 81.3355 118.934 81.3164V81.2508L118.951 81.2699Z",
    fill: "#39BAE9"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M118.963 81.201L119.377 80.9597C119.41 80.9396 119.452 80.9396 119.487 80.9597L120.004 81.2613C120.035 81.2793 120.035 81.3238 120.004 81.3418L119.593 81.581C119.547 81.6075 119.49 81.6075 119.444 81.581L118.963 81.3016C118.925 81.2793 118.925 81.2232 118.963 81.201Z",
    fill: "#ECF5FF"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M118.246 80.859C118.246 80.859 118.253 80.8516 118.258 80.8494L118.672 80.6081C118.705 80.588 118.747 80.588 118.782 80.6081L119.267 80.8907H119.322V80.9553C119.322 80.9712 119.315 80.987 119.299 80.9955L118.888 81.2358C118.842 81.2623 118.785 81.2623 118.739 81.2358L118.258 80.9563C118.239 80.9447 118.23 80.9257 118.229 80.9066V80.841L118.246 80.86V80.859Z",
    fill: "#39BAE9"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M118.258 80.7891L118.672 80.5478C118.705 80.5277 118.747 80.5277 118.782 80.5478L119.299 80.8495C119.33 80.8675 119.33 80.9119 119.299 80.9299L118.888 81.1692C118.842 81.1956 118.785 81.1956 118.739 81.1692L118.258 80.8897C118.22 80.8675 118.22 80.8114 118.258 80.7891Z",
    fill: "#ECF5FF"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M117.54 80.4483C117.54 80.4483 117.548 80.4409 117.553 80.4388L117.966 80.1975C118 80.1773 118.042 80.1773 118.077 80.1975L118.561 80.4801H118.617V80.5447C118.617 80.5605 118.61 80.5764 118.594 80.5849L118.183 80.8241C118.136 80.8506 118.08 80.8506 118.034 80.8241L117.553 80.5447C117.534 80.533 117.525 80.514 117.524 80.4949V80.4293L117.54 80.4483Z",
    fill: "#39BAE9"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M117.553 80.3785L117.967 80.1372C118 80.117 118.042 80.117 118.077 80.1372L118.594 80.4388C118.625 80.4568 118.625 80.5013 118.594 80.5193L118.183 80.7585C118.137 80.785 118.08 80.785 118.034 80.7585L117.553 80.4791C117.514 80.4568 117.514 80.4007 117.553 80.3785Z",
    fill: "#ECF5FF"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M116.837 80.0365C116.837 80.0365 116.844 80.0291 116.849 80.0269L117.263 79.7856C117.296 79.7655 117.338 79.7655 117.373 79.7856L117.857 80.0672H117.913V80.1317C117.913 80.1476 117.906 80.1635 117.89 80.172L117.479 80.4112C117.433 80.4376 117.376 80.4376 117.33 80.4112L116.849 80.1317C116.83 80.1201 116.821 80.101 116.821 80.082V80.0163L116.838 80.0354L116.837 80.0365Z",
    fill: "#39BAE9"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M116.849 79.9666L117.263 79.7253C117.296 79.7052 117.338 79.7052 117.373 79.7253L117.89 80.027C117.92 80.045 117.92 80.0894 117.89 80.1074L117.479 80.3467C117.433 80.3731 117.376 80.3731 117.33 80.3467L116.849 80.0672C116.81 80.045 116.81 79.9889 116.849 79.9666Z",
    fill: "#ECF5FF"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M116.132 79.6258C116.132 79.6258 116.139 79.6184 116.144 79.6163L116.558 79.3749C116.591 79.3548 116.633 79.3548 116.668 79.3749L117.152 79.6576H117.208V79.7221C117.208 79.738 117.201 79.7539 117.185 79.7624L116.774 80.0016C116.728 80.028 116.671 80.028 116.625 80.0016L116.144 79.7221C116.125 79.7105 116.116 79.6914 116.115 79.6724V79.6068L116.132 79.6258Z",
    fill: "#39BAE9"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M116.144 79.556L116.558 79.3146C116.591 79.2945 116.633 79.2945 116.668 79.3146L117.185 79.6163C117.216 79.6343 117.216 79.6788 117.185 79.6968L116.774 79.937C116.728 79.9635 116.671 79.9635 116.625 79.937L116.144 79.6576C116.106 79.6354 116.106 79.5793 116.144 79.557V79.556Z",
    fill: "#ECF5FF"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M115.426 79.2142C115.426 79.2142 115.434 79.2068 115.439 79.2047L115.852 78.9633C115.886 78.9432 115.928 78.9432 115.963 78.9633L116.447 79.2459H116.503V79.3105C116.503 79.3264 116.496 79.3423 116.48 79.3507L116.069 79.59C116.022 79.6164 115.966 79.6164 115.92 79.59L115.439 79.3105C115.42 79.2989 115.411 79.2798 115.41 79.2608V79.1951L115.426 79.2142Z",
    fill: "#39BAE9"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M115.439 79.1453L115.852 78.904C115.886 78.8839 115.928 78.8839 115.963 78.904L116.48 79.2057C116.51 79.2237 116.51 79.2681 116.48 79.2861L116.069 79.5253C116.022 79.5518 115.966 79.5518 115.92 79.5253L115.439 79.2459C115.4 79.2237 115.4 79.1676 115.439 79.1453Z",
    fill: "#ECF5FF"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M114.722 78.8033C114.722 78.8033 114.73 78.7959 114.735 78.7938L115.148 78.5524C115.182 78.5323 115.224 78.5323 115.259 78.5524L115.743 78.834H115.799V78.8986C115.799 78.9145 115.792 78.9303 115.776 78.9388L115.364 79.178C115.318 79.2045 115.262 79.2045 115.215 79.178L114.735 78.8986C114.716 78.8869 114.707 78.8679 114.706 78.8488V78.7832L114.722 78.8023V78.8033Z",
    fill: "#39BAE9"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M114.735 78.7335L115.149 78.4921C115.182 78.472 115.224 78.472 115.259 78.4921L115.776 78.7938C115.806 78.8118 115.806 78.8563 115.776 78.8743L115.365 79.1135C115.319 79.14 115.262 79.14 115.216 79.1135L114.735 78.834C114.696 78.8118 114.696 78.7557 114.735 78.7335Z",
    fill: "#ECF5FF"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M114.017 78.3917C114.017 78.3917 114.025 78.3843 114.03 78.3822L114.443 78.1408C114.477 78.1207 114.519 78.1207 114.553 78.1408L115.038 78.4234H115.094V78.488C115.094 78.5039 115.086 78.5198 115.071 78.5282L114.659 78.7675C114.613 78.7939 114.557 78.7939 114.51 78.7675L114.03 78.488C114.011 78.4764 114.002 78.4573 114 78.4383V78.3726L114.017 78.3917Z",
    fill: "#39BAE9"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M114.03 78.3228L114.443 78.0815C114.477 78.0614 114.519 78.0614 114.554 78.0815L115.071 78.3832C115.101 78.4012 115.101 78.4456 115.071 78.4636L114.66 78.7028C114.613 78.7293 114.557 78.7293 114.511 78.7028L114.03 78.4234C113.991 78.4012 113.991 78.3451 114.03 78.3228Z",
    fill: "#ECF5FF"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M113.312 77.9808C113.312 77.9808 113.32 77.9734 113.325 77.9713L113.738 77.7299C113.772 77.7098 113.814 77.7098 113.848 77.7299L114.333 78.0115H114.389V78.0761C114.389 78.0919 114.381 78.1078 114.366 78.1163L113.954 78.3555C113.908 78.382 113.852 78.382 113.805 78.3555L113.325 78.0761C113.306 78.0644 113.296 78.0454 113.295 78.0263V77.9607L113.312 77.9797V77.9808Z",
    fill: "#39BAE9"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M113.325 77.911L113.738 77.6696C113.772 77.6495 113.814 77.6495 113.848 77.6696L114.366 77.9713C114.396 77.9893 114.396 78.0338 114.366 78.0518L113.954 78.292C113.908 78.3185 113.851 78.3185 113.805 78.292L113.325 78.0126C113.286 77.9904 113.286 77.9343 113.325 77.912V77.911Z",
    fill: "#ECF5FF"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M120.718 81.5587C120.718 81.5587 120.725 81.5513 120.73 81.5492L121.144 81.3078C121.177 81.2877 121.219 81.2877 121.254 81.3078L121.739 81.5904H121.794V81.655C121.794 81.6709 121.787 81.6868 121.771 81.6952L121.36 81.9345C121.314 81.9609 121.257 81.9609 121.211 81.9345L120.73 81.655C120.711 81.6434 120.702 81.6243 120.701 81.6053V81.5396L120.718 81.5587Z",
    fill: "#39BAE9"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M120.73 81.4898L121.144 81.2485C121.177 81.2284 121.219 81.2284 121.254 81.2485L121.771 81.5502C121.802 81.5682 121.802 81.6126 121.771 81.6306L121.36 81.8698C121.314 81.8963 121.257 81.8963 121.211 81.8698L120.73 81.5904C120.691 81.5682 120.691 81.5121 120.73 81.4898Z",
    fill: "#ECF5FF"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M120.013 81.148C120.013 81.148 120.02 81.1406 120.025 81.1385L120.439 80.8972C120.472 80.8771 120.514 80.8771 120.549 80.8972L121.034 81.1798H121.089V81.2444C121.089 81.2602 121.082 81.2761 121.066 81.2846L120.655 81.5238C120.609 81.5503 120.552 81.5503 120.506 81.5238L120.025 81.2444C120.006 81.2327 119.997 81.2137 119.996 81.1946V81.129L120.013 81.148Z",
    fill: "#39BAE9"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M120.025 81.0792L120.439 80.8378C120.472 80.8177 120.514 80.8177 120.549 80.8378L121.066 81.1395C121.096 81.1575 121.096 81.202 121.066 81.22L120.655 81.4592C120.609 81.4857 120.552 81.4857 120.506 81.4592L120.025 81.1798C119.986 81.1575 119.986 81.1014 120.025 81.0792Z",
    fill: "#ECF5FF"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M119.309 80.7372C119.309 80.7372 119.316 80.7297 119.321 80.7276L119.735 80.4863C119.768 80.4662 119.81 80.4662 119.845 80.4863L120.329 80.7689H120.385V80.8335C120.385 80.8494 120.378 80.8652 120.362 80.8737L119.951 81.114C119.904 81.1405 119.848 81.1405 119.802 81.114L119.321 80.8345C119.302 80.8229 119.293 80.8038 119.292 80.7848V80.7192L119.309 80.7382V80.7372Z",
    fill: "#39BAE9"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M119.321 80.6673L119.735 80.426C119.768 80.4059 119.81 80.4059 119.845 80.426L120.362 80.7276C120.393 80.7456 120.393 80.7901 120.362 80.8081L119.951 81.0473C119.905 81.0738 119.848 81.0738 119.802 81.0473L119.321 80.7679C119.283 80.7456 119.283 80.6895 119.321 80.6673Z",
    fill: "#ECF5FF"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M118.603 80.3265C118.603 80.3265 118.611 80.3191 118.616 80.317L119.029 80.0756C119.063 80.0555 119.105 80.0555 119.14 80.0756L119.624 80.3583H119.68V80.4228C119.68 80.4387 119.673 80.4546 119.657 80.4631L119.246 80.7023C119.199 80.7287 119.143 80.7287 119.097 80.7023L118.616 80.4228C118.597 80.4112 118.588 80.3921 118.587 80.3731V80.3074L118.603 80.3265Z",
    fill: "#39BAE9"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M118.616 80.2567L119.03 80.0153C119.063 79.9952 119.105 79.9952 119.14 80.0153L119.657 80.317C119.688 80.335 119.688 80.3795 119.657 80.3974L119.246 80.6367C119.2 80.6631 119.143 80.6631 119.097 80.6367L118.616 80.3572C118.577 80.335 118.577 80.2789 118.616 80.2567Z",
    fill: "#ECF5FF"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M117.898 79.9149C117.898 79.9149 117.906 79.9075 117.911 79.9054L118.324 79.664C118.358 79.6439 118.4 79.6439 118.435 79.664L118.919 79.9456H118.975V80.0102C118.975 80.026 118.968 80.0419 118.952 80.0504L118.541 80.2896C118.494 80.3161 118.438 80.3161 118.392 80.2896L117.911 80.0102C117.892 79.9985 117.883 79.9795 117.882 79.9604V79.8948L117.898 79.9138V79.9149Z",
    fill: "#39BAE9"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M117.911 79.846L118.325 79.6047C118.358 79.5846 118.4 79.5846 118.435 79.6047L118.952 79.9064C118.982 79.9244 118.982 79.9688 118.952 79.9868L118.541 80.226C118.495 80.2525 118.438 80.2525 118.392 80.226L117.911 79.9466C117.872 79.9244 117.872 79.8683 117.911 79.846Z",
    fill: "#ECF5FF"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M117.194 79.504C117.194 79.504 117.202 79.4966 117.207 79.4945L117.62 79.2531C117.654 79.233 117.696 79.233 117.73 79.2531L118.215 79.5357H118.271V79.6003C118.271 79.6162 118.263 79.6321 118.248 79.6405L117.836 79.8808C117.79 79.9073 117.734 79.9073 117.687 79.8808L117.207 79.6014C117.188 79.5897 117.179 79.5707 117.177 79.5516V79.486L117.194 79.505V79.504Z",
    fill: "#39BAE9"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M117.207 79.4342L117.62 79.1928C117.654 79.1727 117.696 79.1727 117.731 79.1928L118.248 79.4945C118.278 79.5125 118.278 79.557 118.248 79.5749L117.837 79.8142C117.79 79.8406 117.734 79.8406 117.688 79.8142L117.207 79.5347C117.168 79.5125 117.168 79.4564 117.207 79.4342Z",
    fill: "#ECF5FF"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M116.489 79.0933C116.489 79.0933 116.497 79.0859 116.502 79.0838L116.915 78.8425C116.949 78.8224 116.991 78.8224 117.025 78.8425L117.51 79.1251H117.566V79.1897C117.566 79.2055 117.558 79.2214 117.543 79.2299L117.131 79.4702C117.085 79.4966 117.029 79.4966 116.982 79.4702L116.502 79.1907C116.483 79.1791 116.473 79.16 116.472 79.141V79.0754L116.489 79.0944V79.0933Z",
    fill: "#39BAE9"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M116.502 79.0235L116.915 78.7822C116.949 78.7621 116.991 78.7621 117.025 78.7822L117.543 79.0839C117.573 79.1019 117.573 79.1463 117.543 79.1643L117.131 79.4046C117.085 79.4311 117.028 79.4311 116.982 79.4046L116.502 79.1251C116.463 79.1029 116.463 79.0468 116.502 79.0246V79.0235Z",
    fill: "#ECF5FF"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M115.784 78.6815C115.784 78.6815 115.791 78.6741 115.797 78.672L116.21 78.4306C116.244 78.4105 116.286 78.4105 116.32 78.4306L116.805 78.7122H116.861V78.7767C116.861 78.7926 116.853 78.8085 116.838 78.817L116.426 79.0562C116.38 79.0827 116.323 79.0827 116.277 79.0562L115.797 78.7767C115.778 78.7651 115.768 78.746 115.767 78.727V78.6614L115.784 78.6804V78.6815Z",
    fill: "#39BAE9"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M115.797 78.6117L116.21 78.3703C116.244 78.3502 116.286 78.3502 116.321 78.3703L116.838 78.672C116.868 78.69 116.868 78.7344 116.838 78.7524L116.426 78.9917C116.38 79.0181 116.324 79.0181 116.277 78.9917L115.797 78.7122C115.758 78.69 115.758 78.6339 115.797 78.6117Z",
    fill: "#ECF5FF"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M115.08 78.2699C115.08 78.2699 115.087 78.2625 115.093 78.2603L115.506 78.019C115.54 77.9989 115.582 77.9989 115.616 78.019L116.101 78.3016H116.157V78.3662C116.157 78.3821 116.149 78.3979 116.133 78.4064L115.722 78.6456C115.676 78.6721 115.619 78.6721 115.573 78.6456L115.093 78.3662C115.074 78.3545 115.064 78.3355 115.063 78.3164V78.2508L115.08 78.2699Z",
    fill: "#39BAE9"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M115.093 78.201L115.506 77.9597C115.54 77.9396 115.582 77.9396 115.616 77.9597L116.134 78.2613C116.164 78.2793 116.164 78.3238 116.134 78.3418L115.722 78.581C115.676 78.6075 115.62 78.6075 115.573 78.581L115.093 78.3016C115.054 78.2793 115.054 78.2232 115.093 78.201Z",
    fill: "#ECF5FF"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M114.375 77.859C114.375 77.859 114.383 77.8516 114.388 77.8495L114.801 77.6081C114.835 77.588 114.877 77.588 114.911 77.6081L115.396 77.8907H115.452V77.9553C115.452 77.9712 115.444 77.9871 115.429 77.9955L115.017 78.2348C114.971 78.2612 114.914 78.2612 114.868 78.2348L114.388 77.9553C114.369 77.9437 114.359 77.9246 114.358 77.9056V77.8399L114.375 77.859Z",
    fill: "#39BAE9"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M114.388 77.7891L114.801 77.5478C114.835 77.5277 114.877 77.5277 114.911 77.5478L115.429 77.8495C115.459 77.8675 115.459 77.9119 115.429 77.9299L115.017 78.1692C114.971 78.1956 114.914 78.1956 114.868 78.1692L114.388 77.8897C114.349 77.8675 114.349 77.8114 114.388 77.7891Z",
    fill: "#ECF5FF"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M114.765 75.8575C114.765 75.8575 114.773 75.8501 114.778 75.848L114.937 75.7548C114.971 75.7347 115.013 75.7347 115.048 75.7548L115.532 76.0375H115.588V76.102C115.588 76.1179 115.581 76.1338 115.565 76.1423L115.407 76.2333C115.361 76.2598 115.305 76.2598 115.258 76.2333L114.778 75.9538C114.759 75.9422 114.75 75.9231 114.749 75.9041V75.8385L114.765 75.8575Z",
    fill: "#39BAE9"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M114.778 75.7877L114.938 75.6945C114.971 75.6744 115.013 75.6744 115.048 75.6945L115.565 75.9962C115.595 76.0142 115.595 76.0587 115.565 76.0767L115.408 76.1677C115.362 76.1941 115.305 76.1941 115.259 76.1677L114.778 75.8882C114.739 75.866 114.739 75.8099 114.778 75.7877Z",
    fill: "#ECF5FF"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M112.48 80.9562L113.902 80.1284C114.018 80.0607 114.163 80.0607 114.28 80.1284L117.113 81.7776C117.219 81.839 117.219 81.9936 117.113 82.055L115.698 82.8785C115.54 82.9706 115.345 82.9706 115.186 82.8785L112.48 81.3034C112.348 81.2261 112.348 81.0335 112.48 80.9562Z",
    fill: "#C9DAFC"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M117.114 81.8105L114.281 80.1613C114.164 80.0936 114.019 80.0936 113.903 80.1613L112.481 80.9891C112.42 81.024 112.388 81.0844 112.383 81.1458C112.376 81.0727 112.409 80.9976 112.481 80.9552L113.903 80.1275C114.019 80.0597 114.164 80.0597 114.281 80.1275L117.114 81.7767C117.172 81.8105 117.196 81.873 117.191 81.9323C117.186 81.8846 117.162 81.838 117.114 81.8105Z",
    fill: "#39BAE9"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M117.583 84.1129L117.996 83.8715C118.03 83.8514 118.072 83.8514 118.106 83.8715L119.43 84.6411C119.461 84.6591 119.461 84.7035 119.43 84.7215L119.019 84.9607C118.973 84.9872 118.916 84.9872 118.87 84.9607L117.583 84.2124C117.544 84.1901 117.544 84.134 117.583 84.1118V84.1129Z",
    fill: "url(#paint40_linear_917_439)"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M118.279 83.7086L118.693 83.4672C118.726 83.4471 118.768 83.4471 118.803 83.4672L119.351 83.7848C119.381 83.8028 119.381 83.8472 119.351 83.8652L118.939 84.1045C118.893 84.1309 118.836 84.1309 118.79 84.1045L118.28 83.8081C118.242 83.7858 118.242 83.7297 118.28 83.7075L118.279 83.7086Z",
    fill: "url(#paint41_linear_917_439)"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M118.901 84.4167L119.353 84.6793L118.95 84.9132L118.499 84.6507L118.901 84.4167Z",
    fill: "#ECF5FF"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M125.685 81.9683L126.101 81.7249V81.9059L125.685 82.1483V81.9683Z",
    fill: "#5F546F"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M126.039 81.8699V81.7619L126.101 81.7249V81.9059L125.685 82.1483V82.0763L126.039 81.8699Z",
    fill: "#ECF5FF"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M125.167 82.27L125.584 82.0276V82.2075L125.167 82.45V82.27Z",
    fill: "#5F546F"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M125.522 82.1716V82.0636L125.584 82.0276V82.2075L125.167 82.45V82.378L125.522 82.1716Z",
    fill: "#ECF5FF"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M119.805 85.4L120.221 85.1565V85.3375L119.805 85.5789V85.4Z",
    fill: "#5F546F"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M120.16 85.3005V85.1925L120.221 85.1565V85.3375L119.805 85.5789V85.5069L120.16 85.3005Z",
    fill: "#ECF5FF"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M126.058 76.7075L125.2 76.2058V75.5315L126.058 76.0332V76.7075Z",
    fill: "#E5F0FF"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M125.03 75.4341V75.4934L124.175 74.9938V74.9355L125.03 75.4341Z",
    fill: "#E5F0FF"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M125.03 75.6194L124.175 75.1197V75.0615L125.03 75.5601V75.6194Z",
    fill: "#E5F0FF"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M125.03 75.7454L124.175 75.2457V75.1875L125.03 75.6861V75.7454Z",
    fill: "#E5F0FF"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M125.03 75.8713L124.175 75.3717V75.3135L125.03 75.8121V75.8713Z",
    fill: "#E5F0FF"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M126.058 77.585L125.2 77.0832V76.4089L126.058 76.9096V77.585Z",
    fill: "#E5F0FF"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M125.03 76.3118V76.37L124.175 75.8715V75.8132L125.03 76.3118Z",
    fill: "#E5F0FF"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M125.03 76.496L124.175 75.9974V75.9392L125.03 76.4378V76.496Z",
    fill: "#E5F0FF"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M125.03 76.6217L124.175 76.1232V76.0649L125.03 76.5635V76.6217Z",
    fill: "#E5F0FF"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M125.03 76.7477L124.175 76.2491V76.1909L125.03 76.6895V76.7477Z",
    fill: "#E5F0FF"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M126.058 78.4519L125.2 77.9502V77.2759L126.058 77.7766V78.4519Z",
    fill: "#E5F0FF"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M125.03 77.1787V77.237L124.175 76.7384V76.6802L125.03 77.1787Z",
    fill: "#E5F0FF"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M125.03 77.3627L124.175 76.8641V76.8059L125.03 77.3045V77.3627Z",
    fill: "#E5F0FF"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M125.03 77.4887L124.175 76.9901V76.9319L125.03 77.4304V77.4887Z",
    fill: "#E5F0FF"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M125.03 77.6146L124.175 77.1161V77.0579L125.03 77.5564V77.6146Z",
    fill: "#E5F0FF"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M126.058 79.3286L125.2 78.8279V78.1526L126.058 78.6543V79.3286Z",
    fill: "#E5F0FF"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M125.03 78.056V78.1143L124.175 77.6157V77.5564L125.03 78.056Z",
    fill: "#E5F0FF"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M125.03 78.2402L124.175 77.7416V77.6824L125.03 78.182V78.2402Z",
    fill: "#E5F0FF"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M125.03 78.3662L124.175 77.8676V77.8083L125.03 78.308V78.3662Z",
    fill: "#E5F0FF"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M125.03 78.4922L124.175 77.9936V77.9343L125.03 78.4339V78.4922Z",
    fill: "#E5F0FF"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M122.855 70.9319V71.0801L118.163 68.3396V68.1914L122.855 70.9319Z",
    fill: "#ECF5FF"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M122.855 71.508V71.6561L118.163 68.9146V68.7664L122.855 71.508Z",
    fill: "#ECF5FF"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M122.855 72.6574V72.8055L118.163 70.065V69.9158L122.855 72.6574Z",
    fill: "#ECF5FF"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M122.855 74.3829V74.5311L118.163 71.7896V71.6414L122.855 74.3829Z",
    fill: "#ECF5FF"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M120.79 69.4385L122.855 70.6452V70.7934L120.79 69.5867V69.4385Z",
    fill: "#ECF5FF"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M120.627 69.3432V69.4914L118.163 68.0518V67.9036L120.627 69.3432Z",
    fill: "#ECF5FF"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M119.789 69.4287L122.855 71.2197V71.3679L119.789 69.5769V69.4287Z",
    fill: "#ECF5FF"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M119.627 69.3336V69.4818L118.163 68.6265V68.4783L119.627 69.3336Z",
    fill: "#ECF5FF"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M120.509 70.4239V70.5721L118.163 69.2024V69.0542L120.509 70.4239Z",
    fill: "#ECF5FF"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M119.635 70.2017L122.855 72.0827V72.2309L119.635 70.3499V70.2017Z",
    fill: "#ECF5FF"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M119.472 70.1064V70.2546L118.163 69.4893V69.3411L119.472 70.1064Z",
    fill: "#ECF5FF"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M120.953 71.259L122.855 72.3694V72.5187L120.953 71.4072V71.259Z",
    fill: "#ECF5FF"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M120.79 71.1638V71.312L118.163 69.7771V69.6289L120.79 71.1638Z",
    fill: "#ECF5FF"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M120.428 71.8148V71.963L118.163 70.6399V70.4917L120.428 71.8148Z",
    fill: "#ECF5FF"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M121.414 72.6786V72.8268L118.163 70.9268V70.7786L121.414 72.6786Z",
    fill: "#ECF5FF"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M119.405 71.7925L122.855 73.8079V73.9561L119.405 71.9407V71.7925Z",
    fill: "#ECF5FF"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M119.242 71.6973V71.8455L118.163 71.2146V71.0664L119.242 71.6973Z",
    fill: "#ECF5FF"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M121.115 73.0757L122.847 74.0866V74.2348L121.115 73.2239V73.0757Z",
    fill: "#ECF5FF"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M120.953 72.9803V73.1285L118.155 71.4941V71.3459L120.953 72.9803Z",
    fill: "#ECF5FF"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M120.136 73.0818L122.855 74.6706V74.8188L120.136 73.23V73.0818Z",
    fill: "#ECF5FF"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M119.975 72.9877V73.1359L118.163 72.0774V71.9292L119.975 72.9877Z",
    fill: "#ECF5FF"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M121.495 74.1637V74.3118L118.163 72.3652V72.217L121.495 74.1637Z",
    fill: "#ECF5FF"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M122.855 75.8668V76.015L118.163 73.2734V73.1252L122.855 75.8668Z",
    fill: "#ECF5FF"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M122.855 76.4418V76.59L118.163 73.8484V73.7002L122.855 76.4418Z",
    fill: "#ECF5FF"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M120.627 74.2781V74.4262L118.163 72.9856V72.8374L120.627 74.2781Z",
    fill: "#ECF5FF"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M119.789 74.3625L122.855 76.1536V76.3018L119.789 74.5107V74.3625Z",
    fill: "#ECF5FF"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M119.627 74.2673V74.4155L118.163 73.5613V73.4131L119.627 74.2673Z",
    fill: "#ECF5FF"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M120.509 75.3588V75.507L118.163 74.1362V73.988L120.509 75.3588Z",
    fill: "#ECF5FF"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M119.472 75.0401V75.1883L118.163 74.4241V74.2759L119.472 75.0401Z",
    fill: "#ECF5FF"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 67.1722L116.203 66.7615V66.9097L116.906 67.3204V67.1722Z",
    fill: "#FAE468"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 67.4517L116.203 67.041V67.1892L116.906 67.601V67.4517Z",
    fill: "#FAE468"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 67.7321L116.203 67.3203V67.4685L116.906 67.8803V67.7321Z",
    fill: "#FAE468"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 68.0115L116.203 67.6008V67.749L116.906 68.1597V68.0115Z",
    fill: "#FAE468"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 68.2911L116.203 67.8804V68.0286L116.906 68.4393V68.2911Z",
    fill: "#FAE468"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 68.5704L116.203 68.1597V68.3079L116.906 68.7186V68.5704Z",
    fill: "#FAE468"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 68.8499L116.203 68.4392V68.5874L116.906 68.9981V68.8499Z",
    fill: "#FAE468"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 69.1295L116.203 68.7188V68.8669L116.906 69.2777V69.1295Z",
    fill: "#ECF5FF"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 69.4088L116.203 68.998V69.1462L116.906 69.5569V69.4088Z",
    fill: "#ECF5FF"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 69.6883L116.203 69.2776V69.4258L116.906 69.8365V69.6883Z",
    fill: "#FAE468"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 69.9678L116.203 69.5571V69.7053L116.906 70.116V69.9678Z",
    fill: "#FAE468"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 70.2482L116.203 69.8364V69.9846L116.906 70.3964V70.2482Z",
    fill: "#FAE468"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 70.5277L116.203 70.116V70.2652L116.906 70.6759V70.5277Z",
    fill: "#ECF5FF"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 70.8072L116.203 70.3965V70.5447L116.906 70.9554V70.8072Z",
    fill: "#FAE468"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 71.0865L116.203 70.6758V70.824L116.906 71.2347V71.0865Z",
    fill: "#FAE468"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 71.366L116.203 70.9553V71.1035L116.906 71.5142V71.366Z",
    fill: "#ECF5FF"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 71.6456L116.203 71.2349V71.3831L116.906 71.7938V71.6456Z",
    fill: "#ECF5FF"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 71.9249L116.203 71.5142V71.6623L116.906 72.0731V71.9249Z",
    fill: "#FAE468"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 72.2044L116.203 71.7937V71.9419L116.906 72.3526V72.2044Z",
    fill: "#FAE468"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 72.484L116.203 72.0732V72.2214L116.906 72.6322V72.484Z",
    fill: "#FAE468"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M117.739 67.657L117.036 67.2463V67.3945L117.739 67.8063V67.657Z",
    fill: "#FAE468"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M117.739 67.9376L117.036 67.5259V67.6741L117.739 68.0858V67.9376Z",
    fill: "#FAE468"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M117.739 68.2171L117.036 67.8064V67.9546L117.739 68.3653V68.2171Z",
    fill: "#FAE468"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M117.739 68.4964L117.036 68.0857V68.2339L117.739 68.6446V68.4964Z",
    fill: "#FAE468"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M117.739 69.0555L117.036 68.6448V68.793L117.739 69.2037V69.0555Z",
    fill: "#FAE468"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M117.739 69.3348L117.036 68.9241V69.0723L117.739 69.483V69.3348Z",
    fill: "#FAE468"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M117.739 69.6143L117.036 69.2036V69.3518L117.739 69.7625V69.6143Z",
    fill: "#FAE468"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M117.739 69.8939L117.036 69.4832V69.6313L117.739 70.0421V69.8939Z",
    fill: "#FAE468"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M117.739 70.1731L117.036 69.7625V69.9106L117.739 70.3213V70.1731Z",
    fill: "#FAE468"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M117.739 70.4538L117.036 70.042V70.1902L117.739 70.602V70.4538Z",
    fill: "#ECF5FF"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M117.739 71.2921L117.036 70.8813V71.0295L117.739 71.4403V71.2921Z",
    fill: "#FAE468"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M117.739 71.5716L117.036 71.1609V71.3091L117.739 71.7198V71.5716Z",
    fill: "#FAE468"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M117.739 71.8509L117.036 71.4402V71.5884L117.739 71.9991V71.8509Z",
    fill: "#FAE468"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M117.739 72.1304L117.036 71.7197V71.8679L117.739 72.2786V72.1304Z",
    fill: "#ECF5FF"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M117.739 72.6893L117.036 72.2786V72.4268L117.739 72.8375V72.6893Z",
    fill: "#FAE468"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M117.739 72.9699L117.036 72.5581V72.7063L117.739 73.1181V72.9699Z",
    fill: "#FAE468"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M123.552 71.0505V71.3353L124.699 72.0053V71.7195L123.552 71.0505Z",
    fill: "#FAE468"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M123.552 71.5046L124.699 72.1736V72.0952L123.552 71.4263V71.5046Z",
    fill: "#FAE468"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M124.912 71.8435V72.1293L126.058 72.7983V72.5136L124.912 71.8435Z",
    fill: "#FAE468"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M124.912 72.2976L126.058 72.9676V72.8882L124.912 72.2192V72.2976Z",
    fill: "#FAE468"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M123.552 71.7864V72.0722L124.699 72.7412V72.4564L123.552 71.7864Z",
    fill: "#FAE468"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M123.552 72.2404L124.699 72.9105V72.8311L123.552 72.1621V72.2404Z",
    fill: "#FAE468"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M124.912 72.5801V72.8648L126.058 73.5338V73.2491L124.912 72.5801Z",
    fill: "#FAE468"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M124.912 73.0332L126.058 73.7032V73.6238L124.912 72.9548V73.0332Z",
    fill: "#FAE468"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M123.552 72.522V72.8078L124.699 73.4768V73.192L123.552 72.522Z",
    fill: "#FAE468"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M123.552 72.976L124.699 73.6461V73.5667L123.552 72.8977V72.976Z",
    fill: "#FAE468"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M124.912 73.3159V73.6007L126.058 74.2696V73.9849L124.912 73.3159Z",
    fill: "#FAE468"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M124.912 73.7701L126.058 74.439V74.3607L124.912 73.6907V73.7701Z",
    fill: "#FAE468"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M123.552 73.2588V73.5435L124.699 74.2125V73.9278L123.552 73.2588Z",
    fill: "#FAE468"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M123.552 73.7119L124.699 74.3819V74.3025L123.552 73.6335V73.7119Z",
    fill: "#FAE468"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M124.912 74.0515V74.3363L126.058 75.0063V74.7205L124.912 74.0515Z",
    fill: "#FAE468"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M124.912 74.5057L126.058 75.1746V75.0963L124.912 74.4263V74.5057Z",
    fill: "#FAE468"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M109.917 95.8699C109.659 96.0308 109.42 96.2319 109.217 96.4584C108.755 96.975 108.306 96.7114 108.306 96.7114L106.385 97.3741C106.231 97.7191 106.9 99.8425 106.9 99.8425C107.468 99.9495 108.128 99.7547 108.652 99.5557C109.876 99.091 110.84 98.1383 111.552 97.0279C111.603 96.9496 111.645 96.8681 111.682 96.7845C111.127 95.3163 110.151 95.7418 109.917 95.8688V95.8699Z",
    fill: "#5A74B7"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M111.538 96.5048C110.791 97.6692 109.779 98.6695 108.495 99.1575C107.984 99.3512 107.352 99.5385 106.788 99.475C106.853 99.6963 106.899 99.8434 106.899 99.8434C107.467 99.9503 108.127 99.7555 108.651 99.5565C109.875 99.0918 110.839 98.1392 111.551 97.0288C111.602 96.9505 111.644 96.8689 111.681 96.7853C111.64 96.6742 111.594 96.5768 111.548 96.4868C111.544 96.4932 111.542 96.4995 111.538 96.5059V96.5048Z",
    fill: "#59559D"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M102.394 86.5189C102.394 86.5189 105.911 85.5694 106.667 88.7365L108.648 96.9835C108.648 96.9835 107.15 97.7541 106.081 97.3973L103.91 89.8575C103.91 89.8575 101.922 87.5912 102.395 86.52L102.394 86.5189Z",
    fill: "#328DCC"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M107.198 108.059C107.683 108.059 108.076 107.631 108.076 107.104C108.076 106.577 107.683 106.149 107.198 106.149C106.713 106.149 106.32 106.577 106.32 107.104C106.32 107.631 106.713 108.059 107.198 108.059Z",
    fill: "#3E4577"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9966 107.879C94.4816 107.879 94.8748 107.451 94.8748 106.924C94.8748 106.397 94.4816 105.969 93.9966 105.969C93.5116 105.969 93.1184 106.397 93.1184 106.924C93.1184 107.451 93.5116 107.879 93.9966 107.879Z",
    fill: "#3E4577"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5023 99.8732C94.5023 100.4 94.1088 100.828 93.6241 100.828C93.1393 100.828 92.7458 100.4 92.7458 99.8732C92.7458 99.3461 93.1393 98.9185 93.6241 98.9185C94.1088 98.9185 94.5023 99.3461 94.5023 99.8732Z",
    fill: "#3E4577"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M108.8 99.5004C108.8 100.028 108.407 100.455 107.922 100.455C107.437 100.455 107.044 100.028 107.044 99.5004C107.044 98.9733 107.437 98.5457 107.922 98.5457C108.407 98.5457 108.8 98.9733 108.8 99.5004Z",
    fill: "#3E4577"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M101.356 102.108L107.42 106.427L108.313 105.992L102.473 101.132L102.474 100.557L108.149 98.9182L107.861 98.5457L101.356 99.7259H99.7957L93.7825 98.6494L93.2694 99.0008L98.8514 100.554V101.132L93.1194 106.044L93.6524 106.437L99.9184 102.086L101.356 102.108Z",
    fill: "#8088C0"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6929 100.958C99.6929 100.958 100.586 101.61 101.832 100.958V96.9209H99.6929V100.958Z",
    fill: "#6F79B2"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M108.149 98.9185L108.009 99.5186L102.473 101.132L102.474 100.557L108.149 98.9185Z",
    fill: "#5F65A6"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2693 99.001L98.8512 100.554V101.132L93.4214 99.6403L93.2693 99.001Z",
    fill: "#5F65A6"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6523 106.437L94.1297 106.924L100.01 102.98L99.9184 102.086L93.6523 106.437Z",
    fill: "#5F65A6"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M101.356 102.108V102.948L107.045 107.033L107.421 106.428L101.356 102.108Z",
    fill: "#5F65A6"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M100.01 102.98L101.356 102.948V102.108L99.9185 102.086L100.01 102.98Z",
    fill: "#5F65A6"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1194 106.044L93.5915 106.603L94.1298 106.924L93.6524 106.437L93.1194 106.044Z",
    fill: "#5F65A6"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M107.045 107.033L108 106.582L108.313 105.992L107.421 106.427L107.045 107.033Z",
    fill: "#5F65A6"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M92.875 92.8667L101.483 97.8703L101.482 99.9175L92.875 94.8652V92.8667Z",
    fill: "#F9CB69"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M101.483 97.8705L110.318 92.6572V94.7044L101.482 99.9176L101.483 97.8705Z",
    fill: "#F7BD67"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M92.875 92.8668L101.743 87.6631L110.319 92.6572L101.483 97.8704L92.875 92.8668Z",
    fill: "#FAE468"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M116.316 101.043C116.024 101.128 115.742 101.259 115.487 101.423C114.906 101.797 114.543 101.423 114.543 101.423L112.516 101.548C112.277 101.839 112.364 104.066 112.364 104.066C112.882 104.321 113.57 104.31 114.128 104.259C115.431 104.138 116.611 103.477 117.589 102.598C117.657 102.536 117.72 102.469 117.778 102.399C117.629 100.835 116.574 100.983 116.316 101.044V101.043Z",
    fill: "#5A74B7"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M117.713 102.091C116.686 103.014 115.447 103.706 114.081 103.833C113.538 103.884 112.879 103.895 112.352 103.682C112.356 103.913 112.363 104.066 112.363 104.066C112.881 104.321 113.569 104.311 114.127 104.259C115.429 104.138 116.61 103.477 117.588 102.598C117.656 102.536 117.719 102.469 117.777 102.399C117.765 102.28 117.747 102.174 117.726 102.075C117.721 102.079 117.717 102.086 117.712 102.09L117.713 102.091Z",
    fill: "#59559D"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M99.693 88.3744L103.233 88.965L107.41 89.6351L112.154 90.702C113.062 90.8153 113.779 91.534 113.898 92.4497L115.062 101.45C113.891 102.592 111.939 101.766 111.939 101.766L110.806 94.0459C110.806 94.0459 105.262 93.3632 102.451 92.4306C99.65 91.5012 99.6919 88.3733 99.6919 88.3733L99.693 88.3744Z",
    fill: "#328DCC"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1698 89.1618C93.1698 89.1618 100.585 84.8399 100.587 84.8388C100.809 84.7097 101.077 84.6705 101.327 84.7308C101.58 84.7933 101.804 84.9828 101.991 85.1606C102.163 85.3247 102.364 85.7068 102.109 85.8952C101.612 86.2625 101.013 86.5377 100.48 86.85C99.9122 87.1824 99.3445 87.5148 98.7779 87.8471C97.6699 88.496 96.5641 89.1502 95.4582 89.8033C95.0762 90.0288 94.5726 90.4733 94.1025 90.4384C93.7857 90.4151 93.1068 90.0753 92.9725 89.7662C92.877 89.545 92.9641 89.2814 93.1698 89.1608V89.1618Z",
    fill: "#8088C0"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9127 89.5375C96.1267 88.8209 97.3406 88.1032 98.5567 87.3908C99.18 87.0256 99.8021 86.6615 100.425 86.2963C100.976 85.9734 101.59 85.6855 102.115 85.3171C102.233 85.5034 102.3 85.7543 102.107 85.8962C101.61 86.2635 101.011 86.5387 100.478 86.8509C99.9102 87.1833 99.3426 87.5157 98.776 87.8481C97.668 88.497 96.5632 89.1511 95.4562 89.8042C95.0743 90.0297 94.5707 90.4743 94.1017 90.4393C93.9537 90.4288 93.7281 90.3483 93.5151 90.2361C94.0041 90.216 94.5172 89.7704 94.9127 89.5375Z",
    fill: "#6F79B2"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M107.745 80.7604C107.729 80.7689 107.712 80.7805 107.696 80.789C107.696 80.789 107.389 80.6736 107.013 79.7537C107.032 79.741 107.031 79.6796 107.05 79.668C107.711 78.8699 108.006 78.6931 108.543 78.4983C109.08 78.3036 109.288 78.275 109.663 78.6C110.037 78.9249 109.669 79.2785 109.669 79.2785C108.841 79.6511 108.487 80.0618 108.487 80.0618C108.487 80.0618 108.663 80.2026 109.053 80.0311C109.443 79.8596 109.461 80.1422 109.461 80.1422C109.461 80.1422 109.431 80.319 108.932 80.4905C108.435 80.6609 107.746 80.7604 107.745 80.7615V80.7604Z",
    fill: "#F9B9A8"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M112.639 82.3959C112.625 82.4065 112.608 82.4181 112.594 82.4287H112.595C112.595 82.4287 112.573 82.759 113.253 83.4798C113.272 83.4671 113.328 83.4936 113.345 83.4809C114.337 83.1972 114.617 82.9971 115.012 82.5822C115.406 82.1662 115.517 81.9862 115.376 81.5099C115.234 81.0325 114.764 81.2273 114.764 81.2273C114.089 81.838 113.573 81.9979 113.573 81.9979C113.573 81.9979 113.518 81.7788 113.831 81.4877C114.145 81.1976 113.897 81.0664 113.897 81.0664C113.897 81.0664 113.725 81.023 113.368 81.4115C113.011 81.7999 112.639 82.3948 112.639 82.3959Z",
    fill: "#F9B9A8"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M103.377 76.3411L103.094 77.9934L105.776 78.3523L105.556 76.9783L103.377 76.3411Z",
    fill: "#F6A3A8"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M106.073 78.1068C106.073 78.1068 104.744 78.0972 103.778 77.713C102.731 77.297 101.961 77.767 101.505 78.3058C101.124 78.7556 99.5566 88.9439 99.5566 88.9439C99.5566 88.9439 104.667 90.9551 107.44 89.9696L107.093 81.0643C107.093 81.0643 106.904 78.6498 106.074 78.1078L106.073 78.1068Z",
    fill: "#5E6280"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M106.065 78.1077C106.065 78.1077 107.921 78.3067 108.426 80.5613L109.471 84.173L112.715 82.038C112.715 82.038 113.391 82.2486 113.339 83.6723L109.459 86.6817C109.004 86.9919 108.343 86.6637 108.088 86.1461L106.065 82.038C106.065 82.038 104.966 80.2427 106.065 78.1087V78.1077Z",
    fill: "#5E6280"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3967 83.6946L99.0078 88.6495L101.486 97.8703L92.875 92.8667L90.3967 83.6946Z",
    fill: "#F9CB69"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0078 88.6496L100.534 87.7615L103.014 96.9823L101.486 97.8704L99.0078 88.6496Z",
    fill: "#F7BD67"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3967 83.6946L91.9339 82.8022L100.534 87.7614L99.0078 88.6495L90.3967 83.6946Z",
    fill: "#FAE468"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M101.489 94.0026C101.489 94.0026 108.904 89.6807 108.906 89.6796C109.129 89.5505 109.396 89.5113 109.646 89.5717C109.9 89.6341 110.123 89.8236 110.31 90.0014C110.482 90.1655 110.684 90.5476 110.429 90.736C109.931 91.1033 109.332 91.3786 108.799 91.6908C108.232 92.0232 107.664 92.3556 107.098 92.6879C105.99 93.3368 104.884 93.991 103.778 94.6441C103.396 94.8696 102.892 95.3141 102.422 95.2792C102.105 95.2559 101.426 94.9161 101.292 94.607C101.197 94.3858 101.284 94.1222 101.489 94.0016V94.0026Z",
    fill: "#8088C0"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M103.232 94.3786C104.446 93.6619 105.66 92.9443 106.876 92.2319C107.499 91.8667 108.121 91.5025 108.745 91.1373C109.296 90.8145 109.909 90.5266 110.434 90.1582C110.553 90.3445 110.62 90.5954 110.427 90.7372C109.929 91.1045 109.33 91.3798 108.797 91.692C108.23 92.0244 107.662 92.3568 107.095 92.6892C105.987 93.338 104.883 93.9922 103.776 94.6453C103.394 94.8708 102.89 95.3154 102.421 95.2804C102.273 95.2698 102.047 95.1894 101.834 95.0772C102.323 95.0571 102.836 94.6114 103.232 94.3786Z",
    fill: "#6F79B2"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M102.579 74.9003C102.818 76.5781 104.206 77.7647 105.679 77.552C107.153 77.3392 108.154 75.8064 107.916 74.1287C107.678 72.4509 106.29 71.2643 104.816 71.4771C103.342 71.6898 102.341 73.2226 102.579 74.9003Z",
    fill: "#F9B9A8"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M107.277 70.8707C105.391 70.225 104.324 70.4314 102.995 71.1914C102.775 71.2655 102.593 71.3766 102.5 71.4888C101.827 71.98 101.46 73.1888 101.531 73.9118C101.633 74.947 102.279 76.1982 103.18 76.8132C103.677 77.153 103.701 77.1932 104.355 77.3636C107.852 76.5761 105.811 73.6895 105.811 73.6895C106.108 73.4947 106.687 73.2269 107.584 73.2788C107.584 73.2788 109.39 71.5958 107.277 70.8728V70.8707Z",
    fill: "#B74E52"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M101.44 49.8536L91.9033 44.2731C87.9823 41.9898 84.7936 43.8222 84.781 48.3675C84.7685 52.9128 87.9361 58.4488 91.8571 60.7331L93.8601 61.906C95.3311 67.3786 99.9624 71.438 99.9624 71.438C98.6603 68.726 98.3865 65.9675 98.3414 64.5279L101.394 66.3137C105.314 68.5969 108.503 66.7635 108.516 62.2182C108.528 57.6729 105.361 52.1369 101.44 49.8536Z",
    fill: "#17BED0"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M100.343 53.4495C101.95 56.2556 101.94 59.2841 100.325 60.2134C99.5156 60.6771 98.459 60.5299 97.4035 59.9149C96.5945 59.4439 95.7845 58.6976 95.0899 57.7418L92.7186 59.1052C92.6399 59.1507 92.5382 59.1359 92.4364 59.0766C92.3346 59.0173 92.2328 58.9125 92.1552 58.777L91.6211 57.8434C91.4669 57.5735 91.4679 57.2803 91.6232 57.1914L93.9956 55.8269C92.9096 53.3309 93.0817 50.872 94.5097 50.0516C95.3176 49.5869 96.3752 49.7351 97.4307 50.3501C98.4863 50.9651 99.5408 52.0469 100.344 53.4505L100.343 53.4495ZM99.3404 58.4944C100.411 57.8794 100.416 55.8756 99.3529 54.0179C98.821 53.0896 98.1232 52.374 97.4245 51.9665C96.7257 51.56 96.0258 51.4616 95.4907 51.7685C94.4205 52.3835 94.4152 54.3873 95.4781 56.245C96.0101 57.1734 96.7078 57.89 97.4066 58.2975C98.1054 58.705 98.8052 58.8024 99.3404 58.4944Z",
    fill: "white"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8435 20.087C63.8992 20.0553 63.9443 20.0807 63.9443 20.1452L63.9474 21.1974C63.9474 21.262 63.9033 21.3393 63.8477 21.3721L63.3724 21.6484C63.3242 21.6769 63.2832 21.7415 63.2738 21.8018C63.1888 22.3893 63.0094 22.9937 62.7565 23.578C62.7292 23.6405 62.7345 23.6998 62.7681 23.7188L63.1028 23.9104C63.1416 23.9326 63.1427 24.0057 63.1028 24.0745L62.4627 25.1934C62.4428 25.2272 62.4176 25.2537 62.3924 25.2685C62.3673 25.2833 62.341 25.2865 62.3222 25.2759L61.9916 25.0854C61.9728 25.0748 61.9465 25.078 61.9213 25.0928C61.9014 25.1044 61.8815 25.1235 61.8636 25.1478C61.488 25.6655 61.0578 26.1291 60.593 26.5027C60.5458 26.5409 60.5112 26.6086 60.5112 26.6647V27.2024C60.5133 27.267 60.4682 27.3443 60.4125 27.3771L59.505 27.9053C59.4493 27.937 59.4042 27.9116 59.4042 27.8471V27.3093C59.4021 27.2532 59.3675 27.2257 59.3203 27.2427C58.8544 27.411 58.4232 27.4491 58.0455 27.3697C58.0276 27.3654 58.0077 27.3707 57.9878 27.3824C57.9626 27.3972 57.9374 27.4237 57.9175 27.4565L57.589 28.0313C57.5691 28.0651 57.5439 28.0916 57.5188 28.1064C57.4936 28.1212 57.4673 28.1255 57.4474 28.1138L56.8032 27.7433C56.7643 27.7211 56.7633 27.6481 56.8032 27.5793L57.1347 27.0003C57.1683 26.941 57.1736 26.8764 57.1463 26.8457C56.8913 26.5578 56.7087 26.1651 56.6206 25.6771C56.6112 25.6273 56.5702 25.6104 56.522 25.639L56.0467 25.9163C55.9911 25.9481 55.947 25.9227 55.947 25.8581L55.9438 24.8059C55.9438 24.7414 55.9879 24.6641 56.0435 24.6323L56.5251 24.3518C56.5734 24.3232 56.6143 24.2597 56.6238 24.1994C56.7119 23.614 56.8924 23.0149 57.1463 22.4338C57.1736 22.3713 57.1694 22.312 57.1347 22.2919L56.7895 22.0929C56.7507 22.0707 56.7497 21.9966 56.7895 21.9289L57.4296 20.8111C57.4495 20.7772 57.4747 20.7507 57.4999 20.7359C57.525 20.7211 57.5513 20.7169 57.5712 20.7285L57.9196 20.9286C57.9384 20.9402 57.9647 20.937 57.9899 20.9211C58.0098 20.9095 58.0297 20.8915 58.0476 20.8672C58.419 20.358 58.8439 19.9028 59.3014 19.5345C59.3486 19.4964 59.3832 19.4286 59.3832 19.3725L59.3811 18.8009C59.3811 18.7364 59.4252 18.6591 59.4808 18.6263L60.3884 18.0981C60.444 18.0663 60.4891 18.0917 60.4891 18.1563L60.4912 18.7279C60.4912 18.784 60.5269 18.8115 60.5741 18.7946C61.0326 18.6284 61.4586 18.5892 61.8311 18.6644C61.8489 18.6675 61.8689 18.6633 61.8888 18.6517C61.914 18.6369 61.9402 18.6104 61.9591 18.5765L62.3054 17.9721C62.3253 17.9382 62.3505 17.9118 62.3757 17.8969C62.4008 17.8821 62.4271 17.8789 62.446 17.8895L63.0902 18.259C63.129 18.2812 63.1301 18.3553 63.0902 18.423L62.746 19.0232C62.7125 19.0835 62.7072 19.1481 62.7356 19.1778C62.9926 19.4614 63.1762 19.8489 63.2665 20.3294C63.2759 20.3792 63.3168 20.3951 63.3651 20.3675L63.8467 20.087H63.8435ZM59.9488 24.7308C60.7651 24.2555 61.424 23.1038 61.4209 22.1575C61.4177 21.2122 60.7546 20.8312 59.9393 21.3065C59.1241 21.7817 58.4652 22.9334 58.4673 23.8787C58.4704 24.8239 59.1335 25.2061 59.9488 24.7308Z",
    fill: "#F7BD67"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5349 22.2867L92.1414 21.9342C92.3376 21.8114 92.5967 21.7881 92.8255 21.9215L101.12 26.7473C101.56 27.0035 101.832 27.4777 101.832 27.9911V33.9707C101.832 34.1495 101.732 34.2935 101.595 34.3665L100.984 34.7222L100.888 34.466L101.064 34.3009L92.3061 29.2052C92.0102 29.0326 91.8276 28.714 91.8276 28.3689V22.5016C91.8276 22.492 91.8287 22.4836 91.8297 22.474L91.5349 22.2846V22.2867Z",
    fill: "#27D9FF"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M101.831 27.9211L100.883 28.4747V34.1961L101.065 34.3019L100.889 34.467L100.985 34.7232L101.596 34.3686C101.733 34.2945 101.833 34.1505 101.833 33.9717V27.9921C101.833 27.9688 101.832 27.9444 101.831 27.9211Z",
    fill: "#039AED"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2117 22.2803L100.506 27.1061C100.947 27.3623 101.218 27.8365 101.218 28.3499V34.3295C101.218 34.6756 100.847 34.8915 100.55 34.719L91.6923 29.565C91.3964 29.3925 91.2139 29.0739 91.2139 28.7288V22.8614C91.2139 22.3449 91.7679 22.0209 92.2117 22.2792V22.2803Z",
    fill: "#0FBCFF"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M100.051 29.5756L95.5461 26.9494V26.3926L100.051 29.0188V29.5756Z",
    fill: "white"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3018 26.2305L92.3701 25.1042V24.5464L94.3018 25.6737V26.2305Z",
    fill: "white"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3018 27.124L92.3701 25.9977V25.4409L94.3018 26.5672V27.124Z",
    fill: "white"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3018 29.8062L92.3701 28.6799V28.1221L94.3018 29.2483V29.8062Z",
    fill: "white"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M94.008 27.8469L92.3701 26.8921V26.3342L94.008 27.289V27.8469Z",
    fill: "white"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1997 29.7268L100.051 30.8065V31.3633L98.1997 30.2846V29.7268Z",
    fill: "#FAE468"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8933 30.1057L95.5461 28.737V28.1792L97.8933 29.5479V30.1057Z",
    fill: "white"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8933 29.2113L95.5461 27.8427V27.2859L97.8933 28.6546V29.2113Z",
    fill: "#FAE468"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1997 28.8335L100.051 29.9121V30.47L98.1997 29.3903V28.8335Z",
    fill: "white"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7434 26.1956L100.051 28.1252V28.682L96.7434 26.7534V26.1956Z",
    fill: "white"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4369 26.5746L95.5461 26.0559V25.498L96.4369 26.0178V26.5746Z",
    fill: "#FAE468"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4369 31.0426L95.5461 30.5239V29.9661L96.4369 30.4858V31.0426Z",
    fill: "white"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M100.051 33.1511L98.1997 32.0714V31.5146L100.051 32.5943V33.1511Z",
    fill: "white"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M100.051 32.2577L96.7434 30.3291V29.7712L100.051 31.6999V32.2577Z",
    fill: "white"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5033 28.4461L92.3701 27.7855V27.2288L93.5033 27.8893V28.4461Z",
    fill: "#FAE468"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3365 24.2162V24.774L92.3701 24.2109V23.6531L93.3365 24.2162Z",
    fill: "white"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5349 12.8711L92.1414 12.5187C92.3376 12.3959 92.5967 12.3726 92.8255 12.506L101.12 17.3318C101.56 17.5879 101.832 18.0621 101.832 18.5755V24.5551C101.832 24.734 101.732 24.878 101.595 24.951L100.984 25.3067L100.888 25.0505L101.064 24.8854L92.3061 19.7897C92.0102 19.6171 91.8276 19.2985 91.8276 18.9534V13.086C91.8276 13.0765 91.8287 13.068 91.8297 13.0585L91.5349 12.869V12.8711Z",
    fill: "#27D9FF"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M101.831 18.5056L100.883 19.0592V24.7805L101.065 24.8864L100.889 25.0515L100.985 25.3077L101.596 24.9531C101.733 24.879 101.833 24.735 101.833 24.5561V18.5765C101.833 18.5532 101.832 18.5289 101.831 18.5056Z",
    fill: "#039AED"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2117 12.8638L100.506 17.6896C100.947 17.9458 101.218 18.42 101.218 18.9334V24.913C101.218 25.2591 100.847 25.475 100.55 25.3025L91.6923 20.1485C91.3964 19.976 91.2139 19.6574 91.2139 19.3123V13.4449C91.2139 12.9283 91.7679 12.6044 92.2117 12.8627V12.8638Z",
    fill: "#0FBCFF"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M100.051 20.1601L95.5461 17.5339V16.9761L100.051 19.6033V20.1601Z",
    fill: "white"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3018 16.8152L92.3701 15.6889V15.1311L94.3018 16.2574V16.8152Z",
    fill: "white"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3018 17.7087L92.3701 16.5824V16.0256L94.3018 17.1519V17.7087Z",
    fill: "white"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3018 20.3898L92.3701 19.2636V18.7068L94.3018 19.8331V20.3898Z",
    fill: "white"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M94.008 18.4305L92.3701 17.4757V16.9189L94.008 17.8737V18.4305Z",
    fill: "white"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1997 20.3115L100.051 21.3902V21.948L98.1997 20.8683V20.3115Z",
    fill: "#FAE468"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8933 20.6904L95.5461 19.3218V18.7639L97.8933 20.1326V20.6904Z",
    fill: "white"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8933 19.7961L95.5461 18.4274V17.8706L97.8933 19.2393V19.7961Z",
    fill: "#FAE468"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1997 19.417L100.051 20.4967V21.0535L98.1997 19.9748V19.417Z",
    fill: "white"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7434 16.7803L100.051 18.7089V19.2667L96.7434 17.3381V16.7803Z",
    fill: "white"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4369 17.1593L95.5461 16.6395V16.0828L96.4369 16.6014V17.1593Z",
    fill: "#FAE468"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4369 21.6273L95.5461 21.1086V20.5508L96.4369 21.0705V21.6273Z",
    fill: "white"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M100.051 23.7358L98.1997 22.6561V22.0994L100.051 23.178V23.7358Z",
    fill: "white"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M100.051 22.8414L96.7434 20.9127V20.356L100.051 22.2846V22.8414Z",
    fill: "white"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5033 19.0306L92.3701 18.3701V17.8123L93.5033 18.4738V19.0306Z",
    fill: "#FAE468"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3365 14.8009V15.3577L92.3701 14.7946V14.2378L93.3365 14.8009Z",
    fill: "white"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5349 3.4544L92.1414 3.10191C92.3376 2.97912 92.5967 2.95583 92.8255 3.0892L101.12 7.91502C101.56 8.17118 101.832 8.6454 101.832 9.15878V15.1384C101.832 15.3173 101.732 15.4612 101.595 15.5343L100.984 15.8899L100.888 15.6338L101.064 15.4686L92.3061 10.3729C92.0102 10.2004 91.8276 9.88175 91.8276 9.53667V3.67245C91.8276 3.66292 91.8287 3.65446 91.8297 3.64493L91.5349 3.45545V3.4544Z",
    fill: "#27D9FF"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M101.831 9.09009L100.883 9.6437V15.3661L101.065 15.4719L100.889 15.6371L100.985 15.8932L101.596 15.5386C101.733 15.4645 101.833 15.3206 101.833 15.1417V9.16207C101.833 9.13878 101.832 9.11443 101.831 9.09115V9.09009Z",
    fill: "#039AED"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2117 3.44792L100.506 8.27374C100.947 8.5299 101.218 9.00412 101.218 9.5175V15.4971C101.218 15.8432 100.847 16.0592 100.55 15.8866L91.6923 10.7327C91.3964 10.5601 91.2139 10.2415 91.2139 9.89645V4.03011C91.2139 3.51355 91.7679 3.18964 92.2117 3.44792Z",
    fill: "#0FBCFF"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M100.051 10.7446L95.5461 8.11733V7.56055L100.051 10.1867V10.7446Z",
    fill: "white"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3018 7.39863L92.3701 6.27236V5.71558L94.3018 6.84185V7.39863Z",
    fill: "white"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3018 8.293L92.3701 7.16673V6.60889L94.3018 7.73516V8.293Z",
    fill: "white"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3018 10.9744L92.3701 9.84813V9.29028L94.3018 10.4166V10.9744Z",
    fill: "white"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M94.008 9.01499L92.3701 8.0602V7.50342L94.008 8.45821V9.01499Z",
    fill: "white"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1997 10.895L100.051 11.9747V12.5315L98.1997 11.4529V10.895Z",
    fill: "#FAE468"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8933 11.2738L95.5461 9.90517V9.34839L97.8933 10.7171V11.2738Z",
    fill: "white"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8933 10.3804L95.5461 9.0117V8.45386L97.8933 9.82253V10.3804Z",
    fill: "#FAE468"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1997 10.0015L100.051 11.0812V11.6379L98.1997 10.5582V10.0015Z",
    fill: "white"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7434 7.36475L100.051 9.29338V9.85016L96.7434 7.92153V7.36475Z",
    fill: "white"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4369 7.74376L95.5461 7.22402V6.66724L96.4369 7.18591V7.74376Z",
    fill: "#FAE468"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4369 12.2118L95.5461 11.692V11.1353L96.4369 11.6539V12.2118Z",
    fill: "white"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M100.051 14.3193L98.1997 13.2407V12.6829L100.051 13.7626V14.3193Z",
    fill: "white"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M100.051 13.4259L96.7434 11.4973V10.9395L100.051 12.8681V13.4259Z",
    fill: "white"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5033 9.61509L92.3701 8.95351V8.39673L93.5033 9.05725V9.61509Z",
    fill: "#FAE468"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3365 5.38418V5.94202L92.3701 5.37889V4.82104L93.3365 5.38418Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.07
  }, _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1936 92.5072C2.1936 94.4168 5.98029 95.9643 10.6515 95.9643C15.3227 95.9643 19.1094 94.4168 19.1094 92.5072C19.1094 90.5976 15.3227 89.05 10.6515 89.05C5.98029 89.05 2.1936 90.5987 2.1936 92.5072Z",
    fill: "#2B778F"
  }))), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82718 64.1599C5.12306 61.0987 7.44607 60.3874 7.44607 60.3874L6.78295 57.7241C6.78295 57.7241 3.23968 59.2569 2.94905 64.1515C2.66156 68.9794 6.48077 69.3562 6.48077 69.3562L6.71266 67.669C6.71266 67.669 4.58376 66.6835 4.82718 64.161V64.1599Z",
    fill: "#9E527F"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2072 58.828C17.2072 58.828 17.1085 59.2927 17.2072 59.6039C17.2963 59.8866 17.2869 60.2719 17.2701 60.329C17.2533 60.3862 17.7381 60.4148 17.7381 60.4148L18.2071 60.0676L18.7726 58.8492C18.7726 58.8492 18.8639 58.3676 18.8534 58.3454C18.8429 58.3242 18.4736 58.0913 18.4736 58.0913L17.2082 58.828H17.2072Z",
    fill: "#F7B378"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3633 55.5341L17.9132 55.1911C17.8272 55.171 17.7412 55.2229 17.7244 55.3054L17.0602 58.6715C17.0455 58.7488 17.0948 58.8239 17.1735 58.8462L18.6015 59.2463C18.6928 59.2717 18.7862 59.2177 18.803 59.1299L19.4787 55.7045C19.4934 55.6272 19.443 55.5521 19.3622 55.5341H19.3633Z",
    fill: "#E6E7E8"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0864 58.5464L18.8397 58.9507L19.4556 55.8281L17.6981 55.4438L17.0864 58.5464Z",
    fill: "#5E617F"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8576 60.3628C17.8576 60.3628 17.7201 59.3848 18.421 58.8491C18.634 58.6872 18.7998 58.4585 18.9079 58.2257C18.9866 58.0574 19.1733 57.8086 19.315 58.0859C19.4682 58.3887 18.9897 58.919 18.8753 59.1593C18.761 59.3996 18.5994 60.4094 18.5994 60.4094L17.8576 60.3628Z",
    fill: "#F7CA82"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2008 56.9597C17.2008 56.9597 16.5492 58.2215 16.9563 59.0122C16.9563 59.0122 17.3152 59.3689 17.568 59.0323C17.8199 58.6957 17.8964 57.5991 17.8199 57.3387C17.7433 57.0783 17.4211 56.8846 17.2019 56.9597H17.2008Z",
    fill: "#F7CA82"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1716 91.2709C14.8788 91.3576 14.5966 91.4868 14.3406 91.6519C13.7582 92.0266 13.3942 91.6519 13.3942 91.6519L11.3639 91.7768C11.1236 92.069 11.2107 94.2993 11.2107 94.2993C11.7301 94.5555 12.4194 94.5438 12.9787 94.4919C14.2829 94.3713 15.4664 93.7097 16.4464 92.8279C16.5156 92.7666 16.5775 92.6988 16.6363 92.6279C16.4862 91.0613 15.4307 91.2095 15.1716 91.2698V91.2709Z",
    fill: "#B54D50"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5702 92.3198C15.5419 93.245 14.3007 93.9383 12.9325 94.0653C12.3879 94.1161 11.728 94.1267 11.2002 93.914C11.2044 94.1447 11.2107 94.2993 11.2107 94.2993C11.7301 94.5554 12.4194 94.5438 12.9786 94.4919C14.2828 94.3712 15.4664 93.7097 16.4464 92.8279C16.5156 92.7665 16.5775 92.6988 16.6363 92.6279C16.6247 92.5093 16.6069 92.4035 16.5859 92.304C16.5807 92.3092 16.5765 92.3145 16.5712 92.3188L16.5702 92.3198Z",
    fill: "#913A40"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80169 90.4474C9.50895 90.5342 9.2267 90.6633 8.97069 90.8284C8.38836 91.2031 8.02428 90.8284 8.02428 90.8284L5.99401 90.9533C5.75373 91.2455 5.84082 93.4758 5.84082 93.4758C6.36019 93.732 7.04954 93.7203 7.60878 93.6685C8.91298 93.5478 10.0965 92.8862 11.0765 92.0044C11.1458 91.9431 11.2077 91.8753 11.2654 91.8044C11.1153 90.2378 10.0598 90.386 9.80169 90.4463V90.4474Z",
    fill: "#B54D50"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2013 91.4963C10.173 92.4215 8.93179 93.1148 7.56359 93.2419C7.01903 93.2927 6.35906 93.3032 5.8313 93.0905C5.8355 93.3212 5.84179 93.4758 5.84179 93.4758C6.36116 93.732 7.05051 93.7203 7.60975 93.6684C8.91395 93.5478 10.0975 92.8862 11.0775 92.0044C11.1467 91.943 11.2086 91.8753 11.2663 91.8044C11.2548 91.6858 11.237 91.58 11.216 91.4805C11.2107 91.4858 11.2065 91.491 11.2013 91.4953V91.4963Z",
    fill: "#913A40"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2478 56.8147L8.54164 56.9015L8.4538 57.2889L8.2478 56.8147Z",
    fill: "#BEC2C6"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15763 69.3551C6.15763 69.3551 6.30872 72.5857 6.39476 74.672L5.42946 90.7044C5.42527 90.7965 5.47143 90.8833 5.55327 90.9363C5.91946 91.1723 7.05473 91.5925 8.90873 91.3745C9.07975 91.3544 9.20881 91.2199 9.21615 91.0612L10.1374 69.5265L6.15658 69.354L6.15763 69.3551Z",
    fill: "#6C8CF4"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7603 70.5672L9.67139 69.1287C9.67139 69.1287 9.55912 71.1039 10.1855 73.5713L10.8518 91.8308C10.8623 91.9504 10.9473 92.0531 11.0711 92.0912C11.5653 92.2415 12.9072 92.5506 14.4989 92.0796C14.608 92.0478 14.6794 91.9494 14.6752 91.8446L13.7613 70.5672H13.7603Z",
    fill: "#6C8CF4"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9429 72.555C13.9334 72.4904 13.9229 72.4269 13.9145 72.3676C13.8044 71.5949 13.7561 68.9369 13.7131 68.1579C13.6281 66.6092 13.7414 65.0828 13.7383 63.5374C13.7341 62.066 13.6438 60.5873 13.6438 59.1149C13.6438 59.1043 13.648 58.972 13.6386 58.9688L11.4793 58.0775L8.24867 57.3884L7.05989 57.6626C6.54681 57.6933 6.12292 58.0394 6.02849 58.5041C5.85956 59.3393 5.67175 60.6857 5.91727 61.7855C6.07885 62.5117 6.06731 64.0211 6.2184 65.3284C6.23309 65.4639 5.94245 70.9513 5.83228 72.0024C5.83228 72.0024 5.805 72.2152 6.08515 72.4301C6.89621 73.116 8.0063 73.3795 9.03035 73.5172C10.5108 73.7172 12.0417 73.6653 13.5221 73.4886C14.0436 73.4261 14.0037 72.9551 13.9439 72.555H13.9429Z",
    fill: "#9E527F"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46695 56.3447C8.56768 56.4442 8.45646 56.5014 8.57083 56.5808C9.24863 57.0508 10.2779 57.2244 11.1047 57.4266C11.2369 57.4583 11.3796 57.4869 11.5255 57.5102L11.4772 58.0776C10.599 58.2988 9.7785 58.2363 9.17099 58.0818C8.71877 57.9664 8.34839 57.8246 8.34839 57.3885L8.3977 56.3098L8.4659 56.3447H8.46695Z",
    fill: "#F9A4A9"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24779 56.8147L7.9519 57.454C7.9519 57.454 9.41769 59.1434 11.9023 58.2522L11.5266 57.87C11.5266 57.87 9.24666 58.177 8.24674 56.8147H8.24779Z",
    fill: "#9E527F"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62235 51.5475C10.1605 50.9304 11.9264 51.5221 12.6934 52.877C13.4006 54.1282 13.389 55.844 12.6136 57.073C12.1667 57.7811 10.7775 57.562 10.0682 57.4255C9.08401 57.2371 8.08409 56.8009 7.55423 55.9785C6.9719 55.0734 6.83445 53.8508 7.23421 52.8622C7.48813 52.2355 8.00225 51.7952 8.62235 51.5464V51.5475Z",
    fill: "#F9BAA9"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M10.255 51.3252C9.71775 51.2669 9.15641 51.3326 8.62235 51.5464C8.00225 51.7951 7.48813 52.2344 7.23421 52.8621C6.83445 53.8497 6.9719 55.0734 7.55423 55.9784C8.08304 56.8009 9.08401 57.2359 10.0682 57.4254C10.3767 57.4847 10.8142 57.5556 11.2465 57.563L11.4647 56.5987C11.1069 56.5987 10.8866 56.1975 10.8205 55.735C10.7544 55.2724 11.0146 55.121 11.2402 55.1083C11.4658 55.0967 11.5182 56.0388 11.5182 56.0388L11.8487 55.9414C11.8026 55.2904 11.9096 54.3991 11.9096 54.3991C11.9096 54.3991 12.7448 54.4891 13.4856 53.7957C13.4856 53.7957 13.4415 51.539 10.2529 51.3252H10.255Z",
    fill: "#5E617F"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8207 60.1025L17.1273 59.7034C16.9625 59.7468 16.9909 59.8326 16.9972 59.8929C17.2249 61.9073 16.5082 63.0992 16.2784 63.2844C15.2554 64.1111 13.6312 58.9635 13.6312 58.9635C13.6312 58.9635 13.0143 58.846 12.4834 60.1247C12.4834 60.1247 12.283 60.6773 12.4834 61.6956C12.838 63.3257 13.6616 65.3316 15.6311 65.755C16.355 65.9106 17.0381 65.7561 17.5249 65.2268C17.7558 64.9759 17.9226 64.6817 18.0705 64.3832C18.6298 63.2548 18.9404 62.0184 18.8889 60.7747C18.8868 60.7238 18.8826 60.1173 18.8197 60.1025H18.8207Z",
    fill: "#9E527F"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M164.13 75.2412L167.968 75.1279L174.274 78.2283C174.87 78.5216 175.285 79.0932 175.383 79.7547L176.712 88.7829C176.712 88.7829 176.458 89.3174 175.198 89.2508L171.122 81.0917L164.836 78.8518L163.432 76.9793L164.13 75.2401V75.2412Z",
    fill: "#3E596D"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M176.792 87.6846C176.792 87.6846 175.698 88.1842 175.828 88.5102C175.957 88.8362 176.172 89.1485 175.828 89.2724C175.482 89.3962 174.913 89.1231 174.895 89.2925C174.878 89.4608 174.991 90.423 175.043 90.8125C175.094 91.2021 176.026 91.3471 177.019 91.6667C178.013 91.9864 179.762 92.5718 180.296 91.7864C180.83 91.0009 180.038 90.6029 179.624 90.405C179.209 90.207 177.661 89.1432 177.336 88.6076C177.012 88.072 176.928 87.6189 176.793 87.6846H176.792Z",
    fill: "#9264E9"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M176.737 91.2611C177.829 91.6125 179.708 92.2402 180.429 91.53C180.4 91.6104 180.357 91.6962 180.295 91.7861C179.761 92.5715 178.012 91.9851 177.018 91.6665C176.025 91.3468 175.093 91.2018 175.042 90.8123C175.039 90.7911 175.035 90.7678 175.032 90.7424C175.467 90.9086 176.09 91.0536 176.737 91.2611Z",
    fill: "#734BDD"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M176.009 89.0784C176.029 88.926 175.909 88.7206 175.827 88.51C175.697 88.185 176.791 87.6843 176.791 87.6843C176.926 87.6187 177.011 88.0707 177.334 88.6063C177.658 89.1419 179.207 90.2057 179.622 90.4037C179.679 90.4312 179.743 90.4619 179.81 90.4979C179.478 90.8536 179.013 91.0081 179.013 91.0081C177.356 90.8536 176.008 89.0774 176.008 89.0774L176.009 89.0784Z",
    fill: "#A281F2"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M162.735 75.1279C162.735 75.1279 160.581 80.1686 165.552 81.1594L171.07 82.1925C171.07 82.1925 171.021 84.0185 172.38 86.5759C173.875 89.3905 173.954 90.25 173.954 90.25C173.954 90.25 174.898 90.6014 175.833 89.7758C175.833 89.7758 174.7 84.7457 173.856 81.0832C173.856 81.0832 173.519 79.8172 172.017 78.9704L165.179 76.4447L162.734 75.1279H162.735Z",
    fill: "#49657F"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M168.386 68.019L169.593 69.1347L169.375 71.1681C169.375 71.1681 168.767 70.9024 167.948 69.8439C167.059 68.6954 168.387 68.019 168.387 68.019H168.386Z",
    fill: "#F6A3A8"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M169.573 66.0894C169.573 66.0894 170.48 70.6505 170.156 70.9152C169.833 71.1808 169.493 71.4328 168.923 70.8432C168.298 70.1964 168.577 66.572 168.577 66.572L169.574 66.0894H169.573Z",
    fill: "#F6A3A8"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M168.06 60.3457C168.06 60.3457 167.189 63.3053 167.988 67.296C167.988 67.296 165.524 65.6965 164.704 65.0403L168.059 60.3457H168.06Z",
    fill: "#464866"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M167.887 61.4137L167.188 57.6729C167.188 57.6729 171.021 59.2733 167.887 61.4137Z",
    fill: "#464866"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M164.642 64.1108C164.642 64.1108 162.51 64.7692 161.48 65.8066C161.48 65.8066 161.106 68.0951 161.855 70.5953C162.603 73.0956 162.27 76.4638 162.27 76.4638C162.27 76.4638 167.351 77.4726 168.144 75.1163C168.144 75.1163 168.306 71.0219 168.632 69.6067C168.936 68.2941 168.777 67.6325 167.563 65.3461C167.372 64.9852 167.037 64.7216 166.645 64.6221L164.641 64.1119L164.642 64.1108Z",
    fill: "#9264E9"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M166.091 63.4196C166.091 63.4196 165.973 64.1659 165.973 64.6856C165.973 64.6856 164.78 65.7071 163.822 64.4104L164.103 62.7834L166.091 63.4207V63.4196Z",
    fill: "#F6A3A8"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M163.397 61.488C163.397 61.488 163.493 63.5373 165.402 63.84C167.605 64.1893 168.203 61.4562 168.14 60.1182C168.082 58.8681 166.811 57.1903 165.133 57.8646C163.874 58.3695 163.266 59.6017 163.397 61.488Z",
    fill: "#F9B9A8"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M166.556 64.5979L162.666 64.9546C162.666 64.9546 164.047 66.7361 166.604 67.9079C166.604 67.9079 167.532 66.789 166.556 64.5979Z",
    fill: "#F6A3A8"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M163.984 64.3131H165.421L166.555 64.5978L165.016 65.7654L162.667 64.9545C163.038 64.7132 163.985 64.312 163.985 64.312L163.984 64.3131Z",
    fill: "#F6A3A8"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M166.871 60.5998C166.871 60.5998 165.818 60.603 164.956 60.2515C164.956 60.2515 164.21 62.6427 164.258 65.2446C164.258 65.2446 163.289 64.8932 162.361 63.6737C162.361 63.6737 161.887 57.4898 165.606 57.3501C165.606 57.3501 168.917 57.1807 168.395 60.4632C168.395 60.4632 167.484 60.6157 166.873 60.6008L166.871 60.5998Z",
    fill: "#464866"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M165.375 59.0236L167.279 58.8923L168.06 59.7635C168.06 59.7635 167.481 61.6255 164.866 61.7927C162.251 61.96 165.375 59.0236 165.375 59.0236Z",
    fill: "#464866"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M162.604 60.494L164.798 61.4138C164.798 61.4138 164.35 64.1099 165.308 66.2524C166.037 67.8835 166.38 69.6703 165.149 69.8376C163.916 70.0048 164.39 65.9486 162.372 65.125C162.372 65.125 162.082 62.4078 162.603 60.4929L162.604 60.494Z",
    fill: "#464866"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M161.48 65.8067C161.48 65.8067 162.511 65.7665 163.157 67.3882L164.412 70.4293L166.663 67.4824L167.839 67.8539L165.11 72.5643C164.79 73.1603 164.058 73.2069 163.675 72.6501L161.387 69.1834C161.387 69.1834 159.766 66.6948 161.48 65.8078V65.8067Z",
    fill: "#F9B9A8"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M168.162 63.0344L169.65 63.189C169.734 63.1974 169.793 63.2715 169.783 63.3509L169.227 67.2315C169.216 67.3045 169.149 67.3574 169.072 67.3522L167.585 67.2548C167.496 67.2484 167.429 67.1711 167.441 67.0875L168.005 63.1519C168.016 63.0789 168.084 63.0281 168.162 63.0355V63.0344Z",
    fill: "#485083"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M167.785 66.1646C167.785 66.1646 167.976 66.1064 167.943 66.3233C167.909 66.5403 167.362 66.9415 167.413 67.4433C167.462 67.945 166.664 67.4814 166.664 67.4814C166.664 67.4814 167.09 66.4239 167.785 66.1646Z",
    fill: "#F9B9A8"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M168.06 64.7959C168.181 64.5641 168.47 64.5725 168.657 64.5979C168.769 64.6127 169.145 64.7334 169.527 64.871C169.718 64.9398 169.804 65.232 169.842 65.5061C169.886 65.8237 169.816 66.1465 169.656 66.4228C169.448 66.7785 169.16 67.2209 169.12 66.9912C169.058 66.6271 168.341 66.264 168.144 66.1307C167.808 65.902 167.951 65.0055 168.059 64.7969L168.06 64.7959Z",
    fill: "#F9BAA9"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M166.868 67.3447C167.264 67.0695 167.873 67.0028 168.027 66.9901C168.039 66.9933 168.052 66.9933 168.064 66.987C168.198 66.9277 168.441 66.7943 168.763 66.5053C168.995 66.2968 169.297 65.8575 169.483 65.9824C169.668 66.1073 169.812 66.7837 169.761 67.0801C169.709 67.3765 169.243 67.7999 168.674 68.1482C168.283 68.3874 167.384 68.6298 167.384 68.6298L166.662 67.4813C166.662 67.4813 166.74 67.44 166.867 67.3447H166.868Z",
    fill: "#F9BAA9"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M175.947 88.5437C175.947 88.5437 174.699 88.928 174.792 89.2974C174.885 89.6668 175.074 90.0341 174.685 90.1188C174.296 90.2035 173.719 89.8288 173.677 90.0077C173.635 90.1876 173.623 91.2409 173.624 91.6685C173.625 92.0951 174.61 92.3841 175.638 92.8699C176.665 93.3558 178.469 94.2354 179.155 93.4638C179.841 92.6921 179.041 92.1512 178.622 91.8792C178.202 91.6071 176.679 90.2406 176.405 89.616C176.13 88.9926 176.101 88.4919 175.946 88.5437H175.947Z",
    fill: "#9264E9"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M175.391 92.3936C176.52 92.9271 178.459 93.8713 179.335 93.2065C179.293 93.2891 179.234 93.3748 179.155 93.4638C178.468 94.2354 176.664 93.3547 175.638 92.8699C174.61 92.3841 173.625 92.0951 173.624 91.6685C173.624 91.6452 173.624 91.6187 173.624 91.5923C174.069 91.8336 174.722 92.0771 175.391 92.3936Z",
    fill: "#734BDD"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M174.909 89.9357C174.951 89.7748 174.852 89.5366 174.792 89.2974C174.698 88.928 175.947 88.5437 175.947 88.5437C176.102 88.4919 176.131 88.9915 176.406 89.616C176.68 90.2395 178.203 91.6071 178.623 91.8792C178.68 91.9173 178.746 91.9596 178.814 92.0072C178.405 92.3439 177.883 92.4444 177.883 92.4444C176.118 92.0432 174.911 89.9368 174.911 89.9368L174.909 89.9357Z",
    fill: "#A281F2"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M74.019 87.1913C74.019 87.1913 76.8404 86.4577 79.0344 87.1913L85.1147 87.4824C85.1147 87.4824 88.1239 94.6253 78.5947 95.1016C78.5947 95.1016 71.1756 95.8013 69.1495 92.6861C67.1234 89.5708 74.019 87.1923 74.019 87.1923V87.1913Z",
    fill: "#5F64A5"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M74.019 87.1912C74.019 87.1912 76.6106 86.518 78.7584 87.1087L78.323 89.1728C78.323 89.1728 75.7534 90.3594 72.0443 90.0746C72.0443 90.0746 69.8819 89.6428 68.9333 90.7669C69.8042 88.6435 74.019 87.1902 74.019 87.1902V87.1912Z",
    fill: "#4D5591"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0552 78.2509L74.166 75.6893C74.2898 75.6279 74.4378 75.6459 74.5416 75.7369L78.322 79.0289L72.482 82.1061L68.9713 78.8405C68.7866 78.669 68.8296 78.3631 69.0552 78.2509Z",
    fill: "url(#paint42_linear_917_439)"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9713 78.8415L72.482 82.1071L78.322 79.0299L74.5416 75.7379C74.4787 75.6829 74.3989 75.6543 74.3182 75.6543C74.2667 75.6543 74.2143 75.6659 74.166 75.6903L69.0552 78.2519C68.8296 78.3652 68.7866 78.67 68.9713 78.8415ZM69.0751 78.5557C69.0783 78.5335 69.0919 78.4784 69.1517 78.4488L74.2625 75.8872C74.2793 75.8787 74.2982 75.8745 74.3171 75.8745C74.3465 75.8745 74.3759 75.8851 74.3979 75.9052L77.9359 78.9855L72.5166 81.8414L69.1181 78.6806C69.0688 78.6351 69.0709 78.579 69.0741 78.5568L69.0751 78.5557Z",
    fill: "#405A68"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1568 81.9314C71.1568 81.9314 70.4507 81.3651 70.1401 81.1746C69.5357 80.803 69.157 80.1573 69.1496 79.8377C69.1423 79.518 69.3374 78.9919 69.5525 78.8903C69.7676 78.7887 70.0625 79.5148 70.2733 79.771C70.7329 80.3288 71.0131 80.3214 71.0131 80.3214C70.9973 80.3214 70.8882 80.0705 70.8788 80.0526C70.7822 79.8705 70.6731 79.6937 70.5682 79.5148C70.5598 79.5 70.5514 79.4852 70.5524 79.4682C70.5545 79.4471 70.5734 79.4323 70.5934 79.427C70.8452 79.3656 71.1736 79.663 71.2691 79.8726C71.3677 80.0875 72.3561 81.2032 72.3561 81.2032L71.1568 81.9314Z",
    fill: "#F9BAA9"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0219 77.9142C78.0219 77.9142 77.321 77.3415 77.0692 77.0769C76.5792 76.5625 75.872 76.3285 75.5614 76.391C75.2508 76.4534 74.7829 76.7594 74.7315 76.9933C74.6801 77.2272 75.446 77.3606 75.7398 77.513C76.3788 77.8443 76.4333 78.1217 76.4333 78.1227C76.4302 78.1069 76.1626 78.0539 76.1437 78.0476C75.9465 77.9915 75.7513 77.9227 75.5572 77.8581C75.5415 77.8528 75.5247 77.8475 75.509 77.8528C75.489 77.8592 75.4785 77.8814 75.4775 77.9015C75.4722 78.163 75.8311 78.4212 76.0545 78.471C76.2833 78.5218 77.578 79.2543 77.578 79.2543L78.0229 77.9153L78.0219 77.9142Z",
    fill: "#F9BAA9"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8872 74.1047L82.1957 75.9053L79.2715 76.2969L79.5118 74.7991L81.8872 74.1047Z",
    fill: "#F9A4A9"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6646 72.6323C82.4159 74.3831 80.9669 75.6227 79.4288 75.3993C77.8906 75.177 76.8455 73.5776 77.0942 71.8257C77.3429 70.0749 78.7919 68.8365 80.33 69.0588C81.8682 69.2811 82.9133 70.8805 82.6646 72.6323Z",
    fill: "#F9BAA9"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9484 76.029C78.9484 76.029 80.3974 76.0185 81.4508 75.5993C82.5914 75.1452 83.6311 75.2976 84.2156 76.2979C84.5398 76.8526 86.0234 89.0002 86.0234 89.0002C86.0234 89.0002 81.1749 90.9998 76.9863 89.359L77.8383 79.2533C77.8383 79.2533 78.044 76.6208 78.9484 76.0301V76.029Z",
    fill: "#485083"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9567 76.0301C78.9567 76.0301 76.9338 76.2471 76.384 78.7039L75.2445 82.6406L71.7086 80.3129C71.7086 80.3129 70.972 80.5426 71.0277 82.0944L75.2571 85.3747C75.7534 85.7124 76.4742 85.3546 76.7523 84.7904L78.9567 80.3129C78.9567 80.3129 80.1549 78.3557 78.9567 76.0291V76.0301Z",
    fill: "#485083"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1033 86.4386C71.1033 86.4386 71.417 85.8374 72.2627 85.9644C73.1094 86.0904 75.4576 87.9565 75.4912 88.8171C75.5247 89.6777 74.7861 89.5539 74.7861 89.5539L71.1033 86.4386Z",
    fill: "#8C4B78"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4443 86.5254C70.7423 86.338 71.1095 86.2989 71.4495 86.3878C73.6529 86.9647 75.0631 89.3157 75.0631 89.3157C75.1753 89.719 74.1901 89.8661 74.1901 89.8661C73.6886 88.8986 72.7096 88.3746 72.4662 88.2878C72.2228 88.201 71.2543 88.4953 71.2543 88.4953C69.7057 87.3807 70.0026 86.8027 70.4433 86.5254H70.4443Z",
    fill: "#9C5984"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2179 68.7655C80.7551 68.7009 81.3165 68.7729 81.8505 69.0089C82.4696 69.282 82.9847 69.7647 83.2376 70.4528C83.6374 71.5377 83.4999 72.88 82.9176 73.8739C82.3888 74.7768 81.3878 75.2553 80.4047 75.4627C80.0962 75.5273 79.6587 75.6056 79.2264 75.6141L79.0081 74.5545C79.3659 74.5545 79.5863 74.1142 79.6524 73.6061C79.7185 73.0991 79.4583 72.9318 79.2327 72.9181C79.0081 72.9043 78.9546 73.9395 78.9546 73.9395L78.6241 73.8326C78.6703 73.1171 78.5633 72.14 78.5633 72.14C78.5633 72.14 77.7281 72.2395 76.9873 71.4785C76.9873 71.4785 77.0314 69.0015 80.2189 68.7665L80.2179 68.7655Z",
    fill: "#494DA5"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4045 69.8631C82.4045 69.8631 82.648 68.903 84.4516 68.3674L85.0381 70.1987C85.0381 70.1987 82.9795 69.9976 82.5819 70.422L82.4045 69.8642V69.8631Z",
    fill: "#494DA5"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0207 122.031C41.0207 122.019 41.0207 122.007 41.0207 121.994L41.0302 120.041L39.7092 120.039C39.662 120.009 39.6137 119.979 39.5644 119.949C37.6233 118.806 34.4766 118.79 32.5355 119.915C32.4726 119.951 32.4117 119.989 32.353 120.028L31.0907 120.025L31.0813 121.963C31.0813 122.706 31.5681 123.452 32.5387 124.023C34.4798 125.167 37.6264 125.183 39.5665 124.058C40.5181 123.507 41.0008 122.783 41.0186 122.055V122.033L41.0207 122.031Z",
    fill: "#39BAE9"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0566 120.405C64.5226 118.148 63.295 116.015 61.3969 114.052C60.0245 112.634 58.3573 111.346 56.4141 110.201C55.2221 109.499 53.9263 108.851 52.5308 108.26C49.7714 107.09 46.6929 106.2 43.3836 105.615C40.8654 105.169 38.2686 102.986 35.4335 102.926C35.4335 103.41 35.4241 105.831 35.4231 106.313C35.4231 106.82 35.421 107.328 35.4231 107.835C35.4231 108.083 35.4314 108.33 35.4388 108.58C35.4398 108.613 35.464 108.644 35.5038 108.667C35.5427 108.691 35.5962 108.706 35.656 108.707C41.965 108.896 47.6026 110.452 51.7324 112.885C55.8716 115.322 58.4968 118.639 58.7675 122.341C58.7696 122.373 58.7937 122.402 58.8305 122.424C58.8724 122.449 58.9333 122.464 58.9983 122.463C59.3215 122.459 59.6677 122.454 60.0098 122.455C61.6298 122.461 63.2771 122.473 64.8699 122.483L65.3357 122.486L65.3452 120.549L65.0598 120.404L65.0566 120.405Z",
    fill: "#39BAE9"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7816 120.332C51.9684 118.374 50.2036 116.593 47.8029 115.18C44.5881 113.286 40.2338 112.05 35.5038 111.92C35.3936 111.917 35.3202 111.949 35.2856 111.968C35.2499 111.988 35.1901 112.03 35.189 112.098L35.167 115.574C35.167 115.624 35.2006 115.669 35.2562 115.702C35.3076 115.732 35.3768 115.752 35.4545 115.756C38.4574 115.922 41.0448 116.632 43.1527 117.871C45.2554 119.11 46.4526 120.63 46.7096 122.387C46.7159 122.434 46.7506 122.474 46.8009 122.505C46.8565 122.537 46.9321 122.557 47.016 122.557L52.9599 122.593C53.0753 122.593 53.1498 122.56 53.1834 122.539C53.2117 122.523 53.2558 122.487 53.2642 122.436H53.2674L53.2768 120.476L52.7784 120.332H52.7816Z",
    fill: "#39BAE9"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2665 119.276C64.8552 116.69 63.5531 114.261 61.3969 112.053C60.0182 110.641 58.3447 109.361 56.3962 108.226C55.2001 107.53 53.9012 106.888 52.5036 106.304C49.7378 105.148 46.6562 104.272 43.3438 103.703C40.8235 103.27 38.2161 103.036 35.3811 102.99C35.3843 103.473 35.3863 103.957 35.3874 104.441C35.3884 104.948 35.3895 105.456 35.3937 105.963C35.3958 106.211 35.4042 106.457 35.4126 106.707C35.4136 106.741 35.4388 106.772 35.4776 106.795C35.5165 106.817 35.57 106.832 35.6298 106.834C41.9399 106.992 47.5848 108.521 51.7261 110.934C55.8769 113.351 58.5178 116.655 58.8063 120.356C58.8095 120.387 58.8326 120.416 58.8693 120.437C58.9123 120.461 58.9721 120.477 59.0372 120.475C59.3603 120.469 59.7066 120.463 60.0486 120.463C61.6686 120.461 63.316 120.465 64.9087 120.468H65.3746C65.3609 120.327 65.3515 120.186 65.3431 120.049C65.3252 119.782 65.3074 119.53 65.2675 119.277L65.2665 119.276Z",
    fill: "#EDF7FC"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8081 113.246C44.5838 111.368 40.2242 110.153 35.4943 110.047C35.3841 110.045 35.3106 110.076 35.276 110.095C35.2403 110.116 35.1805 110.159 35.1805 110.226L35.1753 113.702C35.1753 113.752 35.2089 113.796 35.2655 113.829C35.3169 113.858 35.3862 113.879 35.4649 113.882C38.4678 114.032 41.0594 114.73 43.1726 115.959C45.2815 117.186 46.4861 118.7 46.7515 120.457C46.7589 120.504 46.7924 120.544 46.8438 120.574C46.8995 120.607 46.975 120.626 47.0589 120.626L53.0039 120.633C53.1193 120.633 53.1938 120.598 53.2274 120.578C53.2599 120.558 53.3155 120.516 53.3113 120.452C53.1382 117.684 51.046 115.131 47.8091 113.245L47.8081 113.246Z",
    fill: "#EDF7FC"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5925 118.056C37.6451 116.923 34.4984 116.922 32.5636 118.056C30.6299 119.19 30.6404 121.03 32.5867 122.164C34.5341 123.297 37.6808 123.298 39.6145 122.164C41.5493 121.029 41.5388 119.19 39.5914 118.056H39.5925Z",
    fill: "#EDF7FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_917_439",
    x1: 26.4405,
    y1: 59.5058,
    x2: 27.8635,
    y2: 70.1141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_917_439",
    x1: 27.7278,
    y1: 59.3318,
    x2: 29.1508,
    y2: 69.9412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_917_439",
    x1: 29.0164,
    y1: 59.1596,
    x2: 30.4395,
    y2: 69.7692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_917_439",
    x1: 30.3038,
    y1: 58.9868,
    x2: 31.7268,
    y2: 69.5961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_917_439",
    x1: 31.5911,
    y1: 58.8144,
    x2: 33.0152,
    y2: 69.4238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_917_439",
    x1: 26.4405,
    y1: 60.9375,
    x2: 27.8635,
    y2: 71.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_917_439",
    x1: 27.7278,
    y1: 60.7648,
    x2: 29.1509,
    y2: 71.3743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_917_439",
    x1: 29.0164,
    y1: 60.5925,
    x2: 30.4395,
    y2: 71.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_917_439",
    x1: 30.3038,
    y1: 60.4185,
    x2: 31.7269,
    y2: 71.0281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_917_439",
    x1: 31.5911,
    y1: 60.2465,
    x2: 33.0152,
    y2: 70.8559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_917_439",
    x1: 26.4405,
    y1: 53.5482,
    x2: 27.8635,
    y2: 64.1578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_917_439",
    x1: 27.7278,
    y1: 53.3755,
    x2: 29.1509,
    y2: 63.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_917_439",
    x1: 29.0164,
    y1: 53.203,
    x2: 30.4395,
    y2: 63.8124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_917_439",
    x1: 30.3038,
    y1: 53.0301,
    x2: 31.7268,
    y2: 63.6396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_917_439",
    x1: 31.5911,
    y1: 52.8579,
    x2: 33.0153,
    y2: 63.4663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_917_439",
    x1: 26.4405,
    y1: 54.9812,
    x2: 27.8635,
    y2: 65.5907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_917_439",
    x1: 27.7278,
    y1: 54.8086,
    x2: 29.1509,
    y2: 65.4169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_917_439",
    x1: 29.0164,
    y1: 54.6351,
    x2: 30.4395,
    y2: 65.2445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_917_439",
    x1: 30.3038,
    y1: 54.4622,
    x2: 31.7268,
    y2: 65.0718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_917_439",
    x1: 31.5911,
    y1: 54.2899,
    x2: 33.0152,
    y2: 64.8994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_917_439",
    x1: 26.4405,
    y1: 47.5916,
    x2: 27.8635,
    y2: 58.2011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_917_439",
    x1: 27.7278,
    y1: 47.4191,
    x2: 29.1509,
    y2: 58.0287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_917_439",
    x1: 29.0164,
    y1: 47.2467,
    x2: 30.4395,
    y2: 57.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_917_439",
    x1: 30.3038,
    y1: 47.0741,
    x2: 31.7268,
    y2: 57.6836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_917_439",
    x1: 31.5911,
    y1: 46.9013,
    x2: 33.0152,
    y2: 57.5098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_917_439",
    x1: 26.4405,
    y1: 49.0249,
    x2: 27.8635,
    y2: 59.6334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_917_439",
    x1: 27.7278,
    y1: 48.8524,
    x2: 29.1508,
    y2: 59.4608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_917_439",
    x1: 29.0164,
    y1: 48.6789,
    x2: 30.4395,
    y2: 59.2884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_917_439",
    x1: 30.3038,
    y1: 48.5062,
    x2: 31.7268,
    y2: 59.1157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_917_439",
    x1: 31.5911,
    y1: 48.3338,
    x2: 33.0152,
    y2: 58.9433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_917_439",
    x1: 26.4405,
    y1: 41.6353,
    x2: 27.8635,
    y2: 52.2448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_917_439",
    x1: 27.7278,
    y1: 41.4629,
    x2: 29.1509,
    y2: 52.0724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_917_439",
    x1: 29.0164,
    y1: 41.2905,
    x2: 30.4395,
    y2: 51.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_917_439",
    x1: 30.3038,
    y1: 41.1178,
    x2: 31.7268,
    y2: 51.7263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_917_439",
    x1: 31.5911,
    y1: 40.9451,
    x2: 33.0152,
    y2: 51.5534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_917_439",
    x1: 26.4405,
    y1: 43.0689,
    x2: 27.8635,
    y2: 53.6773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_917_439",
    x1: 27.7278,
    y1: 42.8949,
    x2: 29.1509,
    y2: 53.5044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_917_439",
    x1: 29.0164,
    y1: 42.7226,
    x2: 30.4395,
    y2: 53.3321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_917_439",
    x1: 30.3038,
    y1: 42.5496,
    x2: 31.7268,
    y2: 53.1592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_917_439",
    x1: 31.5911,
    y1: 42.3775,
    x2: 33.0152,
    y2: 52.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E6F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D8ECF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2E6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_917_439",
    x1: 119.213,
    y1: 83.3243,
    x2: 116.906,
    y2: 86.8316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D16DC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2200A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_917_439",
    x1: 119.144,
    y1: 83.2788,
    x2: 116.837,
    y2: 86.7861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D16DC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2200A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_917_439",
    x1: 76.4848,
    y1: 75.4945,
    x2: 66.1574,
    y2: 86.8392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52AFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C78E7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetSupport);
export default __webpack_public_path__ + "static/media/get-support.4ec88c0f529e708181753a74761a04bd.svg";
export { ForwardRef as ReactComponent };